/* tslint:disable */
/* eslint-disable */
/**
 * case-db-service API
 * Canonical REST contract for the Java case-db-service. This spec is the source of truth for the generated TypeScript client in the case-processing UI (ui/case-processing-app/src/lib/api/generated/casedb).
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Activity
 */
export interface Activity {
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    'activityTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    'assignedTo'?: number;
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    'caseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'closedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    'createdBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'dueDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Activity
     */
    'notificationBadge'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'openedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof Activity
     */
    'parentActivityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'status'?: ActivityStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Activity
     */
    'updatedAt'?: string;
}

export const ActivityStatusEnum = {
    Open: 'Open',
    Overdue: 'Overdue',
    AwaitingResponse: 'AwaitingResponse',
    Closed: 'Closed'
} as const;

export type ActivityStatusEnum = typeof ActivityStatusEnum[keyof typeof ActivityStatusEnum];

/**
 * 
 * @export
 * @interface ActivityAttachmentView
 */
export interface ActivityAttachmentView {
    /**
     * 
     * @type {number}
     * @memberof ActivityAttachmentView
     */
    'activity_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityAttachmentView
     */
    'file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAttachmentView
     */
    'file_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityAttachmentView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityAttachmentView
     */
    'storage_path'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityAttachmentView
     */
    'uploaded_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityAttachmentView
     */
    'uploaded_by'?: number;
}
/**
 * 
 * @export
 * @interface ActivityView
 */
export interface ActivityView {
    /**
     * 
     * @type {number}
     * @memberof ActivityView
     */
    'activity_type_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityView
     */
    'assigned_to'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActivityView
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'closed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityView
     */
    'created_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'due_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'next_due_on'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ActivityView
     */
    'notification_badge'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'opened_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActivityView
     */
    'parent_activity_id'?: number;
    /**
     * 
     * @type {QueryProgress}
     * @memberof ActivityView
     */
    'progress'?: QueryProgress;
    /**
     * 
     * @type {QueryExtension}
     * @memberof ActivityView
     */
    'query_extension'?: QueryExtension;
    /**
     * 
     * @type {Array<QueryQuestionView>}
     * @memberof ActivityView
     */
    'questions'?: Array<QueryQuestionView>;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'status'?: ActivityViewStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActivityView
     */
    'updated_at'?: string;
}

export const ActivityViewStatusEnum = {
    Open: 'Open',
    Overdue: 'Overdue',
    AwaitingResponse: 'AwaitingResponse',
    Closed: 'Closed'
} as const;

export type ActivityViewStatusEnum = typeof ActivityViewStatusEnum[keyof typeof ActivityViewStatusEnum];

/**
 * 
 * @export
 * @interface AddCaseLinksRequest
 */
export interface AddCaseLinksRequest {
    /**
     * 
     * @type {string}
     * @memberof AddCaseLinksRequest
     */
    'justification'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof AddCaseLinksRequest
     */
    'linked_case_ids'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AddCaseLinksRequest
     */
    'relationship_type'?: AddCaseLinksRequestRelationshipTypeEnum;
}

export const AddCaseLinksRequestRelationshipTypeEnum = {
    MotherAndBaby: 'MOTHER_AND_BABY',
    Twins: 'TWINS',
    CaseSeries: 'CASE_SERIES',
    AeAndProductComplaint: 'AE_AND_PRODUCT_COMPLAINT',
    DrugAndDevice: 'DRUG_AND_DEVICE',
    Recurrence: 'RECURRENCE',
    SamePatientOtherEvent: 'SAME_PATIENT_OTHER_EVENT',
    Other: 'OTHER'
} as const;

export type AddCaseLinksRequestRelationshipTypeEnum = typeof AddCaseLinksRequestRelationshipTypeEnum[keyof typeof AddCaseLinksRequestRelationshipTypeEnum];

/**
 * 
 * @export
 * @interface AddParentByHandRequest
 */
export interface AddParentByHandRequest {
    /**
     * 
     * @type {string}
     * @memberof AddParentByHandRequest
     */
    'case_number'?: string;
}
/**
 * 
 * @export
 * @interface AgeingBucket
 */
export interface AgeingBucket {
    /**
     * 
     * @type {number}
     * @memberof AgeingBucket
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof AgeingBucket
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgeingBucket
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof AgeingBucket
     */
    'max_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof AgeingBucket
     */
    'min_days'?: number;
}
/**
 * 
 * @export
 * @interface AgentProposalDecision
 */
export interface AgentProposalDecision {
    /**
     * 
     * @type {string}
     * @memberof AgentProposalDecision
     */
    'decision': AgentProposalDecisionDecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentProposalDecision
     */
    'field_id'?: string;
    /**
     * 
     * @type {object}
     * @memberof AgentProposalDecision
     */
    'proposed_value'?: object;
    /**
     * 
     * @type {string}
     * @memberof AgentProposalDecision
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentProposalDecision
     */
    'run_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentProposalDecision
     */
    'tool_call_id'?: string;
}

export const AgentProposalDecisionDecisionEnum = {
    Accepted: 'accepted',
    Rejected: 'rejected'
} as const;

export type AgentProposalDecisionDecisionEnum = typeof AgentProposalDecisionDecisionEnum[keyof typeof AgentProposalDecisionDecisionEnum];

/**
 * 
 * @export
 * @interface AguiThreadSummary
 */
export interface AguiThreadSummary {
    /**
     * 
     * @type {string}
     * @memberof AguiThreadSummary
     */
    'agentName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AguiThreadSummary
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AguiThreadSummary
     */
    'lastActivityAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AguiThreadSummary
     */
    'runCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof AguiThreadSummary
     */
    'threadId'?: string;
}
/**
 * 
 * @export
 * @interface ApiResponseActivityAttachmentView
 */
export interface ApiResponseActivityAttachmentView {
    /**
     * 
     * @type {ActivityAttachmentView}
     * @memberof ApiResponseActivityAttachmentView
     */
    'data'?: ActivityAttachmentView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseActivityAttachmentView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseActivityAttachmentView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseActivityAttachmentView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseActivityView
 */
export interface ApiResponseActivityView {
    /**
     * 
     * @type {ActivityView}
     * @memberof ApiResponseActivityView
     */
    'data'?: ActivityView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseActivityView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseActivityView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseActivityView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseAuditPageDtoAuditActionDto
 */
export interface ApiResponseAuditPageDtoAuditActionDto {
    /**
     * 
     * @type {AuditPageDtoAuditActionDto}
     * @memberof ApiResponseAuditPageDtoAuditActionDto
     */
    'data'?: AuditPageDtoAuditActionDto;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseAuditPageDtoAuditActionDto
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseAuditPageDtoAuditActionDto
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseAuditPageDtoAuditActionDto
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCase
 */
export interface ApiResponseCase {
    /**
     * 
     * @type {Case}
     * @memberof ApiResponseCase
     */
    'data'?: Case;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCase
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCase
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCase
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseAttachmentView
 */
export interface ApiResponseCaseAttachmentView {
    /**
     * 
     * @type {CaseAttachmentView}
     * @memberof ApiResponseCaseAttachmentView
     */
    'data'?: CaseAttachmentView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseAttachmentView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseAttachmentView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseAttachmentView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseContactLog
 */
export interface ApiResponseCaseContactLog {
    /**
     * 
     * @type {CaseContactLog}
     * @memberof ApiResponseCaseContactLog
     */
    'data'?: CaseContactLog;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseContactLog
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseContactLog
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseContactLog
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseDeadlinesView
 */
export interface ApiResponseCaseDeadlinesView {
    /**
     * 
     * @type {CaseDeadlinesView}
     * @memberof ApiResponseCaseDeadlinesView
     */
    'data'?: CaseDeadlinesView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseDeadlinesView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseDeadlinesView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseDeadlinesView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseEventDetails
 */
export interface ApiResponseCaseEventDetails {
    /**
     * 
     * @type {CaseEventDetails}
     * @memberof ApiResponseCaseEventDetails
     */
    'data'?: CaseEventDetails;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseEventDetails
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseEventDetails
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseEventDetails
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseListResponse
 */
export interface ApiResponseCaseListResponse {
    /**
     * 
     * @type {CaseListResponse}
     * @memberof ApiResponseCaseListResponse
     */
    'data'?: CaseListResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseListResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseListResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseListSummary
 */
export interface ApiResponseCaseListSummary {
    /**
     * 
     * @type {CaseListSummary}
     * @memberof ApiResponseCaseListSummary
     */
    'data'?: CaseListSummary;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseListSummary
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseListSummary
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseListSummary
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseNotesAndAttachment
 */
export interface ApiResponseCaseNotesAndAttachment {
    /**
     * 
     * @type {CaseNotesAndAttachment}
     * @memberof ApiResponseCaseNotesAndAttachment
     */
    'data'?: CaseNotesAndAttachment;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseNotesAndAttachment
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseNotesAndAttachment
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseNotesAndAttachment
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseSummary
 */
export interface ApiResponseCaseSummary {
    /**
     * 
     * @type {CaseSummary}
     * @memberof ApiResponseCaseSummary
     */
    'data'?: CaseSummary;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseSummary
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseSummary
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseSummary
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseWorkflowStatusResponse
 */
export interface ApiResponseCaseWorkflowStatusResponse {
    /**
     * 
     * @type {CaseWorkflowStatusResponse}
     * @memberof ApiResponseCaseWorkflowStatusResponse
     */
    'data'?: CaseWorkflowStatusResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseWorkflowStatusResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseWorkflowStatusResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseWorkflowStatusResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCaseWwidView
 */
export interface ApiResponseCaseWwidView {
    /**
     * 
     * @type {CaseWwidView}
     * @memberof ApiResponseCaseWwidView
     */
    'data'?: CaseWwidView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseWwidView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCaseWwidView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCaseWwidView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCatalogReviewResponse
 */
export interface ApiResponseCatalogReviewResponse {
    /**
     * 
     * @type {CatalogReviewResponse}
     * @memberof ApiResponseCatalogReviewResponse
     */
    'data'?: CatalogReviewResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCatalogReviewResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCatalogReviewResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCatalogReviewResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCatalogRouteReadinessResponse
 */
export interface ApiResponseCatalogRouteReadinessResponse {
    /**
     * 
     * @type {CatalogRouteReadinessResponse}
     * @memberof ApiResponseCatalogRouteReadinessResponse
     */
    'data'?: CatalogRouteReadinessResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCatalogRouteReadinessResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCatalogRouteReadinessResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCatalogRouteReadinessResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCatalogSavedReviewResponse
 */
export interface ApiResponseCatalogSavedReviewResponse {
    /**
     * 
     * @type {CatalogSavedReviewResponse}
     * @memberof ApiResponseCatalogSavedReviewResponse
     */
    'data'?: CatalogSavedReviewResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCatalogSavedReviewResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCatalogSavedReviewResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCatalogSavedReviewResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseClientSlasResponse
 */
export interface ApiResponseClientSlasResponse {
    /**
     * 
     * @type {ClientSlasResponse}
     * @memberof ApiResponseClientSlasResponse
     */
    'data'?: ClientSlasResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseClientSlasResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseClientSlasResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseClientSlasResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseComplianceResponse
 */
export interface ApiResponseComplianceResponse {
    /**
     * 
     * @type {ComplianceResponse}
     * @memberof ApiResponseComplianceResponse
     */
    'data'?: ComplianceResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseComplianceResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseComplianceResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseComplianceResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigAiAssist
 */
export interface ApiResponseConfigAiAssist {
    /**
     * 
     * @type {ConfigAiAssist}
     * @memberof ApiResponseConfigAiAssist
     */
    'data'?: ConfigAiAssist;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigAiAssist
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigAiAssist
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigAiAssist
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigCountry
 */
export interface ApiResponseConfigCountry {
    /**
     * 
     * @type {ConfigCountry}
     * @memberof ApiResponseConfigCountry
     */
    'data'?: ConfigCountry;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigCountry
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigCountry
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigCountry
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigDatasheet
 */
export interface ApiResponseConfigDatasheet {
    /**
     * 
     * @type {ConfigDatasheet}
     * @memberof ApiResponseConfigDatasheet
     */
    'data'?: ConfigDatasheet;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigDatasheet
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigDatasheet
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigDatasheet
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigFieldRules
 */
export interface ApiResponseConfigFieldRules {
    /**
     * 
     * @type {ConfigFieldRules}
     * @memberof ApiResponseConfigFieldRules
     */
    'data'?: ConfigFieldRules;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigFieldRules
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigFieldRules
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigFieldRules
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigFormField
 */
export interface ApiResponseConfigFormField {
    /**
     * 
     * @type {ConfigFormField}
     * @memberof ApiResponseConfigFormField
     */
    'data'?: ConfigFormField;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigFormField
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigFormField
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigFormField
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigPriority
 */
export interface ApiResponseConfigPriority {
    /**
     * 
     * @type {ConfigPriority}
     * @memberof ApiResponseConfigPriority
     */
    'data'?: ConfigPriority;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigPriority
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigPriority
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigPriority
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigProduct
 */
export interface ApiResponseConfigProduct {
    /**
     * 
     * @type {ConfigProduct}
     * @memberof ApiResponseConfigProduct
     */
    'data'?: ConfigProduct;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigProduct
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigProduct
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigProduct
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigProductLicense
 */
export interface ApiResponseConfigProductLicense {
    /**
     * 
     * @type {ConfigProductLicense}
     * @memberof ApiResponseConfigProductLicense
     */
    'data'?: ConfigProductLicense;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigProductLicense
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigProductLicense
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigProductLicense
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigReceiver
 */
export interface ApiResponseConfigReceiver {
    /**
     * 
     * @type {ConfigReceiver}
     * @memberof ApiResponseConfigReceiver
     */
    'data'?: ConfigReceiver;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigReceiver
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigReceiver
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigReceiver
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigReportType
 */
export interface ApiResponseConfigReportType {
    /**
     * 
     * @type {ConfigReportType}
     * @memberof ApiResponseConfigReportType
     */
    'data'?: ConfigReportType;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigReportType
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigReportType
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigReportType
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseConfigSender
 */
export interface ApiResponseConfigSender {
    /**
     * 
     * @type {ConfigSender}
     * @memberof ApiResponseConfigSender
     */
    'data'?: ConfigSender;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigSender
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseConfigSender
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseConfigSender
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseCreateNewCaseResponse
 */
export interface ApiResponseCreateNewCaseResponse {
    /**
     * 
     * @type {CreateNewCaseResponse}
     * @memberof ApiResponseCreateNewCaseResponse
     */
    'data'?: CreateNewCaseResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCreateNewCaseResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseCreateNewCaseResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseCreateNewCaseResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDashboardCaseSearchResult
 */
export interface ApiResponseDashboardCaseSearchResult {
    /**
     * 
     * @type {DashboardCaseSearchResult}
     * @memberof ApiResponseDashboardCaseSearchResult
     */
    'data'?: DashboardCaseSearchResult;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDashboardCaseSearchResult
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDashboardCaseSearchResult
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDashboardCaseSearchResult
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDashboardFilterOptions
 */
export interface ApiResponseDashboardFilterOptions {
    /**
     * 
     * @type {DashboardFilterOptions}
     * @memberof ApiResponseDashboardFilterOptions
     */
    'data'?: DashboardFilterOptions;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDashboardFilterOptions
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDashboardFilterOptions
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDashboardFilterOptions
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDashboardRepository
 */
export interface ApiResponseDashboardRepository {
    /**
     * 
     * @type {DashboardRepository}
     * @memberof ApiResponseDashboardRepository
     */
    'data'?: DashboardRepository;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDashboardRepository
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDashboardRepository
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDashboardRepository
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDeadlineReportPage
 */
export interface ApiResponseDeadlineReportPage {
    /**
     * 
     * @type {DeadlineReportPage}
     * @memberof ApiResponseDeadlineReportPage
     */
    'data'?: DeadlineReportPage;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDeadlineReportPage
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDeadlineReportPage
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDeadlineReportPage
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDeadlineReviewed
 */
export interface ApiResponseDeadlineReviewed {
    /**
     * 
     * @type {DeadlineReviewed}
     * @memberof ApiResponseDeadlineReviewed
     */
    'data'?: DeadlineReviewed;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDeadlineReviewed
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDeadlineReviewed
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDeadlineReviewed
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDrilldownResponse
 */
export interface ApiResponseDrilldownResponse {
    /**
     * 
     * @type {DrilldownResponse}
     * @memberof ApiResponseDrilldownResponse
     */
    'data'?: DrilldownResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDrilldownResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDrilldownResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDrilldownResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDueDatePolicyVersionView
 */
export interface ApiResponseDueDatePolicyVersionView {
    /**
     * 
     * @type {DueDatePolicyVersionView}
     * @memberof ApiResponseDueDatePolicyVersionView
     */
    'data'?: DueDatePolicyVersionView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDueDatePolicyVersionView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDueDatePolicyVersionView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDueDatePolicyVersionView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicateCandidateListResponse
 */
export interface ApiResponseDuplicateCandidateListResponse {
    /**
     * 
     * @type {DuplicateCandidateListResponse}
     * @memberof ApiResponseDuplicateCandidateListResponse
     */
    'data'?: DuplicateCandidateListResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateCandidateListResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateCandidateListResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicateCandidateListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicateCandidateSummary
 */
export interface ApiResponseDuplicateCandidateSummary {
    /**
     * 
     * @type {DuplicateCandidateSummary}
     * @memberof ApiResponseDuplicateCandidateSummary
     */
    'data'?: DuplicateCandidateSummary;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateCandidateSummary
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateCandidateSummary
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicateCandidateSummary
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicateComparisonResponse
 */
export interface ApiResponseDuplicateComparisonResponse {
    /**
     * 
     * @type {DuplicateComparisonResponse}
     * @memberof ApiResponseDuplicateComparisonResponse
     */
    'data'?: DuplicateComparisonResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateComparisonResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateComparisonResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicateComparisonResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicateDecisionResponse
 */
export interface ApiResponseDuplicateDecisionResponse {
    /**
     * 
     * @type {DuplicateDecisionResponse}
     * @memberof ApiResponseDuplicateDecisionResponse
     */
    'data'?: DuplicateDecisionResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateDecisionResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateDecisionResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicateDecisionResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicatePolicyScreenView
 */
export interface ApiResponseDuplicatePolicyScreenView {
    /**
     * 
     * @type {DuplicatePolicyScreenView}
     * @memberof ApiResponseDuplicatePolicyScreenView
     */
    'data'?: DuplicatePolicyScreenView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicatePolicyScreenView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicatePolicyScreenView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicatePolicyScreenView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicatePolicyVersionView
 */
export interface ApiResponseDuplicatePolicyVersionView {
    /**
     * 
     * @type {DuplicatePolicyVersionView}
     * @memberof ApiResponseDuplicatePolicyVersionView
     */
    'data'?: DuplicatePolicyVersionView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicatePolicyVersionView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicatePolicyVersionView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicatePolicyVersionView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicateRecheckReport
 */
export interface ApiResponseDuplicateRecheckReport {
    /**
     * 
     * @type {DuplicateRecheckReport}
     * @memberof ApiResponseDuplicateRecheckReport
     */
    'data'?: DuplicateRecheckReport;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateRecheckReport
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateRecheckReport
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicateRecheckReport
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseDuplicateRecheckView
 */
export interface ApiResponseDuplicateRecheckView {
    /**
     * 
     * @type {DuplicateRecheckView}
     * @memberof ApiResponseDuplicateRecheckView
     */
    'data'?: DuplicateRecheckView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateRecheckView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseDuplicateRecheckView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseDuplicateRecheckView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseE2bProfileResponse
 */
export interface ApiResponseE2bProfileResponse {
    /**
     * 
     * @type {E2bProfileResponse}
     * @memberof ApiResponseE2bProfileResponse
     */
    'data'?: E2bProfileResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseE2bProfileResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseE2bProfileResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseE2bProfileResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFieldHistoryDto
 */
export interface ApiResponseFieldHistoryDto {
    /**
     * 
     * @type {FieldHistoryDto}
     * @memberof ApiResponseFieldHistoryDto
     */
    'data'?: FieldHistoryDto;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFieldHistoryDto
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFieldHistoryDto
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFieldHistoryDto
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFilterOptions
 */
export interface ApiResponseFilterOptions {
    /**
     * 
     * @type {FilterOptions}
     * @memberof ApiResponseFilterOptions
     */
    'data'?: FilterOptions;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFilterOptions
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFilterOptions
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFilterOptions
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFollowUpsResponse
 */
export interface ApiResponseFollowUpsResponse {
    /**
     * 
     * @type {FollowUpsResponse}
     * @memberof ApiResponseFollowUpsResponse
     */
    'data'?: FollowUpsResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowUpsResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowUpsResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFollowUpsResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFollowupPreview
 */
export interface ApiResponseFollowupPreview {
    /**
     * 
     * @type {FollowupPreview}
     * @memberof ApiResponseFollowupPreview
     */
    'data'?: FollowupPreview;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupPreview
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupPreview
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFollowupPreview
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFollowupReceiptDateCorrected
 */
export interface ApiResponseFollowupReceiptDateCorrected {
    /**
     * 
     * @type {FollowupReceiptDateCorrected}
     * @memberof ApiResponseFollowupReceiptDateCorrected
     */
    'data'?: FollowupReceiptDateCorrected;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupReceiptDateCorrected
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupReceiptDateCorrected
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFollowupReceiptDateCorrected
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFollowupTakeInView
 */
export interface ApiResponseFollowupTakeInView {
    /**
     * 
     * @type {FollowupTakeInView}
     * @memberof ApiResponseFollowupTakeInView
     */
    'data'?: FollowupTakeInView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupTakeInView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupTakeInView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFollowupTakeInView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseFollowupTakenIn
 */
export interface ApiResponseFollowupTakenIn {
    /**
     * 
     * @type {FollowupTakenIn}
     * @memberof ApiResponseFollowupTakenIn
     */
    'data'?: FollowupTakenIn;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupTakenIn
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseFollowupTakenIn
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseFollowupTakenIn
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseIntakeTrendResponse
 */
export interface ApiResponseIntakeTrendResponse {
    /**
     * 
     * @type {IntakeTrendResponse}
     * @memberof ApiResponseIntakeTrendResponse
     */
    'data'?: IntakeTrendResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseIntakeTrendResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseIntakeTrendResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseIntakeTrendResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseIntakeTriageItemResponse
 */
export interface ApiResponseIntakeTriageItemResponse {
    /**
     * 
     * @type {IntakeTriageItemResponse}
     * @memberof ApiResponseIntakeTriageItemResponse
     */
    'data'?: IntakeTriageItemResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseIntakeTriageItemResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseIntakeTriageItemResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseIntakeTriageItemResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseIntakeTriageListResponse
 */
export interface ApiResponseIntakeTriageListResponse {
    /**
     * 
     * @type {IntakeTriageListResponse}
     * @memberof ApiResponseIntakeTriageListResponse
     */
    'data'?: IntakeTriageListResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseIntakeTriageListResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseIntakeTriageListResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseIntakeTriageListResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseKpisResponse
 */
export interface ApiResponseKpisResponse {
    /**
     * 
     * @type {KpisResponse}
     * @memberof ApiResponseKpisResponse
     */
    'data'?: KpisResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseKpisResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseKpisResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseKpisResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListActivityAttachmentView
 */
export interface ApiResponseListActivityAttachmentView {
    /**
     * 
     * @type {Array<ActivityAttachmentView>}
     * @memberof ApiResponseListActivityAttachmentView
     */
    'data'?: Array<ActivityAttachmentView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListActivityAttachmentView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListActivityAttachmentView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListActivityAttachmentView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListActivityView
 */
export interface ApiResponseListActivityView {
    /**
     * 
     * @type {Array<ActivityView>}
     * @memberof ApiResponseListActivityView
     */
    'data'?: Array<ActivityView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListActivityView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListActivityView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListActivityView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListAssigneeWorkload
 */
export interface ApiResponseListAssigneeWorkload {
    /**
     * 
     * @type {Array<AssigneeWorkload>}
     * @memberof ApiResponseListAssigneeWorkload
     */
    'data'?: Array<AssigneeWorkload>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListAssigneeWorkload
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListAssigneeWorkload
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListAssigneeWorkload
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCaseAttachmentView
 */
export interface ApiResponseListCaseAttachmentView {
    /**
     * 
     * @type {Array<CaseAttachmentView>}
     * @memberof ApiResponseListCaseAttachmentView
     */
    'data'?: Array<CaseAttachmentView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseAttachmentView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseAttachmentView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCaseAttachmentView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCaseContactLog
 */
export interface ApiResponseListCaseContactLog {
    /**
     * 
     * @type {Array<CaseContactLog>}
     * @memberof ApiResponseListCaseContactLog
     */
    'data'?: Array<CaseContactLog>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseContactLog
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseContactLog
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCaseContactLog
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCaseEventDetails
 */
export interface ApiResponseListCaseEventDetails {
    /**
     * 
     * @type {Array<CaseEventDetails>}
     * @memberof ApiResponseListCaseEventDetails
     */
    'data'?: Array<CaseEventDetails>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseEventDetails
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseEventDetails
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCaseEventDetails
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCaseEventView
 */
export interface ApiResponseListCaseEventView {
    /**
     * 
     * @type {Array<CaseEventView>}
     * @memberof ApiResponseListCaseEventView
     */
    'data'?: Array<CaseEventView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseEventView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseEventView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCaseEventView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCaseLinkResponse
 */
export interface ApiResponseListCaseLinkResponse {
    /**
     * 
     * @type {Array<CaseLinkResponse>}
     * @memberof ApiResponseListCaseLinkResponse
     */
    'data'?: Array<CaseLinkResponse>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseLinkResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseLinkResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCaseLinkResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCaseNotesAndAttachment
 */
export interface ApiResponseListCaseNotesAndAttachment {
    /**
     * 
     * @type {Array<CaseNotesAndAttachment>}
     * @memberof ApiResponseListCaseNotesAndAttachment
     */
    'data'?: Array<CaseNotesAndAttachment>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseNotesAndAttachment
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCaseNotesAndAttachment
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCaseNotesAndAttachment
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListCausalityAssessmentView
 */
export interface ApiResponseListCausalityAssessmentView {
    /**
     * 
     * @type {Array<CausalityAssessmentView>}
     * @memberof ApiResponseListCausalityAssessmentView
     */
    'data'?: Array<CausalityAssessmentView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCausalityAssessmentView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListCausalityAssessmentView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListCausalityAssessmentView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigAiAssist
 */
export interface ApiResponseListConfigAiAssist {
    /**
     * 
     * @type {Array<ConfigAiAssist>}
     * @memberof ApiResponseListConfigAiAssist
     */
    'data'?: Array<ConfigAiAssist>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigAiAssist
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigAiAssist
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigAiAssist
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigCountry
 */
export interface ApiResponseListConfigCountry {
    /**
     * 
     * @type {Array<ConfigCountry>}
     * @memberof ApiResponseListConfigCountry
     */
    'data'?: Array<ConfigCountry>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigCountry
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigCountry
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigCountry
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigDatasheet
 */
export interface ApiResponseListConfigDatasheet {
    /**
     * 
     * @type {Array<ConfigDatasheet>}
     * @memberof ApiResponseListConfigDatasheet
     */
    'data'?: Array<ConfigDatasheet>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigDatasheet
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigDatasheet
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigDatasheet
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigFieldRules
 */
export interface ApiResponseListConfigFieldRules {
    /**
     * 
     * @type {Array<ConfigFieldRules>}
     * @memberof ApiResponseListConfigFieldRules
     */
    'data'?: Array<ConfigFieldRules>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigFieldRules
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigFieldRules
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigFieldRules
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigFormField
 */
export interface ApiResponseListConfigFormField {
    /**
     * 
     * @type {Array<ConfigFormField>}
     * @memberof ApiResponseListConfigFormField
     */
    'data'?: Array<ConfigFormField>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigFormField
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigFormField
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigFormField
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigPriority
 */
export interface ApiResponseListConfigPriority {
    /**
     * 
     * @type {Array<ConfigPriority>}
     * @memberof ApiResponseListConfigPriority
     */
    'data'?: Array<ConfigPriority>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigPriority
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigPriority
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigPriority
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigProduct
 */
export interface ApiResponseListConfigProduct {
    /**
     * 
     * @type {Array<ConfigProduct>}
     * @memberof ApiResponseListConfigProduct
     */
    'data'?: Array<ConfigProduct>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigProduct
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigProduct
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigProduct
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigProductLicense
 */
export interface ApiResponseListConfigProductLicense {
    /**
     * 
     * @type {Array<ConfigProductLicense>}
     * @memberof ApiResponseListConfigProductLicense
     */
    'data'?: Array<ConfigProductLicense>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigProductLicense
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigProductLicense
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigProductLicense
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigReceiver
 */
export interface ApiResponseListConfigReceiver {
    /**
     * 
     * @type {Array<ConfigReceiver>}
     * @memberof ApiResponseListConfigReceiver
     */
    'data'?: Array<ConfigReceiver>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigReceiver
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigReceiver
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigReceiver
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigReportType
 */
export interface ApiResponseListConfigReportType {
    /**
     * 
     * @type {Array<ConfigReportType>}
     * @memberof ApiResponseListConfigReportType
     */
    'data'?: Array<ConfigReportType>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigReportType
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigReportType
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigReportType
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListConfigSender
 */
export interface ApiResponseListConfigSender {
    /**
     * 
     * @type {Array<ConfigSender>}
     * @memberof ApiResponseListConfigSender
     */
    'data'?: Array<ConfigSender>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigSender
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListConfigSender
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListConfigSender
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListDashboardRepository
 */
export interface ApiResponseListDashboardRepository {
    /**
     * 
     * @type {Array<DashboardRepository>}
     * @memberof ApiResponseListDashboardRepository
     */
    'data'?: Array<DashboardRepository>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDashboardRepository
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDashboardRepository
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListDashboardRepository
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListDeadlineHistoryEntryView
 */
export interface ApiResponseListDeadlineHistoryEntryView {
    /**
     * 
     * @type {Array<DeadlineHistoryEntryView>}
     * @memberof ApiResponseListDeadlineHistoryEntryView
     */
    'data'?: Array<DeadlineHistoryEntryView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDeadlineHistoryEntryView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDeadlineHistoryEntryView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListDeadlineHistoryEntryView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListDueDatePolicyVersionView
 */
export interface ApiResponseListDueDatePolicyVersionView {
    /**
     * 
     * @type {Array<DueDatePolicyVersionView>}
     * @memberof ApiResponseListDueDatePolicyVersionView
     */
    'data'?: Array<DueDatePolicyVersionView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDueDatePolicyVersionView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDueDatePolicyVersionView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListDueDatePolicyVersionView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListDuplicateCandidateSummary
 */
export interface ApiResponseListDuplicateCandidateSummary {
    /**
     * 
     * @type {Array<DuplicateCandidateSummary>}
     * @memberof ApiResponseListDuplicateCandidateSummary
     */
    'data'?: Array<DuplicateCandidateSummary>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDuplicateCandidateSummary
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListDuplicateCandidateSummary
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListDuplicateCandidateSummary
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListHospitalization
 */
export interface ApiResponseListHospitalization {
    /**
     * 
     * @type {Array<Hospitalization>}
     * @memberof ApiResponseListHospitalization
     */
    'data'?: Array<Hospitalization>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListHospitalization
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListHospitalization
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListHospitalization
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListMapStringObject
 */
export interface ApiResponseListMapStringObject {
    /**
     * 
     * @type {Array<{ [key: string]: object; }>}
     * @memberof ApiResponseListMapStringObject
     */
    'data'?: Array<{ [key: string]: object; }>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListMapStringObject
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListMapStringObject
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListMapStringObject
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListOpenQueryView
 */
export interface ApiResponseListOpenQueryView {
    /**
     * 
     * @type {Array<OpenQueryView>}
     * @memberof ApiResponseListOpenQueryView
     */
    'data'?: Array<OpenQueryView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListOpenQueryView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListOpenQueryView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListOpenQueryView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListPipelineStageCount
 */
export interface ApiResponseListPipelineStageCount {
    /**
     * 
     * @type {Array<PipelineStageCount>}
     * @memberof ApiResponseListPipelineStageCount
     */
    'data'?: Array<PipelineStageCount>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListPipelineStageCount
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListPipelineStageCount
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListPipelineStageCount
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListQueryAttemptView
 */
export interface ApiResponseListQueryAttemptView {
    /**
     * 
     * @type {Array<QueryAttemptView>}
     * @memberof ApiResponseListQueryAttemptView
     */
    'data'?: Array<QueryAttemptView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQueryAttemptView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQueryAttemptView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListQueryAttemptView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListQueryQueueItem
 */
export interface ApiResponseListQueryQueueItem {
    /**
     * 
     * @type {Array<QueryQueueItem>}
     * @memberof ApiResponseListQueryQueueItem
     */
    'data'?: Array<QueryQueueItem>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQueryQueueItem
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQueryQueueItem
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListQueryQueueItem
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListQueryRecipientView
 */
export interface ApiResponseListQueryRecipientView {
    /**
     * 
     * @type {Array<QueryRecipientView>}
     * @memberof ApiResponseListQueryRecipientView
     */
    'data'?: Array<QueryRecipientView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQueryRecipientView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQueryRecipientView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListQueryRecipientView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListQuestionSuggestion
 */
export interface ApiResponseListQuestionSuggestion {
    /**
     * 
     * @type {Array<QuestionSuggestion>}
     * @memberof ApiResponseListQuestionSuggestion
     */
    'data'?: Array<QuestionSuggestion>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQuestionSuggestion
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListQuestionSuggestion
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListQuestionSuggestion
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListReplacementCandidateView
 */
export interface ApiResponseListReplacementCandidateView {
    /**
     * 
     * @type {Array<ReplacementCandidateView>}
     * @memberof ApiResponseListReplacementCandidateView
     */
    'data'?: Array<ReplacementCandidateView>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListReplacementCandidateView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListReplacementCandidateView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListReplacementCandidateView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListRole
 */
export interface ApiResponseListRole {
    /**
     * 
     * @type {Array<Role>}
     * @memberof ApiResponseListRole
     */
    'data'?: Array<Role>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListRole
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListRole
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListRole
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListString
 */
export interface ApiResponseListString {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiResponseListString
     */
    'data'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListString
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListString
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListString
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListStudy
 */
export interface ApiResponseListStudy {
    /**
     * 
     * @type {Array<Study>}
     * @memberof ApiResponseListStudy
     */
    'data'?: Array<Study>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudy
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudy
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListStudy
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListStudyCase
 */
export interface ApiResponseListStudyCase {
    /**
     * 
     * @type {Array<StudyCase>}
     * @memberof ApiResponseListStudyCase
     */
    'data'?: Array<StudyCase>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyCase
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyCase
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListStudyCase
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListStudyCountryOption
 */
export interface ApiResponseListStudyCountryOption {
    /**
     * 
     * @type {Array<StudyCountryOption>}
     * @memberof ApiResponseListStudyCountryOption
     */
    'data'?: Array<StudyCountryOption>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyCountryOption
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyCountryOption
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListStudyCountryOption
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListStudyListingMappingSummary
 */
export interface ApiResponseListStudyListingMappingSummary {
    /**
     * 
     * @type {Array<StudyListingMappingSummary>}
     * @memberof ApiResponseListStudyListingMappingSummary
     */
    'data'?: Array<StudyListingMappingSummary>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyListingMappingSummary
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyListingMappingSummary
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListStudyListingMappingSummary
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseListStudyRegistration
 */
export interface ApiResponseListStudyRegistration {
    /**
     * 
     * @type {Array<StudyRegistration>}
     * @memberof ApiResponseListStudyRegistration
     */
    'data'?: Array<StudyRegistration>;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyRegistration
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseListStudyRegistration
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseListStudyRegistration
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseLockHolderInfo
 */
export interface ApiResponseLockHolderInfo {
    /**
     * 
     * @type {LockHolderInfo}
     * @memberof ApiResponseLockHolderInfo
     */
    'data'?: LockHolderInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseLockHolderInfo
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseLockHolderInfo
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseLockHolderInfo
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseLockView
 */
export interface ApiResponseLockView {
    /**
     * 
     * @type {LockView}
     * @memberof ApiResponseLockView
     */
    'data'?: LockView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseLockView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseLockView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseLockView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseMapStringListCatalogOption
 */
export interface ApiResponseMapStringListCatalogOption {
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof ApiResponseMapStringListCatalogOption
     */
    'data'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {string}
     * @memberof ApiResponseMapStringListCatalogOption
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseMapStringListCatalogOption
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseMapStringListCatalogOption
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseMapStringListObject
 */
export interface ApiResponseMapStringListObject {
    /**
     * 
     * @type {{ [key: string]: Array<object>; }}
     * @memberof ApiResponseMapStringListObject
     */
    'data'?: { [key: string]: Array<object>; };
    /**
     * 
     * @type {string}
     * @memberof ApiResponseMapStringListObject
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseMapStringListObject
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseMapStringListObject
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseNarrative
 */
export interface ApiResponseNarrative {
    /**
     * 
     * @type {Narrative}
     * @memberof ApiResponseNarrative
     */
    'data'?: Narrative;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseNarrative
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseNarrative
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseNarrative
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseObjectNode
 */
export interface ApiResponseObjectNode {
    /**
     * 
     * @type {object}
     * @memberof ApiResponseObjectNode
     */
    'data'?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseObjectNode
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseObjectNode
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseObjectNode
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponsePolicyDraftCheckView
 */
export interface ApiResponsePolicyDraftCheckView {
    /**
     * 
     * @type {PolicyDraftCheckView}
     * @memberof ApiResponsePolicyDraftCheckView
     */
    'data'?: PolicyDraftCheckView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponsePolicyDraftCheckView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponsePolicyDraftCheckView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponsePolicyDraftCheckView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponsePolicyEditorOptionsView
 */
export interface ApiResponsePolicyEditorOptionsView {
    /**
     * 
     * @type {PolicyEditorOptionsView}
     * @memberof ApiResponsePolicyEditorOptionsView
     */
    'data'?: PolicyEditorOptionsView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponsePolicyEditorOptionsView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponsePolicyEditorOptionsView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponsePolicyEditorOptionsView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponsePolicyReplaced
 */
export interface ApiResponsePolicyReplaced {
    /**
     * 
     * @type {PolicyReplaced}
     * @memberof ApiResponsePolicyReplaced
     */
    'data'?: PolicyReplaced;
    /**
     * 
     * @type {string}
     * @memberof ApiResponsePolicyReplaced
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponsePolicyReplaced
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponsePolicyReplaced
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQualityResponse
 */
export interface ApiResponseQualityResponse {
    /**
     * 
     * @type {QualityResponse}
     * @memberof ApiResponseQualityResponse
     */
    'data'?: QualityResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQualityResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQualityResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQualityResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryAttemptView
 */
export interface ApiResponseQueryAttemptView {
    /**
     * 
     * @type {QueryAttemptView}
     * @memberof ApiResponseQueryAttemptView
     */
    'data'?: QueryAttemptView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryAttemptView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryAttemptView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryAttemptView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryCreationResult
 */
export interface ApiResponseQueryCreationResult {
    /**
     * 
     * @type {QueryCreationResult}
     * @memberof ApiResponseQueryCreationResult
     */
    'data'?: QueryCreationResult;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryCreationResult
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryCreationResult
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryCreationResult
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryManagerSummary
 */
export interface ApiResponseQueryManagerSummary {
    /**
     * 
     * @type {QueryManagerSummary}
     * @memberof ApiResponseQueryManagerSummary
     */
    'data'?: QueryManagerSummary;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryManagerSummary
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryManagerSummary
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryManagerSummary
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryScheduleCheckView
 */
export interface ApiResponseQueryScheduleCheckView {
    /**
     * 
     * @type {QueryScheduleCheckView}
     * @memberof ApiResponseQueryScheduleCheckView
     */
    'data'?: QueryScheduleCheckView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleCheckView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleCheckView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryScheduleCheckView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryScheduleScreenView
 */
export interface ApiResponseQueryScheduleScreenView {
    /**
     * 
     * @type {QueryScheduleScreenView}
     * @memberof ApiResponseQueryScheduleScreenView
     */
    'data'?: QueryScheduleScreenView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleScreenView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleScreenView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryScheduleScreenView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryScheduleTestView
 */
export interface ApiResponseQueryScheduleTestView {
    /**
     * 
     * @type {QueryScheduleTestView}
     * @memberof ApiResponseQueryScheduleTestView
     */
    'data'?: QueryScheduleTestView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleTestView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleTestView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryScheduleTestView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseQueryScheduleVersionView
 */
export interface ApiResponseQueryScheduleVersionView {
    /**
     * 
     * @type {QueryScheduleVersionView}
     * @memberof ApiResponseQueryScheduleVersionView
     */
    'data'?: QueryScheduleVersionView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleVersionView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseQueryScheduleVersionView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseQueryScheduleVersionView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseRole
 */
export interface ApiResponseRole {
    /**
     * 
     * @type {Role}
     * @memberof ApiResponseRole
     */
    'data'?: Role;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseRole
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseRole
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseRole
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseSendToIntakeTriageResponse
 */
export interface ApiResponseSendToIntakeTriageResponse {
    /**
     * 
     * @type {SendToIntakeTriageResponse}
     * @memberof ApiResponseSendToIntakeTriageResponse
     */
    'data'?: SendToIntakeTriageResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSendToIntakeTriageResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSendToIntakeTriageResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseSendToIntakeTriageResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseSourceDocumentInfo
 */
export interface ApiResponseSourceDocumentInfo {
    /**
     * 
     * @type {SourceDocumentInfo}
     * @memberof ApiResponseSourceDocumentInfo
     */
    'data'?: SourceDocumentInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSourceDocumentInfo
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSourceDocumentInfo
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseSourceDocumentInfo
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseSpreadsheetView
 */
export interface ApiResponseSpreadsheetView {
    /**
     * 
     * @type {SpreadsheetView}
     * @memberof ApiResponseSpreadsheetView
     */
    'data'?: SpreadsheetView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSpreadsheetView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSpreadsheetView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseSpreadsheetView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseStudy
 */
export interface ApiResponseStudy {
    /**
     * 
     * @type {Study}
     * @memberof ApiResponseStudy
     */
    'data'?: Study;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudy
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudy
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseStudy
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseStudyCase
 */
export interface ApiResponseStudyCase {
    /**
     * 
     * @type {StudyCase}
     * @memberof ApiResponseStudyCase
     */
    'data'?: StudyCase;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudyCase
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudyCase
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseStudyCase
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseStudyCountryView
 */
export interface ApiResponseStudyCountryView {
    /**
     * 
     * @type {StudyCountryView}
     * @memberof ApiResponseStudyCountryView
     */
    'data'?: StudyCountryView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudyCountryView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudyCountryView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseStudyCountryView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseStudyListingMappingView
 */
export interface ApiResponseStudyListingMappingView {
    /**
     * 
     * @type {StudyListingMappingView}
     * @memberof ApiResponseStudyListingMappingView
     */
    'data'?: StudyListingMappingView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudyListingMappingView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseStudyListingMappingView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseStudyListingMappingView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseSubmissionEnqueueResult
 */
export interface ApiResponseSubmissionEnqueueResult {
    /**
     * 
     * @type {SubmissionEnqueueResult}
     * @memberof ApiResponseSubmissionEnqueueResult
     */
    'data'?: SubmissionEnqueueResult;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSubmissionEnqueueResult
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseSubmissionEnqueueResult
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseSubmissionEnqueueResult
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseTeamResponse
 */
export interface ApiResponseTeamResponse {
    /**
     * 
     * @type {TeamResponse}
     * @memberof ApiResponseTeamResponse
     */
    'data'?: TeamResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseTeamResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseTeamResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseTeamResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseTransitionResult
 */
export interface ApiResponseTransitionResult {
    /**
     * 
     * @type {TransitionResult}
     * @memberof ApiResponseTransitionResult
     */
    'data'?: TransitionResult;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseTransitionResult
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseTransitionResult
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseTransitionResult
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseVoid
 */
export interface ApiResponseVoid {
    /**
     * 
     * @type {object}
     * @memberof ApiResponseVoid
     */
    'data'?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseVoid
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseVoid
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseVoid
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseWhoDrugRecodePreview
 */
export interface ApiResponseWhoDrugRecodePreview {
    /**
     * 
     * @type {WhoDrugRecodePreview}
     * @memberof ApiResponseWhoDrugRecodePreview
     */
    'data'?: WhoDrugRecodePreview;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWhoDrugRecodePreview
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWhoDrugRecodePreview
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseWhoDrugRecodePreview
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseWhoDrugSuggestion
 */
export interface ApiResponseWhoDrugSuggestion {
    /**
     * 
     * @type {WhoDrugSuggestion}
     * @memberof ApiResponseWhoDrugSuggestion
     */
    'data'?: WhoDrugSuggestion;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWhoDrugSuggestion
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWhoDrugSuggestion
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseWhoDrugSuggestion
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseWorkflowResponse
 */
export interface ApiResponseWorkflowResponse {
    /**
     * 
     * @type {WorkflowResponse}
     * @memberof ApiResponseWorkflowResponse
     */
    'data'?: WorkflowResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWorkflowResponse
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWorkflowResponse
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseWorkflowResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiResponseWwidSettingsView
 */
export interface ApiResponseWwidSettingsView {
    /**
     * 
     * @type {WwidSettingsView}
     * @memberof ApiResponseWwidSettingsView
     */
    'data'?: WwidSettingsView;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWwidSettingsView
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResponseWwidSettingsView
     */
    'message'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApiResponseWwidSettingsView
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface AssessmentProductContext
 */
export interface AssessmentProductContext {
    /**
     * 
     * @type {string}
     * @memberof AssessmentProductContext
     */
    'label'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentProductContext
     */
    'primary'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProductContext
     */
    'product_id'?: number;
}
/**
 * 
 * @export
 * @interface AssessmentRelationshipContext
 */
export interface AssessmentRelationshipContext {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AssessmentRelationshipContext
     */
    'daily_med_url_by_datasheet_record_id'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'event_classification'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssessmentRelationshipContext
     */
    'event_detail_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'event_intensity'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'event_lower_level_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'event_preferred_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'event_reported_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'event_seriousness'?: string;
    /**
     * 
     * @type {number}
     * @memberof AssessmentRelationshipContext
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentRelationshipContext
     */
    'product_label'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentRelationshipContext
     */
    'product_primary'?: boolean;
    /**
     * 
     * @type {{ [key: string]: Array<ReferenceDocumentView>; }}
     * @memberof AssessmentRelationshipContext
     */
    'reference_documents_by_datasheet_record_id'?: { [key: string]: Array<ReferenceDocumentView>; };
}
/**
 * 
 * @export
 * @interface AssessmentSectionContext
 */
export interface AssessmentSectionContext {
    /**
     * 
     * @type {Array<AssessmentProductContext>}
     * @memberof AssessmentSectionContext
     */
    'products'?: Array<AssessmentProductContext>;
    /**
     * 
     * @type {{ [key: string]: AssessmentRelationshipContext; }}
     * @memberof AssessmentSectionContext
     */
    'relationships'?: { [key: string]: AssessmentRelationshipContext; };
}
/**
 * 
 * @export
 * @interface AssigneeWorkload
 */
export interface AssigneeWorkload {
    /**
     * 
     * @type {number}
     * @memberof AssigneeWorkload
     */
    'serious_cases'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssigneeWorkload
     */
    'total_cases'?: number;
    /**
     * 
     * @type {number}
     * @memberof AssigneeWorkload
     */
    'user_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AssigneeWorkload
     */
    'user_name'?: string;
}
/**
 * 
 * @export
 * @interface AssignmentRequest
 */
export interface AssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof AssignmentRequest
     */
    'assign_to'?: number;
}
/**
 * 
 * @export
 * @interface AttachmentPartView
 */
export interface AttachmentPartView {
    /**
     * 
     * @type {number}
     * @memberof AttachmentPartView
     */
    'attachment_id': number;
    /**
     * 
     * @type {number}
     * @memberof AttachmentPartView
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AttachmentPartView
     */
    'case_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AttachmentPartView
     */
    'in_exception_queue': boolean;
    /**
     * 
     * @type {number}
     * @memberof AttachmentPartView
     */
    'parent_attachment_id': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AttachmentPartView
     */
    'sheet_names': Array<string>;
}
/**
 * 
 * @export
 * @interface AttemptView
 */
export interface AttemptView {
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'dispatched_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'gateway_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'linked_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'outcome_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'result'?: AttemptViewResultEnum;
    /**
     * 
     * @type {string}
     * @memberof AttemptView
     */
    'submission_id'?: string;
}

export const AttemptViewResultEnum = {
    Accepted: 'ACCEPTED',
    Failed: 'FAILED'
} as const;

export type AttemptViewResultEnum = typeof AttemptViewResultEnum[keyof typeof AttemptViewResultEnum];

/**
 * 
 * @export
 * @interface AuditActionDto
 */
export interface AuditActionDto {
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'actionKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuditActionDto
     */
    'actorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'actorKind'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'actorName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditActionDto
     */
    'actorRoles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'caseNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuditActionDto
     */
    'caseVersion'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'eventName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuditActionDto
     */
    'fieldChangeCount'?: number;
    /**
     * 
     * @type {Array<AuditFieldChangeDto>}
     * @memberof AuditActionDto
     */
    'fieldChanges'?: Array<AuditFieldChangeDto>;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'ipAddress'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuditActionDto
     */
    'legacy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'occurredAt'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AuditActionDto
     */
    'provenance'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'requestMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'requestPath'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'source'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditActionDto
     */
    'tables'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditActionDto
     */
    'txnIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'userAgent'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditActionDto
     */
    'workflowState'?: string;
}
/**
 * 
 * @export
 * @interface AuditCoverageDto
 */
export interface AuditCoverageDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AuditCoverageDto
     */
    'excludedTables'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AuditCoverageDto
     */
    'javaAuditEnabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AuditCoverageDto
     */
    'legacyRowCount'?: number;
}
/**
 * 
 * @export
 * @interface AuditFieldChangeDto
 */
export interface AuditFieldChangeDto {
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'changedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'column'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'eventName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'fieldUiId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuditFieldChangeDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'newDisplay'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'newValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'oldDisplay'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'oldValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'recordPk'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AuditFieldChangeDto
     */
    'stateUnavailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'table'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditFieldChangeDto
     */
    'valueClass'?: string;
}
/**
 * 
 * @export
 * @interface AuditPageDtoAuditActionDto
 */
export interface AuditPageDtoAuditActionDto {
    /**
     * 
     * @type {AuditCoverageDto}
     * @memberof AuditPageDtoAuditActionDto
     */
    'coverage'?: AuditCoverageDto;
    /**
     * 
     * @type {Array<AuditActionDto>}
     * @memberof AuditPageDtoAuditActionDto
     */
    'items'?: Array<AuditActionDto>;
    /**
     * 
     * @type {number}
     * @memberof AuditPageDtoAuditActionDto
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditPageDtoAuditActionDto
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuditPageDtoAuditActionDto
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface AuthorityPolicyDefinition
 */
export interface AuthorityPolicyDefinition {
    /**
     * 
     * @type {string}
     * @memberof AuthorityPolicyDefinition
     */
    'authorityCode'?: string;
    /**
     * 
     * @type {CausalityMapping}
     * @memberof AuthorityPolicyDefinition
     */
    'causality'?: CausalityMapping;
    /**
     * 
     * @type {string}
     * @memberof AuthorityPolicyDefinition
     */
    'clientOrganization'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthorityPolicyDefinition
     */
    'complianceBasis'?: AuthorityPolicyDefinitionComplianceBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof AuthorityPolicyDefinition
     */
    'policyKind'?: AuthorityPolicyDefinitionPolicyKindEnum;
    /**
     * 
     * @type {Array<AuthorityRule>}
     * @memberof AuthorityPolicyDefinition
     */
    'rules'?: Array<AuthorityRule>;
    /**
     * 
     * @type {number}
     * @memberof AuthorityPolicyDefinition
     */
    'schemaVersion'?: number;
    /**
     * 
     * @type {AuthorityScope}
     * @memberof AuthorityPolicyDefinition
     */
    'scope'?: AuthorityScope;
    /**
     * 
     * @type {Array<number>}
     * @memberof AuthorityPolicyDefinition
     */
    'territoryCountryIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AuthorityPolicyDefinition
     */
    'timezone'?: string;
}

export const AuthorityPolicyDefinitionComplianceBasisEnum = {
    AcceptanceDate: 'AcceptanceDate',
    SuccessfulDispatchDate: 'SuccessfulDispatchDate'
} as const;

export type AuthorityPolicyDefinitionComplianceBasisEnum = typeof AuthorityPolicyDefinitionComplianceBasisEnum[keyof typeof AuthorityPolicyDefinitionComplianceBasisEnum];
export const AuthorityPolicyDefinitionPolicyKindEnum = {
    Internal: 'Internal',
    Authority: 'Authority'
} as const;

export type AuthorityPolicyDefinitionPolicyKindEnum = typeof AuthorityPolicyDefinitionPolicyKindEnum[keyof typeof AuthorityPolicyDefinitionPolicyKindEnum];

/**
 * 
 * @export
 * @interface AuthorityRule
 */
export interface AuthorityRule {
    /**
     * 
     * @type {number}
     * @memberof AuthorityRule
     */
    'bufferDays'?: number;
    /**
     * 
     * @type {CalendarPolicy}
     * @memberof AuthorityRule
     */
    'calendarPolicy'?: CalendarPolicy;
    /**
     * 
     * @type {string}
     * @memberof AuthorityRule
     */
    'clockBasis'?: AuthorityRuleClockBasisEnum;
    /**
     * 
     * @type {number}
     * @memberof AuthorityRule
     */
    'clockDays'?: number;
    /**
     * 
     * @type {RuleConditions}
     * @memberof AuthorityRule
     */
    'conditions'?: RuleConditions;
    /**
     * 
     * @type {string}
     * @memberof AuthorityRule
     */
    'followupClock'?: AuthorityRuleFollowupClockEnum;
    /**
     * 
     * @type {number}
     * @memberof AuthorityRule
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthorityRule
     */
    'reportKind'?: AuthorityRuleReportKindEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AuthorityRule
     */
    'requiredReferenceIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof AuthorityRule
     */
    'route'?: AuthorityRuleRouteEnum;
}

export const AuthorityRuleClockBasisEnum = {
    InitialReceiptDate: 'INITIAL_RECEIPT_DATE',
    ArrivalReceiptDate: 'ARRIVAL_RECEIPT_DATE'
} as const;

export type AuthorityRuleClockBasisEnum = typeof AuthorityRuleClockBasisEnum[keyof typeof AuthorityRuleClockBasisEnum];
export const AuthorityRuleFollowupClockEnum = {
    None: 'NONE',
    SignificantArrival: 'SIGNIFICANT_ARRIVAL',
    EveryArrival: 'EVERY_ARRIVAL'
} as const;

export type AuthorityRuleFollowupClockEnum = typeof AuthorityRuleFollowupClockEnum[keyof typeof AuthorityRuleFollowupClockEnum];
export const AuthorityRuleReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type AuthorityRuleReportKindEnum = typeof AuthorityRuleReportKindEnum[keyof typeof AuthorityRuleReportKindEnum];
export const AuthorityRuleRouteEnum = {
    Expedited: 'Expedited',
    Periodic: 'Periodic',
    None: 'None',
    Pending: 'Pending'
} as const;

export type AuthorityRuleRouteEnum = typeof AuthorityRuleRouteEnum[keyof typeof AuthorityRuleRouteEnum];

/**
 * 
 * @export
 * @interface AuthorityScope
 */
export interface AuthorityScope {
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthorityScope
     */
    'studyIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface AuthoritySubmissionStatus
 */
export interface AuthoritySubmissionStatus {
    /**
     * 
     * @type {number}
     * @memberof AuthoritySubmissionStatus
     */
    'due_soon'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuthoritySubmissionStatus
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthoritySubmissionStatus
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof AuthoritySubmissionStatus
     */
    'late'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuthoritySubmissionStatus
     */
    'on_time'?: number;
    /**
     * 
     * @type {number}
     * @memberof AuthoritySubmissionStatus
     */
    'overdue'?: number;
}
/**
 * 
 * @export
 * @interface BoundingBox
 */
export interface BoundingBox {
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'x0'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'x1'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'y0'?: number;
    /**
     * 
     * @type {number}
     * @memberof BoundingBox
     */
    'y1'?: number;
}
/**
 * 
 * @export
 * @interface C3Atc
 */
export interface C3Atc {
    /**
     * 
     * @type {string}
     * @memberof C3Atc
     */
    'assignmentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Atc
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Atc
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Atc
     */
    'level'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Atc
     */
    'rid'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Atc
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface C3Candidate
 */
export interface C3Candidate {
    /**
     * 
     * @type {Array<C3Ingredient>}
     * @memberof C3Candidate
     */
    'ingredients'?: Array<C3Ingredient>;
    /**
     * 
     * @type {C3Record}
     * @memberof C3Candidate
     */
    'record'?: C3Record;
}
/**
 * 
 * @export
 * @interface C3Ingredient
 */
export interface C3Ingredient {
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'casNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof C3Ingredient
     */
    'quantity'?: number;
    /**
     * 
     * @type {number}
     * @memberof C3Ingredient
     */
    'quantity2'?: number;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'quantity2UnitText'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'quantityUnitText'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'rid'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'substanceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'substanceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'unitId'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Ingredient
     */
    'unitText'?: string;
}
/**
 * 
 * @export
 * @interface C3Record
 */
export interface C3Record {
    /**
     * 
     * @type {boolean}
     * @memberof C3Record
     */
    'archived'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'countryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'drugCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'drugName'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'drugRecordNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'formId'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'formText'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'mahId'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'mahName'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'nameSpecifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'productTypeId'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'productTypeText'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'rid'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'sequence1'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'sequence2'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'sourceFields'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'strengthId'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'strengthText'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Record
     */
    'substanceOrSynonym'?: string;
}
/**
 * 
 * @export
 * @interface C3Release
 */
export interface C3Release {
    /**
     * 
     * @type {string}
     * @memberof C3Release
     */
    'distributionKind'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Release
     */
    'e2bVersion'?: string;
    /**
     * 
     * @type {number}
     * @memberof C3Release
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof C3Release
     */
    'officialVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof C3Release
     */
    'shortVersion'?: string;
}
/**
 * 
 * @export
 * @interface CalendarPolicy
 */
export interface CalendarPolicy {
    /**
     * 
     * @type {string}
     * @memberof CalendarPolicy
     */
    'adjustment'?: CalendarPolicyAdjustmentEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarPolicy
     */
    'holidays'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CalendarPolicy
     */
    'nonWorkingDays'?: Array<CalendarPolicyNonWorkingDaysEnum>;
}

export const CalendarPolicyAdjustmentEnum = {
    None: 'None',
    PreviousWorkingDay: 'PreviousWorkingDay',
    NextWorkingDay: 'NextWorkingDay'
} as const;

export type CalendarPolicyAdjustmentEnum = typeof CalendarPolicyAdjustmentEnum[keyof typeof CalendarPolicyAdjustmentEnum];
export const CalendarPolicyNonWorkingDaysEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type CalendarPolicyNonWorkingDaysEnum = typeof CalendarPolicyNonWorkingDaysEnum[keyof typeof CalendarPolicyNonWorkingDaysEnum];

/**
 * 
 * @export
 * @interface Case
 */
export interface Case {
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'assignedUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'caseNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'caseStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'caseType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'caseVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'clientOrganization'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'closureTimerStart'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'createdBy'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Case
     */
    'customFields'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'dueDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'duplicateAnalysisOutcome'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'duplicateReviewPriorStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'firstSenderType'?: string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'followupNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    'isDuplicate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    'isLocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    'isReadOnly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Case
     */
    'isSynthetic'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'lockedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'parentId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'priority'?: number;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'reportType'?: number;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'rowVersion'?: number;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'senderReportUid'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'workflowStage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'workflowStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof Case
     */
    'workflowVersion'?: number;
    /**
     * 
     * @type {string}
     * @memberof Case
     */
    'wwid'?: string;
}
/**
 * 
 * @export
 * @interface CaseAttachmentView
 */
export interface CaseAttachmentView {
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'contentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'displayName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'documentType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'fileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'origin'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseAttachmentView
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseAttachmentView
     */
    'sourceCaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseAttachmentView
     */
    'sourceCaseNumber'?: string;
}
/**
 * 
 * @export
 * @interface CaseContactLog
 */
export interface CaseContactLog {
    /**
     * 
     * @type {number}
     * @memberof CaseContactLog
     */
    'caseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'completionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'groupName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseContactLog
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'initiationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'sentDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseContactLog
     */
    'userName'?: string;
}
/**
 * 
 * @export
 * @interface CaseDeadlineSummaryView
 */
export interface CaseDeadlineSummaryView {
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'calculation_state'?: CaseDeadlineSummaryViewCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'completion_state'?: CaseDeadlineSummaryViewCompletionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'deadline_status'?: CaseDeadlineSummaryViewDeadlineStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'earliest_regulatory_authority_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'earliest_regulatory_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'earliest_regulatory_due_timezone'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseDeadlineSummaryView
     */
    'earliest_regulatory_result_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'internal_due_authority_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'internal_due_report_kind'?: CaseDeadlineSummaryViewInternalDueReportKindEnum;
    /**
     * 
     * @type {number}
     * @memberof CaseDeadlineSummaryView
     */
    'internal_due_result_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlineSummaryView
     */
    'internal_due_timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseDeadlineSummaryView
     */
    'listedness_assumed'?: boolean;
    /**
     * 
     * @type {Array<MissingInputView>}
     * @memberof CaseDeadlineSummaryView
     */
    'missing_inputs'?: Array<MissingInputView>;
    /**
     * 
     * @type {number}
     * @memberof CaseDeadlineSummaryView
     */
    'remaining_days'?: number;
}

export const CaseDeadlineSummaryViewCalculationStateEnum = {
    Calculated: 'Calculated',
    Partial: 'Partial',
    Pending: 'Pending'
} as const;

export type CaseDeadlineSummaryViewCalculationStateEnum = typeof CaseDeadlineSummaryViewCalculationStateEnum[keyof typeof CaseDeadlineSummaryViewCalculationStateEnum];
export const CaseDeadlineSummaryViewCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type CaseDeadlineSummaryViewCompletionStateEnum = typeof CaseDeadlineSummaryViewCompletionStateEnum[keyof typeof CaseDeadlineSummaryViewCompletionStateEnum];
export const CaseDeadlineSummaryViewDeadlineStatusEnum = {
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn',
    Pending: 'Pending',
    Overdue: 'Overdue',
    DueSoon: 'Due soon',
    OnTrack: 'On track'
} as const;

export type CaseDeadlineSummaryViewDeadlineStatusEnum = typeof CaseDeadlineSummaryViewDeadlineStatusEnum[keyof typeof CaseDeadlineSummaryViewDeadlineStatusEnum];
export const CaseDeadlineSummaryViewInternalDueReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type CaseDeadlineSummaryViewInternalDueReportKindEnum = typeof CaseDeadlineSummaryViewInternalDueReportKindEnum[keyof typeof CaseDeadlineSummaryViewInternalDueReportKindEnum];

/**
 * 
 * @export
 * @interface CaseDeadlinesView
 */
export interface CaseDeadlinesView {
    /**
     * 
     * @type {number}
     * @memberof CaseDeadlinesView
     */
    'case_revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseDeadlinesView
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {Array<DeadlineResultView>}
     * @memberof CaseDeadlinesView
     */
    'results'?: Array<DeadlineResultView>;
    /**
     * 
     * @type {CaseDeadlineSummaryView}
     * @memberof CaseDeadlinesView
     */
    'summary'?: CaseDeadlineSummaryView;
}
/**
 * 
 * @export
 * @interface CaseEventDetails
 */
export interface CaseEventDetails {
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'adverse_drug_withdrawal_reaction'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseEventDetails
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'coded_term'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEventDetails
     */
    'country_event_occurred'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'created_at'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof CaseEventDetails
     */
    'custom_fields'?: { [key: string]: object; };
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'dropped_from_study_due_to_event'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'duration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'emergency_room_visit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseEventDetails
     */
    'event_classification'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'high_level_group_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'high_level_group_term_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'high_level_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'high_level_term_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEventDetails
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'infection'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseEventDetails
     */
    'intensity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'is_serious'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'lack_of_efficacy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'lower_level_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'lower_level_term_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'meddra_coding'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'medical_confirmation_by_hcp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'onset_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'onset_from_last_dose'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'onset_latency'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEventDetails
     */
    'outcome_of_event'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'patient_has_prior_history'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'physician_office_visit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'preferred_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'preferred_term_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'progression_of_disease'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'receipt_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'related_to_study_conduct'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'related_to_study_conduct_reported'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'reported_term_verbatim'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'seriousness_criteria'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'seriousness_criteria_other'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'soc'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'soc_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'stop_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'term_highlighted_by_reporter'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseEventDetails
     */
    'treatment_received'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseEventDetails
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CaseEventView
 */
export interface CaseEventView {
    /**
     * 
     * @type {string}
     * @memberof CaseEventView
     */
    'actorName'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEventView
     */
    'actorUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseEventView
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventView
     */
    'eventType'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseEventView
     */
    'fromStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEventView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseEventView
     */
    'reason'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseEventView
     */
    'seq'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseEventView
     */
    'toStatus'?: string;
}
/**
 * 
 * @export
 * @interface CaseInfoContext
 */
export interface CaseInfoContext {
    /**
     * 
     * @type {Array<CatalogRowContext>}
     * @memberof CaseInfoContext
     */
    'case_external_identifiers'?: Array<CatalogRowContext>;
    /**
     * 
     * @type {object}
     * @memberof CaseInfoContext
     */
    'case_external_identifiers_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof CaseInfoContext
     */
    'cross_reported_inds_schema'?: object;
    /**
     * 
     * @type {string}
     * @memberof CaseInfoContext
     */
    'current_followup_attached_by'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseInfoContext
     */
    'e2b_enabled'?: boolean;
    /**
     * 
     * @type {Array<CatalogRowContext>}
     * @memberof CaseInfoContext
     */
    'literature'?: Array<CatalogRowContext>;
    /**
     * 
     * @type {object}
     * @memberof CaseInfoContext
     */
    'literature_schema'?: object;
    /**
     * 
     * @type {Array<CaseInfoPreviousFollowup>}
     * @memberof CaseInfoContext
     */
    'previous_followups'?: Array<CaseInfoPreviousFollowup>;
    /**
     * 
     * @type {Array<CaseReportTypeMetadata>}
     * @memberof CaseInfoContext
     */
    'report_types'?: Array<CaseReportTypeMetadata>;
    /**
     * 
     * @type {{ [key: string]: CatalogFieldRequirement; }}
     * @memberof CaseInfoContext
     */
    'requirements'?: { [key: string]: CatalogFieldRequirement; };
    /**
     * 
     * @type {object}
     * @memberof CaseInfoContext
     */
    'schema'?: object;
}
/**
 * 
 * @export
 * @interface CaseInfoPreviousFollowup
 */
export interface CaseInfoPreviousFollowup {
    /**
     * 
     * @type {boolean}
     * @memberof CaseInfoPreviousFollowup
     */
    'amendment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseInfoPreviousFollowup
     */
    'answers_query_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseInfoPreviousFollowup
     */
    'attached_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseInfoPreviousFollowup
     */
    'attached_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseInfoPreviousFollowup
     */
    'case_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseInfoPreviousFollowup
     */
    'justification'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseInfoPreviousFollowup
     */
    'significance_justification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseInfoPreviousFollowup
     */
    'significant'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseInfoPreviousFollowup
     */
    'subtype_id'?: number;
}
/**
 * 
 * @export
 * @interface CaseLinkResponse
 */
export interface CaseLinkResponse {
    /**
     * 
     * @type {number}
     * @memberof CaseLinkResponse
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseLinkResponse
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseLinkResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseLinkResponse
     */
    'created_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseLinkResponse
     */
    'created_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseLinkResponse
     */
    'justification'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseLinkResponse
     */
    'link_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseLinkResponse
     */
    'link_type'?: string;
}
/**
 * 
 * @export
 * @interface CaseListResponse
 */
export interface CaseListResponse {
    /**
     * 
     * @type {Array<CaseRow>}
     * @memberof CaseListResponse
     */
    'items'?: Array<CaseRow>;
    /**
     * 
     * @type {boolean}
     * @memberof CaseListResponse
     */
    'no_accessible_stages'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    'page_size'?: number;
    /**
     * 
     * @type {CaseListSummary}
     * @memberof CaseListResponse
     */
    'summary'?: CaseListSummary;
    /**
     * 
     * @type {TabCounts}
     * @memberof CaseListResponse
     */
    'tab_counts'?: TabCounts;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    'total'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListResponse
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface CaseListSummary
 */
export interface CaseListSummary {
    /**
     * 
     * @type {number}
     * @memberof CaseListSummary
     */
    'dueSoon'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListSummary
     */
    'duplicates'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListSummary
     */
    'nonSerious'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListSummary
     */
    'serious'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseListSummary
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface CaseMixSegment
 */
export interface CaseMixSegment {
    /**
     * 
     * @type {number}
     * @memberof CaseMixSegment
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseMixSegment
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseMixSegment
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseMixSegment
     */
    'seriousness'?: string;
}
/**
 * 
 * @export
 * @interface CaseNotesAndAttachment
 */
export interface CaseNotesAndAttachment {
    /**
     * 
     * @type {number}
     * @memberof CaseNotesAndAttachment
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseNotesAndAttachment
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNotesAndAttachment
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNotesAndAttachment
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseNotesAndAttachment
     */
    'date_added'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseNotesAndAttachment
     */
    'followup_version'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseNotesAndAttachment
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseNotesAndAttachment
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CaseReportTypeMetadata
 */
export interface CaseReportTypeMetadata {
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseReportTypeMetadata
     */
    'categories'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CaseReportTypeMetadata
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CaseRow
 */
export interface CaseRow {
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'assign_stage'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseRow
     */
    'attachment_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'calculation_state'?: CaseRowCalculationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof CaseRow
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'case_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'country_event_occurred'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'deadline_status'?: CaseRowDeadlineStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'due_calculation_state'?: CaseRowDueCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'due_completion_state'?: CaseRowDueCompletionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'due_date_time'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseRow
     */
    'duplicate_match_score'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'duplicate_reason'?: CaseRowDuplicateReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'earliest_regulatory_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'earliest_regulatory_due_timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseRow
     */
    'followup_take_in_pending'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'initial_receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'internal_due_timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CaseRow
     */
    'is_duplicate'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CaseRow
     */
    'listedness_assumed'?: boolean;
    /**
     * 
     * @type {Array<MissingInputView>}
     * @memberof CaseRow
     */
    'missing_inputs'?: Array<MissingInputView>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseRow
     */
    'pifu_identifier_types'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CaseRow
     */
    'pifu_parent_case_numbers'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'primary_product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'primary_source_country'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseRow
     */
    'query_badge_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'seriousness'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseRow
     */
    'source_booking_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'source_file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseRow
     */
    'workflow_status'?: string;
}

export const CaseRowCalculationStateEnum = {
    Calculated: 'Calculated',
    Partial: 'Partial',
    Pending: 'Pending'
} as const;

export type CaseRowCalculationStateEnum = typeof CaseRowCalculationStateEnum[keyof typeof CaseRowCalculationStateEnum];
export const CaseRowDeadlineStatusEnum = {
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn',
    Pending: 'Pending',
    Overdue: 'Overdue',
    DueSoon: 'Due soon',
    OnTrack: 'On track'
} as const;

export type CaseRowDeadlineStatusEnum = typeof CaseRowDeadlineStatusEnum[keyof typeof CaseRowDeadlineStatusEnum];
export const CaseRowDueCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type CaseRowDueCalculationStateEnum = typeof CaseRowDueCalculationStateEnum[keyof typeof CaseRowDueCalculationStateEnum];
export const CaseRowDueCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type CaseRowDueCompletionStateEnum = typeof CaseRowDueCompletionStateEnum[keyof typeof CaseRowDueCompletionStateEnum];
export const CaseRowDuplicateReasonEnum = {
    Pifu: 'PIFU',
    PossibleDuplicate: 'POSSIBLE_DUPLICATE'
} as const;

export type CaseRowDuplicateReasonEnum = typeof CaseRowDuplicateReasonEnum[keyof typeof CaseRowDuplicateReasonEnum];

/**
 * 
 * @export
 * @interface CaseSummary
 */
export interface CaseSummary {
    /**
     * 
     * @type {number}
     * @memberof CaseSummary
     */
    'case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseSummary
     */
    'case_outcome'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'case_outcome_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'case_seriousness'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'case_seriousness_notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseSummary
     */
    'company_agent_causal'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'company_agent_causal_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CaseSummary
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseSummary
     */
    'listedness_determination'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'listedness_determination_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSummary
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CaseSummaryRef
 */
export interface CaseSummaryRef {
    /**
     * 
     * @type {number}
     * @memberof CaseSummaryRef
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CaseSummaryRef
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseSummaryRef
     */
    'workflow_status'?: string;
}
/**
 * 
 * @export
 * @interface CaseWorkflowStatusResponse
 */
export interface CaseWorkflowStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof CaseWorkflowStatusResponse
     */
    'current_stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseWorkflowStatusResponse
     */
    'next_stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseWorkflowStatusResponse
     */
    'previous_stage'?: string;
    /**
     * 
     * @type {Array<WorkflowStageEntry>}
     * @memberof CaseWorkflowStatusResponse
     */
    'workflow_status'?: Array<WorkflowStageEntry>;
}
/**
 * 
 * @export
 * @interface CaseWwidView
 */
export interface CaseWwidView {
    /**
     * 
     * @type {string}
     * @memberof CaseWwidView
     */
    'wwid'?: string;
}
/**
 * 
 * @export
 * @interface CatalogCapabilities
 */
export interface CatalogCapabilities {
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCapabilities
     */
    'can_accept_field_review'?: boolean;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof CatalogCapabilities
     */
    'fields'?: { [key: string]: boolean; };
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCapabilities
     */
    'section_editable'?: boolean;
}
/**
 * 
 * @export
 * @interface CatalogCaseHeader
 */
export interface CatalogCaseHeader {
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'assignee_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCaseHeader
     */
    'awaiting_take_in'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogCaseHeader
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'case_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'current_stage'?: string;
    /**
     * 
     * @type {CaseDeadlineSummaryView}
     * @memberof CatalogCaseHeader
     */
    'deadline_summary'?: CaseDeadlineSummaryView;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'due_date_time'?: string;
    /**
     * 
     * @type {InternalDeadlineView}
     * @memberof CatalogCaseHeader
     */
    'internal_deadline'?: InternalDeadlineView;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'last_modified'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCaseHeader
     */
    'locked'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'locked_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'next_stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'previous_stage'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCaseHeader
     */
    'read_only'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogCaseHeader
     */
    'remaining_days'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCaseHeader
     */
    'serious'?: boolean;
    /**
     * 
     * @type {Array<WorkflowStageEntry>}
     * @memberof CatalogCaseHeader
     */
    'stages'?: Array<WorkflowStageEntry>;
    /**
     * 
     * @type {string}
     * @memberof CatalogCaseHeader
     */
    'wwid'?: string;
}
/**
 * One row of a repeatable collection; the type depends on the collection.
 * @export
 * @interface CatalogCollectionRecord
 */
export interface CatalogCollectionRecord {
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'issuer'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'coding_dictionary'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'continuing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'disease_coded_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'disease_term'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'disease_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'event_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'family_history'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'meddra_coding'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'medical_history_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'start_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'ongoing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'reaction'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'drug_reaction'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'indication'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'name_of_drug_as_reported'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'indication_coded_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'stop_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'interpretation'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'normal_high'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'normal_low'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'reference_range'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'reported_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'result_unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'test_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'test_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'units'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'address_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'address_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'country'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'degree'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'department'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'first_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'health_care_professional'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'institution_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'intermediary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'middle_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'occupation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'postal_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'protect_confidentiality'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'reference_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'relationship_to_patient'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'report_media'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'report_sent_to_authority'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'reporter_type'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'salutation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'suffix'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'abuse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'accidental_exposure'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'action_taken'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'additional_comments'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'authorization_country'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'authorization_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'authorization_type'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'batch_lot_not_within_specs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'batch_lot_within_specs'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'company_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'concentration'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'concentration_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'configuration_product_id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'counterfeit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'dechallenge'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'dechallenge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'description'?: string;
    /**
     * 
     * @type {Array<FwkGenDosageRegimensRecord>}
     * @memberof CatalogCollectionRecord
     */
    'dosage_regimens'?: Array<FwkGenDosageRegimensRecord>;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'drug_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'drug_not_administered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'duration_first_dose_to_event'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'duration_first_dose_to_event_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'duration_last_dose_to_event'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'duration_last_dose_to_event_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'duration_of_administration'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'duration_of_administration_unit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'expired_drug_used'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'father_exposed_to_drug'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'fda_additional_info'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'formulation'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'generic_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'gestational_period_at_exposure'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'has_interaction'?: boolean;
    /**
     * 
     * @type {Array<FwkGenIndicationsRecord>}
     * @memberof CatalogCollectionRecord
     */
    'indications'?: Array<FwkGenIndicationsRecord>;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'is_contraindicated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'is_study_drug'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'manufacturer_holder'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'market_authorization_holder'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'medication_error'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'misuse'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'ndc_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'obtain_drug_country'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'occupational_exposure'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'off_label_use'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'overdose'?: boolean;
    /**
     * 
     * @type {Array<FwkGenPartsRecord>}
     * @memberof CatalogCollectionRecord
     */
    'parts'?: Array<FwkGenPartsRecord>;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'product_role'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'product_type'?: number;
    /**
     * 
     * @type {FwkGenQualityControlObject}
     * @memberof CatalogCollectionRecord
     */
    'quality_control'?: FwkGenQualityControlObject;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'rechallenge'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'rechallenge_date'?: string;
    /**
     * 
     * @type {Array<FwkGenSubstancesRecord>}
     * @memberof CatalogCollectionRecord
     */
    'substances'?: Array<FwkGenSubstancesRecord>;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'taken_previously_tolerated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'tampering'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'trade_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogCollectionRecord
     */
    'was_protocol_followed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'batch_lot_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'dose'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'dose_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'dose_number'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'dose_unit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'frequency'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'parent_administration_route'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'patient_administration_route'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'total_dose'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'total_dose_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'strength'?: number;
    /**
     * 
     * @type {number}
     * @memberof CatalogCollectionRecord
     */
    'strength_unit'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'substance_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'substance_term_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'llt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'pt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'name_part'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'name_part_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'cid_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'lot_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'pcid_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'qc_comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'qc_result'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogCollectionRecord
     */
    'qc_result_date'?: string;
}
/**
 * 
 * @export
 * @interface CatalogFieldProvenance
 */
export interface CatalogFieldProvenance {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CatalogFieldProvenance
     */
    'annotation_strategy_config'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldProvenance
     */
    'annotation_strategy_type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFieldProvenance
     */
    'box_ids'?: Array<string>;
    /**
     * 
     * @type {SourceLocation}
     * @memberof CatalogFieldProvenance
     */
    'preferred_source_location'?: SourceLocation;
    /**
     * 
     * @type {Array<SourceLocation>}
     * @memberof CatalogFieldProvenance
     */
    'source_locations'?: Array<SourceLocation>;
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldProvenance
     */
    'source_text'?: string;
}
/**
 * 
 * @export
 * @interface CatalogFieldRequirement
 */
export interface CatalogFieldRequirement {
    /**
     * 
     * @type {boolean}
     * @memberof CatalogFieldRequirement
     */
    'e2b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogFieldRequirement
     */
    'mandatory'?: boolean;
}
/**
 * 
 * @export
 * @interface CatalogFieldState
 */
export interface CatalogFieldState {
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldState
     */
    'assessed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldState
     */
    'confidence'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CatalogFieldState
     */
    'evidence'?: Array<string>;
    /**
     * Why the pending extracted value was not stored, when it was not (#400); null otherwise
     * @type {ExtractedValueProblem}
     * @memberof CatalogFieldState
     */
    'extracted_value_problem'?: ExtractedValueProblem;
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldState
     */
    'model'?: string;
    /**
     * 
     * @type {CatalogFieldStateNormalizedExtractedValue}
     * @memberof CatalogFieldState
     */
    'normalized_extracted_value'?: CatalogFieldStateNormalizedExtractedValue | null;
    /**
     * Whether normalized_extracted_value is safe to use for mutation; true also permits a genuine null
     * @type {boolean}
     * @memberof CatalogFieldState
     */
    'normalized_extracted_value_available'?: boolean;
    /**
     * 
     * @type {CatalogFieldProvenance}
     * @memberof CatalogFieldState
     */
    'provenance'?: CatalogFieldProvenance | null;
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldState
     */
    'reasoning'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogFieldState
     */
    'review_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldState
     */
    'review_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFieldState
     */
    'source'?: string;
}
/**
 * @type CatalogFieldStateNormalizedExtractedValue
 * The original extracted value normalized to this field\'s API type
 * @export
 */
export type CatalogFieldStateNormalizedExtractedValue = boolean | number | object | string;

/**
 * 
 * @export
 * @interface CatalogFinding
 */
export interface CatalogFinding {
    /**
     * 
     * @type {string}
     * @memberof CatalogFinding
     */
    'field_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFinding
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFinding
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFinding
     */
    'owner_record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFinding
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CatalogFinding
     */
    'severity'?: CatalogFindingSeverityEnum;
}

export const CatalogFindingSeverityEnum = {
    Error: 'ERROR',
    Warning: 'WARNING',
    Info: 'INFO'
} as const;

export type CatalogFindingSeverityEnum = typeof CatalogFindingSeverityEnum[keyof typeof CatalogFindingSeverityEnum];

/**
 * 
 * @export
 * @interface CatalogOption
 */
export interface CatalogOption {
    /**
     * 
     * @type {boolean}
     * @memberof CatalogOption
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CatalogOption
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CatalogOption
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface CatalogReviewPatchRequest
 */
export interface CatalogReviewPatchRequest {
    /**
     * Page-agent proposals the reviewer decided in this save; one entry per field
     * @type {Array<AgentProposalDecision>}
     * @memberof CatalogReviewPatchRequest
     */
    'agent_proposals'?: Array<AgentProposalDecision>;
    /**
     * 
     * @type {string}
     * @memberof CatalogReviewPatchRequest
     */
    'catalog_version'?: string;
    /**
     * The token of a 409 DEADLINE_CHANGE_REQUIRES_CONFIRMATION answer. It confirms the date changes of that answer, so that the same save commits (decision 16).
     * @type {string}
     * @memberof CatalogReviewPatchRequest
     */
    'deadline_change_token'?: string;
    /**
     * 
     * @type {Array<FollowupFieldChoice>}
     * @memberof CatalogReviewPatchRequest
     */
    'followup_decisions'?: Array<FollowupFieldChoice>;
    /**
     * 
     * @type {Array<FollowupRecordChoice>}
     * @memberof CatalogReviewPatchRequest
     */
    'followup_records'?: Array<FollowupRecordChoice>;
    /**
     * 
     * @type {number}
     * @memberof CatalogReviewPatchRequest
     */
    'revision': number;
    /**
     * 
     * @type {{ [key: string]: SectionChange; }}
     * @memberof CatalogReviewPatchRequest
     */
    'sections': { [key: string]: SectionChange; };
}
/**
 * 
 * @export
 * @interface CatalogReviewResponse
 */
export interface CatalogReviewResponse {
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogReviewResponse
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogReviewResponse
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {FollowupReviewView}
     * @memberof CatalogReviewResponse
     */
    'followups'?: FollowupReviewView;
    /**
     * 
     * @type {number}
     * @memberof CatalogReviewResponse
     */
    'revision'?: number;
    /**
     * 
     * @type {CatalogReviewSections}
     * @memberof CatalogReviewResponse
     */
    'sections'?: CatalogReviewSections;
}
/**
 * 
 * @export
 * @interface CatalogReviewSections
 */
export interface CatalogReviewSections {
    /**
     * 
     * @type {CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext}
     * @memberof CatalogReviewSections
     */
    'case.assessment'?: CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext;
    /**
     * 
     * @type {CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext}
     * @memberof CatalogReviewSections
     */
    'case.case_details'?: CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext;
    /**
     * 
     * @type {CatalogSectionResponseFwkGenEventEventsContext}
     * @memberof CatalogReviewSections
     */
    'case.event'?: CatalogSectionResponseFwkGenEventEventsContext;
    /**
     * 
     * @type {CatalogSectionResponseFwkGenNarrativeNarrativeContext}
     * @memberof CatalogReviewSections
     */
    'case.narrative'?: CatalogSectionResponseFwkGenNarrativeNarrativeContext;
    /**
     * 
     * @type {CatalogSectionResponseJsonNodeParentContext}
     * @memberof CatalogReviewSections
     */
    'case.parent'?: CatalogSectionResponseJsonNodeParentContext;
    /**
     * 
     * @type {CatalogSectionResponseJsonNodePatientContext}
     * @memberof CatalogReviewSections
     */
    'case.patient'?: CatalogSectionResponseJsonNodePatientContext;
    /**
     * 
     * @type {CatalogSectionResponseJsonNodeProductsContext}
     * @memberof CatalogReviewSections
     */
    'case.product'?: CatalogSectionResponseJsonNodeProductsContext;
    /**
     * 
     * @type {CatalogSectionResponseObjectNodeReferencesContext}
     * @memberof CatalogReviewSections
     */
    'case.references'?: CatalogSectionResponseObjectNodeReferencesContext;
    /**
     * 
     * @type {CatalogSectionResponseJsonNodeReportersContext}
     * @memberof CatalogReviewSections
     */
    'case.reporter'?: CatalogSectionResponseJsonNodeReportersContext;
    /**
     * 
     * @type {CatalogSectionResponseFwkGenSummarySummaryContext}
     * @memberof CatalogReviewSections
     */
    'case.summary'?: CatalogSectionResponseFwkGenSummarySummaryContext;
}
/**
 * 
 * @export
 * @interface CatalogRouteForwardRequest
 */
export interface CatalogRouteForwardRequest {
    /**
     * 
     * @type {string}
     * @memberof CatalogRouteForwardRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogRouteForwardRequest
     */
    'revision': number;
}
/**
 * 
 * @export
 * @interface CatalogRouteReadinessRequest
 */
export interface CatalogRouteReadinessRequest {
    /**
     * 
     * @type {number}
     * @memberof CatalogRouteReadinessRequest
     */
    'revision': number;
}
/**
 * 
 * @export
 * @interface CatalogRouteReadinessResponse
 */
export interface CatalogRouteReadinessResponse {
    /**
     * 
     * @type {Array<CatalogFinding>}
     * @memberof CatalogRouteReadinessResponse
     */
    'findings'?: Array<CatalogFinding>;
    /**
     * 
     * @type {boolean}
     * @memberof CatalogRouteReadinessResponse
     */
    'ready'?: boolean;
}
/**
 * 
 * @export
 * @interface CatalogRowContext
 */
export interface CatalogRowContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof CatalogRowContext
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface CatalogSavedReviewResponse
 */
export interface CatalogSavedReviewResponse {
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSavedReviewResponse
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSavedReviewResponse
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {number}
     * @memberof CatalogSavedReviewResponse
     */
    'revision'?: number;
    /**
     * 
     * @type {{ [key: string]: CatalogSavedSection; }}
     * @memberof CatalogSavedReviewResponse
     */
    'sections'?: { [key: string]: CatalogSavedSection; };
}
/**
 * 
 * @export
 * @interface CatalogSavedSection
 */
export interface CatalogSavedSection {
    /**
     * 
     * @type {object}
     * @memberof CatalogSavedSection
     */
    'context'?: object;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSavedSection
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {object}
     * @memberof CatalogSavedSection
     */
    'schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof CatalogSavedSection
     */
    'values'?: object;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
 */
export interface CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {AssessmentSectionContext}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'context'?: AssessmentSectionContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'revision'?: number;
    /**
     * 
     * @type {FwkGenAssessment}
     * @memberof CatalogSectionResponseFwkGenAssessmentAssessmentSectionContext
     */
    'values'?: FwkGenAssessment;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
 */
export interface CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {CaseInfoContext}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'context'?: CaseInfoContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'revision'?: number;
    /**
     * 
     * @type {FwkGenCaseDetails}
     * @memberof CatalogSectionResponseFwkGenCaseDetailsCaseInfoContext
     */
    'values'?: FwkGenCaseDetails;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseFwkGenEventEventsContext
 */
export interface CatalogSectionResponseFwkGenEventEventsContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {EventsContext}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'context'?: EventsContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'revision'?: number;
    /**
     * 
     * @type {FwkGenEvent}
     * @memberof CatalogSectionResponseFwkGenEventEventsContext
     */
    'values'?: FwkGenEvent;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseFwkGenNarrativeNarrativeContext
 */
export interface CatalogSectionResponseFwkGenNarrativeNarrativeContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {NarrativeContext}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'context'?: NarrativeContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'revision'?: number;
    /**
     * 
     * @type {FwkGenNarrative}
     * @memberof CatalogSectionResponseFwkGenNarrativeNarrativeContext
     */
    'values'?: FwkGenNarrative;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseFwkGenSummarySummaryContext
 */
export interface CatalogSectionResponseFwkGenSummarySummaryContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {SummaryContext}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'context'?: SummaryContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'revision'?: number;
    /**
     * 
     * @type {FwkGenSummary}
     * @memberof CatalogSectionResponseFwkGenSummarySummaryContext
     */
    'values'?: FwkGenSummary;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseJsonNodeParentContext
 */
export interface CatalogSectionResponseJsonNodeParentContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {ParentContext}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'context'?: ParentContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'revision'?: number;
    /**
     * 
     * @type {object}
     * @memberof CatalogSectionResponseJsonNodeParentContext
     */
    'values'?: object;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseJsonNodePatientContext
 */
export interface CatalogSectionResponseJsonNodePatientContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {PatientContext}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'context'?: PatientContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'revision'?: number;
    /**
     * 
     * @type {object}
     * @memberof CatalogSectionResponseJsonNodePatientContext
     */
    'values'?: object;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseJsonNodeProductsContext
 */
export interface CatalogSectionResponseJsonNodeProductsContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {ProductsContext}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'context'?: ProductsContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'revision'?: number;
    /**
     * 
     * @type {object}
     * @memberof CatalogSectionResponseJsonNodeProductsContext
     */
    'values'?: object;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseJsonNodeReportersContext
 */
export interface CatalogSectionResponseJsonNodeReportersContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {ReportersContext}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'context'?: ReportersContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'revision'?: number;
    /**
     * 
     * @type {object}
     * @memberof CatalogSectionResponseJsonNodeReportersContext
     */
    'values'?: object;
}
/**
 * 
 * @export
 * @interface CatalogSectionResponseObjectNodeReferencesContext
 */
export interface CatalogSectionResponseObjectNodeReferencesContext {
    /**
     * 
     * @type {CatalogCapabilities}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'capabilities'?: CatalogCapabilities;
    /**
     * 
     * @type {CatalogCaseHeader}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'case_header'?: CatalogCaseHeader;
    /**
     * 
     * @type {string}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {ReferencesContext}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'context'?: ReferencesContext;
    /**
     * 
     * @type {{ [key: string]: Array<CatalogOption>; }}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'field_options'?: { [key: string]: Array<CatalogOption>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {number}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'revision'?: number;
    /**
     * 
     * @type {object}
     * @memberof CatalogSectionResponseObjectNodeReferencesContext
     */
    'values'?: object;
}
/**
 * 
 * @export
 * @interface CatalogValidationError
 */
export interface CatalogValidationError {
    /**
     * 
     * @type {string}
     * @memberof CatalogValidationError
     */
    'code'?: string;
    /**
     * 
     * @type {Array<CatalogFinding>}
     * @memberof CatalogValidationError
     */
    'findings'?: Array<CatalogFinding>;
}
/**
 * 
 * @export
 * @interface CausalityAssessmentView
 */
export interface CausalityAssessmentView {
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'action_taken'?: string;
    /**
     * 
     * @type {number}
     * @memberof CausalityAssessmentView
     */
    'case_id'?: number;
    /**
     * 
     * @type {Array<DatasheetView>}
     * @memberof CausalityAssessmentView
     */
    'datasheets'?: Array<DatasheetView>;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'determined_causality_method'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'determined_causality_result'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'determined_causality_source'?: string;
    /**
     * 
     * @type {number}
     * @memberof CausalityAssessmentView
     */
    'event_detail_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CausalityAssessmentView
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof CausalityAssessmentView
     */
    'product_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_assessed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_confidence'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_method'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_model'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_provenance'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_reasoning'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_result'?: string;
    /**
     * 
     * @type {string}
     * @memberof CausalityAssessmentView
     */
    'reported_causality_source'?: string;
}
/**
 * 
 * @export
 * @interface CausalityMapping
 */
export interface CausalityMapping {
    /**
     * 
     * @type {Array<number>}
     * @memberof CausalityMapping
     */
    'notRelatedIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CausalityMapping
     */
    'relatedIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CellView
 */
export interface CellView {
    /**
     * 
     * @type {string}
     * @memberof CellView
     */
    'address': string;
    /**
     * 
     * @type {boolean}
     * @memberof CellView
     */
    'bold': boolean;
    /**
     * 
     * @type {number}
     * @memberof CellView
     */
    'column': number;
    /**
     * 
     * @type {number}
     * @memberof CellView
     */
    'row': number;
    /**
     * 
     * @type {string}
     * @memberof CellView
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface CitedCell
 */
export interface CitedCell {
    /**
     * 
     * @type {number}
     * @memberof CitedCell
     */
    'column': number;
    /**
     * 
     * @type {string}
     * @memberof CitedCell
     */
    'field_path': string;
    /**
     * 
     * @type {string}
     * @memberof CitedCell
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof CitedCell
     */
    'row': number;
    /**
     * 
     * @type {string}
     * @memberof CitedCell
     */
    'sheet': string;
}
/**
 * 
 * @export
 * @interface ClientSlasResponse
 */
export interface ClientSlasResponse {
    /**
     * 
     * @type {Array<DashboardAlert>}
     * @memberof ClientSlasResponse
     */
    'alerts'?: Array<DashboardAlert>;
    /**
     * 
     * @type {Reconciliation}
     * @memberof ClientSlasResponse
     */
    'reconciliation'?: Reconciliation;
    /**
     * 
     * @type {Array<SlaResult>}
     * @memberof ClientSlasResponse
     */
    'scorecard'?: Array<SlaResult>;
}
/**
 * 
 * @export
 * @interface CloseActivityRequest
 */
export interface CloseActivityRequest {
    /**
     * 
     * @type {string}
     * @memberof CloseActivityRequest
     */
    'close_comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof CloseActivityRequest
     */
    'close_reason_id': number;
}
/**
 * 
 * @export
 * @interface CollectionChange
 */
export interface CollectionChange {
    /**
     * 
     * @type {Array<number>}
     * @memberof CollectionChange
     */
    'deleted_ids'?: Array<number>;
    /**
     * 
     * @type {Array<CollectionUpsert>}
     * @memberof CollectionChange
     */
    'upserts'?: Array<CollectionUpsert>;
}
/**
 * 
 * @export
 * @interface CollectionUpsert
 */
export interface CollectionUpsert {
    /**
     * 
     * @type {{ [key: string]: NestedCollectionChange; }}
     * @memberof CollectionUpsert
     */
    'collections'?: { [key: string]: NestedCollectionChange; };
    /**
     * 
     * @type {Array<Decision>}
     * @memberof CollectionUpsert
     */
    'decisions'?: Array<Decision>;
    /**
     * 
     * @type {string}
     * @memberof CollectionUpsert
     */
    'record_id'?: string;
    /**
     * 
     * @type {CatalogCollectionRecord}
     * @memberof CollectionUpsert
     */
    'values': CatalogCollectionRecord;
}
/**
 * 
 * @export
 * @interface ComplianceResponse
 */
export interface ComplianceResponse {
    /**
     * 
     * @type {Array<LateCase>}
     * @memberof ComplianceResponse
     */
    'late_cases'?: Array<LateCase>;
    /**
     * 
     * @type {Array<AuthoritySubmissionStatus>}
     * @memberof ComplianceResponse
     */
    'submission_status'?: Array<AuthoritySubmissionStatus>;
}
/**
 * 
 * @export
 * @interface ConfigAiAssist
 */
export interface ConfigAiAssist {
    /**
     * 
     * @type {string}
     * @memberof ConfigAiAssist
     */
    'aiAgent'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigAiAssist
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ConfigAiAssist
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface ConfigCountry
 */
export interface ConfigCountry {
    /**
     * 
     * @type {string}
     * @memberof ConfigCountry
     */
    'a2Code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigCountry
     */
    'a3Code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigCountry
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigCountry
     */
    'countryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigCountry
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigCountry
     */
    'isDisabled'?: boolean;
}
/**
 * 
 * @export
 * @interface ConfigDatasheet
 */
export interface ConfigDatasheet {
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'datasheetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'effectiveDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigDatasheet
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigDatasheet
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'lltName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'meddraLookup'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'ptName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'termName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigDatasheet
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface ConfigFieldRules
 */
export interface ConfigFieldRules {
    /**
     * 
     * @type {string}
     * @memberof ConfigFieldRules
     */
    'fieldUiId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigFieldRules
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigFieldRules
     */
    'isE2b'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigFieldRules
     */
    'isMandatory'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigFieldRules
     */
    'nullFlavorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigFieldRules
     */
    'section'?: string;
}
/**
 * 
 * @export
 * @interface ConfigFormField
 */
export interface ConfigFormField {
    /**
     * 
     * @type {string}
     * @memberof ConfigFormField
     */
    'fieldName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigFormField
     */
    'formName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigFormField
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigFormField
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigFormField
     */
    'isRequired'?: boolean;
}
/**
 * 
 * @export
 * @interface ConfigPriority
 */
export interface ConfigPriority {
    /**
     * 
     * @type {number}
     * @memberof ConfigPriority
     */
    'dueDays'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigPriority
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigPriority
     */
    'priorityLevel'?: string;
}
/**
 * 
 * @export
 * @interface ConfigProduct
 */
export interface ConfigProduct {
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'formulation'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'genericName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigProduct
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'ingredients'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigProduct
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'productDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'productIbd'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'productId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'productName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'productType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'strength'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProduct
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface ConfigProductLicense
 */
export interface ConfigProductLicense {
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'authorizationCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'authorizationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'dailymedSetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigProductLicense
     */
    'datasheetId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfigProductLicense
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'licenseAwardDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'licenseType'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'marketAuthorizationHolder'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigProductLicense
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'tradeName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigProductLicense
     */
    'withdrawnDate'?: string;
}
/**
 * 
 * @export
 * @interface ConfigReceiver
 */
export interface ConfigReceiver {
    /**
     * 
     * @type {number}
     * @memberof ConfigReceiver
     */
    'countryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigReceiver
     */
    'department'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigReceiver
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigReceiver
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigReceiver
     */
    'organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigReceiver
     */
    'receiverId'?: string;
}
/**
 * 
 * @export
 * @interface ConfigReportType
 */
export interface ConfigReportType {
    /**
     * 
     * @type {string}
     * @memberof ConfigReportType
     */
    'e2bCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigReportType
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigReportType
     */
    'isDisabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConfigReportType
     */
    'reportType'?: string;
}
/**
 * 
 * @export
 * @interface ConfigSender
 */
export interface ConfigSender {
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigSender
     */
    'countryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'department'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'givenName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfigSender
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'postcode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'senderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'state'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigSender
     */
    'title'?: string;
}
/**
 * @type CorrectReceiptDate409Response
 * @export
 */
export type CorrectReceiptDate409Response = Array<FollowupFailure> | DeadlineChangeConfirmation;

/**
 * 
 * @export
 * @interface CountItem
 */
export interface CountItem {
    /**
     * 
     * @type {number}
     * @memberof CountItem
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof CountItem
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountItem
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CountItem
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface CreateNewCaseRequest
 */
export interface CreateNewCaseRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateNewCaseRequest
     */
    'justification'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateNewCaseRequest
     */
    'linked_case_ids'?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateNewCaseRequest
     */
    'relationship_types'?: { [key: string]: string; };
}

export const CreateNewCaseRequestRelationshipTypesEnum = {
    MotherAndBaby: 'MOTHER_AND_BABY',
    Twins: 'TWINS',
    CaseSeries: 'CASE_SERIES',
    AeAndProductComplaint: 'AE_AND_PRODUCT_COMPLAINT',
    DrugAndDevice: 'DRUG_AND_DEVICE',
    Recurrence: 'RECURRENCE',
    SamePatientOtherEvent: 'SAME_PATIENT_OTHER_EVENT',
    Other: 'OTHER'
} as const;

export type CreateNewCaseRequestRelationshipTypesEnum = typeof CreateNewCaseRequestRelationshipTypesEnum[keyof typeof CreateNewCaseRequestRelationshipTypesEnum];

/**
 * 
 * @export
 * @interface CreateNewCaseResponse
 */
export interface CreateNewCaseResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateNewCaseResponse
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateNewCaseResponse
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateNewCaseResponse
     */
    'decided_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateNewCaseResponse
     */
    'decided_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateNewCaseResponse
     */
    'justification'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateNewCaseResponse
     */
    'linked_case_ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DashboardAlert
 */
export interface DashboardAlert {
    /**
     * 
     * @type {number}
     * @memberof DashboardAlert
     */
    'age_hours'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardAlert
     */
    'severity'?: DashboardAlertSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardAlert
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardAlert
     */
    'title'?: string;
}

export const DashboardAlertSeverityEnum = {
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW'
} as const;

export type DashboardAlertSeverityEnum = typeof DashboardAlertSeverityEnum[keyof typeof DashboardAlertSeverityEnum];

/**
 * 
 * @export
 * @interface DashboardCaseRow
 */
export interface DashboardCaseRow {
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'calculation_state'?: DashboardCaseRowCalculationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof DashboardCaseRow
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'case_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'client_organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'deadline_status'?: DashboardCaseRowDeadlineStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'due_calculation_state'?: DashboardCaseRowDueCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'due_completion_state'?: DashboardCaseRowDueCompletionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'due_date_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'earliest_regulatory_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'earliest_regulatory_due_timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'event_term'?: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardCaseRow
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'initial_receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'internal_due_timezone'?: string;
    /**
     * 
     * @type {Array<MissingInputView>}
     * @memberof DashboardCaseRow
     */
    'missing_inputs'?: Array<MissingInputView>;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'primary_event_verbatim'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'primary_product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'primary_report_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'primary_reported_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'primary_source_country'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'recent_received_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'report_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'seriousness'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCaseRow
     */
    'workflow_status'?: string;
}

export const DashboardCaseRowCalculationStateEnum = {
    Calculated: 'Calculated',
    Partial: 'Partial',
    Pending: 'Pending'
} as const;

export type DashboardCaseRowCalculationStateEnum = typeof DashboardCaseRowCalculationStateEnum[keyof typeof DashboardCaseRowCalculationStateEnum];
export const DashboardCaseRowDeadlineStatusEnum = {
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn',
    Pending: 'Pending',
    Overdue: 'Overdue',
    DueSoon: 'Due soon',
    OnTrack: 'On track'
} as const;

export type DashboardCaseRowDeadlineStatusEnum = typeof DashboardCaseRowDeadlineStatusEnum[keyof typeof DashboardCaseRowDeadlineStatusEnum];
export const DashboardCaseRowDueCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type DashboardCaseRowDueCalculationStateEnum = typeof DashboardCaseRowDueCalculationStateEnum[keyof typeof DashboardCaseRowDueCalculationStateEnum];
export const DashboardCaseRowDueCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type DashboardCaseRowDueCompletionStateEnum = typeof DashboardCaseRowDueCompletionStateEnum[keyof typeof DashboardCaseRowDueCompletionStateEnum];

/**
 * 
 * @export
 * @interface DashboardCaseSearchResult
 */
export interface DashboardCaseSearchResult {
    /**
     * 
     * @type {Array<DashboardCaseRow>}
     * @memberof DashboardCaseSearchResult
     */
    'cases'?: Array<DashboardCaseRow>;
    /**
     * 
     * @type {number}
     * @memberof DashboardCaseSearchResult
     */
    'open_cases'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardCaseSearchResult
     */
    'serious_cases'?: number;
    /**
     * 
     * @type {number}
     * @memberof DashboardCaseSearchResult
     */
    'total_count'?: number;
}
/**
 * 
 * @export
 * @interface DashboardFilterOptions
 */
export interface DashboardFilterOptions {
    /**
     * 
     * @type {Array<FilterOption>}
     * @memberof DashboardFilterOptions
     */
    'authorities'?: Array<FilterOption>;
    /**
     * 
     * @type {Array<FilterOption>}
     * @memberof DashboardFilterOptions
     */
    'periods'?: Array<FilterOption>;
    /**
     * 
     * @type {Array<FilterOption>}
     * @memberof DashboardFilterOptions
     */
    'products'?: Array<FilterOption>;
}
/**
 * 
 * @export
 * @interface DashboardRepository
 */
export interface DashboardRepository {
    /**
     * 
     * @type {string}
     * @memberof DashboardRepository
     */
    'chartMetadata'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRepository
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRepository
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof DashboardRepository
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DashboardRepository
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardRepository
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface DatasheetView
 */
export interface DatasheetView {
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'dailymed_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'database_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'datasheet_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'determined_listedness'?: string;
    /**
     * 
     * @type {number}
     * @memberof DatasheetView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'license_number'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DatasheetView
     */
    'listed_evidence'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'listedness_assessed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'listedness_confidence'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'listedness_model'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'listedness_reasoning'?: string;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'listedness_source'?: string;
    /**
     * 
     * @type {number}
     * @memberof DatasheetView
     */
    'product_event_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatasheetView
     */
    'product_license_id'?: number;
    /**
     * 
     * @type {Array<ReferenceDocumentView>}
     * @memberof DatasheetView
     */
    'reference_documents'?: Array<ReferenceDocumentView>;
    /**
     * 
     * @type {string}
     * @memberof DatasheetView
     */
    'trade_name'?: string;
}
/**
 * 
 * @export
 * @interface DeadlineChangeConfirmation
 */
export interface DeadlineChangeConfirmation {
    /**
     * 
     * @type {number}
     * @memberof DeadlineChangeConfirmation
     */
    'case_revision'?: number;
    /**
     * 
     * @type {Array<DeadlineChangeView>}
     * @memberof DeadlineChangeConfirmation
     */
    'changes'?: Array<DeadlineChangeView>;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeConfirmation
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeConfirmation
     */
    'earliest_internal_due_after'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeConfirmation
     */
    'earliest_internal_due_before'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeConfirmation
     */
    'priority_after'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeConfirmation
     */
    'priority_before'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineChangeConfirmation
     */
    'priority_changed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeConfirmation
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface DeadlineChangeView
 */
export interface DeadlineChangeView {
    /**
     * 
     * @type {DeadlineResultStateView}
     * @memberof DeadlineChangeView
     */
    'after'?: DeadlineResultStateView;
    /**
     * 
     * @type {DeadlineResultStateView}
     * @memberof DeadlineChangeView
     */
    'before'?: DeadlineResultStateView;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeadlineChangeView
     */
    'changed_inputs'?: Array<DeadlineChangeViewChangedInputsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineChangeView
     */
    'correction'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineChangeView
     */
    'followup'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeView
     */
    'obligation_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeView
     */
    'outcome'?: DeadlineChangeViewOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeView
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineChangeView
     */
    'report_kind'?: DeadlineChangeViewReportKindEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineChangeView
     */
    'requires_confirmation'?: boolean;
}

export const DeadlineChangeViewChangedInputsEnum = {
    ClockSource: 'CLOCK_SOURCE',
    Priority: 'PRIORITY',
    PriorityBasis: 'PRIORITY_BASIS',
    PolicyVersion: 'POLICY_VERSION',
    Arrival: 'ARRIVAL',
    AuthorityScope: 'AUTHORITY_SCOPE',
    CaseCountry: 'CASE_COUNTRY',
    ReportType: 'REPORT_TYPE',
    PairFacts: 'PAIR_FACTS',
    FollowupDecision: 'FOLLOWUP_DECISION'
} as const;

export type DeadlineChangeViewChangedInputsEnum = typeof DeadlineChangeViewChangedInputsEnum[keyof typeof DeadlineChangeViewChangedInputsEnum];
export const DeadlineChangeViewOutcomeEnum = {
    Calculated: 'CALCULATED',
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Reopened: 'REOPENED',
    NotApplicable: 'NOT_APPLICABLE',
    Withdrawn: 'WITHDRAWN',
    Replaced: 'REPLACED',
    Submitted: 'SUBMITTED',
    AttemptFailed: 'ATTEMPT_FAILED',
    EvidenceRecorded: 'EVIDENCE_RECORDED'
} as const;

export type DeadlineChangeViewOutcomeEnum = typeof DeadlineChangeViewOutcomeEnum[keyof typeof DeadlineChangeViewOutcomeEnum];
export const DeadlineChangeViewReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type DeadlineChangeViewReportKindEnum = typeof DeadlineChangeViewReportKindEnum[keyof typeof DeadlineChangeViewReportKindEnum];

/**
 * 
 * @export
 * @interface DeadlineHistoryEntryView
 */
export interface DeadlineHistoryEntryView {
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'action_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'actor_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'actor_kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'actor_name'?: string;
    /**
     * 
     * @type {DeadlineResultStateView}
     * @memberof DeadlineHistoryEntryView
     */
    'after'?: DeadlineResultStateView;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'arrival_id'?: number;
    /**
     * 
     * @type {DeadlineResultStateView}
     * @memberof DeadlineHistoryEntryView
     */
    'before'?: DeadlineResultStateView;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'case_revision'?: number;
    /**
     * 
     * @type {Array<AuditFieldChangeDto>}
     * @memberof DeadlineHistoryEntryView
     */
    'changed_facts'?: Array<AuditFieldChangeDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeadlineHistoryEntryView
     */
    'changed_inputs'?: Array<DeadlineHistoryEntryViewChangedInputsEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineHistoryEntryView
     */
    'confirmed_change'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'correlation_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'followup_number'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'obligation_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'occurred_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'outcome'?: DeadlineHistoryEntryViewOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'report_kind'?: DeadlineHistoryEntryViewReportKindEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineHistoryEntryView
     */
    'result_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'trigger'?: DeadlineHistoryEntryViewTriggerEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineHistoryEntryView
     */
    'txn_id'?: string;
}

export const DeadlineHistoryEntryViewChangedInputsEnum = {
    ClockSource: 'CLOCK_SOURCE',
    Priority: 'PRIORITY',
    PriorityBasis: 'PRIORITY_BASIS',
    PolicyVersion: 'POLICY_VERSION',
    Arrival: 'ARRIVAL',
    AuthorityScope: 'AUTHORITY_SCOPE',
    CaseCountry: 'CASE_COUNTRY',
    ReportType: 'REPORT_TYPE',
    PairFacts: 'PAIR_FACTS',
    FollowupDecision: 'FOLLOWUP_DECISION'
} as const;

export type DeadlineHistoryEntryViewChangedInputsEnum = typeof DeadlineHistoryEntryViewChangedInputsEnum[keyof typeof DeadlineHistoryEntryViewChangedInputsEnum];
export const DeadlineHistoryEntryViewOutcomeEnum = {
    Calculated: 'CALCULATED',
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Reopened: 'REOPENED',
    NotApplicable: 'NOT_APPLICABLE',
    Withdrawn: 'WITHDRAWN',
    Replaced: 'REPLACED',
    Submitted: 'SUBMITTED',
    AttemptFailed: 'ATTEMPT_FAILED',
    EvidenceRecorded: 'EVIDENCE_RECORDED'
} as const;

export type DeadlineHistoryEntryViewOutcomeEnum = typeof DeadlineHistoryEntryViewOutcomeEnum[keyof typeof DeadlineHistoryEntryViewOutcomeEnum];
export const DeadlineHistoryEntryViewReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type DeadlineHistoryEntryViewReportKindEnum = typeof DeadlineHistoryEntryViewReportKindEnum[keyof typeof DeadlineHistoryEntryViewReportKindEnum];
export const DeadlineHistoryEntryViewTriggerEnum = {
    ExtractionSave: 'EXTRACTION_SAVE',
    ReviewerSave: 'REVIEWER_SAVE',
    FollowupSave: 'FOLLOWUP_SAVE',
    RuleReplacement: 'RULE_REPLACEMENT',
    WorkflowStage: 'WORKFLOW_STAGE',
    FollowupAttachment: 'FOLLOWUP_ATTACHMENT',
    ExactMatch: 'EXACT_MATCH',
    FollowupTakeIn: 'FOLLOWUP_TAKE_IN',
    ReceiptCorrection: 'RECEIPT_CORRECTION',
    DeadlineReview: 'DEADLINE_REVIEW',
    SubmissionEnqueue: 'SUBMISSION_ENQUEUE',
    SubmissionOutcome: 'SUBMISSION_OUTCOME'
} as const;

export type DeadlineHistoryEntryViewTriggerEnum = typeof DeadlineHistoryEntryViewTriggerEnum[keyof typeof DeadlineHistoryEntryViewTriggerEnum];

/**
 * 
 * @export
 * @interface DeadlineReportPage
 */
export interface DeadlineReportPage {
    /**
     * 
     * @type {Array<DeadlineReportRow>}
     * @memberof DeadlineReportPage
     */
    'items'?: Array<DeadlineReportRow>;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportPage
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportPage
     */
    'page_size'?: number;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportPage
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface DeadlineReportRow
 */
export interface DeadlineReportRow {
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'authority_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'calculation_state'?: DeadlineReportRowCalculationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportRow
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'completion_state'?: DeadlineReportRowCompletionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'compliance_status'?: DeadlineReportRowComplianceStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportRow
     */
    'days_remaining'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'deadline_status'?: DeadlineReportRowDeadlineStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportRow
     */
    'followup_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'regulatory_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'report_kind'?: DeadlineReportRowReportKindEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineReportRow
     */
    'result_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReportRow
     */
    'timezone'?: string;
}

export const DeadlineReportRowCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type DeadlineReportRowCalculationStateEnum = typeof DeadlineReportRowCalculationStateEnum[keyof typeof DeadlineReportRowCalculationStateEnum];
export const DeadlineReportRowCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type DeadlineReportRowCompletionStateEnum = typeof DeadlineReportRowCompletionStateEnum[keyof typeof DeadlineReportRowCompletionStateEnum];
export const DeadlineReportRowComplianceStatusEnum = {
    OnTime: 'On time',
    Late: 'Late',
    Pending: 'Pending'
} as const;

export type DeadlineReportRowComplianceStatusEnum = typeof DeadlineReportRowComplianceStatusEnum[keyof typeof DeadlineReportRowComplianceStatusEnum];
export const DeadlineReportRowDeadlineStatusEnum = {
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn',
    Pending: 'Pending',
    Overdue: 'Overdue',
    DueSoon: 'Due soon',
    OnTrack: 'On track'
} as const;

export type DeadlineReportRowDeadlineStatusEnum = typeof DeadlineReportRowDeadlineStatusEnum[keyof typeof DeadlineReportRowDeadlineStatusEnum];
export const DeadlineReportRowReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type DeadlineReportRowReportKindEnum = typeof DeadlineReportRowReportKindEnum[keyof typeof DeadlineReportRowReportKindEnum];

/**
 * 
 * @export
 * @interface DeadlineResultStateView
 */
export interface DeadlineResultStateView {
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'authority_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'calculation_state'?: DeadlineResultStateViewCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'clock_basis'?: DeadlineResultStateViewClockBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'clock_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'completion_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'completion_state'?: DeadlineResultStateViewCompletionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'compliance_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultStateView
     */
    'interval_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'late_reason'?: string;
    /**
     * 
     * @type {Array<MissingInputView>}
     * @memberof DeadlineResultStateView
     */
    'missing_inputs'?: Array<MissingInputView>;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'not_applicable_reason'?: DeadlineResultStateViewNotApplicableReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'policy_key'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultStateView
     */
    'policy_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'priority_level'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'regulatory_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'route'?: DeadlineResultStateViewRouteEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultStateView
     */
    'rule_version_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'source_field_path'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'submission_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultStateView
     */
    'timezone'?: string;
}

export const DeadlineResultStateViewCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type DeadlineResultStateViewCalculationStateEnum = typeof DeadlineResultStateViewCalculationStateEnum[keyof typeof DeadlineResultStateViewCalculationStateEnum];
export const DeadlineResultStateViewClockBasisEnum = {
    InitialReceiptDate: 'INITIAL_RECEIPT_DATE',
    ArrivalReceiptDate: 'ARRIVAL_RECEIPT_DATE'
} as const;

export type DeadlineResultStateViewClockBasisEnum = typeof DeadlineResultStateViewClockBasisEnum[keyof typeof DeadlineResultStateViewClockBasisEnum];
export const DeadlineResultStateViewCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type DeadlineResultStateViewCompletionStateEnum = typeof DeadlineResultStateViewCompletionStateEnum[keyof typeof DeadlineResultStateViewCompletionStateEnum];
export const DeadlineResultStateViewNotApplicableReasonEnum = {
    OutOfScope: 'OUT_OF_SCOPE',
    RoutePeriodic: 'ROUTE_PERIODIC',
    RouteNone: 'ROUTE_NONE',
    RuleNotStarted: 'RULE_NOT_STARTED',
    ReviewNoReport: 'REVIEW_NO_REPORT',
    ObligationRemoved: 'OBLIGATION_REMOVED',
    FollowedUp: 'FOLLOWED_UP',
    ExactMatch: 'EXACT_MATCH'
} as const;

export type DeadlineResultStateViewNotApplicableReasonEnum = typeof DeadlineResultStateViewNotApplicableReasonEnum[keyof typeof DeadlineResultStateViewNotApplicableReasonEnum];
export const DeadlineResultStateViewRouteEnum = {
    Expedited: 'Expedited',
    Periodic: 'Periodic',
    None: 'None',
    Pending: 'Pending'
} as const;

export type DeadlineResultStateViewRouteEnum = typeof DeadlineResultStateViewRouteEnum[keyof typeof DeadlineResultStateViewRouteEnum];

/**
 * 
 * @export
 * @interface DeadlineResultView
 */
export interface DeadlineResultView {
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'arrival_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'authority_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'buffer_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'calculation_state'?: DeadlineResultViewCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'calendar_adjustment'?: DeadlineResultViewCalendarAdjustmentEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'clock_basis'?: DeadlineResultViewClockBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'clock_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'completion_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'completion_state'?: DeadlineResultViewCompletionStateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'compliance_correctable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'current_case'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'days_remaining'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'deadline_status'?: DeadlineResultViewDeadlineStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'followup_number'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'frozen'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'interval_days'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'late_reason_recordable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'listedness_assumed'?: boolean;
    /**
     * 
     * @type {Array<MissingInputView>}
     * @memberof DeadlineResultView
     */
    'missing_inputs'?: Array<MissingInputView>;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'not_applicable_reason'?: DeadlineResultViewNotApplicableReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'obligation_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'policy_key'?: string;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'policy_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'priority_level'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DeadlineResultView
     */
    'reference_document_ids'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'regulatory_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'report_kind'?: DeadlineResultViewReportKindEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'result_id'?: number;
    /**
     * 
     * @type {ReviewEvidenceView}
     * @memberof DeadlineResultView
     */
    'review'?: ReviewEvidenceView;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'reviewable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'route'?: DeadlineResultViewRouteEnum;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'rule_order'?: number;
    /**
     * 
     * @type {ScopeBasisView}
     * @memberof DeadlineResultView
     */
    'scope_basis'?: ScopeBasisView;
    /**
     * 
     * @type {number}
     * @memberof DeadlineResultView
     */
    'source_result_id'?: number;
    /**
     * 
     * @type {SubmissionTrackView}
     * @memberof DeadlineResultView
     */
    'submission'?: SubmissionTrackView;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'submittable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeadlineResultView
     */
    'timezone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeadlineResultView
     */
    'withdrawable'?: boolean;
}

export const DeadlineResultViewCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type DeadlineResultViewCalculationStateEnum = typeof DeadlineResultViewCalculationStateEnum[keyof typeof DeadlineResultViewCalculationStateEnum];
export const DeadlineResultViewCalendarAdjustmentEnum = {
    None: 'None',
    PreviousWorkingDay: 'PreviousWorkingDay',
    NextWorkingDay: 'NextWorkingDay'
} as const;

export type DeadlineResultViewCalendarAdjustmentEnum = typeof DeadlineResultViewCalendarAdjustmentEnum[keyof typeof DeadlineResultViewCalendarAdjustmentEnum];
export const DeadlineResultViewClockBasisEnum = {
    InitialReceiptDate: 'INITIAL_RECEIPT_DATE',
    ArrivalReceiptDate: 'ARRIVAL_RECEIPT_DATE'
} as const;

export type DeadlineResultViewClockBasisEnum = typeof DeadlineResultViewClockBasisEnum[keyof typeof DeadlineResultViewClockBasisEnum];
export const DeadlineResultViewCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type DeadlineResultViewCompletionStateEnum = typeof DeadlineResultViewCompletionStateEnum[keyof typeof DeadlineResultViewCompletionStateEnum];
export const DeadlineResultViewDeadlineStatusEnum = {
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn',
    Pending: 'Pending',
    Overdue: 'Overdue',
    DueSoon: 'Due soon',
    OnTrack: 'On track'
} as const;

export type DeadlineResultViewDeadlineStatusEnum = typeof DeadlineResultViewDeadlineStatusEnum[keyof typeof DeadlineResultViewDeadlineStatusEnum];
export const DeadlineResultViewNotApplicableReasonEnum = {
    OutOfScope: 'OUT_OF_SCOPE',
    RoutePeriodic: 'ROUTE_PERIODIC',
    RouteNone: 'ROUTE_NONE',
    RuleNotStarted: 'RULE_NOT_STARTED',
    ReviewNoReport: 'REVIEW_NO_REPORT',
    ObligationRemoved: 'OBLIGATION_REMOVED',
    FollowedUp: 'FOLLOWED_UP',
    ExactMatch: 'EXACT_MATCH'
} as const;

export type DeadlineResultViewNotApplicableReasonEnum = typeof DeadlineResultViewNotApplicableReasonEnum[keyof typeof DeadlineResultViewNotApplicableReasonEnum];
export const DeadlineResultViewReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type DeadlineResultViewReportKindEnum = typeof DeadlineResultViewReportKindEnum[keyof typeof DeadlineResultViewReportKindEnum];
export const DeadlineResultViewRouteEnum = {
    Expedited: 'Expedited',
    Periodic: 'Periodic',
    None: 'None',
    Pending: 'Pending'
} as const;

export type DeadlineResultViewRouteEnum = typeof DeadlineResultViewRouteEnum[keyof typeof DeadlineResultViewRouteEnum];

/**
 * 
 * @export
 * @interface DeadlineReviewCommand
 */
export interface DeadlineReviewCommand {
    /**
     * 
     * @type {number}
     * @memberof DeadlineReviewCommand
     */
    'case_revision': number;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'catalog_version': string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'completion_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'correction_receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'decision': DeadlineReviewCommandDecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'evidence_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'late_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeadlineReviewCommand
     */
    'reason': string;
}

export const DeadlineReviewCommandDecisionEnum = {
    ReportRequired: 'REPORT_REQUIRED',
    NoReportRequired: 'NO_REPORT_REQUIRED',
    KeepPending: 'KEEP_PENDING',
    Withdraw: 'WITHDRAW',
    ManualComplete: 'MANUAL_COMPLETE',
    RecordLateReason: 'RECORD_LATE_REASON',
    CorrectComplianceEvidence: 'CORRECT_COMPLIANCE_EVIDENCE'
} as const;

export type DeadlineReviewCommandDecisionEnum = typeof DeadlineReviewCommandDecisionEnum[keyof typeof DeadlineReviewCommandDecisionEnum];

/**
 * 
 * @export
 * @interface DeadlineReviewed
 */
export interface DeadlineReviewed {
    /**
     * 
     * @type {number}
     * @memberof DeadlineReviewed
     */
    'case_revision'?: number;
    /**
     * 
     * @type {DeadlineResultView}
     * @memberof DeadlineReviewed
     */
    'result'?: DeadlineResultView;
    /**
     * 
     * @type {CaseDeadlineSummaryView}
     * @memberof DeadlineReviewed
     */
    'summary'?: CaseDeadlineSummaryView;
}
/**
 * 
 * @export
 * @interface Decision
 */
export interface Decision {
    /**
     * 
     * @type {string}
     * @memberof Decision
     */
    'decision'?: string;
    /**
     * 
     * @type {string}
     * @memberof Decision
     */
    'field_id'?: string;
}
/**
 * 
 * @export
 * @interface DemoMenuFlags
 */
export interface DemoMenuFlags {
    /**
     * 
     * @type {boolean}
     * @memberof DemoMenuFlags
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DemoMenuFlags
     */
    'show'?: boolean;
}
/**
 * 
 * @export
 * @interface DemoMenuResponse
 */
export interface DemoMenuResponse {
    /**
     * 
     * @type {string}
     * @memberof DemoMenuResponse
     */
    'error'?: string;
    /**
     * 
     * @type {{ [key: string]: DemoMenuFlags; }}
     * @memberof DemoMenuResponse
     */
    'overrides'?: { [key: string]: DemoMenuFlags; };
    /**
     * 
     * @type {string}
     * @memberof DemoMenuResponse
     */
    'revision'?: string;
}
/**
 * 
 * @export
 * @interface DiscoveredCase
 */
export interface DiscoveredCase {
    /**
     * 
     * @type {string}
     * @memberof DiscoveredCase
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveredCase
     */
    'evidence'?: string;
    /**
     * 
     * @type {string}
     * @memberof DiscoveredCase
     */
    'firstSender'?: DiscoveredCaseFirstSenderEnum;
    /**
     * 
     * @type {string}
     * @memberof DiscoveredCase
     */
    'firstSenderEvidence'?: string;
    /**
     * 
     * @type {FollowUpClaim}
     * @memberof DiscoveredCase
     */
    'followUp'?: FollowUpClaim;
    /**
     * 
     * @type {Array<ExternalCaseReference>}
     * @memberof DiscoveredCase
     */
    'identifiers'?: Array<ExternalCaseReference>;
    /**
     * 
     * @type {string}
     * @memberof DiscoveredCase
     */
    'label'?: string;
    /**
     * 
     * @type {Array<LineSpan>}
     * @memberof DiscoveredCase
     */
    'lineSpans'?: Array<LineSpan>;
    /**
     * 
     * @type {Array<LineRange>}
     * @memberof DiscoveredCase
     */
    'lines'?: Array<LineRange>;
}

export const DiscoveredCaseFirstSenderEnum = {
    RegulatoryAuthority: 'REGULATORY_AUTHORITY',
    Other: 'OTHER',
    Unknown: 'UNKNOWN'
} as const;

export type DiscoveredCaseFirstSenderEnum = typeof DiscoveredCaseFirstSenderEnum[keyof typeof DiscoveredCaseFirstSenderEnum];

/**
 * 
 * @export
 * @interface DrilldownResponse
 */
export interface DrilldownResponse {
    /**
     * 
     * @type {Array<DrilldownRow>}
     * @memberof DrilldownResponse
     */
    'rows'?: Array<DrilldownRow>;
    /**
     * 
     * @type {string}
     * @memberof DrilldownResponse
     */
    'target'?: DrilldownResponseTargetEnum;
    /**
     * 
     * @type {number}
     * @memberof DrilldownResponse
     */
    'total'?: number;
}

export const DrilldownResponseTargetEnum = {
    Cases: 'CASES',
    Overdue: 'OVERDUE',
    DueSoon: 'DUE_SOON',
    Stage: 'STAGE',
    Ageing: 'AGEING',
    CaseMix: 'CASE_MIX',
    Authority: 'AUTHORITY',
    Assignee: 'ASSIGNEE',
    Unassigned: 'UNASSIGNED'
} as const;

export type DrilldownResponseTargetEnum = typeof DrilldownResponseTargetEnum[keyof typeof DrilldownResponseTargetEnum];

/**
 * 
 * @export
 * @interface DrilldownRow
 */
export interface DrilldownRow {
    /**
     * 
     * @type {string}
     * @memberof DrilldownRow
     */
    'assignee'?: string;
    /**
     * 
     * @type {string}
     * @memberof DrilldownRow
     */
    'authority'?: string;
    /**
     * 
     * @type {string}
     * @memberof DrilldownRow
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof DrilldownRow
     */
    'due_in_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrilldownRow
     */
    'product'?: string;
    /**
     * 
     * @type {number}
     * @memberof DrilldownRow
     */
    'received_days_ago'?: number;
    /**
     * 
     * @type {string}
     * @memberof DrilldownRow
     */
    'seriousness'?: string;
    /**
     * 
     * @type {string}
     * @memberof DrilldownRow
     */
    'stage'?: string;
}
/**
 * 
 * @export
 * @interface DueDatePolicyDraftCommand
 */
export interface DueDatePolicyDraftCommand {
    /**
     * 
     * @type {AuthorityPolicyDefinition}
     * @memberof DueDatePolicyDraftCommand
     */
    'authority_definition'?: AuthorityPolicyDefinition;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyDraftCommand
     */
    'change_reason': string;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyDraftCommand
     */
    'effective_from': string;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyDraftCommand
     */
    'expected_draft_token'?: string;
    /**
     * 
     * @type {InternalPolicyDefinition}
     * @memberof DueDatePolicyDraftCommand
     */
    'internal_definition'?: InternalPolicyDefinition;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyDraftCommand
     */
    'policy_key': string;
}
/**
 * 
 * @export
 * @interface DueDatePolicyVersionView
 */
export interface DueDatePolicyVersionView {
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'approved_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof DueDatePolicyVersionView
     */
    'approved_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'approved_by_name'?: string;
    /**
     * 
     * @type {AuthorityPolicyDefinition}
     * @memberof DueDatePolicyVersionView
     */
    'authority_definition'?: AuthorityPolicyDefinition;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'change_reason': string;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof DueDatePolicyVersionView
     */
    'created_by': number;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'created_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'draft_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'effective_from': string;
    /**
     * 
     * @type {number}
     * @memberof DueDatePolicyVersionView
     */
    'id': number;
    /**
     * 
     * @type {InternalPolicyDefinition}
     * @memberof DueDatePolicyVersionView
     */
    'internal_definition'?: InternalPolicyDefinition;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'policy_key': string;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'policy_kind': DueDatePolicyVersionViewPolicyKindEnum;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'publication_state': DueDatePolicyVersionViewPublicationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof DueDatePolicyVersionView
     */
    'timezone'?: string;
    /**
     * 
     * @type {number}
     * @memberof DueDatePolicyVersionView
     */
    'version': number;
}

export const DueDatePolicyVersionViewPolicyKindEnum = {
    Internal: 'Internal',
    Authority: 'Authority'
} as const;

export type DueDatePolicyVersionViewPolicyKindEnum = typeof DueDatePolicyVersionViewPolicyKindEnum[keyof typeof DueDatePolicyVersionViewPolicyKindEnum];
export const DueDatePolicyVersionViewPublicationStateEnum = {
    Draft: 'Draft',
    Published: 'Published'
} as const;

export type DueDatePolicyVersionViewPublicationStateEnum = typeof DueDatePolicyVersionViewPublicationStateEnum[keyof typeof DueDatePolicyVersionViewPublicationStateEnum];

/**
 * 
 * @export
 * @interface DueSoonKpi
 */
export interface DueSoonKpi {
    /**
     * 
     * @type {number}
     * @memberof DueSoonKpi
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof DueSoonKpi
     */
    'delta_vs_last_week'?: number;
    /**
     * 
     * @type {number}
     * @memberof DueSoonKpi
     */
    'serious'?: number;
    /**
     * 
     * @type {number}
     * @memberof DueSoonKpi
     */
    'unassigned'?: number;
}
/**
 * 
 * @export
 * @interface DuplicateCandidateListResponse
 */
export interface DuplicateCandidateListResponse {
    /**
     * 
     * @type {Array<DuplicateCandidateSummary>}
     * @memberof DuplicateCandidateListResponse
     */
    'candidates'?: Array<DuplicateCandidateSummary>;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateListResponse
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateListResponse
     */
    'case_number'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateCandidateListResponse
     */
    'conflicting_identifiers'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateListResponse
     */
    'duplicate_analysis_outcome'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateListResponse
     */
    'list_reason'?: DuplicateCandidateListResponseListReasonEnum;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateListResponse
     */
    'total'?: number;
}

export const DuplicateCandidateListResponseListReasonEnum = {
    Pifu: 'PIFU',
    PossibleDuplicate: 'POSSIBLE_DUPLICATE'
} as const;

export type DuplicateCandidateListResponseListReasonEnum = typeof DuplicateCandidateListResponseListReasonEnum[keyof typeof DuplicateCandidateListResponseListReasonEnum];

/**
 * 
 * @export
 * @interface DuplicateCandidateSummary
 */
export interface DuplicateCandidateSummary {
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'ai_recommendation'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'assignee'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateSummary
     */
    'candidate_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'candidate_case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'country_event_occurred'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'decision'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateSummary
     */
    'due_in_days'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateCandidateSummary
     */
    'edit_mode'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'editor_name'?: string;
    /**
     * 
     * @type {PairEvidence}
     * @memberof DuplicateCandidateSummary
     */
    'evidence'?: PairEvidence;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'gender'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateSummary
     */
    'match_score'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'match_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateCandidateSummary
     */
    'patient_age'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'product_trade_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'related_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'related_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'reported_term_verbatim'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'review_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateCandidateSummary
     */
    'workflow_status'?: string;
}
/**
 * 
 * @export
 * @interface DuplicateComparisonResponse
 */
export interface DuplicateComparisonResponse {
    /**
     * 
     * @type {CaseSummaryRef}
     * @memberof DuplicateComparisonResponse
     */
    'candidate'?: CaseSummaryRef;
    /**
     * 
     * @type {CaseSummaryRef}
     * @memberof DuplicateComparisonResponse
     */
    'case'?: CaseSummaryRef;
    /**
     * 
     * @type {Array<FieldComparison>}
     * @memberof DuplicateComparisonResponse
     */
    'field_comparison'?: Array<FieldComparison>;
    /**
     * 
     * @type {NarrativeComparison}
     * @memberof DuplicateComparisonResponse
     */
    'narrative_comparison'?: NarrativeComparison;
    /**
     * 
     * @type {Array<SourceDocument>}
     * @memberof DuplicateComparisonResponse
     */
    'source_documents'?: Array<SourceDocument>;
    /**
     * 
     * @type {Array<TimelineEvent>}
     * @memberof DuplicateComparisonResponse
     */
    'timeline'?: Array<TimelineEvent>;
}
/**
 * 
 * @export
 * @interface DuplicateDecisionRequest
 */
export interface DuplicateDecisionRequest {
    /**
     * 
     * @type {string}
     * @memberof DuplicateDecisionRequest
     */
    'decision'?: DuplicateDecisionRequestDecisionEnum;
    /**
     * 
     * @type {Array<FieldOverride>}
     * @memberof DuplicateDecisionRequest
     */
    'field_overrides'?: Array<FieldOverride>;
    /**
     * 
     * @type {FollowupAttachCommand}
     * @memberof DuplicateDecisionRequest
     */
    'followup'?: FollowupAttachCommand;
    /**
     * 
     * @type {boolean}
     * @memberof DuplicateDecisionRequest
     */
    'is_significant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDecisionRequest
     */
    'notes'?: string;
}

export const DuplicateDecisionRequestDecisionEnum = {
    FollowUp: 'follow_up',
    ConfirmedDuplicate: 'confirmed_duplicate'
} as const;

export type DuplicateDecisionRequestDecisionEnum = typeof DuplicateDecisionRequestDecisionEnum[keyof typeof DuplicateDecisionRequestDecisionEnum];

/**
 * 
 * @export
 * @interface DuplicateDecisionResponse
 */
export interface DuplicateDecisionResponse {
    /**
     * 
     * @type {number}
     * @memberof DuplicateDecisionResponse
     */
    'candidate_case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicateDecisionResponse
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDecisionResponse
     */
    'decided_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicateDecisionResponse
     */
    'decided_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDecisionResponse
     */
    'decision'?: DuplicateDecisionResponseDecisionEnum;
    /**
     * 
     * @type {number}
     * @memberof DuplicateDecisionResponse
     */
    'decision_id'?: number;
    /**
     * 
     * @type {FollowupAttached}
     * @memberof DuplicateDecisionResponse
     */
    'followup'?: FollowupAttached;
    /**
     * 
     * @type {string}
     * @memberof DuplicateDecisionResponse
     */
    'notes'?: string;
}

export const DuplicateDecisionResponseDecisionEnum = {
    FollowUp: 'follow_up',
    ConfirmedDuplicate: 'confirmed_duplicate'
} as const;

export type DuplicateDecisionResponseDecisionEnum = typeof DuplicateDecisionResponseDecisionEnum[keyof typeof DuplicateDecisionResponseDecisionEnum];

/**
 * 
 * @export
 * @interface DuplicatePolicyDraftCommand
 */
export interface DuplicatePolicyDraftCommand {
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyDraftCommand
     */
    'cutoff_percent'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyDraftCommand
     */
    'expected_row_version'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyDraftCommand
     */
    'look_back_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyDraftCommand
     */
    'onset_tolerance_days_non_trial'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyDraftCommand
     */
    'onset_tolerance_days_trial'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyDraftCommand
     */
    'receipt_tolerance_days'?: number;
}
/**
 * 
 * @export
 * @interface DuplicatePolicyPublicationCommand
 */
export interface DuplicatePolicyPublicationCommand {
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyPublicationCommand
     */
    'change_reason'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyPublicationCommand
     */
    'expected_row_version'?: number;
}
/**
 * 
 * @export
 * @interface DuplicatePolicyScreenView
 */
export interface DuplicatePolicyScreenView {
    /**
     * 
     * @type {DuplicatePolicyVersionView}
     * @memberof DuplicatePolicyScreenView
     */
    'draft'?: DuplicatePolicyVersionView;
    /**
     * 
     * @type {DuplicatePolicySettingsView}
     * @memberof DuplicatePolicyScreenView
     */
    'in_effect'?: DuplicatePolicySettingsView;
    /**
     * 
     * @type {Array<DuplicatePolicyVersionView>}
     * @memberof DuplicatePolicyScreenView
     */
    'versions'?: Array<DuplicatePolicyVersionView>;
}
/**
 * 
 * @export
 * @interface DuplicatePolicySettingsView
 */
export interface DuplicatePolicySettingsView {
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicySettingsView
     */
    'cutoff_percent'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicySettingsView
     */
    'look_back_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicySettingsView
     */
    'onset_tolerance_days_non_trial'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicySettingsView
     */
    'onset_tolerance_days_trial'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicySettingsView
     */
    'receipt_tolerance_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicySettingsView
     */
    'version'?: number;
}
/**
 * 
 * @export
 * @interface DuplicatePolicyVersionView
 */
export interface DuplicatePolicyVersionView {
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyVersionView
     */
    'approved_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyVersionView
     */
    'approved_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyVersionView
     */
    'approved_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyVersionView
     */
    'change_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyVersionView
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyVersionView
     */
    'created_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyVersionView
     */
    'created_by_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyVersionView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DuplicatePolicyVersionView
     */
    'publication_state'?: DuplicatePolicyVersionViewPublicationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyVersionView
     */
    'row_version'?: number;
    /**
     * 
     * @type {DuplicatePolicySettingsView}
     * @memberof DuplicatePolicyVersionView
     */
    'settings'?: DuplicatePolicySettingsView;
    /**
     * 
     * @type {number}
     * @memberof DuplicatePolicyVersionView
     */
    'version'?: number;
}

export const DuplicatePolicyVersionViewPublicationStateEnum = {
    Draft: 'Draft',
    Published: 'Published'
} as const;

export type DuplicatePolicyVersionViewPublicationStateEnum = typeof DuplicatePolicyVersionViewPublicationStateEnum[keyof typeof DuplicatePolicyVersionViewPublicationStateEnum];

/**
 * 
 * @export
 * @interface DuplicateRecheckReport
 */
export interface DuplicateRecheckReport {
    /**
     * 
     * @type {number}
     * @memberof DuplicateRecheckReport
     */
    'cases_to_recheck'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicateRecheckReport
     */
    'checked'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DuplicateRecheckReport
     */
    'failures'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof DuplicateRecheckReport
     */
    'left_list'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicateRecheckReport
     */
    'stayed_on_list'?: number;
}
/**
 * 
 * @export
 * @interface DuplicateRecheckView
 */
export interface DuplicateRecheckView {
    /**
     * 
     * @type {number}
     * @memberof DuplicateRecheckView
     */
    'cases_per_run'?: number;
    /**
     * 
     * @type {number}
     * @memberof DuplicateRecheckView
     */
    'cases_to_recheck'?: number;
}
/**
 * 
 * @export
 * @interface E2bProfileResponse
 */
export interface E2bProfileResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof E2bProfileResponse
     */
    'declarationProfiles'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof E2bProfileResponse
     */
    'profile'?: E2bProfileResponseProfileEnum;
    /**
     * 
     * @type {Array<E2bReceiverOption>}
     * @memberof E2bProfileResponse
     */
    'receivers'?: Array<E2bReceiverOption>;
}

export const E2bProfileResponseProfileEnum = {
    Ich: 'ICH',
    Fda: 'FDA'
} as const;

export type E2bProfileResponseProfileEnum = typeof E2bProfileResponseProfileEnum[keyof typeof E2bProfileResponseProfileEnum];

/**
 * 
 * @export
 * @interface E2bReceiverOption
 */
export interface E2bReceiverOption {
    /**
     * 
     * @type {string}
     * @memberof E2bReceiverOption
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof E2bReceiverOption
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof E2bReceiverOption
     */
    'route'?: E2bReceiverOptionRouteEnum;
}

export const E2bReceiverOptionRouteEnum = {
    Postmarket: 'POSTMARKET',
    Ind: 'IND',
    IndExemptBaBe: 'IND_EXEMPT_BA_BE'
} as const;

export type E2bReceiverOptionRouteEnum = typeof E2bReceiverOptionRouteEnum[keyof typeof E2bReceiverOptionRouteEnum];

/**
 * 
 * @export
 * @interface ErrorTypeCount
 */
export interface ErrorTypeCount {
    /**
     * 
     * @type {number}
     * @memberof ErrorTypeCount
     */
    'cases'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorTypeCount
     */
    'label'?: string;
}
/**
 * 
 * @export
 * @interface EventSummary
 */
export interface EventSummary {
    /**
     * 
     * @type {number}
     * @memberof EventSummary
     */
    'database_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    'hospitalization_record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    'label'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventSummary
     */
    'primary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EventSummary
     */
    'record_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventSummary
     */
    'serious'?: boolean;
}
/**
 * 
 * @export
 * @interface EventsContext
 */
export interface EventsContext {
    /**
     * 
     * @type {Array<EventSummary>}
     * @memberof EventsContext
     */
    'events'?: Array<EventSummary>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EventsContext
     */
    'option_labels_by_field_id'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ExternalCaseReference
 */
export interface ExternalCaseReference {
    /**
     * 
     * @type {string}
     * @memberof ExternalCaseReference
     */
    'issuer'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalCaseReference
     */
    'page'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalCaseReference
     */
    'sourceQuote'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCaseReference
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCaseReference
     */
    'value'?: string;
}
/**
 * Why a pending extracted value was not stored; the reviewer replaces it or leaves the field empty
 * @export
 * @interface ExtractedValueProblem
 */
export interface ExtractedValueProblem {
    /**
     * 
     * @type {number}
     * @memberof ExtractedValueProblem
     */
    'length'?: number;
    /**
     * 
     * @type {number}
     * @memberof ExtractedValueProblem
     */
    'limit'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtractedValueProblem
     */
    'reason'?: ExtractedValueProblemReasonEnum;
}

export const ExtractedValueProblemReasonEnum = {
    TooLong: 'TOO_LONG'
} as const;

export type ExtractedValueProblemReasonEnum = typeof ExtractedValueProblemReasonEnum[keyof typeof ExtractedValueProblemReasonEnum];

/**
 * 
 * @export
 * @interface FieldAddress
 */
export interface FieldAddress {
    /**
     * 
     * @type {string}
     * @memberof FieldAddress
     */
    'field_id'?: string;
    /**
     * 
     * @type {RecordAddress}
     * @memberof FieldAddress
     */
    'record'?: RecordAddress;
}
/**
 * 
 * @export
 * @interface FieldComparison
 */
export interface FieldComparison {
    /**
     * 
     * @type {string}
     * @memberof FieldComparison
     */
    'current_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldComparison
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldComparison
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldComparison
     */
    'match_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldComparison
     */
    'section'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldComparison
     */
    'selected_value'?: string;
}
/**
 * 
 * @export
 * @interface FieldGroupRate
 */
export interface FieldGroupRate {
    /**
     * 
     * @type {number}
     * @memberof FieldGroupRate
     */
    'cases'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldGroupRate
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldGroupRate
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof FieldGroupRate
     */
    'percent'?: number;
}
/**
 * 
 * @export
 * @interface FieldHistoryDto
 */
export interface FieldHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryDto
     */
    'caseNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryDto
     */
    'column'?: string;
    /**
     * 
     * @type {Array<FieldHistoryEntryDto>}
     * @memberof FieldHistoryDto
     */
    'entries'?: Array<FieldHistoryEntryDto>;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryDto
     */
    'fieldUiId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryDto
     */
    'recordPk'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryDto
     */
    'table'?: string;
}
/**
 * 
 * @export
 * @interface FieldHistoryEntryDto
 */
export interface FieldHistoryEntryDto {
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'actionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'actorKind'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'actorName'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'changedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'newDisplay'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'oldDisplay'?: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof FieldHistoryEntryDto
     */
    'provenance'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'source'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FieldHistoryEntryDto
     */
    'stateUnavailable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'valueClass'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldHistoryEntryDto
     */
    'workflowState'?: string;
}
/**
 * 
 * @export
 * @interface FieldOverride
 */
export interface FieldOverride {
    /**
     * 
     * @type {string}
     * @memberof FieldOverride
     */
    'field_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldOverride
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface FieldResult
 */
export interface FieldResult {
    /**
     * 
     * @type {string}
     * @memberof FieldResult
     */
    'candidate'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldResult
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldResult
     */
    'incoming'?: string;
    /**
     * 
     * @type {number}
     * @memberof FieldResult
     */
    'points'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldResult
     */
    'result'?: string;
    /**
     * 
     * @type {number}
     * @memberof FieldResult
     */
    'weight'?: number;
    /**
     * 
     * @type {string}
     * @memberof FieldResult
     */
    'why'?: string;
}
/**
 * 
 * @export
 * @interface FilterOption
 */
export interface FilterOption {
    /**
     * 
     * @type {string}
     * @memberof FilterOption
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof FilterOption
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof FilterOption
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface FilterOptions
 */
export interface FilterOptions {
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterOptions
     */
    'authorities'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterOptions
     */
    'countries'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterOptions
     */
    'priorities'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterOptions
     */
    'products'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterOptions
     */
    'seriousness'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FollowUpAttempt
 */
export interface FollowUpAttempt {
    /**
     * 
     * @type {number}
     * @memberof FollowUpAttempt
     */
    'attempt'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowUpAttempt
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowUpAttempt
     */
    'due_in_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowUpAttempt
     */
    'information_needed'?: string;
}
/**
 * 
 * @export
 * @interface FollowUpClaim
 */
export interface FollowUpClaim {
    /**
     * 
     * @type {boolean}
     * @memberof FollowUpClaim
     */
    'claimed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FollowUpClaim
     */
    'evidence'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FollowUpClaim
     */
    'explicit'?: boolean;
}
/**
 * 
 * @export
 * @interface FollowUpsResponse
 */
export interface FollowUpsResponse {
    /**
     * 
     * @type {Array<FollowUpAttempt>}
     * @memberof FollowUpsResponse
     */
    'attempts_due'?: Array<FollowUpAttempt>;
    /**
     * 
     * @type {Array<OpenQuery>}
     * @memberof FollowUpsResponse
     */
    'open_queries'?: Array<OpenQuery>;
    /**
     * 
     * @type {number}
     * @memberof FollowUpsResponse
     */
    'open_queries_total'?: number;
}
/**
 * 
 * @export
 * @interface FollowupArrivalView
 */
export interface FollowupArrivalView {
    /**
     * 
     * @type {boolean}
     * @memberof FollowupArrivalView
     */
    'amendment'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'answers_query_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'base_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupArrivalView
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupArrivalView
     */
    'created_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupArrivalView
     */
    'document_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'incoming_case_id'?: number;
    /**
     * 
     * @type {InternalDeadlineView}
     * @memberof FollowupArrivalView
     */
    'internal_deadline'?: InternalDeadlineView;
    /**
     * 
     * @type {string}
     * @memberof FollowupArrivalView
     */
    'justification'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'pending_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupArrivalView
     */
    'received_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'row_version'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupArrivalView
     */
    'significant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FollowupArrivalView
     */
    'status'?: FollowupArrivalViewStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'target_case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupArrivalView
     */
    'version'?: number;
}

export const FollowupArrivalViewStatusEnum = {
    Pending: 'PENDING',
    Complete: 'COMPLETE'
} as const;

export type FollowupArrivalViewStatusEnum = typeof FollowupArrivalViewStatusEnum[keyof typeof FollowupArrivalViewStatusEnum];

/**
 * 
 * @export
 * @interface FollowupAttachCommand
 */
export interface FollowupAttachCommand {
    /**
     * 
     * @type {boolean}
     * @memberof FollowupAttachCommand
     */
    'amendment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FollowupAttachCommand
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttachCommand
     */
    'incoming_revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupAttachCommand
     */
    'justification'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttachCommand
     */
    'parent_revision'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttachCommand
     */
    'query_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupAttachCommand
     */
    'received_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupAttachCommand
     */
    'received_date_confirmed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupAttachCommand
     */
    'significant'?: boolean;
}
/**
 * 
 * @export
 * @interface FollowupAttached
 */
export interface FollowupAttached {
    /**
     * 
     * @type {boolean}
     * @memberof FollowupAttached
     */
    'created_version'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttached
     */
    'followup_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttached
     */
    'parent_revision'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttached
     */
    'pending_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttached
     */
    'target_case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupAttached
     */
    'target_version'?: number;
}
/**
 * 
 * @export
 * @interface FollowupCurrentSourceView
 */
export interface FollowupCurrentSourceView {
    /**
     * 
     * @type {FieldAddress}
     * @memberof FollowupCurrentSourceView
     */
    'address'?: FieldAddress;
    /**
     * 
     * @type {object}
     * @memberof FollowupCurrentSourceView
     */
    'applied_value'?: object;
    /**
     * 
     * @type {string}
     * @memberof FollowupCurrentSourceView
     */
    'decision'?: FollowupCurrentSourceViewDecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof FollowupCurrentSourceView
     */
    'decision_action_id'?: string;
    /**
     * 
     * @type {FollowupEvidenceView}
     * @memberof FollowupCurrentSourceView
     */
    'evidence'?: FollowupEvidenceView;
}

export const FollowupCurrentSourceViewDecisionEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Edited: 'EDITED',
    Kept: 'KEPT',
    Unchanged: 'UNCHANGED',
    Excluded: 'EXCLUDED',
    Inherited: 'INHERITED'
} as const;

export type FollowupCurrentSourceViewDecisionEnum = typeof FollowupCurrentSourceViewDecisionEnum[keyof typeof FollowupCurrentSourceViewDecisionEnum];

/**
 * 
 * @export
 * @interface FollowupDocumentView
 */
export interface FollowupDocumentView {
    /**
     * 
     * @type {string}
     * @memberof FollowupDocumentView
     */
    'file_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupDocumentView
     */
    'followup_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupDocumentView
     */
    'source_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupDocumentView
     */
    'source_kind'?: FollowupDocumentViewSourceKindEnum;
}

export const FollowupDocumentViewSourceKindEnum = {
    Original: 'ORIGINAL',
    BaseVersion: 'BASE_VERSION',
    Incoming: 'INCOMING'
} as const;

export type FollowupDocumentViewSourceKindEnum = typeof FollowupDocumentViewSourceKindEnum[keyof typeof FollowupDocumentViewSourceKindEnum];

/**
 * 
 * @export
 * @interface FollowupEvidenceView
 */
export interface FollowupEvidenceView {
    /**
     * 
     * @type {string}
     * @memberof FollowupEvidenceView
     */
    'confidence'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupEvidenceView
     */
    'document_case_id'?: number;
    /**
     * 
     * @type {CatalogFieldProvenance}
     * @memberof FollowupEvidenceView
     */
    'provenance'?: CatalogFieldProvenance;
    /**
     * 
     * @type {string}
     * @memberof FollowupEvidenceView
     */
    'reasoning'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupEvidenceView
     */
    'review_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupEvidenceView
     */
    'source_case_id'?: number;
    /**
     * 
     * @type {object}
     * @memberof FollowupEvidenceView
     */
    'value'?: object;
    /**
     * 
     * @type {string}
     * @memberof FollowupEvidenceView
     */
    'value_origin'?: FollowupEvidenceViewValueOriginEnum;
}

export const FollowupEvidenceViewValueOriginEnum = {
    AiExtracted: 'AI_EXTRACTED',
    ReviewerEdited: 'REVIEWER_EDITED',
    Stored: 'STORED',
    Inherited: 'INHERITED'
} as const;

export type FollowupEvidenceViewValueOriginEnum = typeof FollowupEvidenceViewValueOriginEnum[keyof typeof FollowupEvidenceViewValueOriginEnum];

/**
 * 
 * @export
 * @interface FollowupFailure
 */
export interface FollowupFailure {
    /**
     * 
     * @type {string}
     * @memberof FollowupFailure
     */
    'code'?: FollowupFailureCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof FollowupFailure
     */
    'field_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupFailure
     */
    'followup_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupFailure
     */
    'item_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupFailure
     */
    'latest_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupFailure
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupFailure
     */
    'source_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupFailure
     */
    'target_address'?: string;
}

export const FollowupFailureCodeEnum = {
    Unauthenticated: 'UNAUTHENTICATED',
    FollowupAlreadyAttached: 'FOLLOWUP_ALREADY_ATTACHED',
    FollowupInvalidParent: 'FOLLOWUP_INVALID_PARENT',
    FollowupEditLocked: 'FOLLOWUP_EDIT_LOCKED',
    FollowupParentInSubmission: 'FOLLOWUP_PARENT_IN_SUBMISSION',
    FollowupParentSuperseded: 'FOLLOWUP_PARENT_SUPERSEDED',
    FollowupUnsupportedParentState: 'FOLLOWUP_UNSUPPORTED_PARENT_STATE',
    FollowupInvalidRequest: 'FOLLOWUP_INVALID_REQUEST',
    FollowupUnsupportedField: 'FOLLOWUP_UNSUPPORTED_FIELD',
    FollowupTargetChanged: 'FOLLOWUP_TARGET_CHANGED',
    FollowupCompetingDecisions: 'FOLLOWUP_COMPETING_DECISIONS',
    FollowupNotAwaitingTakeIn: 'FOLLOWUP_NOT_AWAITING_TAKE_IN'
} as const;

export type FollowupFailureCodeEnum = typeof FollowupFailureCodeEnum[keyof typeof FollowupFailureCodeEnum];

/**
 * 
 * @export
 * @interface FollowupFieldChoice
 */
export interface FollowupFieldChoice {
    /**
     * 
     * @type {string}
     * @memberof FollowupFieldChoice
     */
    'action': FollowupFieldChoiceActionEnum;
    /**
     * 
     * @type {object}
     * @memberof FollowupFieldChoice
     */
    'edited_value'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupFieldChoice
     */
    'expected_current_present': boolean;
    /**
     * 
     * @type {object}
     * @memberof FollowupFieldChoice
     */
    'expected_current_value'?: object;
    /**
     * 
     * @type {number}
     * @memberof FollowupFieldChoice
     */
    'item_id': number;
    /**
     * 
     * @type {number}
     * @memberof FollowupFieldChoice
     */
    'item_revision': number;
}

export const FollowupFieldChoiceActionEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Edited: 'EDITED',
    Kept: 'KEPT',
    Unchanged: 'UNCHANGED',
    Excluded: 'EXCLUDED',
    Inherited: 'INHERITED'
} as const;

export type FollowupFieldChoiceActionEnum = typeof FollowupFieldChoiceActionEnum[keyof typeof FollowupFieldChoiceActionEnum];

/**
 * 
 * @export
 * @interface FollowupFieldView
 */
export interface FollowupFieldView {
    /**
     * 
     * @type {FieldAddress}
     * @memberof FollowupFieldView
     */
    'address'?: FieldAddress;
    /**
     * 
     * @type {object}
     * @memberof FollowupFieldView
     */
    'applied_value'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupFieldView
     */
    'baseline_present'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof FollowupFieldView
     */
    'baseline_value'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupFieldView
     */
    'current_present'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof FollowupFieldView
     */
    'current_value'?: object;
    /**
     * 
     * @type {string}
     * @memberof FollowupFieldView
     */
    'decided_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupFieldView
     */
    'decided_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupFieldView
     */
    'decision'?: FollowupFieldViewDecisionEnum;
    /**
     * 
     * @type {number}
     * @memberof FollowupFieldView
     */
    'followup_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupFieldView
     */
    'id'?: number;
    /**
     * 
     * @type {FollowupEvidenceView}
     * @memberof FollowupFieldView
     */
    'incoming_evidence'?: FollowupEvidenceView;
    /**
     * 
     * @type {object}
     * @memberof FollowupFieldView
     */
    'incoming_value'?: object;
    /**
     * 
     * @type {string}
     * @memberof FollowupFieldView
     */
    'match_action'?: FollowupFieldViewMatchActionEnum;
    /**
     * 
     * @type {string}
     * @memberof FollowupFieldView
     */
    'origin'?: FollowupFieldViewOriginEnum;
    /**
     * 
     * @type {FollowupEvidenceView}
     * @memberof FollowupFieldView
     */
    'original_evidence'?: FollowupEvidenceView;
    /**
     * 
     * @type {number}
     * @memberof FollowupFieldView
     */
    'row_version'?: number;
    /**
     * 
     * @type {RecordAddress}
     * @memberof FollowupFieldView
     */
    'source_address'?: RecordAddress;
}

export const FollowupFieldViewDecisionEnum = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Edited: 'EDITED',
    Kept: 'KEPT',
    Unchanged: 'UNCHANGED',
    Excluded: 'EXCLUDED',
    Inherited: 'INHERITED'
} as const;

export type FollowupFieldViewDecisionEnum = typeof FollowupFieldViewDecisionEnum[keyof typeof FollowupFieldViewDecisionEnum];
export const FollowupFieldViewMatchActionEnum = {
    Unresolved: 'UNRESOLVED',
    Match: 'MATCH',
    Create: 'CREATE',
    Exclude: 'EXCLUDE',
    Singleton: 'SINGLETON'
} as const;

export type FollowupFieldViewMatchActionEnum = typeof FollowupFieldViewMatchActionEnum[keyof typeof FollowupFieldViewMatchActionEnum];
export const FollowupFieldViewOriginEnum = {
    Incoming: 'INCOMING',
    BaseVersion: 'BASE_VERSION'
} as const;

export type FollowupFieldViewOriginEnum = typeof FollowupFieldViewOriginEnum[keyof typeof FollowupFieldViewOriginEnum];

/**
 * 
 * @export
 * @interface FollowupPreview
 */
export interface FollowupPreview {
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'action'?: FollowupPreviewActionEnum;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'assignee'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'case_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {LockHolderInfo}
     * @memberof FollowupPreview
     */
    'editor'?: LockHolderInfo;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupPreview
     */
    'eligible'?: boolean;
    /**
     * 
     * @type {Array<FollowupFailure>}
     * @memberof FollowupPreview
     */
    'findings'?: Array<FollowupFailure>;
    /**
     * 
     * @type {number}
     * @memberof FollowupPreview
     */
    'incoming_case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupPreview
     */
    'incoming_revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'lifecycle'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupPreview
     */
    'parent_case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupPreview
     */
    'parent_revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'received_date_prefill'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupPreview
     */
    'today'?: string;
}

export const FollowupPreviewActionEnum = {
    UseExistingVersion: 'USE_EXISTING_VERSION',
    MoveToQr: 'MOVE_TO_QR',
    NewVersion: 'NEW_VERSION'
} as const;

export type FollowupPreviewActionEnum = typeof FollowupPreviewActionEnum[keyof typeof FollowupPreviewActionEnum];

/**
 * 
 * @export
 * @interface FollowupReceiptDateCorrected
 */
export interface FollowupReceiptDateCorrected {
    /**
     * 
     * @type {InternalDeadlineView}
     * @memberof FollowupReceiptDateCorrected
     */
    'arrival_deadline'?: InternalDeadlineView;
    /**
     * 
     * @type {number}
     * @memberof FollowupReceiptDateCorrected
     */
    'arrival_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof FollowupReceiptDateCorrected
     */
    'arrival_row_version'?: number;
    /**
     * 
     * @type {InternalDeadlineView}
     * @memberof FollowupReceiptDateCorrected
     */
    'case_deadline'?: InternalDeadlineView;
    /**
     * 
     * @type {number}
     * @memberof FollowupReceiptDateCorrected
     */
    'case_revision'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupReceiptDateCorrected
     */
    'followup_receipt_date'?: string;
}
/**
 * 
 * @export
 * @interface FollowupReceiptDateCorrection
 */
export interface FollowupReceiptDateCorrection {
    /**
     * 
     * @type {number}
     * @memberof FollowupReceiptDateCorrection
     */
    'arrival_row_version': number;
    /**
     * 
     * @type {number}
     * @memberof FollowupReceiptDateCorrection
     */
    'case_revision': number;
    /**
     * 
     * @type {string}
     * @memberof FollowupReceiptDateCorrection
     */
    'catalog_version': string;
    /**
     * 
     * @type {string}
     * @memberof FollowupReceiptDateCorrection
     */
    'deadline_change_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupReceiptDateCorrection
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof FollowupReceiptDateCorrection
     */
    'received_date': string;
}
/**
 * 
 * @export
 * @interface FollowupRecordChoice
 */
export interface FollowupRecordChoice {
    /**
     * 
     * @type {string}
     * @memberof FollowupRecordChoice
     */
    'action': FollowupRecordChoiceActionEnum;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof FollowupRecordChoice
     */
    'additional_values'?: { [key: string]: object; };
    /**
     * 
     * @type {number}
     * @memberof FollowupRecordChoice
     */
    'followup_id': number;
    /**
     * 
     * @type {RecordAddress}
     * @memberof FollowupRecordChoice
     */
    'source': RecordAddress;
    /**
     * 
     * @type {RecordAddress}
     * @memberof FollowupRecordChoice
     */
    'target'?: RecordAddress;
}

export const FollowupRecordChoiceActionEnum = {
    Unresolved: 'UNRESOLVED',
    Match: 'MATCH',
    Create: 'CREATE',
    Exclude: 'EXCLUDE',
    Singleton: 'SINGLETON'
} as const;

export type FollowupRecordChoiceActionEnum = typeof FollowupRecordChoiceActionEnum[keyof typeof FollowupRecordChoiceActionEnum];

/**
 * 
 * @export
 * @interface FollowupRecordGroupView
 */
export interface FollowupRecordGroupView {
    /**
     * 
     * @type {number}
     * @memberof FollowupRecordGroupView
     */
    'followup_id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FollowupRecordGroupView
     */
    'item_ids'?: Array<number>;
    /**
     * 
     * @type {Array<RecordAddress>}
     * @memberof FollowupRecordGroupView
     */
    'links'?: Array<RecordAddress>;
    /**
     * 
     * @type {string}
     * @memberof FollowupRecordGroupView
     */
    'match_action'?: FollowupRecordGroupViewMatchActionEnum;
    /**
     * 
     * @type {RecordAddress}
     * @memberof FollowupRecordGroupView
     */
    'source_address'?: RecordAddress;
    /**
     * 
     * @type {RecordAddress}
     * @memberof FollowupRecordGroupView
     */
    'target_address'?: RecordAddress;
    /**
     * 
     * @type {string}
     * @memberof FollowupRecordGroupView
     */
    'title'?: string;
}

export const FollowupRecordGroupViewMatchActionEnum = {
    Unresolved: 'UNRESOLVED',
    Match: 'MATCH',
    Create: 'CREATE',
    Exclude: 'EXCLUDE',
    Singleton: 'SINGLETON'
} as const;

export type FollowupRecordGroupViewMatchActionEnum = typeof FollowupRecordGroupViewMatchActionEnum[keyof typeof FollowupRecordGroupViewMatchActionEnum];

/**
 * 
 * @export
 * @interface FollowupReviewView
 */
export interface FollowupReviewView {
    /**
     * 
     * @type {Array<FollowupArrivalView>}
     * @memberof FollowupReviewView
     */
    'arrivals'?: Array<FollowupArrivalView>;
    /**
     * 
     * @type {Array<FollowupCurrentSourceView>}
     * @memberof FollowupReviewView
     */
    'current_sources'?: Array<FollowupCurrentSourceView>;
    /**
     * 
     * @type {Array<FollowupDocumentView>}
     * @memberof FollowupReviewView
     */
    'documents'?: Array<FollowupDocumentView>;
    /**
     * 
     * @type {Array<FollowupFieldView>}
     * @memberof FollowupReviewView
     */
    'fields'?: Array<FollowupFieldView>;
    /**
     * 
     * @type {number}
     * @memberof FollowupReviewView
     */
    'pending_count'?: number;
    /**
     * 
     * @type {Array<FollowupRecordGroupView>}
     * @memberof FollowupReviewView
     */
    'record_groups'?: Array<FollowupRecordGroupView>;
}
/**
 * 
 * @export
 * @interface FollowupTakeInCommand
 */
export interface FollowupTakeInCommand {
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInCommand
     */
    'justification'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupTakeInCommand
     */
    'revision'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FollowupTakeInCommand
     */
    'significant'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FollowupTakeInCommand
     */
    'subtype_id'?: number;
}
/**
 * 
 * @export
 * @interface FollowupTakeInView
 */
export interface FollowupTakeInView {
    /**
     * 
     * @type {number}
     * @memberof FollowupTakeInView
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'determined_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'determined_by'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupTakeInView
     */
    'followup_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'followup_justification'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'incoming_case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupTakeInView
     */
    'parent_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'parent_case_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'parent_case_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'received_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupTakeInView
     */
    'revision'?: number;
    /**
     * 
     * @type {Array<CatalogOption>}
     * @memberof FollowupTakeInView
     */
    'subtypes'?: Array<CatalogOption>;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'version_if_not_significant'?: string;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakeInView
     */
    'version_if_significant'?: string;
}
/**
 * 
 * @export
 * @interface FollowupTakenIn
 */
export interface FollowupTakenIn {
    /**
     * 
     * @type {number}
     * @memberof FollowupTakenIn
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FollowupTakenIn
     */
    'case_version'?: string;
    /**
     * 
     * @type {number}
     * @memberof FollowupTakenIn
     */
    'revision'?: number;
}
/**
 * 
 * @export
 * @interface FwkGenAssessment
 */
export interface FwkGenAssessment {
    /**
     * 
     * @type {Array<FwkGenRelationshipsRecord>}
     * @memberof FwkGenAssessment
     */
    'relationships'?: Array<FwkGenRelationshipsRecord>;
}
/**
 * 
 * @export
 * @interface FwkGenCaseDetails
 */
export interface FwkGenCaseDetails {
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'case_blind_status'?: number;
    /**
     * 
     * @type {Array<FwkGenCaseExternalIdentifiersRecord>}
     * @memberof FwkGenCaseDetails
     */
    'case_external_identifiers'?: Array<FwkGenCaseExternalIdentifiersRecord>;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'center_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'central_receipt_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'classification'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenCaseDetails
     */
    'combination_product_report'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'country_of_incidence'?: number;
    /**
     * 
     * @type {Array<FwkGenCrossReportedIndsRecord>}
     * @memberof FwkGenCaseDetails
     */
    'cross_reported_inds'?: Array<FwkGenCrossReportedIndsRecord>;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'followup_case_version'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenCaseDetails
     */
    'followup_is_amendment'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'followup_received_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'followup_significance_justification'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenCaseDetails
     */
    'followup_significant'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'followup_subtype'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'followup_version'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenCaseDetails
     */
    'fulfils_local_expedited_criteria'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'ind_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'initial_receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'justification'?: string;
    /**
     * 
     * @type {Array<FwkGenLiteratureRecord>}
     * @memberof FwkGenCaseDetails
     */
    'literature'?: Array<FwkGenLiteratureRecord>;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'local_criteria_report_type'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenCaseDetails
     */
    'medically_confirmed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'modification_followup_justification'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'pre_anda_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'project_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'report_source_evidence'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'report_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'sponsor_study_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'study_blind_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'study_comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'study_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'study_design_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'study_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'study_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'study_phase'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'study_type'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenCaseDetails
     */
    'treatment_arm'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseDetails
     */
    'unblinding_date'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenCaseExternalIdentifiersRecord
 */
export interface FwkGenCaseExternalIdentifiersRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseExternalIdentifiersRecord
     */
    'issuer'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseExternalIdentifiersRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseExternalIdentifiersRecord
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCaseExternalIdentifiersRecord
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenCrossReportedIndsRecord
 */
export interface FwkGenCrossReportedIndsRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenCrossReportedIndsRecord
     */
    'ind_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenCrossReportedIndsRecord
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenDatasheetsRecord
 */
export interface FwkGenDatasheetsRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenDatasheetsRecord
     */
    'database_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDatasheetsRecord
     */
    'datasheet_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDatasheetsRecord
     */
    'determined_listedness'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDatasheetsRecord
     */
    'license_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDatasheetsRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDatasheetsRecord
     */
    'trade_name'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenDeterminedCausalityObject
 */
export interface FwkGenDeterminedCausalityObject {
    /**
     * 
     * @type {number}
     * @memberof FwkGenDeterminedCausalityObject
     */
    'method'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDeterminedCausalityObject
     */
    'result'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDeterminedCausalityObject
     */
    'source'?: number;
}
/**
 * 
 * @export
 * @interface FwkGenDosageRegimensRecord
 */
export interface FwkGenDosageRegimensRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenDosageRegimensRecord
     */
    'batch_lot_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'dose'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDosageRegimensRecord
     */
    'dose_description'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'dose_number'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'dose_unit'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDosageRegimensRecord
     */
    'expiration_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'frequency'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenDosageRegimensRecord
     */
    'ongoing'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'parent_administration_route'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'patient_administration_route'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDosageRegimensRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDosageRegimensRecord
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenDosageRegimensRecord
     */
    'stop_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'total_dose'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenDosageRegimensRecord
     */
    'total_dose_unit'?: number;
}
/**
 * 
 * @export
 * @interface FwkGenEntriesRecord
 */
export interface FwkGenEntriesRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'cid_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'lot_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'pcid_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'qc_comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'qc_result'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'qc_result_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEntriesRecord
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenEvent
 */
export interface FwkGenEvent {
    /**
     * 
     * @type {Array<FwkGenEventsRecord>}
     * @memberof FwkGenEvent
     */
    'events'?: Array<FwkGenEventsRecord>;
}
/**
 * 
 * @export
 * @interface FwkGenEventsRecord
 */
export interface FwkGenEventsRecord {
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'adverse_drug_withdrawal_reaction'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'coded_term'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenEventsRecord
     */
    'country_event_occurred'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'dropped_from_study_due_to_event'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'duration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'emergency_room_visit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenEventsRecord
     */
    'event_classification'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'high_level_group_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'high_level_group_term_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'high_level_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'high_level_term_code'?: string;
    /**
     * 
     * @type {FwkGenHospitalizationObject}
     * @memberof FwkGenEventsRecord
     */
    'hospitalization'?: FwkGenHospitalizationObject;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'infection'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenEventsRecord
     */
    'intensity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'is_serious'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'lack_of_efficacy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'lower_level_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'lower_level_term_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'meddra_coding'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'medical_confirmation_by_hcp'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'onset_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'onset_from_last_dose'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'onset_latency'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenEventsRecord
     */
    'outcome'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'patient_has_prior_history'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'physician_office_visit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'preferred_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'preferred_term_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'progression_of_disease'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'related_to_study_conduct'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'related_to_study_conduct_reported'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'reported_term'?: string;
    /**
     * 
     * @type {FwkGenSeriousnessCriteriaValue}
     * @memberof FwkGenEventsRecord
     */
    'seriousness_criteria'?: FwkGenSeriousnessCriteriaValue;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'seriousness_criteria_other'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'seriousness_from_ime'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'soc'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'soc_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenEventsRecord
     */
    'stop_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'term_highlighted_by_reporter'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenEventsRecord
     */
    'treatment_received'?: boolean;
}
/**
 * 
 * @export
 * @interface FwkGenHospitalizationObject
 */
export interface FwkGenHospitalizationObject {
    /**
     * 
     * @type {string}
     * @memberof FwkGenHospitalizationObject
     */
    'date_of_admission'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenHospitalizationObject
     */
    'date_of_discharge'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenHospitalizationObject
     */
    'hospital_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenHospitalizationObject
     */
    'narrative'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenHospitalizationObject
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenIndicationsRecord
 */
export interface FwkGenIndicationsRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenIndicationsRecord
     */
    'indication'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenIndicationsRecord
     */
    'llt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenIndicationsRecord
     */
    'meddra_coding'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenIndicationsRecord
     */
    'pt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenIndicationsRecord
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenLiteratureRecord
 */
export interface FwkGenLiteratureRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'authors'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'digital_object_identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'journal'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'pages'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'publication_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenLiteratureRecord
     */
    'volume'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenMedicalHistoryRecord
 */
export interface FwkGenMedicalHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'coding_dictionary'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'comments'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'continuing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'disease_coded_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'disease_term'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'disease_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'event_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'family_history'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'meddra_coding'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'medical_history_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenMedicalHistoryRecord
     */
    'start_date'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenNarrative
 */
export interface FwkGenNarrative {
    /**
     * 
     * @type {string}
     * @memberof FwkGenNarrative
     */
    'case_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenNarrative
     */
    'company_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenNarrative
     */
    'description_of_event'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenNarrative
     */
    'evaluation_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenNarrative
     */
    'final_narrative'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenParentMedicalHistoryRecord
 */
export interface FwkGenParentMedicalHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'disease_term'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'disease_type'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'end_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'ongoing'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'reaction'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentMedicalHistoryRecord
     */
    'start_date'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenParentPastDrugHistoryRecord
 */
export interface FwkGenParentPastDrugHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'drug_reaction'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'indication'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'name_of_drug_as_reported'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenParentPastDrugHistoryRecord
     */
    'start_date'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenPartsRecord
 */
export interface FwkGenPartsRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenPartsRecord
     */
    'name_part'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPartsRecord
     */
    'name_part_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPartsRecord
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenPastDrugHistoryRecord
 */
export interface FwkGenPastDrugHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'drug_reaction'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'indication'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'indication_coded_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenPastDrugHistoryRecord
     */
    'stop_date'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenProductsRecord
 */
export interface FwkGenProductsRecord {
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'abuse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'accidental_exposure'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'action_taken'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'additional_comments'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'authorization_country'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'authorization_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'authorization_type'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'batch_lot_not_within_specs'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'batch_lot_within_specs'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'company_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'concentration'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'concentration_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'configuration_product_id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'counterfeit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'dechallenge'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'dechallenge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'description'?: string;
    /**
     * 
     * @type {Array<FwkGenDosageRegimensRecord>}
     * @memberof FwkGenProductsRecord
     */
    'dosage_regimens'?: Array<FwkGenDosageRegimensRecord>;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'drug_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'drug_not_administered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'duration_first_dose_to_event'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'duration_first_dose_to_event_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'duration_last_dose_to_event'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'duration_last_dose_to_event_unit'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'duration_of_administration'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'duration_of_administration_unit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'expired_drug_used'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'father_exposed_to_drug'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'fda_additional_info'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'formulation'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'generic_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'gestational_period_at_exposure'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'has_interaction'?: boolean;
    /**
     * 
     * @type {Array<FwkGenIndicationsRecord>}
     * @memberof FwkGenProductsRecord
     */
    'indications'?: Array<FwkGenIndicationsRecord>;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'is_contraindicated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'is_study_drug'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'manufacturer_holder'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'market_authorization_holder'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'medication_error'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'misuse'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'ndc_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'obtain_drug_country'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'occupational_exposure'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'off_label_use'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'overdose'?: boolean;
    /**
     * 
     * @type {Array<FwkGenPartsRecord>}
     * @memberof FwkGenProductsRecord
     */
    'parts'?: Array<FwkGenPartsRecord>;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'product_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'product_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'product_role'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'product_type'?: number;
    /**
     * 
     * @type {FwkGenQualityControlObject}
     * @memberof FwkGenProductsRecord
     */
    'quality_control'?: FwkGenQualityControlObject;
    /**
     * 
     * @type {number}
     * @memberof FwkGenProductsRecord
     */
    'rechallenge'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'rechallenge_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {Array<FwkGenSubstancesRecord>}
     * @memberof FwkGenProductsRecord
     */
    'substances'?: Array<FwkGenSubstancesRecord>;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'taken_previously_tolerated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'tampering'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenProductsRecord
     */
    'trade_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenProductsRecord
     */
    'was_protocol_followed'?: boolean;
}
/**
 * 
 * @export
 * @interface FwkGenQualityControlObject
 */
export interface FwkGenQualityControlObject {
    /**
     * 
     * @type {string}
     * @memberof FwkGenQualityControlObject
     */
    'date_returned'?: string;
    /**
     * 
     * @type {Array<FwkGenEntriesRecord>}
     * @memberof FwkGenQualityControlObject
     */
    'entries'?: Array<FwkGenEntriesRecord>;
    /**
     * 
     * @type {string}
     * @memberof FwkGenQualityControlObject
     */
    'qc_cross_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenQualityControlObject
     */
    'qc_safety_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenQualityControlObject
     */
    'qc_sent_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenQualityControlObject
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface FwkGenRelationshipsRecord
 */
export interface FwkGenRelationshipsRecord {
    /**
     * 
     * @type {Array<FwkGenDatasheetsRecord>}
     * @memberof FwkGenRelationshipsRecord
     */
    'datasheets'?: Array<FwkGenDatasheetsRecord>;
    /**
     * 
     * @type {number}
     * @memberof FwkGenRelationshipsRecord
     */
    'dechallenge'?: number;
    /**
     * 
     * @type {FwkGenDeterminedCausalityObject}
     * @memberof FwkGenRelationshipsRecord
     */
    'determined_causality'?: FwkGenDeterminedCausalityObject;
    /**
     * 
     * @type {number}
     * @memberof FwkGenRelationshipsRecord
     */
    'rechallenge'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenRelationshipsRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {FwkGenReportedCausalityObject}
     * @memberof FwkGenRelationshipsRecord
     */
    'reported_causality'?: FwkGenReportedCausalityObject;
}
/**
 * 
 * @export
 * @interface FwkGenReportedCausalityObject
 */
export interface FwkGenReportedCausalityObject {
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportedCausalityObject
     */
    'method'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportedCausalityObject
     */
    'result'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportedCausalityObject
     */
    'source'?: number;
}
/**
 * 
 * @export
 * @interface FwkGenReportersRecord
 */
export interface FwkGenReportersRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'address_line1'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'address_line2'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'city'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'country'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'county'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'degree'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'department'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'fax'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'first_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenReportersRecord
     */
    'health_care_professional'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'institution_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenReportersRecord
     */
    'intermediary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenReportersRecord
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'middle_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'occupation'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'postal_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenReportersRecord
     */
    'protect_confidentiality'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'reference_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'relationship_to_patient'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'report_media'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'report_sent_to_authority'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'reporter_type'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'salutation'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenReportersRecord
     */
    'state'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenReportersRecord
     */
    'suffix'?: number;
}
/**
 * 
 * @export
 * @interface FwkGenSeriousnessCriteriaValue
 */
export interface FwkGenSeriousnessCriteriaValue {
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'congenital_anomaly'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'death'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'disability'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'hospitalized'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'intervention_required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'life_threatening'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'medically_significant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FwkGenSeriousnessCriteriaValue
     */
    'other'?: boolean;
}
/**
 * 
 * @export
 * @interface FwkGenSubstancesRecord
 */
export interface FwkGenSubstancesRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenSubstancesRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenSubstancesRecord
     */
    'strength'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenSubstancesRecord
     */
    'strength_unit'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSubstancesRecord
     */
    'substance_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSubstancesRecord
     */
    'substance_term_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSubstancesRecord
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenSummary
 */
export interface FwkGenSummary {
    /**
     * 
     * @type {number}
     * @memberof FwkGenSummary
     */
    'case_outcome'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSummary
     */
    'case_outcome_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSummary
     */
    'case_seriousness'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSummary
     */
    'case_seriousness_notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenSummary
     */
    'company_agent_causal'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSummary
     */
    'company_agent_causal_notes'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenSummary
     */
    'listedness_determination'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenSummary
     */
    'listedness_determination_notes'?: string;
}
/**
 * 
 * @export
 * @interface FwkGenTestProceduresRecord
 */
export interface FwkGenTestProceduresRecord {
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'interpretation'?: string;
    /**
     * 
     * @type {number}
     * @memberof FwkGenTestProceduresRecord
     */
    'normal_high'?: number;
    /**
     * 
     * @type {number}
     * @memberof FwkGenTestProceduresRecord
     */
    'normal_low'?: number;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'reference_range'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'reported_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'result'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'result_unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'test_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'test_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FwkGenTestProceduresRecord
     */
    'units'?: string;
}
/**
 * 
 * @export
 * @interface Hospitalization
 */
export interface Hospitalization {
    /**
     * 
     * @type {number}
     * @memberof Hospitalization
     */
    'case_event_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Hospitalization
     */
    'case_id'?: number;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof Hospitalization
     */
    'custom_fields'?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'date_of_admission'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'date_of_discharge'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'hospital_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'hospitalization_narrative'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Hospitalization
     */
    'hospitalized_yes_no'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Hospitalization
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'reason_for_hospitalization'?: string;
    /**
     * 
     * @type {string}
     * @memberof Hospitalization
     */
    'start_date'?: string;
}
/**
 * 
 * @export
 * @interface IdentifierMatch
 */
export interface IdentifierMatch {
    /**
     * 
     * @type {string}
     * @memberof IdentifierMatch
     */
    'candidate_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentifierMatch
     */
    'candidate_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentifierMatch
     */
    'incoming_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdentifierMatch
     */
    'incoming_value'?: string;
}
/**
 * 
 * @export
 * @interface ImeSeriousnessPreview
 */
export interface ImeSeriousnessPreview {
    /**
     * 
     * @type {boolean}
     * @memberof ImeSeriousnessPreview
     */
    'applies'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImeSeriousnessPreview
     */
    'list_preferred_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImeSeriousnessPreview
     */
    'list_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof ImeSeriousnessPreview
     */
    'meddra_code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImeSeriousnessPreview
     */
    'on_list'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImeSeriousnessPreview
     */
    'preferred_term'?: string;
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof ImeSeriousnessPreview
     */
    'seriousness_criteria'?: { [key: string]: boolean; };
    /**
     * 
     * @type {string}
     * @memberof ImeSeriousnessPreview
     */
    'seriousness_notes'?: string;
}
/**
 * 
 * @export
 * @interface IntakeScope
 */
export interface IntakeScope {
    /**
     * 
     * @type {number}
     * @memberof IntakeScope
     */
    'caseIndex'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeScope
     */
    'coverage'?: IntakeScopeCoverageEnum;
    /**
     * 
     * @type {string}
     * @memberof IntakeScope
     */
    'indexBlobKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeScope
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeScope
     */
    'label'?: string;
    /**
     * 
     * @type {Array<LineRange>}
     * @memberof IntakeScope
     */
    'lines'?: Array<LineRange>;
    /**
     * 
     * @type {Array<LineRange>}
     * @memberof IntakeScope
     */
    'sharedLines'?: Array<LineRange>;
    /**
     * 
     * @type {Array<ResolvedSpan>}
     * @memberof IntakeScope
     */
    'spans'?: Array<ResolvedSpan>;
    /**
     * 
     * @type {Array<UnresolvedLines>}
     * @memberof IntakeScope
     */
    'unresolvedLines'?: Array<UnresolvedLines>;
    /**
     * 
     * @type {boolean}
     * @memberof IntakeScope
     */
    'wholeDocument'?: boolean;
}

export const IntakeScopeCoverageEnum = {
    ValidatedLines: 'VALIDATED_LINES',
    UnscopedDocument: 'UNSCOPED_DOCUMENT'
} as const;

export type IntakeScopeCoverageEnum = typeof IntakeScopeCoverageEnum[keyof typeof IntakeScopeCoverageEnum];

/**
 * 
 * @export
 * @interface IntakeTrendResponse
 */
export interface IntakeTrendResponse {
    /**
     * 
     * @type {Array<TrendBar>}
     * @memberof IntakeTrendResponse
     */
    'bars'?: Array<TrendBar>;
    /**
     * 
     * @type {string}
     * @memberof IntakeTrendResponse
     */
    'range'?: IntakeTrendResponseRangeEnum;
}

export const IntakeTrendResponseRangeEnum = {
    SevenDays: 'SEVEN_DAYS',
    ThirtyDays: 'THIRTY_DAYS',
    ThreeMonths: 'THREE_MONTHS',
    OneYear: 'ONE_YEAR'
} as const;

export type IntakeTrendResponseRangeEnum = typeof IntakeTrendResponseRangeEnum[keyof typeof IntakeTrendResponseRangeEnum];

/**
 * 
 * @export
 * @interface IntakeTriageDecisionRequest
 */
export interface IntakeTriageDecisionRequest {
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageDecisionRequest
     */
    'decision'?: IntakeTriageDecisionRequestDecisionEnum;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageDecisionRequest
     */
    'duplicate_of_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageDecisionRequest
     */
    'justification'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageDecisionRequest
     */
    'parent_case_id'?: number;
    /**
     * FOLLOW_UP only, optional. The open query of the existing case that this document answers (\"This document answers a query\"). The query gets the receipt date as its response date.
     * @type {number}
     * @memberof IntakeTriageDecisionRequest
     */
    'query_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageDecisionRequest
     */
    'reason_code'?: IntakeTriageDecisionRequestReasonCodeEnum;
    /**
     * FOLLOW_UP only. The date that the company received the report. Required for an item from a document; it must not be in the future. Not used for an item from a case: the receipt date then comes from the referred case.
     * @type {string}
     * @memberof IntakeTriageDecisionRequest
     */
    'receipt_date'?: string;
    /**
     * FOLLOW_UP only, required. True when the follow-up has new medical information. Only a significant follow-up starts a new internal work date.
     * @type {boolean}
     * @memberof IntakeTriageDecisionRequest
     */
    'significant'?: boolean;
}

export const IntakeTriageDecisionRequestDecisionEnum = {
    NewCase: 'NEW_CASE',
    FollowUp: 'FOLLOW_UP',
    Duplicate: 'DUPLICATE',
    NotACase: 'NOT_A_CASE'
} as const;

export type IntakeTriageDecisionRequestDecisionEnum = typeof IntakeTriageDecisionRequestDecisionEnum[keyof typeof IntakeTriageDecisionRequestDecisionEnum];
export const IntakeTriageDecisionRequestReasonCodeEnum = {
    NotAnAdverseEvent: 'NOT_AN_ADVERSE_EVENT',
    TestOrDuplicateSubmission: 'TEST_OR_DUPLICATE_SUBMISSION',
    InsufficientInformation: 'INSUFFICIENT_INFORMATION',
    OutOfScope: 'OUT_OF_SCOPE'
} as const;

export type IntakeTriageDecisionRequestReasonCodeEnum = typeof IntakeTriageDecisionRequestReasonCodeEnum[keyof typeof IntakeTriageDecisionRequestReasonCodeEnum];

/**
 * The follow-up that a FOLLOW_UP decision recorded. Only the decision response carries it.
 * @export
 * @interface IntakeTriageFollowupView
 */
export interface IntakeTriageFollowupView {
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageFollowupView
     */
    'closed_case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageFollowupView
     */
    'existing_case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageFollowupView
     */
    'existing_case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageFollowupView
     */
    'followup_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageFollowupView
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageFollowupView
     */
    'receipt_date'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntakeTriageFollowupView
     */
    'significant'?: boolean;
}
/**
 * 
 * @export
 * @interface IntakeTriageItemResponse
 */
export interface IntakeTriageItemResponse {
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'claimed_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageItemResponse
     */
    'claimed_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'decided_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageItemResponse
     */
    'decided_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'decision'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'decision_justification'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'decision_reason_code'?: string;
    /**
     * Original source attachment file name
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'document_name'?: string;
    /**
     * What kind of file intake routing saw; null for items older than routing
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'document_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageItemResponse
     */
    'duplicate_of_case_id'?: number;
    /**
     * 
     * @type {IntakeTriageFollowupView}
     * @memberof IntakeTriageItemResponse
     */
    'follow_up'?: IntakeTriageFollowupView;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageItemResponse
     */
    'id'?: number;
    /**
     * 
     * @type {StoredDiscovery}
     * @memberof IntakeTriageItemResponse
     */
    'intake_classification'?: StoredDiscovery;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'reason_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'reason_detail'?: string;
    /**
     * Item from a case only: the initial receipt date of the referred case. A Follow-up decision uses it as the receipt date. Only the read of one item carries it.
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'referred_case_receipt_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageItemResponse
     */
    'resulting_case_id'?: number;
    /**
     * 
     * @type {IntakeTriageSliceDto}
     * @memberof IntakeTriageItemResponse
     */
    'slice'?: IntakeTriageSliceDto;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'source_ref'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageItemResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface IntakeTriageListResponse
 */
export interface IntakeTriageListResponse {
    /**
     * 
     * @type {Array<IntakeTriageItemResponse>}
     * @memberof IntakeTriageListResponse
     */
    'items'?: Array<IntakeTriageItemResponse>;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageListResponse
     */
    'page'?: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IntakeTriageListResponse
     */
    'reason_counts'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageListResponse
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageListResponse
     */
    'total_items'?: number;
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageListResponse
     */
    'total_pages'?: number;
}
/**
 * 
 * @export
 * @interface IntakeTriageSliceDto
 */
export interface IntakeTriageSliceDto {
    /**
     * 
     * @type {number}
     * @memberof IntakeTriageSliceDto
     */
    'age_years'?: number;
    /**
     * 
     * @type {Array<ExternalCaseReference>}
     * @memberof IntakeTriageSliceDto
     */
    'case_external_identifiers'?: Array<ExternalCaseReference>;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'client_organization'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'event_preferred_term'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'generic_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'onset_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'patient_identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'patient_initials'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'product_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'project_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'report_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'reporter_country'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'reporter_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof IntakeTriageSliceDto
     */
    'study_id'?: string;
}
/**
 * 
 * @export
 * @interface InternalDeadlineView
 */
export interface InternalDeadlineView {
    /**
     * 
     * @type {number}
     * @memberof InternalDeadlineView
     */
    'arrival_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'calculation_state'?: InternalDeadlineViewCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'case_calculation_state'?: InternalDeadlineViewCaseCalculationStateEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'clock_basis'?: InternalDeadlineViewClockBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'clock_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'completion_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'completion_state'?: InternalDeadlineViewCompletionStateEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'internal_due_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'internal_due_timezone'?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalDeadlineView
     */
    'interval_days'?: number;
    /**
     * 
     * @type {Array<MissingInputView>}
     * @memberof InternalDeadlineView
     */
    'missing_inputs'?: Array<MissingInputView>;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'policy_key'?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalDeadlineView
     */
    'policy_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'priority_level'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalDeadlineView
     */
    'source_field_path'?: string;
}

export const InternalDeadlineViewCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type InternalDeadlineViewCalculationStateEnum = typeof InternalDeadlineViewCalculationStateEnum[keyof typeof InternalDeadlineViewCalculationStateEnum];
export const InternalDeadlineViewCaseCalculationStateEnum = {
    Calculated: 'Calculated',
    Partial: 'Partial',
    Pending: 'Pending'
} as const;

export type InternalDeadlineViewCaseCalculationStateEnum = typeof InternalDeadlineViewCaseCalculationStateEnum[keyof typeof InternalDeadlineViewCaseCalculationStateEnum];
export const InternalDeadlineViewClockBasisEnum = {
    InitialReceiptDate: 'INITIAL_RECEIPT_DATE',
    ArrivalReceiptDate: 'ARRIVAL_RECEIPT_DATE'
} as const;

export type InternalDeadlineViewClockBasisEnum = typeof InternalDeadlineViewClockBasisEnum[keyof typeof InternalDeadlineViewClockBasisEnum];
export const InternalDeadlineViewCompletionStateEnum = {
    Open: 'Open',
    InProgress: 'In progress',
    Complete: 'Complete',
    NotApplicable: 'Not applicable',
    Withdrawn: 'Withdrawn'
} as const;

export type InternalDeadlineViewCompletionStateEnum = typeof InternalDeadlineViewCompletionStateEnum[keyof typeof InternalDeadlineViewCompletionStateEnum];

/**
 * 
 * @export
 * @interface InternalPolicyDefinition
 */
export interface InternalPolicyDefinition {
    /**
     * 
     * @type {string}
     * @memberof InternalPolicyDefinition
     */
    'clientOrganization'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalPolicyDefinition
     */
    'clockBasis'?: InternalPolicyDefinitionClockBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalPolicyDefinition
     */
    'completionStage'?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalPolicyDefinition
     */
    'followupClock'?: InternalPolicyDefinitionFollowupClockEnum;
    /**
     * 
     * @type {string}
     * @memberof InternalPolicyDefinition
     */
    'policyKind'?: InternalPolicyDefinitionPolicyKindEnum;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof InternalPolicyDefinition
     */
    'priorityIntervals'?: { [key: string]: number; };
    /**
     * 
     * @type {number}
     * @memberof InternalPolicyDefinition
     */
    'schemaVersion'?: number;
    /**
     * 
     * @type {string}
     * @memberof InternalPolicyDefinition
     */
    'timezone'?: string;
}

export const InternalPolicyDefinitionClockBasisEnum = {
    InitialReceiptDate: 'INITIAL_RECEIPT_DATE',
    ArrivalReceiptDate: 'ARRIVAL_RECEIPT_DATE'
} as const;

export type InternalPolicyDefinitionClockBasisEnum = typeof InternalPolicyDefinitionClockBasisEnum[keyof typeof InternalPolicyDefinitionClockBasisEnum];
export const InternalPolicyDefinitionFollowupClockEnum = {
    None: 'NONE',
    SignificantArrival: 'SIGNIFICANT_ARRIVAL',
    EveryArrival: 'EVERY_ARRIVAL'
} as const;

export type InternalPolicyDefinitionFollowupClockEnum = typeof InternalPolicyDefinitionFollowupClockEnum[keyof typeof InternalPolicyDefinitionFollowupClockEnum];
export const InternalPolicyDefinitionPolicyKindEnum = {
    Internal: 'Internal',
    Authority: 'Authority'
} as const;

export type InternalPolicyDefinitionPolicyKindEnum = typeof InternalPolicyDefinitionPolicyKindEnum[keyof typeof InternalPolicyDefinitionPolicyKindEnum];

/**
 * 
 * @export
 * @interface KpisResponse
 */
export interface KpisResponse {
    /**
     * 
     * @type {DueSoonKpi}
     * @memberof KpisResponse
     */
    'due_in_48_hours'?: DueSoonKpi;
    /**
     * 
     * @type {OnTimeKpi}
     * @memberof KpisResponse
     */
    'on_time_submissions'?: OnTimeKpi;
    /**
     * 
     * @type {OpenCasesKpi}
     * @memberof KpisResponse
     */
    'open_cases'?: OpenCasesKpi;
    /**
     * 
     * @type {OverdueKpi}
     * @memberof KpisResponse
     */
    'overdue'?: OverdueKpi;
}
/**
 * 
 * @export
 * @interface LateCase
 */
export interface LateCase {
    /**
     * 
     * @type {string}
     * @memberof LateCase
     */
    'authority'?: string;
    /**
     * 
     * @type {string}
     * @memberof LateCase
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof LateCase
     */
    'days_late'?: number;
    /**
     * 
     * @type {string}
     * @memberof LateCase
     */
    'product'?: string;
    /**
     * 
     * @type {string}
     * @memberof LateCase
     */
    'stage'?: string;
}
/**
 * 
 * @export
 * @interface LicenceBasisView
 */
export interface LicenceBasisView {
    /**
     * 
     * @type {string}
     * @memberof LicenceBasisView
     */
    'authorization_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof LicenceBasisView
     */
    'country_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof LicenceBasisView
     */
    'licence_id'?: number;
}
/**
 * 
 * @export
 * @interface LineRange
 */
export interface LineRange {
    /**
     * 
     * @type {number}
     * @memberof LineRange
     */
    'fromLine'?: number;
    /**
     * 
     * @type {number}
     * @memberof LineRange
     */
    'toLine'?: number;
}
/**
 * 
 * @export
 * @interface LineSpan
 */
export interface LineSpan {
    /**
     * 
     * @type {number}
     * @memberof LineSpan
     */
    'line'?: number;
    /**
     * 
     * @type {string}
     * @memberof LineSpan
     */
    'text'?: string;
}
/**
 * @type ListQueryQueue409Response
 * @export
 */
export type ListQueryQueue409Response = ApiResponseLockHolderInfo | ApiResponseVoid;

/**
 * 
 * @export
 * @interface LockHolderInfo
 */
export interface LockHolderInfo {
    /**
     * 
     * @type {string}
     * @memberof LockHolderInfo
     */
    'expires_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof LockHolderInfo
     */
    'locked_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof LockHolderInfo
     */
    'locked_by_name'?: string;
}
/**
 * 
 * @export
 * @interface LockOverrideRequest
 */
export interface LockOverrideRequest {
    /**
     * 
     * @type {string}
     * @memberof LockOverrideRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface LockView
 */
export interface LockView {
    /**
     * 
     * @type {string}
     * @memberof LockView
     */
    'acquiredAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof LockView
     */
    'caseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof LockView
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof LockView
     */
    'lockedBy'?: number;
    /**
     * 
     * @type {string}
     * @memberof LockView
     */
    'sessionId'?: string;
}
/**
 * 
 * @export
 * @interface MeddraPath
 */
export interface MeddraPath {
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'hlgt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'hlgtCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'hlt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'hltCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'pathId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeddraPath
     */
    'primarySoc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'soc'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraPath
     */
    'socCode'?: string;
}
/**
 * 
 * @export
 * @interface MeddraRelease
 */
export interface MeddraRelease {
    /**
     * 
     * @type {boolean}
     * @memberof MeddraRelease
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeddraRelease
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraRelease
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface MeddraSearchResponse
 */
export interface MeddraSearchResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MeddraSearchResponse
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MeddraSearchResponse
     */
    'offset'?: number;
    /**
     * 
     * @type {Array<MeddraTerm>}
     * @memberof MeddraSearchResponse
     */
    'terms'?: Array<MeddraTerm>;
}
/**
 * 
 * @export
 * @interface MeddraTerm
 */
export interface MeddraTerm {
    /**
     * 
     * @type {string}
     * @memberof MeddraTerm
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MeddraTerm
     */
    'current'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MeddraTerm
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraTerm
     */
    'name'?: string;
    /**
     * 
     * @type {Array<MeddraPath>}
     * @memberof MeddraTerm
     */
    'paths'?: Array<MeddraPath>;
    /**
     * 
     * @type {string}
     * @memberof MeddraTerm
     */
    'pt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraTerm
     */
    'ptCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof MeddraTerm
     */
    'version'?: string;
}
/**
 * 
 * @export
 * @interface MedicalHistoryRowContext
 */
export interface MedicalHistoryRowContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof MedicalHistoryRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof MedicalHistoryRowContext
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface MergedRangeView
 */
export interface MergedRangeView {
    /**
     * 
     * @type {number}
     * @memberof MergedRangeView
     */
    'first_column': number;
    /**
     * 
     * @type {number}
     * @memberof MergedRangeView
     */
    'first_row': number;
    /**
     * 
     * @type {number}
     * @memberof MergedRangeView
     */
    'last_column': number;
    /**
     * 
     * @type {number}
     * @memberof MergedRangeView
     */
    'last_row': number;
}
/**
 * 
 * @export
 * @interface MissingInputView
 */
export interface MissingInputView {
    /**
     * 
     * @type {number}
     * @memberof MissingInputView
     */
    'arrival_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MissingInputView
     */
    'authority_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingInputView
     */
    'field_path'?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingInputView
     */
    'reason_code'?: MissingInputViewReasonCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof MissingInputView
     */
    'record_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof MissingInputView
     */
    'result_id'?: number;
}

export const MissingInputViewReasonCodeEnum = {
    Missing: 'MISSING',
    FutureDate: 'FUTURE_DATE',
    NoPublishedPolicy: 'NO_PUBLISHED_POLICY',
    Unknown: 'UNKNOWN',
    Unresolved: 'UNRESOLVED',
    ReviewRequired: 'REVIEW_REQUIRED'
} as const;

export type MissingInputViewReasonCodeEnum = typeof MissingInputViewReasonCodeEnum[keyof typeof MissingInputViewReasonCodeEnum];

/**
 * 
 * @export
 * @interface Narrative
 */
export interface Narrative {
    /**
     * 
     * @type {number}
     * @memberof Narrative
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Narrative
     */
    'description_of_event'?: string;
    /**
     * 
     * @type {string}
     * @memberof Narrative
     */
    'final_narrative'?: string;
    /**
     * 
     * @type {number}
     * @memberof Narrative
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Narrative
     */
    'medracoded_event_desc'?: string;
    /**
     * 
     * @type {string}
     * @memberof Narrative
     */
    'pt_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Narrative
     */
    'suggested_followups'?: string;
}
/**
 * 
 * @export
 * @interface NarrativeComparison
 */
export interface NarrativeComparison {
    /**
     * 
     * @type {string}
     * @memberof NarrativeComparison
     */
    'candidate_narrative'?: string;
    /**
     * 
     * @type {string}
     * @memberof NarrativeComparison
     */
    'case_narrative'?: string;
}
/**
 * 
 * @export
 * @interface NarrativeContext
 */
export interface NarrativeContext {
    /**
     * 
     * @type {boolean}
     * @memberof NarrativeContext
     */
    'e2b_enabled'?: boolean;
    /**
     * 
     * @type {{ [key: string]: CatalogFieldRequirement; }}
     * @memberof NarrativeContext
     */
    'requirements'?: { [key: string]: CatalogFieldRequirement; };
    /**
     * 
     * @type {object}
     * @memberof NarrativeContext
     */
    'schema'?: object;
}
/**
 * 
 * @export
 * @interface NestedCollectionChange
 */
export interface NestedCollectionChange {
    /**
     * 
     * @type {Array<number>}
     * @memberof NestedCollectionChange
     */
    'deleted_ids'?: Array<number>;
    /**
     * 
     * @type {Array<NestedCollectionUpsert>}
     * @memberof NestedCollectionChange
     */
    'upserts'?: Array<NestedCollectionUpsert>;
}
/**
 * 
 * @export
 * @interface NestedCollectionUpsert
 */
export interface NestedCollectionUpsert {
    /**
     * 
     * @type {Array<Decision>}
     * @memberof NestedCollectionUpsert
     */
    'decisions'?: Array<Decision>;
    /**
     * 
     * @type {string}
     * @memberof NestedCollectionUpsert
     */
    'record_id'?: string;
    /**
     * 
     * @type {CatalogCollectionRecord}
     * @memberof NestedCollectionUpsert
     */
    'values': CatalogCollectionRecord;
}
/**
 * 
 * @export
 * @interface OnTimeKpi
 */
export interface OnTimeKpi {
    /**
     * 
     * @type {number}
     * @memberof OnTimeKpi
     */
    'delta_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof OnTimeKpi
     */
    'percent'?: number;
    /**
     * 
     * @type {number}
     * @memberof OnTimeKpi
     */
    'target_percent'?: number;
}
/**
 * 
 * @export
 * @interface OpenCasesKpi
 */
export interface OpenCasesKpi {
    /**
     * 
     * @type {number}
     * @memberof OpenCasesKpi
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenCasesKpi
     */
    'delta_vs_last_week'?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenCasesKpi
     */
    'unassigned'?: number;
}
/**
 * 
 * @export
 * @interface OpenQuery
 */
export interface OpenQuery {
    /**
     * 
     * @type {number}
     * @memberof OpenQuery
     */
    'age_days'?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenQuery
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenQuery
     */
    'kind'?: OpenQueryKindEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenQuery
     */
    'title'?: string;
}

export const OpenQueryKindEnum = {
    Query: 'QUERY',
    Task: 'TASK'
} as const;

export type OpenQueryKindEnum = typeof OpenQueryKindEnum[keyof typeof OpenQueryKindEnum];

/**
 * 
 * @export
 * @interface OpenQueryView
 */
export interface OpenQueryView {
    /**
     * 
     * @type {number}
     * @memberof OpenQueryView
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof OpenQueryView
     */
    'open_question_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof OpenQueryView
     */
    'recipient_label'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpenQueryView
     */
    'status'?: OpenQueryViewStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof OpenQueryView
     */
    'title'?: string;
}

export const OpenQueryViewStatusEnum = {
    Open: 'Open',
    Overdue: 'Overdue',
    AwaitingResponse: 'AwaitingResponse',
    Closed: 'Closed'
} as const;

export type OpenQueryViewStatusEnum = typeof OpenQueryViewStatusEnum[keyof typeof OpenQueryViewStatusEnum];

/**
 * 
 * @export
 * @interface OverdueKpi
 */
export interface OverdueKpi {
    /**
     * 
     * @type {number}
     * @memberof OverdueKpi
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof OverdueKpi
     */
    'delta_vs_last_week'?: number;
    /**
     * 
     * @type {string}
     * @memberof OverdueKpi
     */
    'oldest_clock'?: string;
    /**
     * 
     * @type {number}
     * @memberof OverdueKpi
     */
    'oldest_days_late'?: number;
}
/**
 * 
 * @export
 * @interface PairEvidence
 */
export interface PairEvidence {
    /**
     * 
     * @type {string}
     * @memberof PairEvidence
     */
    'added_by_hand_as'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PairEvidence
     */
    'agreeing_areas'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PairEvidence
     */
    'comparable_points'?: number;
    /**
     * 
     * @type {number}
     * @memberof PairEvidence
     */
    'earned_points'?: number;
    /**
     * 
     * @type {Array<FieldResult>}
     * @memberof PairEvidence
     */
    'fields'?: Array<FieldResult>;
    /**
     * 
     * @type {Array<IdentifierMatch>}
     * @memberof PairEvidence
     */
    'identifier_matches'?: Array<IdentifierMatch>;
    /**
     * 
     * @type {string}
     * @memberof PairEvidence
     */
    'model'?: string;
    /**
     * 
     * @type {number}
     * @memberof PairEvidence
     */
    'receipt_gap_days'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PairEvidence
     */
    'receipt_gap_over_twelve_months'?: boolean;
}
/**
 * 
 * @export
 * @interface ParentContext
 */
export interface ParentContext {
    /**
     * 
     * @type {boolean}
     * @memberof ParentContext
     */
    'e2b_enabled'?: boolean;
    /**
     * 
     * @type {Array<ParentRowContext>}
     * @memberof ParentContext
     */
    'parent_medical_history'?: Array<ParentRowContext>;
    /**
     * 
     * @type {object}
     * @memberof ParentContext
     */
    'parent_medical_history_schema'?: object;
    /**
     * 
     * @type {Array<ParentRowContext>}
     * @memberof ParentContext
     */
    'parent_past_drug_history'?: Array<ParentRowContext>;
    /**
     * 
     * @type {object}
     * @memberof ParentContext
     */
    'parent_past_drug_history_schema'?: object;
    /**
     * 
     * @type {{ [key: string]: CatalogFieldRequirement; }}
     * @memberof ParentContext
     */
    'requirements'?: { [key: string]: CatalogFieldRequirement; };
    /**
     * 
     * @type {object}
     * @memberof ParentContext
     */
    'schema'?: object;
}
/**
 * 
 * @export
 * @interface ParentRowContext
 */
export interface ParentRowContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof ParentRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof ParentRowContext
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface PastDrugHistoryRowContext
 */
export interface PastDrugHistoryRowContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof PastDrugHistoryRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof PastDrugHistoryRowContext
     */
    'record_id'?: string;
}
/**
 * @type Patch409Response
 * @export
 */
export type Patch409Response = CatalogValidationError | DeadlineChangeConfirmation;

/**
 * 
 * @export
 * @interface PatientContext
 */
export interface PatientContext {
    /**
     * 
     * @type {boolean}
     * @memberof PatientContext
     */
    'e2b_enabled'?: boolean;
    /**
     * 
     * @type {Array<MedicalHistoryRowContext>}
     * @memberof PatientContext
     */
    'medical_history'?: Array<MedicalHistoryRowContext>;
    /**
     * 
     * @type {object}
     * @memberof PatientContext
     */
    'medical_history_schema'?: object;
    /**
     * 
     * @type {Array<PastDrugHistoryRowContext>}
     * @memberof PatientContext
     */
    'past_drug_history'?: Array<PastDrugHistoryRowContext>;
    /**
     * 
     * @type {object}
     * @memberof PatientContext
     */
    'past_drug_history_schema'?: object;
    /**
     * 
     * @type {{ [key: string]: CatalogFieldRequirement; }}
     * @memberof PatientContext
     */
    'requirements'?: { [key: string]: CatalogFieldRequirement; };
    /**
     * 
     * @type {object}
     * @memberof PatientContext
     */
    'schema'?: object;
    /**
     * 
     * @type {Array<TestProcedureRowContext>}
     * @memberof PatientContext
     */
    'test_procedures'?: Array<TestProcedureRowContext>;
    /**
     * 
     * @type {object}
     * @memberof PatientContext
     */
    'test_procedures_schema'?: object;
}
/**
 * 
 * @export
 * @interface PipelineStageCount
 */
export interface PipelineStageCount {
    /**
     * 
     * @type {number}
     * @memberof PipelineStageCount
     */
    'completed': number;
    /**
     * 
     * @type {number}
     * @memberof PipelineStageCount
     */
    'in_progress': number;
    /**
     * 
     * @type {number}
     * @memberof PipelineStageCount
     */
    'pending': number;
    /**
     * 
     * @type {string}
     * @memberof PipelineStageCount
     */
    'workflow_step': string;
}
/**
 * 
 * @export
 * @interface PolicyDraftCheckView
 */
export interface PolicyDraftCheckView {
    /**
     * 
     * @type {Array<string>}
     * @memberof PolicyDraftCheckView
     */
    'problems'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PolicyEditorOptionsView
 */
export interface PolicyEditorOptionsView {
    /**
     * 
     * @type {Array<ReferenceDocumentOptionView>}
     * @memberof PolicyEditorOptionsView
     */
    'reference_documents'?: Array<ReferenceDocumentOptionView>;
    /**
     * 
     * @type {Array<StudyOptionView>}
     * @memberof PolicyEditorOptionsView
     */
    'studies'?: Array<StudyOptionView>;
}
/**
 * 
 * @export
 * @interface PolicyPublicationCommand
 */
export interface PolicyPublicationCommand {
    /**
     * 
     * @type {string}
     * @memberof PolicyPublicationCommand
     */
    'change_reason': string;
    /**
     * 
     * @type {string}
     * @memberof PolicyPublicationCommand
     */
    'expected_draft_token': string;
}
/**
 * 
 * @export
 * @interface PolicyReplaced
 */
export interface PolicyReplaced {
    /**
     * 
     * @type {Array<ReplacedResultView>}
     * @memberof PolicyReplaced
     */
    'replaced': Array<ReplacedResultView>;
    /**
     * 
     * @type {number}
     * @memberof PolicyReplaced
     */
    'rule_version_id': number;
}
/**
 * 
 * @export
 * @interface PolicyReplacementCommand
 */
export interface PolicyReplacementCommand {
    /**
     * 
     * @type {string}
     * @memberof PolicyReplacementCommand
     */
    'reason': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PolicyReplacementCommand
     */
    'result_ids': Array<number>;
}
/**
 * 
 * @export
 * @interface ProcessorLoad
 */
export interface ProcessorLoad {
    /**
     * 
     * @type {string}
     * @memberof ProcessorLoad
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessorLoad
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessorLoad
     */
    'open_cases'?: number;
}
/**
 * 
 * @export
 * @interface ProcessorOutput
 */
export interface ProcessorOutput {
    /**
     * 
     * @type {string}
     * @memberof ProcessorOutput
     */
    'key'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessorOutput
     */
    'last_week'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProcessorOutput
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProcessorOutput
     */
    'this_week'?: number;
}
/**
 * 
 * @export
 * @interface ProductRecordContext
 */
export interface ProductRecordContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof ProductRecordContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof ProductRecordContext
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface ProductRowContext
 */
export interface ProductRowContext {
    /**
     * Coded indication captured at intake, retained for review only and excluded from WHODD matching.
     * @type {string}
     * @memberof ProductRowContext
     */
    'coded_indication'?: string;
    /**
     * Retained dictionary coding source for an unchanged product; absent when unattributed.
     * @type {string}
     * @memberof ProductRowContext
     */
    'coding_source'?: ProductRowContextCodingSourceEnum;
    /**
     * 
     * @type {{ [key: string]: Array<ProductRecordContext>; }}
     * @memberof ProductRowContext
     */
    'collections'?: { [key: string]: Array<ProductRecordContext>; };
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof ProductRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof ProductRowContext
     */
    'record_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductRowContext
     */
    'unattached_ai_values'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductRowContext
     */
    'whodrug_recode_available'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductRowContext
     */
    'whodrug_rid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductRowContext
     */
    'whodrug_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductRowContext
     */
    'whodrug_version'?: string;
}

export const ProductRowContextCodingSourceEnum = {
    CompanyConfiguration: 'COMPANY_CONFIGURATION',
    WhoDd: 'WHO_DD'
} as const;

export type ProductRowContextCodingSourceEnum = typeof ProductRowContextCodingSourceEnum[keyof typeof ProductRowContextCodingSourceEnum];

/**
 * 
 * @export
 * @interface ProductsContext
 */
export interface ProductsContext {
    /**
     * 
     * @type {Array<ProductRowContext>}
     * @memberof ProductsContext
     */
    'products'?: Array<ProductRowContext>;
    /**
     * 
     * @type {object}
     * @memberof ProductsContext
     */
    'products_schema'?: object;
}
/**
 * 
 * @export
 * @interface QcError
 */
export interface QcError {
    /**
     * 
     * @type {number}
     * @memberof QcError
     */
    'delta_points'?: number;
    /**
     * 
     * @type {Array<ErrorTypeCount>}
     * @memberof QcError
     */
    'error_types'?: Array<ErrorTypeCount>;
    /**
     * 
     * @type {Array<FieldGroupRate>}
     * @memberof QcError
     */
    'field_groups'?: Array<FieldGroupRate>;
    /**
     * 
     * @type {number}
     * @memberof QcError
     */
    'rate_percent'?: number;
}
/**
 * 
 * @export
 * @interface QualityResponse
 */
export interface QualityResponse {
    /**
     * 
     * @type {QcError}
     * @memberof QualityResponse
     */
    'qc_error'?: QcError;
    /**
     * 
     * @type {Rework}
     * @memberof QualityResponse
     */
    'rework'?: Rework;
}
/**
 * 
 * @export
 * @interface QueryAttemptView
 */
export interface QueryAttemptView {
    /**
     * 
     * @type {number}
     * @memberof QueryAttemptView
     */
    'activity_id': number;
    /**
     * 
     * @type {number}
     * @memberof QueryAttemptView
     */
    'attempt_number': number;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'due_on': string;
    /**
     * 
     * @type {number}
     * @memberof QueryAttemptView
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'kind': QueryAttemptViewKindEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'letter_file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'recipient_change_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'recipient_label'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryAttemptView
     */
    'recipient_reporter_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'sent_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryAttemptView
     */
    'sent_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryAttemptView
     */
    'state': QueryAttemptViewStateEnum;
}

export const QueryAttemptViewKindEnum = {
    First: 'FIRST',
    Reminder: 'REMINDER'
} as const;

export type QueryAttemptViewKindEnum = typeof QueryAttemptViewKindEnum[keyof typeof QueryAttemptViewKindEnum];
export const QueryAttemptViewStateEnum = {
    Draft: 'DRAFT',
    Sent: 'SENT',
    Skipped: 'SKIPPED'
} as const;

export type QueryAttemptViewStateEnum = typeof QueryAttemptViewStateEnum[keyof typeof QueryAttemptViewStateEnum];

/**
 * 
 * @export
 * @interface QueryCreationResult
 */
export interface QueryCreationResult {
    /**
     * 
     * @type {ActivityView}
     * @memberof QueryCreationResult
     */
    'activity'?: ActivityView;
}
/**
 * 
 * @export
 * @interface QueryExtension
 */
export interface QueryExtension {
    /**
     * 
     * @type {number}
     * @memberof QueryExtension
     */
    'activity_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryExtension
     */
    'attempt_number'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryExtension
     */
    'auto_close_on'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QueryExtension
     */
    'auto_closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueryExtension
     */
    'auto_followup_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof QueryExtension
     */
    'close_comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryExtension
     */
    'close_reason_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryExtension
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryExtension
     */
    'response_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryExtension
     */
    'response_channel'?: QueryExtensionResponseChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryExtension
     */
    'schedule_rule_key'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryExtension
     */
    'schedule_rule_version_id'?: number;
}

export const QueryExtensionResponseChannelEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE',
    Letter: 'LETTER',
    Fax: 'FAX'
} as const;

export type QueryExtensionResponseChannelEnum = typeof QueryExtensionResponseChannelEnum[keyof typeof QueryExtensionResponseChannelEnum];

/**
 * 
 * @export
 * @interface QueryLetterPreviewRequest
 */
export interface QueryLetterPreviewRequest {
    /**
     * 
     * @type {Array<QueryQuestionInput>}
     * @memberof QueryLetterPreviewRequest
     */
    'questions'?: Array<QueryQuestionInput>;
    /**
     * 
     * @type {number}
     * @memberof QueryLetterPreviewRequest
     */
    'recipient_reporter_id'?: number;
}
/**
 * 
 * @export
 * @interface QueryLetterRequest
 */
export interface QueryLetterRequest {
    /**
     * 
     * @type {string}
     * @memberof QueryLetterRequest
     */
    'recipient_change_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryLetterRequest
     */
    'recipient_email'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryLetterRequest
     */
    'recipient_reporter_id'?: number;
}
/**
 * 
 * @export
 * @interface QueryLetterTemplate
 */
export interface QueryLetterTemplate {
    /**
     * 
     * @type {string}
     * @memberof QueryLetterTemplate
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof QueryLetterTemplate
     */
    'subject': string;
}
/**
 * 
 * @export
 * @interface QueryLetterTemplates
 */
export interface QueryLetterTemplates {
    /**
     * 
     * @type {QueryLetterTemplate}
     * @memberof QueryLetterTemplates
     */
    'FIRST': QueryLetterTemplate;
    /**
     * 
     * @type {QueryLetterTemplate}
     * @memberof QueryLetterTemplates
     */
    'REMINDER': QueryLetterTemplate;
}
/**
 * 
 * @export
 * @interface QueryManagerSummary
 */
export interface QueryManagerSummary {
    /**
     * 
     * @type {number}
     * @memberof QueryManagerSummary
     */
    'due_soon_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryManagerSummary
     */
    'open_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryManagerSummary
     */
    'overdue_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryManagerSummary
     */
    'total_count'?: number;
}
/**
 * 
 * @export
 * @interface QueryProgress
 */
export interface QueryProgress {
    /**
     * 
     * @type {string}
     * @memberof QueryProgress
     */
    'next_attempt_due_on'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryProgress
     */
    'next_attempt_number'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryProgress
     */
    'planned_attempts'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof QueryProgress
     */
    'reminder_draft': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueryProgress
     */
    'response_received': boolean;
}
/**
 * 
 * @export
 * @interface QueryQuestionInput
 */
export interface QueryQuestionInput {
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionInput
     */
    'evidence_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionInput
     */
    'field_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionInput
     */
    'question_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionInput
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface QueryQuestionView
 */
export interface QueryQuestionView {
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'closed_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQuestionView
     */
    'closed_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'evidence_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'field_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQuestionView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'outcome_comment'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQuestionView
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'question_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'record_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQuestionView
     */
    'status'?: QueryQuestionViewStatusEnum;
}

export const QueryQuestionViewStatusEnum = {
    Open: 'OPEN',
    Answered: 'ANSWERED',
    UnknownConfirmed: 'UNKNOWN_CONFIRMED',
    Withdrawn: 'WITHDRAWN'
} as const;

export type QueryQuestionViewStatusEnum = typeof QueryQuestionViewStatusEnum[keyof typeof QueryQuestionViewStatusEnum];

/**
 * 
 * @export
 * @interface QueryQueueItem
 */
export interface QueryQueueItem {
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'activity_type_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'assigned_to'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'assigned_to_name'?: string;
    /**
     * 
     * @type {Array<ActivityAttachmentView>}
     * @memberof QueryQueueItem
     */
    'attachments'?: Array<ActivityAttachmentView>;
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'case_processor_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'closed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'created_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'due_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof QueryQueueItem
     */
    'is_serious'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueryQueueItem
     */
    'notification_badge'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'open_query_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'opened_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryQueueItem
     */
    'parent_activity_id'?: number;
    /**
     * 
     * @type {QueryProgress}
     * @memberof QueryQueueItem
     */
    'progress'?: QueryProgress;
    /**
     * 
     * @type {QueryExtension}
     * @memberof QueryQueueItem
     */
    'query_extension'?: QueryExtension;
    /**
     * 
     * @type {Array<QueryQuestionView>}
     * @memberof QueryQueueItem
     */
    'questions'?: Array<QueryQuestionView>;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'status'?: QueryQueueItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryQueueItem
     */
    'updated_at'?: string;
}

export const QueryQueueItemStatusEnum = {
    Open: 'Open',
    Overdue: 'Overdue',
    AwaitingResponse: 'AwaitingResponse',
    Closed: 'Closed'
} as const;

export type QueryQueueItemStatusEnum = typeof QueryQueueItemStatusEnum[keyof typeof QueryQueueItemStatusEnum];

/**
 * 
 * @export
 * @interface QueryRecipientView
 */
export interface QueryRecipientView {
    /**
     * 
     * @type {boolean}
     * @memberof QueryRecipientView
     */
    'confidential': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueryRecipientView
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryRecipientView
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueryRecipientView
     */
    'primary': boolean;
    /**
     * 
     * @type {number}
     * @memberof QueryRecipientView
     */
    'reporter_id': number;
}
/**
 * 
 * @export
 * @interface QueryScheduleCheckView
 */
export interface QueryScheduleCheckView {
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryScheduleCheckView
     */
    'problems': Array<string>;
}
/**
 * 
 * @export
 * @interface QueryScheduleDefinition
 */
export interface QueryScheduleDefinition {
    /**
     * 
     * @type {Array<QueryScheduleRule>}
     * @memberof QueryScheduleDefinition
     */
    'rules': Array<QueryScheduleRule>;
    /**
     * 
     * @type {QueryLetterTemplates}
     * @memberof QueryScheduleDefinition
     */
    'templates': QueryLetterTemplates;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleDefinition
     */
    'timezone': string;
}
/**
 * 
 * @export
 * @interface QueryScheduleDraftCommand
 */
export interface QueryScheduleDraftCommand {
    /**
     * 
     * @type {QueryScheduleDefinition}
     * @memberof QueryScheduleDraftCommand
     */
    'definition': QueryScheduleDefinition;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleDraftCommand
     */
    'expected_draft_token'?: string;
}
/**
 * 
 * @export
 * @interface QuerySchedulePublicationCommand
 */
export interface QuerySchedulePublicationCommand {
    /**
     * 
     * @type {string}
     * @memberof QuerySchedulePublicationCommand
     */
    'change_reason': string;
    /**
     * 
     * @type {string}
     * @memberof QuerySchedulePublicationCommand
     */
    'effective_from': string;
    /**
     * 
     * @type {string}
     * @memberof QuerySchedulePublicationCommand
     */
    'expected_draft_token': string;
}
/**
 * 
 * @export
 * @interface QueryScheduleRule
 */
export interface QueryScheduleRule {
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleRule
     */
    'autoCloseAfterDays': number;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleRule
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleRule
     */
    'pregnancy': QueryScheduleRulePregnancyEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof QueryScheduleRule
     */
    'reminderDays': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof QueryScheduleRule
     */
    'reportTypeIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleRule
     */
    'seriousness': QueryScheduleRuleSeriousnessEnum;
}

export const QueryScheduleRulePregnancyEnum = {
    Any: 'ANY',
    Pregnant: 'PREGNANT',
    NotPregnant: 'NOT_PREGNANT'
} as const;

export type QueryScheduleRulePregnancyEnum = typeof QueryScheduleRulePregnancyEnum[keyof typeof QueryScheduleRulePregnancyEnum];
export const QueryScheduleRuleSeriousnessEnum = {
    Any: 'ANY',
    Serious: 'SERIOUS',
    NonSerious: 'NON_SERIOUS'
} as const;

export type QueryScheduleRuleSeriousnessEnum = typeof QueryScheduleRuleSeriousnessEnum[keyof typeof QueryScheduleRuleSeriousnessEnum];

/**
 * 
 * @export
 * @interface QueryScheduleScreenView
 */
export interface QueryScheduleScreenView {
    /**
     * 
     * @type {boolean}
     * @memberof QueryScheduleScreenView
     */
    'can_edit': boolean;
    /**
     * 
     * @type {QueryScheduleVersionView}
     * @memberof QueryScheduleScreenView
     */
    'draft'?: QueryScheduleVersionView;
    /**
     * 
     * @type {QueryScheduleVersionView}
     * @memberof QueryScheduleScreenView
     */
    'published'?: QueryScheduleVersionView;
}
/**
 * 
 * @export
 * @interface QueryScheduleTestView
 */
export interface QueryScheduleTestView {
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleTestView
     */
    'case_number': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueryScheduleTestView
     */
    'pregnant': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleTestView
     */
    'report_type_name'?: string;
    /**
     * 
     * @type {QueryScheduleRule}
     * @memberof QueryScheduleTestView
     */
    'rule': QueryScheduleRule;
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleTestView
     */
    'rule_position': number;
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleTestView
     */
    'schedule_version': number;
    /**
     * 
     * @type {boolean}
     * @memberof QueryScheduleTestView
     */
    'serious': boolean;
}
/**
 * 
 * @export
 * @interface QueryScheduleVersionView
 */
export interface QueryScheduleVersionView {
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'approved_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleVersionView
     */
    'approved_by'?: number;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'approved_by_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'change_reason': string;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleVersionView
     */
    'created_by': number;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'created_by_name'?: string;
    /**
     * 
     * @type {QueryScheduleDefinition}
     * @memberof QueryScheduleVersionView
     */
    'definition': QueryScheduleDefinition;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'draft_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'effective_from': string;
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleVersionView
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof QueryScheduleVersionView
     */
    'publication_state': QueryScheduleVersionViewPublicationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof QueryScheduleVersionView
     */
    'version': number;
}

export const QueryScheduleVersionViewPublicationStateEnum = {
    Draft: 'Draft',
    Published: 'Published'
} as const;

export type QueryScheduleVersionViewPublicationStateEnum = typeof QueryScheduleVersionViewPublicationStateEnum[keyof typeof QueryScheduleVersionViewPublicationStateEnum];

/**
 * 
 * @export
 * @interface QuestionOutcomeInput
 */
export interface QuestionOutcomeInput {
    /**
     * 
     * @type {number}
     * @memberof QuestionOutcomeInput
     */
    'question_id': number;
    /**
     * 
     * @type {string}
     * @memberof QuestionOutcomeInput
     */
    'status': QuestionOutcomeInputStatusEnum;
}

export const QuestionOutcomeInputStatusEnum = {
    Open: 'OPEN',
    Answered: 'ANSWERED',
    UnknownConfirmed: 'UNKNOWN_CONFIRMED',
    Withdrawn: 'WITHDRAWN'
} as const;

export type QuestionOutcomeInputStatusEnum = typeof QuestionOutcomeInputStatusEnum[keyof typeof QuestionOutcomeInputStatusEnum];

/**
 * 
 * @export
 * @interface QuestionOutcomeRequest
 */
export interface QuestionOutcomeRequest {
    /**
     * 
     * @type {string}
     * @memberof QuestionOutcomeRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionOutcomeRequest
     */
    'status': QuestionOutcomeRequestStatusEnum;
}

export const QuestionOutcomeRequestStatusEnum = {
    Open: 'OPEN',
    Answered: 'ANSWERED',
    UnknownConfirmed: 'UNKNOWN_CONFIRMED',
    Withdrawn: 'WITHDRAWN'
} as const;

export type QuestionOutcomeRequestStatusEnum = typeof QuestionOutcomeRequestStatusEnum[keyof typeof QuestionOutcomeRequestStatusEnum];

/**
 * 
 * @export
 * @interface QuestionSuggestion
 */
export interface QuestionSuggestion {
    /**
     * 
     * @type {string}
     * @memberof QuestionSuggestion
     */
    'evidence_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionSuggestion
     */
    'field_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionSuggestion
     */
    'field_label'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionSuggestion
     */
    'question_text'?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionSuggestion
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface RaiseQueryRequest
 */
export interface RaiseQueryRequest {
    /**
     * 
     * @type {number}
     * @memberof RaiseQueryRequest
     */
    'activity_type_id': number;
    /**
     * 
     * @type {string}
     * @memberof RaiseQueryRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Array<QueryQuestionInput>}
     * @memberof RaiseQueryRequest
     */
    'questions'?: Array<QueryQuestionInput>;
}
/**
 * 
 * @export
 * @interface Reconciliation
 */
export interface Reconciliation {
    /**
     * 
     * @type {number}
     * @memberof Reconciliation
     */
    'ack_received'?: number;
    /**
     * 
     * @type {number}
     * @memberof Reconciliation
     */
    'submitted'?: number;
    /**
     * 
     * @type {Array<UnmatchedSubmission>}
     * @memberof Reconciliation
     */
    'unmatched'?: Array<UnmatchedSubmission>;
}
/**
 * 
 * @export
 * @interface RecordAddress
 */
export interface RecordAddress {
    /**
     * 
     * @type {string}
     * @memberof RecordAddress
     */
    'collection_id'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof RecordAddress
     */
    'owner_ids'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof RecordAddress
     */
    'record_id'?: number;
}
/**
 * 
 * @export
 * @interface RecordQueryResponseRequest
 */
export interface RecordQueryResponseRequest {
    /**
     * 
     * @type {string}
     * @memberof RecordQueryResponseRequest
     */
    'channel': RecordQueryResponseRequestChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof RecordQueryResponseRequest
     */
    'comment'?: string;
    /**
     * 
     * @type {Array<QuestionOutcomeInput>}
     * @memberof RecordQueryResponseRequest
     */
    'outcomes'?: Array<QuestionOutcomeInput>;
    /**
     * 
     * @type {string}
     * @memberof RecordQueryResponseRequest
     */
    'response_date': string;
}

export const RecordQueryResponseRequestChannelEnum = {
    Email: 'EMAIL',
    Phone: 'PHONE',
    Letter: 'LETTER',
    Fax: 'FAX'
} as const;

export type RecordQueryResponseRequestChannelEnum = typeof RecordQueryResponseRequestChannelEnum[keyof typeof RecordQueryResponseRequestChannelEnum];

/**
 * 
 * @export
 * @interface ReferenceDocumentOptionView
 */
export interface ReferenceDocumentOptionView {
    /**
     * 
     * @type {string}
     * @memberof ReferenceDocumentOptionView
     */
    'document_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDocumentOptionView
     */
    'file_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReferenceDocumentOptionView
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDocumentOptionView
     */
    'jurisdiction'?: string;
}
/**
 * 
 * @export
 * @interface ReferenceDocumentView
 */
export interface ReferenceDocumentView {
    /**
     * 
     * @type {number}
     * @memberof ReferenceDocumentView
     */
    'case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReferenceDocumentView
     */
    'document_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDocumentView
     */
    'file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDocumentView
     */
    'language'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReferenceDocumentView
     */
    'page_numbers'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ReferenceDocumentView
     */
    'section'?: string;
}
/**
 * 
 * @export
 * @interface ReferencesContext
 */
export interface ReferencesContext {
    /**
     * 
     * @type {boolean}
     * @memberof ReferencesContext
     */
    'e2b_enabled'?: boolean;
    /**
     * 
     * @type {object}
     * @memberof ReferencesContext
     */
    'notes_schema'?: object;
    /**
     * 
     * @type {object}
     * @memberof ReferencesContext
     */
    'references_schema'?: object;
    /**
     * 
     * @type {{ [key: string]: CatalogFieldRequirement; }}
     * @memberof ReferencesContext
     */
    'requirements'?: { [key: string]: CatalogFieldRequirement; };
}
/**
 * 
 * @export
 * @interface ReplacedResultView
 */
export interface ReplacedResultView {
    /**
     * 
     * @type {string}
     * @memberof ReplacedResultView
     */
    'calculation_state': ReplacedResultViewCalculationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof ReplacedResultView
     */
    'case_id': number;
    /**
     * 
     * @type {string}
     * @memberof ReplacedResultView
     */
    'case_number': string;
    /**
     * 
     * @type {string}
     * @memberof ReplacedResultView
     */
    'internal_due'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacedResultView
     */
    'regulatory_due'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReplacedResultView
     */
    'result_id': number;
}

export const ReplacedResultViewCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type ReplacedResultViewCalculationStateEnum = typeof ReplacedResultViewCalculationStateEnum[keyof typeof ReplacedResultViewCalculationStateEnum];

/**
 * 
 * @export
 * @interface ReplacementCandidateView
 */
export interface ReplacementCandidateView {
    /**
     * 
     * @type {number}
     * @memberof ReplacementCandidateView
     */
    'arrival_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'calculation_state': ReplacementCandidateViewCalculationStateEnum;
    /**
     * 
     * @type {number}
     * @memberof ReplacementCandidateView
     */
    'case_id': number;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'case_number': string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'clock_start'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'internal_due'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'obligation_key': string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'regulatory_due'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReplacementCandidateView
     */
    'report_kind': ReplacementCandidateViewReportKindEnum;
    /**
     * 
     * @type {number}
     * @memberof ReplacementCandidateView
     */
    'result_id': number;
    /**
     * 
     * @type {number}
     * @memberof ReplacementCandidateView
     */
    'rule_version'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReplacementCandidateView
     */
    'rule_version_id'?: number;
}

export const ReplacementCandidateViewCalculationStateEnum = {
    Calculated: 'Calculated',
    Pending: 'Pending'
} as const;

export type ReplacementCandidateViewCalculationStateEnum = typeof ReplacementCandidateViewCalculationStateEnum[keyof typeof ReplacementCandidateViewCalculationStateEnum];
export const ReplacementCandidateViewReportKindEnum = {
    InternalWork: 'INTERNAL_WORK',
    EarlyNotice: 'EARLY_NOTICE',
    ExpeditedReport: 'EXPEDITED_REPORT',
    FollowupReport: 'FOLLOWUP_REPORT'
} as const;

export type ReplacementCandidateViewReportKindEnum = typeof ReplacementCandidateViewReportKindEnum[keyof typeof ReplacementCandidateViewReportKindEnum];

/**
 * 
 * @export
 * @interface ReporterRowContext
 */
export interface ReporterRowContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof ReporterRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof ReporterRowContext
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface ReportersContext
 */
export interface ReportersContext {
    /**
     * 
     * @type {Array<ReporterRowContext>}
     * @memberof ReportersContext
     */
    'reporters'?: Array<ReporterRowContext>;
    /**
     * 
     * @type {object}
     * @memberof ReportersContext
     */
    'reporters_schema'?: object;
}
/**
 * 
 * @export
 * @interface ResolvedSpan
 */
export interface ResolvedSpan {
    /**
     * 
     * @type {number}
     * @memberof ResolvedSpan
     */
    'firstToken'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSpan
     */
    'lastToken'?: number;
    /**
     * 
     * @type {number}
     * @memberof ResolvedSpan
     */
    'line'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResolvedSpan
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface ReviewEvidenceView
 */
export interface ReviewEvidenceView {
    /**
     * 
     * @type {string}
     * @memberof ReviewEvidenceView
     */
    'actor_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEvidenceView
     */
    'correction_receipt_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEvidenceView
     */
    'decided_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEvidenceView
     */
    'decision'?: ReviewEvidenceViewDecisionEnum;
    /**
     * 
     * @type {string}
     * @memberof ReviewEvidenceView
     */
    'evidence_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReviewEvidenceView
     */
    'reason'?: string;
}

export const ReviewEvidenceViewDecisionEnum = {
    ReportRequired: 'REPORT_REQUIRED',
    NoReportRequired: 'NO_REPORT_REQUIRED',
    KeepPending: 'KEEP_PENDING',
    Withdraw: 'WITHDRAW',
    ManualComplete: 'MANUAL_COMPLETE',
    RecordLateReason: 'RECORD_LATE_REASON',
    CorrectComplianceEvidence: 'CORRECT_COMPLIANCE_EVIDENCE'
} as const;

export type ReviewEvidenceViewDecisionEnum = typeof ReviewEvidenceViewDecisionEnum[keyof typeof ReviewEvidenceViewDecisionEnum];

/**
 * 
 * @export
 * @interface Rework
 */
export interface Rework {
    /**
     * 
     * @type {number}
     * @memberof Rework
     */
    'reopened'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Rework
     */
    'reopened_by_week'?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Rework
     */
    'reopened_delta'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rework
     */
    'sent_back_delta'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rework
     */
    'sent_back_from_qc'?: number;
}
/**
 * 
 * @export
 * @interface Role
 */
export interface Role {
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof Role
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Role
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface RouteForwardRequest
 */
export interface RouteForwardRequest {
    /**
     * 
     * @type {boolean}
     * @memberof RouteForwardRequest
     */
    'esig_provided'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RouteForwardRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface RuleConditions
 */
export interface RuleConditions {
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleConditions
     */
    'causality'?: Array<RuleConditionsCausalityEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleConditions
     */
    'expectedness'?: Array<RuleConditionsExpectednessEnum>;
    /**
     * 
     * @type {string}
     * @memberof RuleConditions
     */
    'origin'?: RuleConditionsOriginEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof RuleConditions
     */
    'reportTypeIds'?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RuleConditions
     */
    'seriousness'?: Array<RuleConditionsSeriousnessEnum>;
}

export const RuleConditionsCausalityEnum = {
    Related: 'RELATED',
    NotRelated: 'NOT_RELATED',
    Unknown: 'UNKNOWN'
} as const;

export type RuleConditionsCausalityEnum = typeof RuleConditionsCausalityEnum[keyof typeof RuleConditionsCausalityEnum];
export const RuleConditionsExpectednessEnum = {
    Listed: 'Listed',
    Unlisted: 'Unlisted'
} as const;

export type RuleConditionsExpectednessEnum = typeof RuleConditionsExpectednessEnum[keyof typeof RuleConditionsExpectednessEnum];
export const RuleConditionsOriginEnum = {
    Domestic: 'DOMESTIC',
    Foreign: 'FOREIGN'
} as const;

export type RuleConditionsOriginEnum = typeof RuleConditionsOriginEnum[keyof typeof RuleConditionsOriginEnum];
export const RuleConditionsSeriousnessEnum = {
    FatalOrLifeThreatening: 'FATAL_OR_LIFE_THREATENING',
    Serious: 'SERIOUS',
    NonSerious: 'NON_SERIOUS'
} as const;

export type RuleConditionsSeriousnessEnum = typeof RuleConditionsSeriousnessEnum[keyof typeof RuleConditionsSeriousnessEnum];

/**
 * 
 * @export
 * @interface ScopeBasisView
 */
export interface ScopeBasisView {
    /**
     * 
     * @type {string}
     * @memberof ScopeBasisView
     */
    'case_country_name'?: string;
    /**
     * 
     * @type {Array<LicenceBasisView>}
     * @memberof ScopeBasisView
     */
    'licences'?: Array<LicenceBasisView>;
    /**
     * 
     * @type {string}
     * @memberof ScopeBasisView
     */
    'origin'?: ScopeBasisViewOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof ScopeBasisView
     */
    'study_id'?: string;
}

export const ScopeBasisViewOriginEnum = {
    Domestic: 'DOMESTIC',
    Foreign: 'FOREIGN'
} as const;

export type ScopeBasisViewOriginEnum = typeof ScopeBasisViewOriginEnum[keyof typeof ScopeBasisViewOriginEnum];

/**
 * 
 * @export
 * @interface SectionChange
 */
export interface SectionChange {
    /**
     * 
     * @type {{ [key: string]: CollectionChange; }}
     * @memberof SectionChange
     */
    'collections'?: { [key: string]: CollectionChange; };
    /**
     * 
     * @type {Array<Decision>}
     * @memberof SectionChange
     */
    'decisions'?: Array<Decision>;
    /**
     * 
     * @type {object}
     * @memberof SectionChange
     */
    'values': object;
}
/**
 * 
 * @export
 * @interface SendToIntakeTriageRequest
 */
export interface SendToIntakeTriageRequest {
    /**
     * 
     * @type {string}
     * @memberof SendToIntakeTriageRequest
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendToIntakeTriageRequest
     */
    'reason'?: SendToIntakeTriageRequestReasonEnum;
}

export const SendToIntakeTriageRequestReasonEnum = {
    DeadlineRisk: 'DEADLINE_RISK',
    ConflictingIdentifiers: 'CONFLICTING_IDENTIFIERS',
    Other: 'OTHER'
} as const;

export type SendToIntakeTriageRequestReasonEnum = typeof SendToIntakeTriageRequestReasonEnum[keyof typeof SendToIntakeTriageRequestReasonEnum];

/**
 * 
 * @export
 * @interface SendToIntakeTriageResponse
 */
export interface SendToIntakeTriageResponse {
    /**
     * 
     * @type {number}
     * @memberof SendToIntakeTriageResponse
     */
    'case_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof SendToIntakeTriageResponse
     */
    'intake_triage_item_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SendToIntakeTriageResponse
     */
    'reason_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SendToIntakeTriageResponse
     */
    'workflow_status'?: string;
}
/**
 * 
 * @export
 * @interface SheetView
 */
export interface SheetView {
    /**
     * 
     * @type {Array<CellView>}
     * @memberof SheetView
     */
    'cells': Array<CellView>;
    /**
     * 
     * @type {number}
     * @memberof SheetView
     */
    'column_count': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SheetView
     */
    'column_widths': Array<number>;
    /**
     * 
     * @type {Array<MergedRangeView>}
     * @memberof SheetView
     */
    'merged_ranges': Array<MergedRangeView>;
    /**
     * 
     * @type {string}
     * @memberof SheetView
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof SheetView
     */
    'row_count': number;
}
/**
 * 
 * @export
 * @interface SlaResult
 */
export interface SlaResult {
    /**
     * 
     * @type {number}
     * @memberof SlaResult
     */
    'actual_percent'?: number;
    /**
     * 
     * @type {number}
     * @memberof SlaResult
     */
    'cases'?: number;
    /**
     * 
     * @type {string}
     * @memberof SlaResult
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof SlaResult
     */
    'label'?: string;
    /**
     * 
     * @type {number}
     * @memberof SlaResult
     */
    'target_percent'?: number;
}
/**
 * 
 * @export
 * @interface SourceDocument
 */
export interface SourceDocument {
    /**
     * 
     * @type {number}
     * @memberof SourceDocument
     */
    'attachment_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceDocument
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof SourceDocument
     */
    'case_version'?: number;
    /**
     * 
     * @type {string}
     * @memberof SourceDocument
     */
    'document_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceDocument
     */
    'download_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceDocument
     */
    'file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceDocument
     */
    'received_at'?: string;
}
/**
 * 
 * @export
 * @interface SourceDocumentInfo
 */
export interface SourceDocumentInfo {
    /**
     * 
     * @type {string}
     * @memberof SourceDocumentInfo
     */
    'file_name': string;
    /**
     * 
     * @type {string}
     * @memberof SourceDocumentInfo
     */
    'kind': SourceDocumentInfoKindEnum;
}

export const SourceDocumentInfoKindEnum = {
    Pdf: 'PDF',
    Spreadsheet: 'SPREADSHEET',
    Other: 'OTHER'
} as const;

export type SourceDocumentInfoKindEnum = typeof SourceDocumentInfoKindEnum[keyof typeof SourceDocumentInfoKindEnum];

/**
 * 
 * @export
 * @interface SourceLocation
 */
export interface SourceLocation {
    /**
     * 
     * @type {Array<BoundingBox>}
     * @memberof SourceLocation
     */
    'boxes'?: Array<BoundingBox>;
    /**
     * 
     * @type {number}
     * @memberof SourceLocation
     */
    'page'?: number;
}
/**
 * 
 * @export
 * @interface SourceReference
 */
export interface SourceReference {
    /**
     * 
     * @type {string}
     * @memberof SourceReference
     */
    'indexBlobKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceReference
     */
    'ingress'?: SourceReferenceIngressEnum;
    /**
     * 
     * @type {string}
     * @memberof SourceReference
     */
    'pdfBlobKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof SourceReference
     */
    'readableType'?: SourceReferenceReadableTypeEnum;
}

export const SourceReferenceIngressEnum = {
    DirectUpload: 'DIRECT_UPLOAD',
    IntakeItem: 'INTAKE_ITEM'
} as const;

export type SourceReferenceIngressEnum = typeof SourceReferenceIngressEnum[keyof typeof SourceReferenceIngressEnum];
export const SourceReferenceReadableTypeEnum = {
    PdfNative: 'PDF_NATIVE',
    PdfScanned: 'PDF_SCANNED',
    PdfMixed: 'PDF_MIXED',
    Spreadsheet: 'SPREADSHEET',
    Word: 'WORD',
    Xml: 'XML',
    Email: 'EMAIL',
    Archive: 'ARCHIVE',
    Markdown: 'MARKDOWN',
    Text: 'TEXT',
    Unknown: 'UNKNOWN'
} as const;

export type SourceReferenceReadableTypeEnum = typeof SourceReferenceReadableTypeEnum[keyof typeof SourceReferenceReadableTypeEnum];

/**
 * 
 * @export
 * @interface SpreadsheetView
 */
export interface SpreadsheetView {
    /**
     * Every cell a field value was read from, for cell-to-field lookup
     * @type {Array<CitedCell>}
     * @memberof SpreadsheetView
     */
    'cited_cells': Array<CitedCell>;
    /**
     * 
     * @type {string}
     * @memberof SpreadsheetView
     */
    'file_name': string;
    /**
     * 
     * @type {Array<SheetView>}
     * @memberof SpreadsheetView
     */
    'sheets': Array<SheetView>;
}
/**
 * 
 * @export
 * @interface SseEmitter
 */
export interface SseEmitter {
    /**
     * 
     * @type {number}
     * @memberof SseEmitter
     */
    'timeout'?: number;
}
/**
 * 
 * @export
 * @interface StoredDiscovery
 */
export interface StoredDiscovery {
    /**
     * 
     * @type {Array<DiscoveredCase>}
     * @memberof StoredDiscovery
     */
    'cases'?: Array<DiscoveredCase>;
    /**
     * 
     * @type {string}
     * @memberof StoredDiscovery
     */
    'explanation'?: string;
    /**
     * 
     * @type {Array<ExternalCaseReference>}
     * @memberof StoredDiscovery
     */
    'externalIdentifiers'?: Array<ExternalCaseReference>;
    /**
     * 
     * @type {string}
     * @memberof StoredDiscovery
     */
    'firstSender'?: StoredDiscoveryFirstSenderEnum;
    /**
     * 
     * @type {FollowUpClaim}
     * @memberof StoredDiscovery
     */
    'followUp'?: FollowUpClaim;
    /**
     * 
     * @type {string}
     * @memberof StoredDiscovery
     */
    'outcome'?: StoredDiscoveryOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoredDiscovery
     */
    'reportType'?: StoredDiscoveryReportTypeEnum;
    /**
     * 
     * @type {Array<IntakeScope>}
     * @memberof StoredDiscovery
     */
    'scopes'?: Array<IntakeScope>;
    /**
     * 
     * @type {Array<LineRange>}
     * @memberof StoredDiscovery
     */
    'sharedLines'?: Array<LineRange>;
    /**
     * 
     * @type {SourceReference}
     * @memberof StoredDiscovery
     */
    'source'?: SourceReference;
    /**
     * 
     * @type {Array<UnresolvedLines>}
     * @memberof StoredDiscovery
     */
    'unresolvedLines'?: Array<UnresolvedLines>;
}

export const StoredDiscoveryFirstSenderEnum = {
    RegulatoryAuthority: 'REGULATORY_AUTHORITY',
    Other: 'OTHER',
    Unknown: 'UNKNOWN'
} as const;

export type StoredDiscoveryFirstSenderEnum = typeof StoredDiscoveryFirstSenderEnum[keyof typeof StoredDiscoveryFirstSenderEnum];
export const StoredDiscoveryOutcomeEnum = {
    CasesFound: 'CASES_FOUND',
    NoCase: 'NO_CASE',
    CaseBoundariesUnresolved: 'CASE_BOUNDARIES_UNRESOLVED'
} as const;

export type StoredDiscoveryOutcomeEnum = typeof StoredDiscoveryOutcomeEnum[keyof typeof StoredDiscoveryOutcomeEnum];
export const StoredDiscoveryReportTypeEnum = {
    Spontaneous: 'SPONTANEOUS',
    Pifu: 'PIFU',
    PossibleFollowup: 'POSSIBLE_FOLLOWUP',
    Literature: 'LITERATURE',
    Study: 'STUDY',
    RegulatoryAuthority: 'REGULATORY_AUTHORITY',
    Solicited: 'SOLICITED',
    Invalid: 'INVALID',
    Unknown: 'UNKNOWN'
} as const;

export type StoredDiscoveryReportTypeEnum = typeof StoredDiscoveryReportTypeEnum[keyof typeof StoredDiscoveryReportTypeEnum];

/**
 * 
 * @export
 * @interface Study
 */
export interface Study {
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'blinding_status'?: number;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'center_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'comments'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'e2b_study_type_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'ind_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'observe_study_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'other_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'pre_anda_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'project_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'study_blind_type_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'study_description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'study_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'study_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'study_phase'?: number;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'study_type'?: number;
    /**
     * 
     * @type {number}
     * @memberof Study
     */
    'treatment_arm'?: number;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'unblinding_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof Study
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface StudyCase
 */
export interface StudyCase {
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'centerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof StudyCase
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'observeStudyType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'otherId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'projectId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyBlindType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyBlindingStatus'?: string;
    /**
     * 
     * @type {number}
     * @memberof StudyCase
     */
    'studyCountryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyEligibleUnblinding'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyPhase'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'studyType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyCase
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface StudyCountryOption
 */
export interface StudyCountryOption {
    /**
     * 
     * @type {string}
     * @memberof StudyCountryOption
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof StudyCountryOption
     */
    'country_id': number;
    /**
     * 
     * @type {string}
     * @memberof StudyCountryOption
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface StudyCountryRequest
 */
export interface StudyCountryRequest {
    /**
     * 
     * @type {number}
     * @memberof StudyCountryRequest
     */
    'country_id'?: number;
}
/**
 * 
 * @export
 * @interface StudyCountryView
 */
export interface StudyCountryView {
    /**
     * 
     * @type {boolean}
     * @memberof StudyCountryView
     */
    'country_active': boolean;
    /**
     * 
     * @type {number}
     * @memberof StudyCountryView
     */
    'country_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyCountryView
     */
    'country_name'?: string;
    /**
     * 
     * @type {number}
     * @memberof StudyCountryView
     */
    'study_case_id': number;
    /**
     * 
     * @type {string}
     * @memberof StudyCountryView
     */
    'study_id': string;
}
/**
 * 
 * @export
 * @interface StudyListingMappingActivation
 */
export interface StudyListingMappingActivation {
    /**
     * 
     * @type {boolean}
     * @memberof StudyListingMappingActivation
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface StudyListingMappingRequest
 */
export interface StudyListingMappingRequest {
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingRequest
     */
    'layout_json': string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingRequest
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface StudyListingMappingSummary
 */
export interface StudyListingMappingSummary {
    /**
     * 
     * @type {boolean}
     * @memberof StudyListingMappingSummary
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof StudyListingMappingSummary
     */
    'based_on_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof StudyListingMappingSummary
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof StudyListingMappingSummary
     */
    'made_for_attachment_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingSummary
     */
    'origin': StudyListingMappingSummaryOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingSummary
     */
    'review_note'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingSummary
     */
    'review_status': StudyListingMappingSummaryReviewStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingSummary
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingSummary
     */
    'updated_at'?: string;
}

export const StudyListingMappingSummaryOriginEnum = {
    Configured: 'CONFIGURED',
    AiDrafted: 'AI_DRAFTED',
    AiAdapted: 'AI_ADAPTED'
} as const;

export type StudyListingMappingSummaryOriginEnum = typeof StudyListingMappingSummaryOriginEnum[keyof typeof StudyListingMappingSummaryOriginEnum];
export const StudyListingMappingSummaryReviewStatusEnum = {
    Approved: 'APPROVED',
    ToReview: 'TO_REVIEW'
} as const;

export type StudyListingMappingSummaryReviewStatusEnum = typeof StudyListingMappingSummaryReviewStatusEnum[keyof typeof StudyListingMappingSummaryReviewStatusEnum];

/**
 * 
 * @export
 * @interface StudyListingMappingView
 */
export interface StudyListingMappingView {
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingView
     */
    'layout_json': string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingMappingView
     */
    'study_id': string;
    /**
     * 
     * @type {StudyListingMappingSummary}
     * @memberof StudyListingMappingView
     */
    'summary': StudyListingMappingSummary;
}
/**
 * 
 * @export
 * @interface StudyListingStudyView
 */
export interface StudyListingStudyView {
    /**
     * 
     * @type {boolean}
     * @memberof StudyListingStudyView
     */
    'has_listing_format': boolean;
    /**
     * 
     * @type {number}
     * @memberof StudyListingStudyView
     */
    'study_case_id': number;
    /**
     * 
     * @type {string}
     * @memberof StudyListingStudyView
     */
    'study_id': string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingStudyView
     */
    'study_name': string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingStudyView
     */
    'study_phase'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyListingStudyView
     */
    'study_type'?: string;
}
/**
 * 
 * @export
 * @interface StudyListingUploadView
 */
export interface StudyListingUploadView {
    /**
     * 
     * @type {number}
     * @memberof StudyListingUploadView
     */
    'attachment_id': number;
    /**
     * 
     * @type {number}
     * @memberof StudyListingUploadView
     */
    'booking_id': number;
    /**
     * 
     * @type {string}
     * @memberof StudyListingUploadView
     */
    'filename': string;
}
/**
 * 
 * @export
 * @interface StudyOptionView
 */
export interface StudyOptionView {
    /**
     * 
     * @type {string}
     * @memberof StudyOptionView
     */
    'study_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyOptionView
     */
    'study_name'?: string;
}
/**
 * 
 * @export
 * @interface StudyRegistration
 */
export interface StudyRegistration {
    /**
     * 
     * @type {string}
     * @memberof StudyRegistration
     */
    'createdAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof StudyRegistration
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof StudyRegistration
     */
    'registrationCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyRegistration
     */
    'registrationNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyRegistration
     */
    'registrationType'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyRegistration
     */
    'studyId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StudyRegistration
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface SubmissionEnqueueRequest
 */
export interface SubmissionEnqueueRequest {
    /**
     * 
     * @type {number}
     * @memberof SubmissionEnqueueRequest
     */
    'case_revision': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SubmissionEnqueueRequest
     */
    'deadline_result_ids'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueRequest
     */
    'profile': string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueRequest
     */
    'receiver'?: string;
}
/**
 * 
 * @export
 * @interface SubmissionEnqueueResult
 */
export interface SubmissionEnqueueResult {
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueResult
     */
    'authority_code'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionEnqueueResult
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueResult
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof SubmissionEnqueueResult
     */
    'case_revision'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SubmissionEnqueueResult
     */
    'deadline_result_ids'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueResult
     */
    'message_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueResult
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionEnqueueResult
     */
    'submission_id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubmissionEnqueueResult
     */
    'warnings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface SubmissionTrackView
 */
export interface SubmissionTrackView {
    /**
     * 
     * @type {Array<AttemptView>}
     * @memberof SubmissionTrackView
     */
    'attempts'?: Array<AttemptView>;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'compliance_basis'?: SubmissionTrackViewComplianceBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'compliance_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'compliance_pending_reason'?: SubmissionTrackViewCompliancePendingReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'compliance_source'?: SubmissionTrackViewComplianceSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'compliance_status'?: SubmissionTrackViewComplianceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'evidence_reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'late_reason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubmissionTrackView
     */
    'late_reason_required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmissionTrackView
     */
    'submission_id'?: string;
}

export const SubmissionTrackViewComplianceBasisEnum = {
    AcceptanceDate: 'AcceptanceDate',
    SuccessfulDispatchDate: 'SuccessfulDispatchDate'
} as const;

export type SubmissionTrackViewComplianceBasisEnum = typeof SubmissionTrackViewComplianceBasisEnum[keyof typeof SubmissionTrackViewComplianceBasisEnum];
export const SubmissionTrackViewCompliancePendingReasonEnum = {
    MissingEvent: 'MISSING_EVENT',
    UnknownEventTime: 'UNKNOWN_EVENT_TIME'
} as const;

export type SubmissionTrackViewCompliancePendingReasonEnum = typeof SubmissionTrackViewCompliancePendingReasonEnum[keyof typeof SubmissionTrackViewCompliancePendingReasonEnum];
export const SubmissionTrackViewComplianceSourceEnum = {
    Gateway: 'GATEWAY',
    Manual: 'MANUAL',
    Correction: 'CORRECTION'
} as const;

export type SubmissionTrackViewComplianceSourceEnum = typeof SubmissionTrackViewComplianceSourceEnum[keyof typeof SubmissionTrackViewComplianceSourceEnum];
export const SubmissionTrackViewComplianceStatusEnum = {
    OnTime: 'On time',
    Late: 'Late',
    Pending: 'Pending'
} as const;

export type SubmissionTrackViewComplianceStatusEnum = typeof SubmissionTrackViewComplianceStatusEnum[keyof typeof SubmissionTrackViewComplianceStatusEnum];

/**
 * 
 * @export
 * @interface SummaryContext
 */
export interface SummaryContext {
    /**
     * 
     * @type {boolean}
     * @memberof SummaryContext
     */
    'e2b_enabled'?: boolean;
    /**
     * 
     * @type {{ [key: string]: CatalogFieldRequirement; }}
     * @memberof SummaryContext
     */
    'requirements'?: { [key: string]: CatalogFieldRequirement; };
    /**
     * 
     * @type {object}
     * @memberof SummaryContext
     */
    'schema'?: object;
}
/**
 * 
 * @export
 * @interface TabCounts
 */
export interface TabCounts {
    /**
     * 
     * @type {number}
     * @memberof TabCounts
     */
    'completed'?: number;
    /**
     * 
     * @type {number}
     * @memberof TabCounts
     */
    'in_progress'?: number;
    /**
     * 
     * @type {number}
     * @memberof TabCounts
     */
    'new'?: number;
}
/**
 * 
 * @export
 * @interface TeamResponse
 */
export interface TeamResponse {
    /**
     * 
     * @type {number}
     * @memberof TeamResponse
     */
    'capacity_per_processor'?: number;
    /**
     * 
     * @type {Array<ProcessorOutput>}
     * @memberof TeamResponse
     */
    'productivity'?: Array<ProcessorOutput>;
    /**
     * 
     * @type {number}
     * @memberof TeamResponse
     */
    'unassigned'?: number;
    /**
     * 
     * @type {Array<ProcessorLoad>}
     * @memberof TeamResponse
     */
    'workload'?: Array<ProcessorLoad>;
}
/**
 * 
 * @export
 * @interface TestProcedureRowContext
 */
export interface TestProcedureRowContext {
    /**
     * 
     * @type {{ [key: string]: CatalogFieldState; }}
     * @memberof TestProcedureRowContext
     */
    'field_states'?: { [key: string]: CatalogFieldState; };
    /**
     * 
     * @type {string}
     * @memberof TestProcedureRowContext
     */
    'record_id'?: string;
}
/**
 * 
 * @export
 * @interface TimelineEvent
 */
export interface TimelineEvent {
    /**
     * 
     * @type {string}
     * @memberof TimelineEvent
     */
    'current_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineEvent
     */
    'difference'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineEvent
     */
    'event'?: string;
    /**
     * 
     * @type {string}
     * @memberof TimelineEvent
     */
    'selected_date'?: string;
}
/**
 * 
 * @export
 * @interface TransitionRequest
 */
export interface TransitionRequest {
    /**
     * 
     * @type {number}
     * @memberof TransitionRequest
     */
    'assignTo'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TransitionRequest
     */
    'esigProvided'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransitionRequest
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionRequest
     */
    'toStatus'?: string;
}
/**
 * 
 * @export
 * @interface TransitionResult
 */
export interface TransitionResult {
    /**
     * 
     * @type {number}
     * @memberof TransitionResult
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransitionResult
     */
    'from_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof TransitionResult
     */
    'lifecycle'?: string;
    /**
     * 
     * @type {number}
     * @memberof TransitionResult
     */
    'seq'?: number;
    /**
     * 
     * @type {string}
     * @memberof TransitionResult
     */
    'to_status'?: string;
}
/**
 * 
 * @export
 * @interface TrendBar
 */
export interface TrendBar {
    /**
     * 
     * @type {string}
     * @memberof TrendBar
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof TrendBar
     */
    'non_serious'?: number;
    /**
     * 
     * @type {number}
     * @memberof TrendBar
     */
    'serious'?: number;
}
/**
 * 
 * @export
 * @interface UnlinkCaseRequest
 */
export interface UnlinkCaseRequest {
    /**
     * 
     * @type {string}
     * @memberof UnlinkCaseRequest
     */
    'justification'?: string;
}
/**
 * 
 * @export
 * @interface UnmatchedSubmission
 */
export interface UnmatchedSubmission {
    /**
     * 
     * @type {string}
     * @memberof UnmatchedSubmission
     */
    'authority'?: string;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedSubmission
     */
    'case_number'?: string;
    /**
     * 
     * @type {number}
     * @memberof UnmatchedSubmission
     */
    'sent_hours_ago'?: number;
    /**
     * 
     * @type {string}
     * @memberof UnmatchedSubmission
     */
    'status'?: UnmatchedSubmissionStatusEnum;
}

export const UnmatchedSubmissionStatusEnum = {
    AwaitingAck: 'AWAITING_ACK',
    AckOverdue: 'ACK_OVERDUE',
    RejectedByGateway: 'REJECTED_BY_GATEWAY'
} as const;

export type UnmatchedSubmissionStatusEnum = typeof UnmatchedSubmissionStatusEnum[keyof typeof UnmatchedSubmissionStatusEnum];

/**
 * 
 * @export
 * @interface UnresolvedLines
 */
export interface UnresolvedLines {
    /**
     * 
     * @type {LineRange}
     * @memberof UnresolvedLines
     */
    'lines'?: LineRange;
    /**
     * 
     * @type {string}
     * @memberof UnresolvedLines
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface UploadAttachmentView
 */
export interface UploadAttachmentView {
    /**
     * 
     * @type {boolean}
     * @memberof UploadAttachmentView
     */
    'can_retry': boolean;
    /**
     * 
     * @type {number}
     * @memberof UploadAttachmentView
     */
    'case_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadAttachmentView
     */
    'case_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadAttachmentView
     */
    'failure_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadAttachmentView
     */
    'filename': string;
    /**
     * 
     * @type {number}
     * @memberof UploadAttachmentView
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof UploadAttachmentView
     */
    'in_exception_queue': boolean;
    /**
     * 
     * @type {string}
     * @memberof UploadAttachmentView
     */
    'process_status': string;
    /**
     * 
     * @type {string}
     * @memberof UploadAttachmentView
     */
    'review_status': string;
    /**
     * 
     * @type {string}
     * @memberof UploadAttachmentView
     */
    'status_date': string;
    /**
     * 
     * @type {UploadListingView}
     * @memberof UploadAttachmentView
     */
    'study_listing'?: UploadListingView;
}
/**
 * 
 * @export
 * @interface UploadBookingView
 */
export interface UploadBookingView {
    /**
     * 
     * @type {number}
     * @memberof UploadBookingView
     */
    'attachment_count'?: number;
    /**
     * 
     * @type {Array<UploadAttachmentView>}
     * @memberof UploadBookingView
     */
    'attachments': Array<UploadAttachmentView>;
    /**
     * 
     * @type {string}
     * @memberof UploadBookingView
     */
    'booking_datetime': string;
    /**
     * 
     * @type {string}
     * @memberof UploadBookingView
     */
    'booking_status': string;
    /**
     * 
     * @type {string}
     * @memberof UploadBookingView
     */
    'entity_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadBookingView
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UploadBookingView
     */
    'intake_type': string;
    /**
     * 
     * @type {string}
     * @memberof UploadBookingView
     */
    'subject'?: string;
}
/**
 * 
 * @export
 * @interface UploadListingView
 */
export interface UploadListingView {
    /**
     * 
     * @type {number}
     * @memberof UploadListingView
     */
    'cases_made': number;
    /**
     * 
     * @type {number}
     * @memberof UploadListingView
     */
    'invalid_cases': number;
    /**
     * 
     * @type {number}
     * @memberof UploadListingView
     */
    'not_saved': number;
    /**
     * 
     * @type {number}
     * @memberof UploadListingView
     */
    'patients': number;
    /**
     * 
     * @type {number}
     * @memberof UploadListingView
     */
    'pending': number;
    /**
     * 
     * @type {string}
     * @memberof UploadListingView
     */
    'study_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadListingView
     */
    'unchanged': number;
}
/**
 * 
 * @export
 * @interface WhoDrugEntry
 */
export interface WhoDrugEntry {
    /**
     * 
     * @type {Array<C3Atc>}
     * @memberof WhoDrugEntry
     */
    'atcs'?: Array<C3Atc>;
    /**
     * 
     * @type {C3Candidate}
     * @memberof WhoDrugEntry
     */
    'candidate'?: C3Candidate;
    /**
     * 
     * @type {C3Release}
     * @memberof WhoDrugEntry
     */
    'release'?: C3Release;
}
/**
 * 
 * @export
 * @interface WhoDrugFieldChange
 */
export interface WhoDrugFieldChange {
    /**
     * 
     * @type {boolean}
     * @memberof WhoDrugFieldChange
     */
    'changed'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFieldChange
     */
    'currentValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFieldChange
     */
    'dictionaryValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFieldChange
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFieldChange
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFieldChange
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFieldChange
     */
    'proposedValue'?: string;
}
/**
 * 
 * @export
 * @interface WhoDrugFilterOption
 */
export interface WhoDrugFilterOption {
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFilterOption
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugFilterOption
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface WhoDrugFilterOptions
 */
export interface WhoDrugFilterOptions {
    /**
     * 
     * @type {Array<WhoDrugFilterOption>}
     * @memberof WhoDrugFilterOptions
     */
    'countries'?: Array<WhoDrugFilterOption>;
    /**
     * 
     * @type {Array<WhoDrugFilterOption>}
     * @memberof WhoDrugFilterOptions
     */
    'holders'?: Array<WhoDrugFilterOption>;
}
/**
 * 
 * @export
 * @interface WhoDrugRecodePreview
 */
export interface WhoDrugRecodePreview {
    /**
     * 
     * @type {Array<WhoDrugFieldChange>}
     * @memberof WhoDrugRecodePreview
     */
    'changes'?: Array<WhoDrugFieldChange>;
    /**
     * 
     * @type {WhoDrugEntry}
     * @memberof WhoDrugRecodePreview
     */
    'entry'?: WhoDrugEntry;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugRecodePreview
     */
    'fingerprint'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhoDrugRecodePreview
     */
    'warnings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WhoDrugRecodeRequest
 */
export interface WhoDrugRecodeRequest {
    /**
     * 
     * @type {string}
     * @memberof WhoDrugRecodeRequest
     */
    'catalog_version'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugRecodeRequest
     */
    'deadline_change_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugRecodeRequest
     */
    'fingerprint'?: string;
    /**
     * 
     * @type {number}
     * @memberof WhoDrugRecodeRequest
     */
    'release_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof WhoDrugRecodeRequest
     */
    'revision': number;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugRecodeRequest
     */
    'rid'?: string;
}
/**
 * 
 * @export
 * @interface WhoDrugSearchPage
 */
export interface WhoDrugSearchPage {
    /**
     * 
     * @type {Array<C3Candidate>}
     * @memberof WhoDrugSearchPage
     */
    'entries'?: Array<C3Candidate>;
    /**
     * 
     * @type {boolean}
     * @memberof WhoDrugSearchPage
     */
    'hasMore'?: boolean;
    /**
     * 
     * @type {C3Release}
     * @memberof WhoDrugSearchPage
     */
    'release'?: C3Release;
}
/**
 * 
 * @export
 * @interface WhoDrugSuggestion
 */
export interface WhoDrugSuggestion {
    /**
     * 
     * @type {C3Candidate}
     * @memberof WhoDrugSuggestion
     */
    'candidate'?: C3Candidate;
    /**
     * 
     * @type {number}
     * @memberof WhoDrugSuggestion
     */
    'candidateCount'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof WhoDrugSuggestion
     */
    'context'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof WhoDrugSuggestion
     */
    'limitedSearch'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WhoDrugSuggestion
     */
    'reason'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WhoDrugSuggestion
     */
    'warnings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface WorkflowResponse
 */
export interface WorkflowResponse {
    /**
     * 
     * @type {Array<AgeingBucket>}
     * @memberof WorkflowResponse
     */
    'ageing'?: Array<AgeingBucket>;
    /**
     * 
     * @type {Array<CaseMixSegment>}
     * @memberof WorkflowResponse
     */
    'case_mix'?: Array<CaseMixSegment>;
    /**
     * 
     * @type {number}
     * @memberof WorkflowResponse
     */
    'closed_this_period'?: number;
    /**
     * 
     * @type {Array<CountItem>}
     * @memberof WorkflowResponse
     */
    'intake_breakdown'?: Array<CountItem>;
    /**
     * 
     * @type {Array<CountItem>}
     * @memberof WorkflowResponse
     */
    'stages'?: Array<CountItem>;
}
/**
 * 
 * @export
 * @interface WorkflowStageEntry
 */
export interface WorkflowStageEntry {
    /**
     * 
     * @type {string}
     * @memberof WorkflowStageEntry
     */
    'stage'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStageEntry
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface WwidSettingsUpdateRequest
 */
export interface WwidSettingsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof WwidSettingsUpdateRequest
     */
    'default_country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof WwidSettingsUpdateRequest
     */
    'organisation'?: string;
}
/**
 * 
 * @export
 * @interface WwidSettingsView
 */
export interface WwidSettingsView {
    /**
     * 
     * @type {string}
     * @memberof WwidSettingsView
     */
    'default_country_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof WwidSettingsView
     */
    'default_country_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof WwidSettingsView
     */
    'organisation'?: string;
}

/**
 * ActivitiesControllerApi - axios parameter creator
 * @export
 */
export const ActivitiesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBadge: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('clearBadge', 'id', id)
            const localVarPath = `/api/v1/activities/{id}/clear-badge`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {CloseActivityRequest} closeActivityRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeActivity: async (id: number, closeActivityRequest: CloseActivityRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('closeActivity', 'id', id)
            // verify required parameter 'closeActivityRequest' is not null or undefined
            assertParamExists('closeActivity', 'closeActivityRequest', closeActivityRequest)
            const localVarPath = `/api/v1/activities/{id}/close`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(closeActivityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {Activity} activity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity: async (caseId: number, activity: Activity, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('createActivity', 'caseId', caseId)
            // verify required parameter 'activity' is not null or undefined
            assertParamExists('createActivity', 'activity', activity)
            const localVarPath = `/api/v1/cases/{caseId}/activities`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteActivity', 'id', id)
            const localVarPath = `/api/v1/activities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getActivity', 'id', id)
            const localVarPath = `/api/v1/activities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {ListActivitiesStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivities: async (caseId: number, status?: ListActivitiesStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listActivities', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/activities`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {RaiseQueryRequest} raiseQueryRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        raiseQuery: async (caseId: number, raiseQueryRequest: RaiseQueryRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('raiseQuery', 'caseId', caseId)
            // verify required parameter 'raiseQueryRequest' is not null or undefined
            assertParamExists('raiseQuery', 'raiseQueryRequest', raiseQueryRequest)
            const localVarPath = `/api/v1/cases/{caseId}/activities/queries`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(raiseQueryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Activity} activity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity: async (id: number, activity: Activity, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateActivity', 'id', id)
            // verify required parameter 'activity' is not null or undefined
            assertParamExists('updateActivity', 'activity', activity)
            const localVarPath = `/api/v1/activities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activity, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivitiesControllerApi - functional programming interface
 * @export
 */
export const ActivitiesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivitiesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearBadge(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearBadge(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.clearBadge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {CloseActivityRequest} closeActivityRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeActivity(id: number, closeActivityRequest: CloseActivityRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeActivity(id, closeActivityRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.closeActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {Activity} activity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivity(caseId: number, activity: Activity, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivity(caseId, activity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.createActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivity(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.deleteActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivity(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivity(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.getActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {ListActivitiesStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActivities(caseId: number, status?: ListActivitiesStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActivities(caseId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.listActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {RaiseQueryRequest} raiseQueryRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async raiseQuery(caseId: number, raiseQueryRequest: RaiseQueryRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryCreationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.raiseQuery(caseId, raiseQueryRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.raiseQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Activity} activity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActivity(id: number, activity: Activity, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActivity(id, activity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivitiesControllerApi.updateActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivitiesControllerApi - factory interface
 * @export
 */
export const ActivitiesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivitiesControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearBadge(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.clearBadge(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {CloseActivityRequest} closeActivityRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeActivity(id: number, closeActivityRequest: CloseActivityRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.closeActivity(id, closeActivityRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {Activity} activity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivity(caseId: number, activity: Activity, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.createActivity(caseId, activity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivity(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActivity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivity(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.getActivity(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {ListActivitiesStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivities(caseId: number, status?: ListActivitiesStatusEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListActivityView> {
            return localVarFp.listActivities(caseId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {RaiseQueryRequest} raiseQueryRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        raiseQuery(caseId: number, raiseQueryRequest: RaiseQueryRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryCreationResult> {
            return localVarFp.raiseQuery(caseId, raiseQueryRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {Activity} activity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivity(id: number, activity: Activity, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.updateActivity(id, activity, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivitiesControllerApi - object-oriented interface
 * @export
 * @class ActivitiesControllerApi
 * @extends {BaseAPI}
 */
export class ActivitiesControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public clearBadge(id: number, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).clearBadge(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {CloseActivityRequest} closeActivityRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public closeActivity(id: number, closeActivityRequest: CloseActivityRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).closeActivity(id, closeActivityRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {Activity} activity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public createActivity(caseId: number, activity: Activity, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).createActivity(caseId, activity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public deleteActivity(id: number, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).deleteActivity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public getActivity(id: number, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).getActivity(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {ListActivitiesStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public listActivities(caseId: number, status?: ListActivitiesStatusEnum, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).listActivities(caseId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {RaiseQueryRequest} raiseQueryRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public raiseQuery(caseId: number, raiseQueryRequest: RaiseQueryRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).raiseQuery(caseId, raiseQueryRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {Activity} activity 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivitiesControllerApi
     */
    public updateActivity(id: number, activity: Activity, options?: RawAxiosRequestConfig) {
        return ActivitiesControllerApiFp(this.configuration).updateActivity(id, activity, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListActivitiesStatusEnum = {
    Open: 'Open',
    Overdue: 'Overdue',
    AwaitingResponse: 'AwaitingResponse',
    Closed: 'Closed'
} as const;
export type ListActivitiesStatusEnum = typeof ListActivitiesStatusEnum[keyof typeof ListActivitiesStatusEnum];


/**
 * ActivityAttachmentControllerApi - axios parameter creator
 * @export
 */
export const ActivityAttachmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivityAttachments: async (activityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('listActivityAttachments', 'activityId', activityId)
            const localVarPath = `/api/v1/activities/{activityId}/attachments`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} activityId 
         * @param {File} file 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActivityAttachment: async (activityId: number, file: File, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activityId' is not null or undefined
            assertParamExists('uploadActivityAttachment', 'activityId', activityId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadActivityAttachment', 'file', file)
            const localVarPath = `/api/v1/activities/{activityId}/attachments`
                .replace(`{${"activityId"}}`, encodeURIComponent(String(activityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityAttachmentControllerApi - functional programming interface
 * @export
 */
export const ActivityAttachmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityAttachmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActivityAttachments(activityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListActivityAttachmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActivityAttachments(activityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityAttachmentControllerApi.listActivityAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} activityId 
         * @param {File} file 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadActivityAttachment(activityId: number, file: File, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityAttachmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadActivityAttachment(activityId, file, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityAttachmentControllerApi.uploadActivityAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityAttachmentControllerApi - factory interface
 * @export
 */
export const ActivityAttachmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityAttachmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} activityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActivityAttachments(activityId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListActivityAttachmentView> {
            return localVarFp.listActivityAttachments(activityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} activityId 
         * @param {File} file 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadActivityAttachment(activityId: number, file: File, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityAttachmentView> {
            return localVarFp.uploadActivityAttachment(activityId, file, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityAttachmentControllerApi - object-oriented interface
 * @export
 * @class ActivityAttachmentControllerApi
 * @extends {BaseAPI}
 */
export class ActivityAttachmentControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} activityId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityAttachmentControllerApi
     */
    public listActivityAttachments(activityId: number, options?: RawAxiosRequestConfig) {
        return ActivityAttachmentControllerApiFp(this.configuration).listActivityAttachments(activityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} activityId 
     * @param {File} file 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityAttachmentControllerApi
     */
    public uploadActivityAttachment(activityId: number, file: File, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return ActivityAttachmentControllerApiFp(this.configuration).uploadActivityAttachment(activityId, file, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AguiRunControllerApi - axios parameter creator
 * @export
 */
export const AguiRunControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (runId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('cancel', 'runId', runId)
            const localVarPath = `/api/v1/agui/runs/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agent 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        run: async (agent: string, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agent' is not null or undefined
            assertParamExists('run', 'agent', agent)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('run', 'body', body)
            const localVarPath = `/api/v1/agui/{agent}/run`
                .replace(`{${"agent"}}`, encodeURIComponent(String(agent)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AguiRunControllerApi - functional programming interface
 * @export
 */
export const AguiRunControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AguiRunControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(runId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AguiRunControllerApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} agent 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async run(agent: string, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SseEmitter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.run(agent, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AguiRunControllerApi.run']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AguiRunControllerApi - factory interface
 * @export
 */
export const AguiRunControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AguiRunControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(runId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancel(runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} agent 
         * @param {string} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        run(agent: string, body: string, options?: RawAxiosRequestConfig): AxiosPromise<SseEmitter> {
            return localVarFp.run(agent, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AguiRunControllerApi - object-oriented interface
 * @export
 * @class AguiRunControllerApi
 * @extends {BaseAPI}
 */
export class AguiRunControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} runId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AguiRunControllerApi
     */
    public cancel(runId: string, options?: RawAxiosRequestConfig) {
        return AguiRunControllerApiFp(this.configuration).cancel(runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} agent 
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AguiRunControllerApi
     */
    public run(agent: string, body: string, options?: RawAxiosRequestConfig) {
        return AguiRunControllerApiFp(this.configuration).run(agent, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AguiThreadControllerApi - axios parameter creator
 * @export
 */
export const AguiThreadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} agent 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearMessages: async (agent: string, threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agent' is not null or undefined
            assertParamExists('clearMessages', 'agent', agent)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('clearMessages', 'threadId', threadId)
            const localVarPath = `/api/v1/agui/{agent}/threads/{threadId}/messages`
                .replace(`{${"agent"}}`, encodeURIComponent(String(agent)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agent 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messages: async (agent: string, threadId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agent' is not null or undefined
            assertParamExists('messages', 'agent', agent)
            // verify required parameter 'threadId' is not null or undefined
            assertParamExists('messages', 'threadId', threadId)
            const localVarPath = `/api/v1/agui/{agent}/threads/{threadId}/messages`
                .replace(`{${"agent"}}`, encodeURIComponent(String(agent)))
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} agent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threads: async (agent: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agent' is not null or undefined
            assertParamExists('threads', 'agent', agent)
            const localVarPath = `/api/v1/agui/{agent}/threads`
                .replace(`{${"agent"}}`, encodeURIComponent(String(agent)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AguiThreadControllerApi - functional programming interface
 * @export
 */
export const AguiThreadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AguiThreadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} agent 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearMessages(agent: string, threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearMessages(agent, threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AguiThreadControllerApi.clearMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} agent 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messages(agent: string, threadId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messages(agent, threadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AguiThreadControllerApi.messages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} agent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threads(agent: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AguiThreadSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threads(agent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AguiThreadControllerApi.threads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AguiThreadControllerApi - factory interface
 * @export
 */
export const AguiThreadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AguiThreadControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} agent 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearMessages(agent: string, threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clearMessages(agent, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} agent 
         * @param {string} threadId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messages(agent: string, threadId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.messages(agent, threadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} agent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threads(agent: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<AguiThreadSummary>> {
            return localVarFp.threads(agent, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AguiThreadControllerApi - object-oriented interface
 * @export
 * @class AguiThreadControllerApi
 * @extends {BaseAPI}
 */
export class AguiThreadControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} agent 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AguiThreadControllerApi
     */
    public clearMessages(agent: string, threadId: string, options?: RawAxiosRequestConfig) {
        return AguiThreadControllerApiFp(this.configuration).clearMessages(agent, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} agent 
     * @param {string} threadId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AguiThreadControllerApi
     */
    public messages(agent: string, threadId: string, options?: RawAxiosRequestConfig) {
        return AguiThreadControllerApiFp(this.configuration).messages(agent, threadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} agent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AguiThreadControllerApi
     */
    public threads(agent: string, options?: RawAxiosRequestConfig) {
        return AguiThreadControllerApiFp(this.configuration).threads(agent, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AttachmentPartsControllerApi - axios parameter creator
 * @export
 */
export const AttachmentPartsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachmentParts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/intake/attachment-parts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentPartsControllerApi - functional programming interface
 * @export
 */
export const AttachmentPartsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentPartsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAttachmentParts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AttachmentPartView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAttachmentParts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentPartsControllerApi.listAttachmentParts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttachmentPartsControllerApi - factory interface
 * @export
 */
export const AttachmentPartsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentPartsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttachmentParts(options?: RawAxiosRequestConfig): AxiosPromise<Array<AttachmentPartView>> {
            return localVarFp.listAttachmentParts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentPartsControllerApi - object-oriented interface
 * @export
 * @class AttachmentPartsControllerApi
 * @extends {BaseAPI}
 */
export class AttachmentPartsControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentPartsControllerApi
     */
    public listAttachmentParts(options?: RawAxiosRequestConfig) {
        return AttachmentPartsControllerApiFp(this.configuration).listAttachmentParts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditPolicyControllerApi - axios parameter creator
 * @export
 */
export const AuditPolicyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reload: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/audit/policy/reload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditPolicyControllerApi - functional programming interface
 * @export
 */
export const AuditPolicyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditPolicyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reload(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reload(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditPolicyControllerApi.reload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditPolicyControllerApi - factory interface
 * @export
 */
export const AuditPolicyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditPolicyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reload(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.reload(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditPolicyControllerApi - object-oriented interface
 * @export
 * @class AuditPolicyControllerApi
 * @extends {BaseAPI}
 */
export class AuditPolicyControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditPolicyControllerApi
     */
    public reload(options?: RawAxiosRequestConfig) {
        return AuditPolicyControllerApiFp(this.configuration).reload(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditReadControllerApi - axios parameter creator
 * @export
 */
export const AuditReadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _export: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('_export', 'caseId', caseId)
            const localVarPath = `/api/v1/audit/cases/{caseId}/export`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} [actorKind] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actions: async (caseId: number, actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('actions', 'caseId', caseId)
            const localVarPath = `/api/v1/audit/cases/{caseId}/actions`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actorKind !== undefined) {
                localVarQueryParameter['actorKind'] = actorKind;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [actorKind] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recent: async (actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/audit/recent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (actorKind !== undefined) {
                localVarQueryParameter['actorKind'] = actorKind;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditReadControllerApi - functional programming interface
 * @export
 */
export const AuditReadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditReadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _export(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._export(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditReadControllerApi._export']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} [actorKind] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async actions(caseId: number, actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAuditPageDtoAuditActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.actions(caseId, actorKind, from, to, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditReadControllerApi.actions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [actorKind] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recent(actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseAuditPageDtoAuditActionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recent(actorKind, from, to, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditReadControllerApi.recent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditReadControllerApi - factory interface
 * @export
 */
export const AuditReadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditReadControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _export(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp._export(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} [actorKind] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        actions(caseId: number, actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAuditPageDtoAuditActionDto> {
            return localVarFp.actions(caseId, actorKind, from, to, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [actorKind] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recent(actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseAuditPageDtoAuditActionDto> {
            return localVarFp.recent(actorKind, from, to, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditReadControllerApi - object-oriented interface
 * @export
 * @class AuditReadControllerApi
 * @extends {BaseAPI}
 */
export class AuditReadControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditReadControllerApi
     */
    public _export(caseId: number, options?: RawAxiosRequestConfig) {
        return AuditReadControllerApiFp(this.configuration)._export(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {string} [actorKind] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditReadControllerApi
     */
    public actions(caseId: number, actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AuditReadControllerApiFp(this.configuration).actions(caseId, actorKind, from, to, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [actorKind] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditReadControllerApi
     */
    public recent(actorKind?: string, from?: string, to?: string, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return AuditReadControllerApiFp(this.configuration).recent(actorKind, from, to, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseAssignmentControllerApi - axios parameter creator
 * @export
 */
export const CaseAssignmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {AssignmentRequest} [assignmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assign: async (id: number, xSessionId?: string, assignmentRequest?: AssignmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assign', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/assignments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseAssignmentControllerApi - functional programming interface
 * @export
 */
export const CaseAssignmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseAssignmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {AssignmentRequest} [assignmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assign(id: number, xSessionId?: string, assignmentRequest?: AssignmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseTransitionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assign(id, xSessionId, assignmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseAssignmentControllerApi.assign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseAssignmentControllerApi - factory interface
 * @export
 */
export const CaseAssignmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseAssignmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {AssignmentRequest} [assignmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assign(id: number, xSessionId?: string, assignmentRequest?: AssignmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseTransitionResult> {
            return localVarFp.assign(id, xSessionId, assignmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseAssignmentControllerApi - object-oriented interface
 * @export
 * @class CaseAssignmentControllerApi
 * @extends {BaseAPI}
 */
export class CaseAssignmentControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {AssignmentRequest} [assignmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAssignmentControllerApi
     */
    public assign(id: number, xSessionId?: string, assignmentRequest?: AssignmentRequest, options?: RawAxiosRequestConfig) {
        return CaseAssignmentControllerApiFp(this.configuration).assign(id, xSessionId, assignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseAttachmentControllerApi - axios parameter creator
 * @export
 */
export const CaseAttachmentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseAttachments: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listCaseAttachments', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/attachments`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCaseAttachment: async (caseId: number, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('readCaseAttachment', 'caseId', caseId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('readCaseAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/cases/{caseId}/attachments/{attachmentId}/content`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} displayName 
         * @param {string} documentType 
         * @param {string} xSessionId 
         * @param {File} file 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCaseAttachment: async (caseId: number, displayName: string, documentType: string, xSessionId: string, file: File, description?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('uploadCaseAttachment', 'caseId', caseId)
            // verify required parameter 'displayName' is not null or undefined
            assertParamExists('uploadCaseAttachment', 'displayName', displayName)
            // verify required parameter 'documentType' is not null or undefined
            assertParamExists('uploadCaseAttachment', 'documentType', documentType)
            // verify required parameter 'xSessionId' is not null or undefined
            assertParamExists('uploadCaseAttachment', 'xSessionId', xSessionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadCaseAttachment', 'file', file)
            const localVarPath = `/api/v1/cases/{caseId}/attachments`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (displayName !== undefined) {
                localVarQueryParameter['displayName'] = displayName;
            }

            if (documentType !== undefined) {
                localVarQueryParameter['documentType'] = documentType;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseAttachmentControllerApi - functional programming interface
 * @export
 */
export const CaseAttachmentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseAttachmentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCaseAttachments(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseAttachmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCaseAttachments(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseAttachmentControllerApi.listCaseAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readCaseAttachment(caseId: number, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readCaseAttachment(caseId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseAttachmentControllerApi.readCaseAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} displayName 
         * @param {string} documentType 
         * @param {string} xSessionId 
         * @param {File} file 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadCaseAttachment(caseId: number, displayName: string, documentType: string, xSessionId: string, file: File, description?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseAttachmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadCaseAttachment(caseId, displayName, documentType, xSessionId, file, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseAttachmentControllerApi.uploadCaseAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseAttachmentControllerApi - factory interface
 * @export
 */
export const CaseAttachmentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseAttachmentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseAttachments(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseAttachmentView> {
            return localVarFp.listCaseAttachments(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readCaseAttachment(caseId: number, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.readCaseAttachment(caseId, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} displayName 
         * @param {string} documentType 
         * @param {string} xSessionId 
         * @param {File} file 
         * @param {string} [description] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCaseAttachment(caseId: number, displayName: string, documentType: string, xSessionId: string, file: File, description?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseAttachmentView> {
            return localVarFp.uploadCaseAttachment(caseId, displayName, documentType, xSessionId, file, description, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseAttachmentControllerApi - object-oriented interface
 * @export
 * @class CaseAttachmentControllerApi
 * @extends {BaseAPI}
 */
export class CaseAttachmentControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAttachmentControllerApi
     */
    public listCaseAttachments(caseId: number, options?: RawAxiosRequestConfig) {
        return CaseAttachmentControllerApiFp(this.configuration).listCaseAttachments(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {string} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAttachmentControllerApi
     */
    public readCaseAttachment(caseId: number, attachmentId: string, options?: RawAxiosRequestConfig) {
        return CaseAttachmentControllerApiFp(this.configuration).readCaseAttachment(caseId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {string} displayName 
     * @param {string} documentType 
     * @param {string} xSessionId 
     * @param {File} file 
     * @param {string} [description] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseAttachmentControllerApi
     */
    public uploadCaseAttachment(caseId: number, displayName: string, documentType: string, xSessionId: string, file: File, description?: string, options?: RawAxiosRequestConfig) {
        return CaseAttachmentControllerApiFp(this.configuration).uploadCaseAttachment(caseId, displayName, documentType, xSessionId, file, description, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseControllerApi - axios parameter creator
 * @export
 */
export const CaseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Case} _case 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCase: async (_case: Case, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter '_case' is not null or undefined
            assertParamExists('createCase', '_case', _case)
            const localVarPath = `/api/v1/cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(_case, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCase: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCase', 'id', id)
            const localVarPath = `/api/v1/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCase: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCase', 'id', id)
            const localVarPath = `/api/v1/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Case} _case 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCase: async (id: number, _case: Case, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCase', 'id', id)
            // verify required parameter '_case' is not null or undefined
            assertParamExists('updateCase', '_case', _case)
            const localVarPath = `/api/v1/cases/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(_case, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseControllerApi - functional programming interface
 * @export
 */
export const CaseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Case} _case 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCase(_case: Case, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCase(_case, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseControllerApi.createCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCase(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCase(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseControllerApi.deleteCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCase(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCase(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseControllerApi.getCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {Case} _case 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCase(id: number, _case: Case, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCase(id, _case, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseControllerApi.updateCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseControllerApi - factory interface
 * @export
 */
export const CaseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Case} _case 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCase(_case: Case, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCase> {
            return localVarFp.createCase(_case, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCase(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCase(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCase(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCase> {
            return localVarFp.getCase(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {Case} _case 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCase(id: number, _case: Case, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCase> {
            return localVarFp.updateCase(id, _case, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseControllerApi - object-oriented interface
 * @export
 * @class CaseControllerApi
 * @extends {BaseAPI}
 */
export class CaseControllerApi extends BaseAPI {
    /**
     * 
     * @param {Case} _case 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseControllerApi
     */
    public createCase(_case: Case, options?: RawAxiosRequestConfig) {
        return CaseControllerApiFp(this.configuration).createCase(_case, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseControllerApi
     */
    public deleteCase(id: number, options?: RawAxiosRequestConfig) {
        return CaseControllerApiFp(this.configuration).deleteCase(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseControllerApi
     */
    public getCase(id: number, options?: RawAxiosRequestConfig) {
        return CaseControllerApiFp(this.configuration).getCase(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {Case} _case 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseControllerApi
     */
    public updateCase(id: number, _case: Case, options?: RawAxiosRequestConfig) {
        return CaseControllerApiFp(this.configuration).updateCase(id, _case, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseDeadlinesControllerApi - axios parameter creator
 * @export
 */
export const CaseDeadlinesControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseDeadlines: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('caseDeadlines', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/deadlines`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseDeadlinesControllerApi - functional programming interface
 * @export
 */
export const CaseDeadlinesControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseDeadlinesControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async caseDeadlines(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseDeadlinesView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.caseDeadlines(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseDeadlinesControllerApi.caseDeadlines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseDeadlinesControllerApi - factory interface
 * @export
 */
export const CaseDeadlinesControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseDeadlinesControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        caseDeadlines(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseDeadlinesView> {
            return localVarFp.caseDeadlines(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseDeadlinesControllerApi - object-oriented interface
 * @export
 * @class CaseDeadlinesControllerApi
 * @extends {BaseAPI}
 */
export class CaseDeadlinesControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseDeadlinesControllerApi
     */
    public caseDeadlines(caseId: number, options?: RawAxiosRequestConfig) {
        return CaseDeadlinesControllerApiFp(this.configuration).caseDeadlines(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseLinkControllerApi - axios parameter creator
 * @export
 */
export const CaseLinkControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {AddCaseLinksRequest} addCaseLinksRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCaseLinks: async (caseId: number, addCaseLinksRequest: AddCaseLinksRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('addCaseLinks', 'caseId', caseId)
            // verify required parameter 'addCaseLinksRequest' is not null or undefined
            assertParamExists('addCaseLinks', 'addCaseLinksRequest', addCaseLinksRequest)
            const localVarPath = `/api/v1/cases/{caseId}/links`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addCaseLinksRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} linkId 
         * @param {UnlinkCaseRequest} unlinkCaseRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkCase: async (caseId: number, linkId: number, unlinkCaseRequest: UnlinkCaseRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('unlinkCase', 'caseId', caseId)
            // verify required parameter 'linkId' is not null or undefined
            assertParamExists('unlinkCase', 'linkId', linkId)
            // verify required parameter 'unlinkCaseRequest' is not null or undefined
            assertParamExists('unlinkCase', 'unlinkCaseRequest', unlinkCaseRequest)
            const localVarPath = `/api/v1/cases/{caseId}/links/{linkId}/unlink`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"linkId"}}`, encodeURIComponent(String(linkId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unlinkCaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseLinkControllerApi - functional programming interface
 * @export
 */
export const CaseLinkControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseLinkControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {AddCaseLinksRequest} addCaseLinksRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addCaseLinks(caseId: number, addCaseLinksRequest: AddCaseLinksRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addCaseLinks(caseId, addCaseLinksRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLinkControllerApi.addCaseLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} linkId 
         * @param {UnlinkCaseRequest} unlinkCaseRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkCase(caseId: number, linkId: number, unlinkCaseRequest: UnlinkCaseRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkCase(caseId, linkId, unlinkCaseRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLinkControllerApi.unlinkCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseLinkControllerApi - factory interface
 * @export
 */
export const CaseLinkControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseLinkControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {AddCaseLinksRequest} addCaseLinksRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addCaseLinks(caseId: number, addCaseLinksRequest: AddCaseLinksRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseLinkResponse> {
            return localVarFp.addCaseLinks(caseId, addCaseLinksRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} linkId 
         * @param {UnlinkCaseRequest} unlinkCaseRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkCase(caseId: number, linkId: number, unlinkCaseRequest: UnlinkCaseRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.unlinkCase(caseId, linkId, unlinkCaseRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseLinkControllerApi - object-oriented interface
 * @export
 * @class CaseLinkControllerApi
 * @extends {BaseAPI}
 */
export class CaseLinkControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {AddCaseLinksRequest} addCaseLinksRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLinkControllerApi
     */
    public addCaseLinks(caseId: number, addCaseLinksRequest: AddCaseLinksRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CaseLinkControllerApiFp(this.configuration).addCaseLinks(caseId, addCaseLinksRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {number} linkId 
     * @param {UnlinkCaseRequest} unlinkCaseRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLinkControllerApi
     */
    public unlinkCase(caseId: number, linkId: number, unlinkCaseRequest: UnlinkCaseRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CaseLinkControllerApiFp(this.configuration).unlinkCase(caseId, linkId, unlinkCaseRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseLockControllerApi - axios parameter creator
 * @export
 */
export const CaseLockControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquire: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acquire', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        current: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('current', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {LockOverrideRequest} [lockOverrideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        override: async (id: number, xSessionId?: string, lockOverrideRequest?: LockOverrideRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('override', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/lock/override`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(lockOverrideRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('refresh', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/lock/refresh`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        release1: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('release1', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseLockControllerApi - functional programming interface
 * @export
 */
export const CaseLockControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseLockControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acquire(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseLockView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acquire(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLockControllerApi.acquire']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async current(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseLockView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.current(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLockControllerApi.current']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {LockOverrideRequest} [lockOverrideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async override(id: number, xSessionId?: string, lockOverrideRequest?: LockOverrideRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.override(id, xSessionId, lockOverrideRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLockControllerApi.override']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseLockView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLockControllerApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async release1(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.release1(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseLockControllerApi.release1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseLockControllerApi - factory interface
 * @export
 */
export const CaseLockControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseLockControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquire(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseLockView> {
            return localVarFp.acquire(id, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        current(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseLockView> {
            return localVarFp.current(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {LockOverrideRequest} [lockOverrideRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        override(id: number, xSessionId?: string, lockOverrideRequest?: LockOverrideRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.override(id, xSessionId, lockOverrideRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseLockView> {
            return localVarFp.refresh(id, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        release1(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.release1(id, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseLockControllerApi - object-oriented interface
 * @export
 * @class CaseLockControllerApi
 * @extends {BaseAPI}
 */
export class CaseLockControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLockControllerApi
     */
    public acquire(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CaseLockControllerApiFp(this.configuration).acquire(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLockControllerApi
     */
    public current(id: number, options?: RawAxiosRequestConfig) {
        return CaseLockControllerApiFp(this.configuration).current(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {LockOverrideRequest} [lockOverrideRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLockControllerApi
     */
    public override(id: number, xSessionId?: string, lockOverrideRequest?: LockOverrideRequest, options?: RawAxiosRequestConfig) {
        return CaseLockControllerApiFp(this.configuration).override(id, xSessionId, lockOverrideRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLockControllerApi
     */
    public refresh(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CaseLockControllerApiFp(this.configuration).refresh(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseLockControllerApi
     */
    public release1(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CaseLockControllerApiFp(this.configuration).release1(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CasePdfControllerApi - axios parameter creator
 * @export
 */
export const CasePdfControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfByCaseId: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getPdfByCaseId', 'caseId', caseId)
            const localVarPath = `/get_pdf_by_case_id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseId !== undefined) {
                localVarQueryParameter['case_id'] = caseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CasePdfControllerApi - functional programming interface
 * @export
 */
export const CasePdfControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CasePdfControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPdfByCaseId(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPdfByCaseId(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasePdfControllerApi.getPdfByCaseId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CasePdfControllerApi - factory interface
 * @export
 */
export const CasePdfControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CasePdfControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPdfByCaseId(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getPdfByCaseId(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CasePdfControllerApi - object-oriented interface
 * @export
 * @class CasePdfControllerApi
 * @extends {BaseAPI}
 */
export class CasePdfControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasePdfControllerApi
     */
    public getPdfByCaseId(caseId: number, options?: RawAxiosRequestConfig) {
        return CasePdfControllerApiFp(this.configuration).getPdfByCaseId(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CasePipelineControllerApi - axios parameter creator
 * @export
 */
export const CasePipelineControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseStatusOverview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/case-status-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CasePipelineControllerApi - functional programming interface
 * @export
 */
export const CasePipelineControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CasePipelineControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseStatusOverview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListPipelineStageCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseStatusOverview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CasePipelineControllerApi.getCaseStatusOverview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CasePipelineControllerApi - factory interface
 * @export
 */
export const CasePipelineControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CasePipelineControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseStatusOverview(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListPipelineStageCount> {
            return localVarFp.getCaseStatusOverview(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CasePipelineControllerApi - object-oriented interface
 * @export
 * @class CasePipelineControllerApi
 * @extends {BaseAPI}
 */
export class CasePipelineControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CasePipelineControllerApi
     */
    public getCaseStatusOverview(options?: RawAxiosRequestConfig) {
        return CasePipelineControllerApiFp(this.configuration).getCaseStatusOverview(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseQueryControllerApi - axios parameter creator
 * @export
 */
export const CaseQueryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cases/filter-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [subStatus] 
         * @param {Array<string>} [stage] 
         * @param {string} [search] 
         * @param {string} [product] 
         * @param {string} [seriousness] 
         * @param {string} [country] 
         * @param {boolean} [isDuplicate] 
         * @param {string} [dueDateFilter] 
         * @param {string} [deadlineStatus] 
         * @param {boolean} [pendingOnly] 
         * @param {string} [authority] 
         * @param {string} [priority] 
         * @param {string} [assignedUserId] 
         * @param {boolean} [accessibleToMe] 
         * @param {boolean} [includePool] 
         * @param {boolean} [excludePickupOnly] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (page?: number, pageSize?: number, subStatus?: string, stage?: Array<string>, search?: string, product?: string, seriousness?: string, country?: string, isDuplicate?: boolean, dueDateFilter?: string, deadlineStatus?: string, pendingOnly?: boolean, authority?: string, priority?: string, assignedUserId?: string, accessibleToMe?: boolean, includePool?: boolean, excludePickupOnly?: boolean, sortBy?: string, sortOrder?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (subStatus !== undefined) {
                localVarQueryParameter['sub_status'] = subStatus;
            }

            if (stage) {
                localVarQueryParameter['stage'] = stage;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (seriousness !== undefined) {
                localVarQueryParameter['seriousness'] = seriousness;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (isDuplicate !== undefined) {
                localVarQueryParameter['is_duplicate'] = isDuplicate;
            }

            if (dueDateFilter !== undefined) {
                localVarQueryParameter['due_date_filter'] = dueDateFilter;
            }

            if (deadlineStatus !== undefined) {
                localVarQueryParameter['deadline_status'] = deadlineStatus;
            }

            if (pendingOnly !== undefined) {
                localVarQueryParameter['pending_only'] = pendingOnly;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }

            if (assignedUserId !== undefined) {
                localVarQueryParameter['assigned_user_id'] = assignedUserId;
            }

            if (accessibleToMe !== undefined) {
                localVarQueryParameter['accessible_to_me'] = accessibleToMe;
            }

            if (includePool !== undefined) {
                localVarQueryParameter['include_pool'] = includePool;
            }

            if (excludePickupOnly !== undefined) {
                localVarQueryParameter['exclude_pickup_only'] = excludePickupOnly;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cases/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [stage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workload: async (stage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/cases/workload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stage !== undefined) {
                localVarQueryParameter['stage'] = stage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseQueryControllerApi - functional programming interface
 * @export
 */
export const CaseQueryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseQueryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filterOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFilterOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filterOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueryControllerApi.filterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [subStatus] 
         * @param {Array<string>} [stage] 
         * @param {string} [search] 
         * @param {string} [product] 
         * @param {string} [seriousness] 
         * @param {string} [country] 
         * @param {boolean} [isDuplicate] 
         * @param {string} [dueDateFilter] 
         * @param {string} [deadlineStatus] 
         * @param {boolean} [pendingOnly] 
         * @param {string} [authority] 
         * @param {string} [priority] 
         * @param {string} [assignedUserId] 
         * @param {boolean} [accessibleToMe] 
         * @param {boolean} [includePool] 
         * @param {boolean} [excludePickupOnly] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(page?: number, pageSize?: number, subStatus?: string, stage?: Array<string>, search?: string, product?: string, seriousness?: string, country?: string, isDuplicate?: boolean, dueDateFilter?: string, deadlineStatus?: string, pendingOnly?: boolean, authority?: string, priority?: string, assignedUserId?: string, accessibleToMe?: boolean, includePool?: boolean, excludePickupOnly?: boolean, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(page, pageSize, subStatus, stage, search, product, seriousness, country, isDuplicate, dueDateFilter, deadlineStatus, pendingOnly, authority, priority, assignedUserId, accessibleToMe, includePool, excludePickupOnly, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueryControllerApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async summary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseListSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.summary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueryControllerApi.summary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [stage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workload(stage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListAssigneeWorkload>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workload(stage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseQueryControllerApi.workload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseQueryControllerApi - factory interface
 * @export
 */
export const CaseQueryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseQueryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filterOptions(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFilterOptions> {
            return localVarFp.filterOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [subStatus] 
         * @param {Array<string>} [stage] 
         * @param {string} [search] 
         * @param {string} [product] 
         * @param {string} [seriousness] 
         * @param {string} [country] 
         * @param {boolean} [isDuplicate] 
         * @param {string} [dueDateFilter] 
         * @param {string} [deadlineStatus] 
         * @param {boolean} [pendingOnly] 
         * @param {string} [authority] 
         * @param {string} [priority] 
         * @param {string} [assignedUserId] 
         * @param {boolean} [accessibleToMe] 
         * @param {boolean} [includePool] 
         * @param {boolean} [excludePickupOnly] 
         * @param {string} [sortBy] 
         * @param {string} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(page?: number, pageSize?: number, subStatus?: string, stage?: Array<string>, search?: string, product?: string, seriousness?: string, country?: string, isDuplicate?: boolean, dueDateFilter?: string, deadlineStatus?: string, pendingOnly?: boolean, authority?: string, priority?: string, assignedUserId?: string, accessibleToMe?: boolean, includePool?: boolean, excludePickupOnly?: boolean, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseListResponse> {
            return localVarFp.list(page, pageSize, subStatus, stage, search, product, seriousness, country, isDuplicate, dueDateFilter, deadlineStatus, pendingOnly, authority, priority, assignedUserId, accessibleToMe, includePool, excludePickupOnly, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        summary(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseListSummary> {
            return localVarFp.summary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [stage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workload(stage?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListAssigneeWorkload> {
            return localVarFp.workload(stage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseQueryControllerApi - object-oriented interface
 * @export
 * @class CaseQueryControllerApi
 * @extends {BaseAPI}
 */
export class CaseQueryControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueryControllerApi
     */
    public filterOptions(options?: RawAxiosRequestConfig) {
        return CaseQueryControllerApiFp(this.configuration).filterOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [subStatus] 
     * @param {Array<string>} [stage] 
     * @param {string} [search] 
     * @param {string} [product] 
     * @param {string} [seriousness] 
     * @param {string} [country] 
     * @param {boolean} [isDuplicate] 
     * @param {string} [dueDateFilter] 
     * @param {string} [deadlineStatus] 
     * @param {boolean} [pendingOnly] 
     * @param {string} [authority] 
     * @param {string} [priority] 
     * @param {string} [assignedUserId] 
     * @param {boolean} [accessibleToMe] 
     * @param {boolean} [includePool] 
     * @param {boolean} [excludePickupOnly] 
     * @param {string} [sortBy] 
     * @param {string} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueryControllerApi
     */
    public list(page?: number, pageSize?: number, subStatus?: string, stage?: Array<string>, search?: string, product?: string, seriousness?: string, country?: string, isDuplicate?: boolean, dueDateFilter?: string, deadlineStatus?: string, pendingOnly?: boolean, authority?: string, priority?: string, assignedUserId?: string, accessibleToMe?: boolean, includePool?: boolean, excludePickupOnly?: boolean, sortBy?: string, sortOrder?: string, options?: RawAxiosRequestConfig) {
        return CaseQueryControllerApiFp(this.configuration).list(page, pageSize, subStatus, stage, search, product, seriousness, country, isDuplicate, dueDateFilter, deadlineStatus, pendingOnly, authority, priority, assignedUserId, accessibleToMe, includePool, excludePickupOnly, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueryControllerApi
     */
    public summary(options?: RawAxiosRequestConfig) {
        return CaseQueryControllerApiFp(this.configuration).summary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [stage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseQueryControllerApi
     */
    public workload(stage?: string, options?: RawAxiosRequestConfig) {
        return CaseQueryControllerApiFp(this.configuration).workload(stage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseRouteForwardControllerApi - axios parameter creator
 * @export
 */
export const CaseRouteForwardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {RouteForwardRequest} [routeForwardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routeForward: async (id: number, xSessionId?: string, routeForwardRequest?: RouteForwardRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('routeForward', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/route-forward`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(routeForwardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseRouteForwardControllerApi - functional programming interface
 * @export
 */
export const CaseRouteForwardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseRouteForwardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {RouteForwardRequest} [routeForwardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async routeForward(id: number, xSessionId?: string, routeForwardRequest?: RouteForwardRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseTransitionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.routeForward(id, xSessionId, routeForwardRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseRouteForwardControllerApi.routeForward']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseRouteForwardControllerApi - factory interface
 * @export
 */
export const CaseRouteForwardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseRouteForwardControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {RouteForwardRequest} [routeForwardRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routeForward(id: number, xSessionId?: string, routeForwardRequest?: RouteForwardRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseTransitionResult> {
            return localVarFp.routeForward(id, xSessionId, routeForwardRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseRouteForwardControllerApi - object-oriented interface
 * @export
 * @class CaseRouteForwardControllerApi
 * @extends {BaseAPI}
 */
export class CaseRouteForwardControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {RouteForwardRequest} [routeForwardRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseRouteForwardControllerApi
     */
    public routeForward(id: number, xSessionId?: string, routeForwardRequest?: RouteForwardRequest, options?: RawAxiosRequestConfig) {
        return CaseRouteForwardControllerApiFp(this.configuration).routeForward(id, xSessionId, routeForwardRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseSourceDocumentViewControllerApi - axios parameter creator
 * @export
 */
export const CaseSourceDocumentViewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceDocumentKind: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getSourceDocumentKind', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/source-document/kind`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceSpreadsheet: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getSourceSpreadsheet', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/source-spreadsheet`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseSourceDocumentViewControllerApi - functional programming interface
 * @export
 */
export const CaseSourceDocumentViewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseSourceDocumentViewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourceDocumentKind(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceDocumentInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourceDocumentKind(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseSourceDocumentViewControllerApi.getSourceDocumentKind']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSourceSpreadsheet(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpreadsheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSourceSpreadsheet(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseSourceDocumentViewControllerApi.getSourceSpreadsheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseSourceDocumentViewControllerApi - factory interface
 * @export
 */
export const CaseSourceDocumentViewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseSourceDocumentViewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceDocumentKind(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<SourceDocumentInfo> {
            return localVarFp.getSourceDocumentKind(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSourceSpreadsheet(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<SpreadsheetView> {
            return localVarFp.getSourceSpreadsheet(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseSourceDocumentViewControllerApi - object-oriented interface
 * @export
 * @class CaseSourceDocumentViewControllerApi
 * @extends {BaseAPI}
 */
export class CaseSourceDocumentViewControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseSourceDocumentViewControllerApi
     */
    public getSourceDocumentKind(caseId: number, options?: RawAxiosRequestConfig) {
        return CaseSourceDocumentViewControllerApiFp(this.configuration).getSourceDocumentKind(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseSourceDocumentViewControllerApi
     */
    public getSourceSpreadsheet(caseId: number, options?: RawAxiosRequestConfig) {
        return CaseSourceDocumentViewControllerApiFp(this.configuration).getSourceSpreadsheet(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseTransitionControllerApi - axios parameter creator
 * @export
 */
export const CaseTransitionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        events: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('events', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/transitions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {TransitionRequest} transitionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transition: async (id: number, transitionRequest: TransitionRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transition', 'id', id)
            // verify required parameter 'transitionRequest' is not null or undefined
            assertParamExists('transition', 'transitionRequest', transitionRequest)
            const localVarPath = `/api/v1/cases/{id}/transitions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseTransitionControllerApi - functional programming interface
 * @export
 */
export const CaseTransitionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseTransitionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async events(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseEventView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.events(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTransitionControllerApi.events']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {TransitionRequest} transitionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transition(id: number, transitionRequest: TransitionRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseTransitionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transition(id, transitionRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseTransitionControllerApi.transition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseTransitionControllerApi - factory interface
 * @export
 */
export const CaseTransitionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseTransitionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        events(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseEventView> {
            return localVarFp.events(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {TransitionRequest} transitionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transition(id: number, transitionRequest: TransitionRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseTransitionResult> {
            return localVarFp.transition(id, transitionRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseTransitionControllerApi - object-oriented interface
 * @export
 * @class CaseTransitionControllerApi
 * @extends {BaseAPI}
 */
export class CaseTransitionControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTransitionControllerApi
     */
    public events(id: number, options?: RawAxiosRequestConfig) {
        return CaseTransitionControllerApiFp(this.configuration).events(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {TransitionRequest} transitionRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseTransitionControllerApi
     */
    public transition(id: number, transitionRequest: TransitionRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CaseTransitionControllerApiFp(this.configuration).transition(id, transitionRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseWorkflowStatusControllerApi - axios parameter creator
 * @export
 */
export const CaseWorkflowStatusControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowStatus: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('workflowStatus', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/workflow-status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseWorkflowStatusControllerApi - functional programming interface
 * @export
 */
export const CaseWorkflowStatusControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseWorkflowStatusControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflowStatus(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseWorkflowStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflowStatus(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseWorkflowStatusControllerApi.workflowStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseWorkflowStatusControllerApi - factory interface
 * @export
 */
export const CaseWorkflowStatusControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseWorkflowStatusControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflowStatus(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseWorkflowStatusResponse> {
            return localVarFp.workflowStatus(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseWorkflowStatusControllerApi - object-oriented interface
 * @export
 * @class CaseWorkflowStatusControllerApi
 * @extends {BaseAPI}
 */
export class CaseWorkflowStatusControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseWorkflowStatusControllerApi
     */
    public workflowStatus(id: number, options?: RawAxiosRequestConfig) {
        return CaseWorkflowStatusControllerApiFp(this.configuration).workflowStatus(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CaseWwidControllerApi - axios parameter creator
 * @export
 */
export const CaseWwidControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseWwid: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCaseWwid', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/wwid`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CaseWwidControllerApi - functional programming interface
 * @export
 */
export const CaseWwidControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CaseWwidControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCaseWwid(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseWwidView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCaseWwid(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CaseWwidControllerApi.getCaseWwid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CaseWwidControllerApi - factory interface
 * @export
 */
export const CaseWwidControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CaseWwidControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCaseWwid(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseWwidView> {
            return localVarFp.getCaseWwid(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CaseWwidControllerApi - object-oriented interface
 * @export
 * @class CaseWwidControllerApi
 * @extends {BaseAPI}
 */
export class CaseWwidControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseWwidControllerApi
     */
    public getCaseWwid(id: number, options?: RawAxiosRequestConfig) {
        return CaseWwidControllerApiFp(this.configuration).getCaseWwid(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogFieldHistoryControllerApi - axios parameter creator
 * @export
 */
export const CatalogFieldHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} fieldId 
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogFieldHistory: async (caseId: number, fieldId: string, recordId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('catalogFieldHistory', 'caseId', caseId)
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('catalogFieldHistory', 'fieldId', fieldId)
            const localVarPath = `/api/v2/cases/{caseId}/review/fields/{fieldId}/history`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (recordId !== undefined) {
                localVarQueryParameter['record_id'] = recordId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogFieldHistoryControllerApi - functional programming interface
 * @export
 */
export const CatalogFieldHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogFieldHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} fieldId 
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async catalogFieldHistory(caseId: number, fieldId: string, recordId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFieldHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.catalogFieldHistory(caseId, fieldId, recordId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogFieldHistoryControllerApi.catalogFieldHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogFieldHistoryControllerApi - factory interface
 * @export
 */
export const CatalogFieldHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogFieldHistoryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} fieldId 
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        catalogFieldHistory(caseId: number, fieldId: string, recordId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFieldHistoryDto> {
            return localVarFp.catalogFieldHistory(caseId, fieldId, recordId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogFieldHistoryControllerApi - object-oriented interface
 * @export
 * @class CatalogFieldHistoryControllerApi
 * @extends {BaseAPI}
 */
export class CatalogFieldHistoryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {string} fieldId 
     * @param {string} [recordId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogFieldHistoryControllerApi
     */
    public catalogFieldHistory(caseId: number, fieldId: string, recordId?: string, options?: RawAxiosRequestConfig) {
        return CatalogFieldHistoryControllerApiFp(this.configuration).catalogFieldHistory(caseId, fieldId, recordId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogOptionControllerApi - axios parameter creator
 * @export
 */
export const CatalogOptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _options: async (fieldId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('_options', 'fieldId', fieldId)
            const localVarPath = `/api/v1/field-catalog/options/{fieldId}`
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogOptionControllerApi - functional programming interface
 * @export
 */
export const CatalogOptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogOptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _options(fieldId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._options(fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogOptionControllerApi._options']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogOptionControllerApi - factory interface
 * @export
 */
export const CatalogOptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogOptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _options(fieldId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CatalogOption>> {
            return localVarFp._options(fieldId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogOptionControllerApi - object-oriented interface
 * @export
 * @class CatalogOptionControllerApi
 * @extends {BaseAPI}
 */
export class CatalogOptionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} fieldId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogOptionControllerApi
     */
    public _options(fieldId: string, options?: RawAxiosRequestConfig) {
        return CatalogOptionControllerApiFp(this.configuration)._options(fieldId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogReviewControllerApi - axios parameter creator
 * @export
 */
export const CatalogReviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (caseId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('get', 'caseId', caseId)
            const localVarPath = `/api/v2/cases/{caseId}/review`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogReviewPatchRequest} catalogReviewPatchRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch: async (caseId: number, catalogReviewPatchRequest: CatalogReviewPatchRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('patch', 'caseId', caseId)
            // verify required parameter 'catalogReviewPatchRequest' is not null or undefined
            assertParamExists('patch', 'catalogReviewPatchRequest', catalogReviewPatchRequest)
            const localVarPath = `/api/v2/cases/{caseId}/review`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogReviewPatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogReviewControllerApi - functional programming interface
 * @export
 */
export const CatalogReviewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogReviewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCatalogReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(caseId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogReviewControllerApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogReviewPatchRequest} catalogReviewPatchRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patch(caseId: number, catalogReviewPatchRequest: CatalogReviewPatchRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCatalogReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patch(caseId, catalogReviewPatchRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogReviewControllerApi.patch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogReviewControllerApi - factory interface
 * @export
 */
export const CatalogReviewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogReviewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCatalogReviewResponse> {
            return localVarFp.get(caseId, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogReviewPatchRequest} catalogReviewPatchRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patch(caseId: number, catalogReviewPatchRequest: CatalogReviewPatchRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCatalogReviewResponse> {
            return localVarFp.patch(caseId, catalogReviewPatchRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogReviewControllerApi - object-oriented interface
 * @export
 * @class CatalogReviewControllerApi
 * @extends {BaseAPI}
 */
export class CatalogReviewControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogReviewControllerApi
     */
    public get(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CatalogReviewControllerApiFp(this.configuration).get(caseId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {CatalogReviewPatchRequest} catalogReviewPatchRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogReviewControllerApi
     */
    public patch(caseId: number, catalogReviewPatchRequest: CatalogReviewPatchRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CatalogReviewControllerApiFp(this.configuration).patch(caseId, catalogReviewPatchRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogReviewRoutingControllerApi - axios parameter creator
 * @export
 */
export const CatalogReviewRoutingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogRouteReadinessRequest} catalogRouteReadinessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readiness: async (caseId: number, catalogRouteReadinessRequest: CatalogRouteReadinessRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('readiness', 'caseId', caseId)
            // verify required parameter 'catalogRouteReadinessRequest' is not null or undefined
            assertParamExists('readiness', 'catalogRouteReadinessRequest', catalogRouteReadinessRequest)
            const localVarPath = `/api/v2/cases/{caseId}/review/route-readiness`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogRouteReadinessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogRouteForwardRequest} catalogRouteForwardRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route: async (caseId: number, catalogRouteForwardRequest: CatalogRouteForwardRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('route', 'caseId', caseId)
            // verify required parameter 'catalogRouteForwardRequest' is not null or undefined
            assertParamExists('route', 'catalogRouteForwardRequest', catalogRouteForwardRequest)
            const localVarPath = `/api/v2/cases/{caseId}/review/route-forward`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogRouteForwardRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogReviewRoutingControllerApi - functional programming interface
 * @export
 */
export const CatalogReviewRoutingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogReviewRoutingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogRouteReadinessRequest} catalogRouteReadinessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readiness(caseId: number, catalogRouteReadinessRequest: CatalogRouteReadinessRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCatalogRouteReadinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readiness(caseId, catalogRouteReadinessRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogReviewRoutingControllerApi.readiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogRouteForwardRequest} catalogRouteForwardRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async route(caseId: number, catalogRouteForwardRequest: CatalogRouteForwardRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseTransitionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.route(caseId, catalogRouteForwardRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogReviewRoutingControllerApi.route']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogReviewRoutingControllerApi - factory interface
 * @export
 */
export const CatalogReviewRoutingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogReviewRoutingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogRouteReadinessRequest} catalogRouteReadinessRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readiness(caseId: number, catalogRouteReadinessRequest: CatalogRouteReadinessRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCatalogRouteReadinessResponse> {
            return localVarFp.readiness(caseId, catalogRouteReadinessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CatalogRouteForwardRequest} catalogRouteForwardRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        route(caseId: number, catalogRouteForwardRequest: CatalogRouteForwardRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseTransitionResult> {
            return localVarFp.route(caseId, catalogRouteForwardRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogReviewRoutingControllerApi - object-oriented interface
 * @export
 * @class CatalogReviewRoutingControllerApi
 * @extends {BaseAPI}
 */
export class CatalogReviewRoutingControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {CatalogRouteReadinessRequest} catalogRouteReadinessRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogReviewRoutingControllerApi
     */
    public readiness(caseId: number, catalogRouteReadinessRequest: CatalogRouteReadinessRequest, options?: RawAxiosRequestConfig) {
        return CatalogReviewRoutingControllerApiFp(this.configuration).readiness(caseId, catalogRouteReadinessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {CatalogRouteForwardRequest} catalogRouteForwardRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogReviewRoutingControllerApi
     */
    public route(caseId: number, catalogRouteForwardRequest: CatalogRouteForwardRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return CatalogReviewRoutingControllerApiFp(this.configuration).route(caseId, catalogRouteForwardRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogSavedReviewControllerApi - axios parameter creator
 * @export
 */
export const CatalogSavedReviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedReview: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getSavedReview', 'caseId', caseId)
            const localVarPath = `/api/v2/cases/{caseId}/saved-review`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogSavedReviewControllerApi - functional programming interface
 * @export
 */
export const CatalogSavedReviewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogSavedReviewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSavedReview(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCatalogSavedReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSavedReview(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogSavedReviewControllerApi.getSavedReview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogSavedReviewControllerApi - factory interface
 * @export
 */
export const CatalogSavedReviewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogSavedReviewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavedReview(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCatalogSavedReviewResponse> {
            return localVarFp.getSavedReview(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogSavedReviewControllerApi - object-oriented interface
 * @export
 * @class CatalogSavedReviewControllerApi
 * @extends {BaseAPI}
 */
export class CatalogSavedReviewControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogSavedReviewControllerApi
     */
    public getSavedReview(caseId: number, options?: RawAxiosRequestConfig) {
        return CatalogSavedReviewControllerApiFp(this.configuration).getSavedReview(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CatalogSectionOptionsControllerApi - axios parameter creator
 * @export
 */
export const CatalogSectionOptionsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sectionOptions: async (sectionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('sectionOptions', 'sectionId', sectionId)
            const localVarPath = `/api/v2/field-catalog/sections/{sectionId}/options`
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CatalogSectionOptionsControllerApi - functional programming interface
 * @export
 */
export const CatalogSectionOptionsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CatalogSectionOptionsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sectionOptions(sectionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMapStringListCatalogOption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sectionOptions(sectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CatalogSectionOptionsControllerApi.sectionOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CatalogSectionOptionsControllerApi - factory interface
 * @export
 */
export const CatalogSectionOptionsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CatalogSectionOptionsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} sectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sectionOptions(sectionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMapStringListCatalogOption> {
            return localVarFp.sectionOptions(sectionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CatalogSectionOptionsControllerApi - object-oriented interface
 * @export
 * @class CatalogSectionOptionsControllerApi
 * @extends {BaseAPI}
 */
export class CatalogSectionOptionsControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CatalogSectionOptionsControllerApi
     */
    public sectionOptions(sectionId: string, options?: RawAxiosRequestConfig) {
        return CatalogSectionOptionsControllerApiFp(this.configuration).sectionOptions(sectionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClinicalReadControllerApi - axios parameter creator
 * @export
 */
export const ClinicalReadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCausalityAssessments: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getCausalityAssessments', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/causality-assessments`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClinicalReadControllerApi - functional programming interface
 * @export
 */
export const ClinicalReadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClinicalReadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCausalityAssessments(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCausalityAssessmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCausalityAssessments(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClinicalReadControllerApi.getCausalityAssessments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClinicalReadControllerApi - factory interface
 * @export
 */
export const ClinicalReadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClinicalReadControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCausalityAssessments(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCausalityAssessmentView> {
            return localVarFp.getCausalityAssessments(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClinicalReadControllerApi - object-oriented interface
 * @export
 * @class ClinicalReadControllerApi
 * @extends {BaseAPI}
 */
export class ClinicalReadControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClinicalReadControllerApi
     */
    public getCausalityAssessments(caseId: number, options?: RawAxiosRequestConfig) {
        return ClinicalReadControllerApiFp(this.configuration).getCausalityAssessments(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CodelistControllerApi - axios parameter creator
 * @export
 */
export const CodelistControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} tableName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodelist: async (tableName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tableName' is not null or undefined
            assertParamExists('getCodelist', 'tableName', tableName)
            const localVarPath = `/api/v1/codelists/{tableName}`
                .replace(`{${"tableName"}}`, encodeURIComponent(String(tableName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodelistControllerApi - functional programming interface
 * @export
 */
export const CodelistControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CodelistControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} tableName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCodelist(tableName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListMapStringObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCodelist(tableName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CodelistControllerApi.getCodelist']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CodelistControllerApi - factory interface
 * @export
 */
export const CodelistControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CodelistControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} tableName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodelist(tableName: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListMapStringObject> {
            return localVarFp.getCodelist(tableName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CodelistControllerApi - object-oriented interface
 * @export
 * @class CodelistControllerApi
 * @extends {BaseAPI}
 */
export class CodelistControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} tableName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodelistControllerApi
     */
    public getCodelist(tableName: string, options?: RawAxiosRequestConfig) {
        return CodelistControllerApiFp(this.configuration).getCodelist(tableName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConfigControllerApi - axios parameter creator
 * @export
 */
export const ConfigControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ConfigCountry} configCountry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCountry: async (configCountry: ConfigCountry, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configCountry' is not null or undefined
            assertParamExists('createCountry', 'configCountry', configCountry)
            const localVarPath = `/api/v1/config/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configCountry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigDatasheet} configDatasheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasheet: async (configDatasheet: ConfigDatasheet, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configDatasheet' is not null or undefined
            assertParamExists('createDatasheet', 'configDatasheet', configDatasheet)
            const localVarPath = `/api/v1/config/datasheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configDatasheet, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigProductLicense} configProductLicense 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLicense: async (configProductLicense: ConfigProductLicense, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configProductLicense' is not null or undefined
            assertParamExists('createLicense', 'configProductLicense', configProductLicense)
            const localVarPath = `/api/v1/config/product-licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configProductLicense, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigPriority} configPriority 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriority: async (configPriority: ConfigPriority, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configPriority' is not null or undefined
            assertParamExists('createPriority', 'configPriority', configPriority)
            const localVarPath = `/api/v1/config/priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configPriority, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigProduct} configProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: async (configProduct: ConfigProduct, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configProduct' is not null or undefined
            assertParamExists('createProduct', 'configProduct', configProduct)
            const localVarPath = `/api/v1/config/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configProduct, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigReceiver} configReceiver 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReceiver: async (configReceiver: ConfigReceiver, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configReceiver' is not null or undefined
            assertParamExists('createReceiver', 'configReceiver', configReceiver)
            const localVarPath = `/api/v1/config/receivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configReceiver, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigReportType} configReportType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportType: async (configReportType: ConfigReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configReportType' is not null or undefined
            assertParamExists('createReportType', 'configReportType', configReportType)
            const localVarPath = `/api/v1/config/report-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configReportType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ConfigSender} configSender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSender: async (configSender: ConfigSender, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'configSender' is not null or undefined
            assertParamExists('createSender', 'configSender', configSender)
            const localVarPath = `/api/v1/config/senders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configSender, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasheet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDatasheet', 'id', id)
            const localVarPath = `/api/v1/config/datasheets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLicense: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLicense', 'id', id)
            const localVarPath = `/api/v1/config/product-licenses/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriority: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePriority', 'id', id)
            const localVarPath = `/api/v1/config/priorities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteProduct', 'id', id)
            const localVarPath = `/api/v1/config/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReceiver: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReceiver', 'id', id)
            const localVarPath = `/api/v1/config/receivers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportType: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteReportType', 'id', id)
            const localVarPath = `/api/v1/config/report-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSender: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteSender', 'id', id)
            const localVarPath = `/api/v1/config/senders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiAgents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/ai-agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDatasheets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/datasheets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFieldRules: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/field-rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormFields: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/form-fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLicenses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/product-licenses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPriorities: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/priorities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/receivers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportTypes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/report-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSenders: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/senders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigAiAssist} configAiAssist 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiAgent: async (id: number, configAiAssist: ConfigAiAssist, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAiAgent', 'id', id)
            // verify required parameter 'configAiAssist' is not null or undefined
            assertParamExists('updateAiAgent', 'configAiAssist', configAiAssist)
            const localVarPath = `/api/v1/config/ai-agents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configAiAssist, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigCountry} configCountry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCountry: async (id: number, configCountry: ConfigCountry, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCountry', 'id', id)
            // verify required parameter 'configCountry' is not null or undefined
            assertParamExists('updateCountry', 'configCountry', configCountry)
            const localVarPath = `/api/v1/config/countries/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configCountry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigFieldRules} configFieldRules 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFieldRule: async (id: number, configFieldRules: ConfigFieldRules, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFieldRule', 'id', id)
            // verify required parameter 'configFieldRules' is not null or undefined
            assertParamExists('updateFieldRule', 'configFieldRules', configFieldRules)
            const localVarPath = `/api/v1/config/field-rules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configFieldRules, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigFormField} configFormField 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormField: async (id: number, configFormField: ConfigFormField, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFormField', 'id', id)
            // verify required parameter 'configFormField' is not null or undefined
            assertParamExists('updateFormField', 'configFormField', configFormField)
            const localVarPath = `/api/v1/config/form-fields/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configFormField, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigPriority} configPriority 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriority: async (id: number, configPriority: ConfigPriority, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePriority', 'id', id)
            // verify required parameter 'configPriority' is not null or undefined
            assertParamExists('updatePriority', 'configPriority', configPriority)
            const localVarPath = `/api/v1/config/priorities/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configPriority, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigProduct} configProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: async (id: number, configProduct: ConfigProduct, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateProduct', 'id', id)
            // verify required parameter 'configProduct' is not null or undefined
            assertParamExists('updateProduct', 'configProduct', configProduct)
            const localVarPath = `/api/v1/config/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configProduct, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigReceiver} configReceiver 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReceiver: async (id: number, configReceiver: ConfigReceiver, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReceiver', 'id', id)
            // verify required parameter 'configReceiver' is not null or undefined
            assertParamExists('updateReceiver', 'configReceiver', configReceiver)
            const localVarPath = `/api/v1/config/receivers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configReceiver, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigReportType} configReportType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportType: async (id: number, configReportType: ConfigReportType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateReportType', 'id', id)
            // verify required parameter 'configReportType' is not null or undefined
            assertParamExists('updateReportType', 'configReportType', configReportType)
            const localVarPath = `/api/v1/config/report-types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configReportType, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigSender} configSender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSender: async (id: number, configSender: ConfigSender, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateSender', 'id', id)
            // verify required parameter 'configSender' is not null or undefined
            assertParamExists('updateSender', 'configSender', configSender)
            const localVarPath = `/api/v1/config/senders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configSender, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConfigControllerApi - functional programming interface
 * @export
 */
export const ConfigControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConfigControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ConfigCountry} configCountry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCountry(configCountry: ConfigCountry, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCountry(configCountry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigDatasheet} configDatasheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDatasheet(configDatasheet: ConfigDatasheet, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigDatasheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDatasheet(configDatasheet, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createDatasheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigProductLicense} configProductLicense 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLicense(configProductLicense: ConfigProductLicense, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigProductLicense>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLicense(configProductLicense, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createLicense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigPriority} configPriority 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPriority(configPriority: ConfigPriority, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigPriority>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPriority(configPriority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createPriority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigProduct} configProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProduct(configProduct: ConfigProduct, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProduct(configProduct, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigReceiver} configReceiver 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReceiver(configReceiver: ConfigReceiver, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigReceiver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReceiver(configReceiver, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createReceiver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigReportType} configReportType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createReportType(configReportType: ConfigReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigReportType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createReportType(configReportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createReportType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ConfigSender} configSender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSender(configSender: ConfigSender, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigSender>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSender(configSender, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.createSender']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDatasheet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDatasheet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deleteDatasheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLicense(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLicense(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deleteLicense']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePriority(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePriority(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deletePriority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProduct(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deleteProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReceiver(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReceiver(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deleteReceiver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteReportType(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteReportType(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deleteReportType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSender(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSender(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.deleteSender']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAiAgents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigAiAssist>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAiAgents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listAiAgents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDatasheets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigDatasheet>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDatasheets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listDatasheets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFieldRules(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigFieldRules>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFieldRules(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listFieldRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFormFields(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigFormField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFormFields(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listFormFields']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLicenses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigProductLicense>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLicenses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listLicenses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPriorities(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigPriority>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPriorities(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listPriorities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReceivers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigReceiver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReceivers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listReceivers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReportTypes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigReportType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReportTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listReportTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSenders(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListConfigSender>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSenders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.listSenders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigAiAssist} configAiAssist 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAiAgent(id: number, configAiAssist: ConfigAiAssist, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigAiAssist>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAiAgent(id, configAiAssist, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateAiAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigCountry} configCountry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCountry(id: number, configCountry: ConfigCountry, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigCountry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCountry(id, configCountry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigFieldRules} configFieldRules 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFieldRule(id: number, configFieldRules: ConfigFieldRules, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigFieldRules>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFieldRule(id, configFieldRules, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateFieldRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigFormField} configFormField 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFormField(id: number, configFormField: ConfigFormField, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigFormField>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFormField(id, configFormField, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateFormField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigPriority} configPriority 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePriority(id: number, configPriority: ConfigPriority, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigPriority>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePriority(id, configPriority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updatePriority']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigProduct} configProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProduct(id: number, configProduct: ConfigProduct, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigProduct>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProduct(id, configProduct, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigReceiver} configReceiver 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReceiver(id: number, configReceiver: ConfigReceiver, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigReceiver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReceiver(id, configReceiver, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateReceiver']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigReportType} configReportType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateReportType(id: number, configReportType: ConfigReportType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigReportType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateReportType(id, configReportType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateReportType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigSender} configSender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSender(id: number, configSender: ConfigSender, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseConfigSender>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSender(id, configSender, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConfigControllerApi.updateSender']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConfigControllerApi - factory interface
 * @export
 */
export const ConfigControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConfigControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ConfigCountry} configCountry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCountry(configCountry: ConfigCountry, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigCountry> {
            return localVarFp.createCountry(configCountry, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigDatasheet} configDatasheet 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDatasheet(configDatasheet: ConfigDatasheet, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigDatasheet> {
            return localVarFp.createDatasheet(configDatasheet, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigProductLicense} configProductLicense 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLicense(configProductLicense: ConfigProductLicense, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigProductLicense> {
            return localVarFp.createLicense(configProductLicense, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigPriority} configPriority 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPriority(configPriority: ConfigPriority, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigPriority> {
            return localVarFp.createPriority(configPriority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigProduct} configProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct(configProduct: ConfigProduct, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigProduct> {
            return localVarFp.createProduct(configProduct, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigReceiver} configReceiver 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReceiver(configReceiver: ConfigReceiver, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigReceiver> {
            return localVarFp.createReceiver(configReceiver, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigReportType} configReportType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportType(configReportType: ConfigReportType, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigReportType> {
            return localVarFp.createReportType(configReportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ConfigSender} configSender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSender(configSender: ConfigSender, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigSender> {
            return localVarFp.createSender(configSender, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDatasheet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDatasheet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLicense(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteLicense(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriority(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePriority(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReceiver(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReceiver(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteReportType(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteReportType(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSender(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSender(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAiAgents(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigAiAssist> {
            return localVarFp.listAiAgents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigCountry> {
            return localVarFp.listCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDatasheets(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigDatasheet> {
            return localVarFp.listDatasheets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFieldRules(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigFieldRules> {
            return localVarFp.listFieldRules(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFormFields(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigFormField> {
            return localVarFp.listFormFields(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLicenses(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigProductLicense> {
            return localVarFp.listLicenses(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPriorities(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigPriority> {
            return localVarFp.listPriorities(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigProduct> {
            return localVarFp.listProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReceivers(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigReceiver> {
            return localVarFp.listReceivers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReportTypes(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigReportType> {
            return localVarFp.listReportTypes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSenders(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListConfigSender> {
            return localVarFp.listSenders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigAiAssist} configAiAssist 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAiAgent(id: number, configAiAssist: ConfigAiAssist, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigAiAssist> {
            return localVarFp.updateAiAgent(id, configAiAssist, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigCountry} configCountry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCountry(id: number, configCountry: ConfigCountry, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigCountry> {
            return localVarFp.updateCountry(id, configCountry, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigFieldRules} configFieldRules 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFieldRule(id: number, configFieldRules: ConfigFieldRules, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigFieldRules> {
            return localVarFp.updateFieldRule(id, configFieldRules, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigFormField} configFormField 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFormField(id: number, configFormField: ConfigFormField, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigFormField> {
            return localVarFp.updateFormField(id, configFormField, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigPriority} configPriority 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePriority(id: number, configPriority: ConfigPriority, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigPriority> {
            return localVarFp.updatePriority(id, configPriority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigProduct} configProduct 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct(id: number, configProduct: ConfigProduct, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigProduct> {
            return localVarFp.updateProduct(id, configProduct, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigReceiver} configReceiver 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReceiver(id: number, configReceiver: ConfigReceiver, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigReceiver> {
            return localVarFp.updateReceiver(id, configReceiver, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigReportType} configReportType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateReportType(id: number, configReportType: ConfigReportType, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigReportType> {
            return localVarFp.updateReportType(id, configReportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {ConfigSender} configSender 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSender(id: number, configSender: ConfigSender, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseConfigSender> {
            return localVarFp.updateSender(id, configSender, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConfigControllerApi - object-oriented interface
 * @export
 * @class ConfigControllerApi
 * @extends {BaseAPI}
 */
export class ConfigControllerApi extends BaseAPI {
    /**
     * 
     * @param {ConfigCountry} configCountry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createCountry(configCountry: ConfigCountry, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createCountry(configCountry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigDatasheet} configDatasheet 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createDatasheet(configDatasheet: ConfigDatasheet, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createDatasheet(configDatasheet, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigProductLicense} configProductLicense 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createLicense(configProductLicense: ConfigProductLicense, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createLicense(configProductLicense, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigPriority} configPriority 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createPriority(configPriority: ConfigPriority, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createPriority(configPriority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigProduct} configProduct 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createProduct(configProduct: ConfigProduct, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createProduct(configProduct, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigReceiver} configReceiver 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createReceiver(configReceiver: ConfigReceiver, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createReceiver(configReceiver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigReportType} configReportType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createReportType(configReportType: ConfigReportType, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createReportType(configReportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ConfigSender} configSender 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public createSender(configSender: ConfigSender, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).createSender(configSender, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deleteDatasheet(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deleteDatasheet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deleteLicense(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deleteLicense(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deletePriority(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deletePriority(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deleteProduct(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deleteProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deleteReceiver(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deleteReceiver(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deleteReportType(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deleteReportType(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public deleteSender(id: number, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).deleteSender(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listAiAgents(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listAiAgents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listCountries(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listDatasheets(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listDatasheets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listFieldRules(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listFieldRules(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listFormFields(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listFormFields(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listLicenses(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listLicenses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listPriorities(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listPriorities(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listProducts(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listReceivers(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listReceivers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listReportTypes(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listReportTypes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public listSenders(options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).listSenders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigAiAssist} configAiAssist 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateAiAgent(id: number, configAiAssist: ConfigAiAssist, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateAiAgent(id, configAiAssist, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigCountry} configCountry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateCountry(id: number, configCountry: ConfigCountry, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateCountry(id, configCountry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigFieldRules} configFieldRules 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateFieldRule(id: number, configFieldRules: ConfigFieldRules, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateFieldRule(id, configFieldRules, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigFormField} configFormField 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateFormField(id: number, configFormField: ConfigFormField, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateFormField(id, configFormField, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigPriority} configPriority 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updatePriority(id: number, configPriority: ConfigPriority, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updatePriority(id, configPriority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigProduct} configProduct 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateProduct(id: number, configProduct: ConfigProduct, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateProduct(id, configProduct, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigReceiver} configReceiver 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateReceiver(id: number, configReceiver: ConfigReceiver, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateReceiver(id, configReceiver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigReportType} configReportType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateReportType(id: number, configReportType: ConfigReportType, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateReportType(id, configReportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {ConfigSender} configSender 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ConfigControllerApi
     */
    public updateSender(id: number, configSender: ConfigSender, options?: RawAxiosRequestConfig) {
        return ConfigControllerApiFp(this.configuration).updateSender(id, configSender, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardCaseSearchControllerApi - axios parameter creator
 * @export
 */
export const DashboardCaseSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [openOnly] 
         * @param {string} [seriousness] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {boolean} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboardCases: async (openOnly?: boolean, seriousness?: string, page?: number, pageSize?: number, sortBy?: string, descending?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (openOnly !== undefined) {
                localVarQueryParameter['open_only'] = openOnly;
            }

            if (seriousness !== undefined) {
                localVarQueryParameter['seriousness'] = seriousness;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardCaseSearchControllerApi - functional programming interface
 * @export
 */
export const DashboardCaseSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardCaseSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [openOnly] 
         * @param {string} [seriousness] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {boolean} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDashboardCases(openOnly?: boolean, seriousness?: string, page?: number, pageSize?: number, sortBy?: string, descending?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDashboardCaseSearchResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDashboardCases(openOnly, seriousness, page, pageSize, sortBy, descending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardCaseSearchControllerApi.searchDashboardCases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardCaseSearchControllerApi - factory interface
 * @export
 */
export const DashboardCaseSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardCaseSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [openOnly] 
         * @param {string} [seriousness] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [sortBy] 
         * @param {boolean} [descending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDashboardCases(openOnly?: boolean, seriousness?: string, page?: number, pageSize?: number, sortBy?: string, descending?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDashboardCaseSearchResult> {
            return localVarFp.searchDashboardCases(openOnly, seriousness, page, pageSize, sortBy, descending, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardCaseSearchControllerApi - object-oriented interface
 * @export
 * @class DashboardCaseSearchControllerApi
 * @extends {BaseAPI}
 */
export class DashboardCaseSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [openOnly] 
     * @param {string} [seriousness] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [sortBy] 
     * @param {boolean} [descending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardCaseSearchControllerApi
     */
    public searchDashboardCases(openOnly?: boolean, seriousness?: string, page?: number, pageSize?: number, sortBy?: string, descending?: boolean, options?: RawAxiosRequestConfig) {
        return DashboardCaseSearchControllerApiFp(this.configuration).searchDashboardCases(openOnly, seriousness, page, pageSize, sortBy, descending, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardControllerApi - axios parameter creator
 * @export
 */
export const DashboardControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DashboardRepository} dashboardRepository 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard: async (dashboardRepository: DashboardRepository, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dashboardRepository' is not null or undefined
            assertParamExists('createDashboard', 'dashboardRepository', dashboardRepository)
            const localVarPath = `/api/v1/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardRepository, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDashboard', 'id', id)
            const localVarPath = `/api/v1/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDashboard', 'id', id)
            const localVarPath = `/api/v1/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {DashboardRepository} dashboardRepository 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard: async (id: number, dashboardRepository: DashboardRepository, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDashboard', 'id', id)
            // verify required parameter 'dashboardRepository' is not null or undefined
            assertParamExists('updateDashboard', 'dashboardRepository', dashboardRepository)
            const localVarPath = `/api/v1/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dashboardRepository, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardControllerApi - functional programming interface
 * @export
 */
export const DashboardControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DashboardRepository} dashboardRepository 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDashboard(dashboardRepository: DashboardRepository, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDashboardRepository>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDashboard(dashboardRepository, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.createDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDashboard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDashboard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.deleteDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDashboardRepository>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.getDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDashboards(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListDashboardRepository>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDashboards(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.listDashboards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {DashboardRepository} dashboardRepository 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDashboard(id: number, dashboardRepository: DashboardRepository, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDashboardRepository>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDashboard(id, dashboardRepository, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardControllerApi.updateDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardControllerApi - factory interface
 * @export
 */
export const DashboardControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DashboardRepository} dashboardRepository 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDashboard(dashboardRepository: DashboardRepository, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDashboardRepository> {
            return localVarFp.createDashboard(dashboardRepository, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDashboard(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteDashboard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDashboardRepository> {
            return localVarFp.getDashboard(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDashboards(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListDashboardRepository> {
            return localVarFp.listDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {DashboardRepository} dashboardRepository 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard(id: number, dashboardRepository: DashboardRepository, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDashboardRepository> {
            return localVarFp.updateDashboard(id, dashboardRepository, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardControllerApi - object-oriented interface
 * @export
 * @class DashboardControllerApi
 * @extends {BaseAPI}
 */
export class DashboardControllerApi extends BaseAPI {
    /**
     * 
     * @param {DashboardRepository} dashboardRepository 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public createDashboard(dashboardRepository: DashboardRepository, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).createDashboard(dashboardRepository, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public deleteDashboard(id: number, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).deleteDashboard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public getDashboard(id: number, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).getDashboard(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public listDashboards(options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).listDashboards(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {DashboardRepository} dashboardRepository 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardControllerApi
     */
    public updateDashboard(id: number, dashboardRepository: DashboardRepository, options?: RawAxiosRequestConfig) {
        return DashboardControllerApiFp(this.configuration).updateDashboard(id, dashboardRepository, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DashboardSectionControllerApi - axios parameter creator
 * @export
 */
export const DashboardSectionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSlas: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/client-slas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compliance: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/compliance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DrilldownTargetEnum} target 
         * @param {number} total The number that was clicked
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {string} [itemKey] The key of the clicked item, for the targets that need one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drilldown: async (target: DrilldownTargetEnum, total: number, product?: string, period?: string, authority?: string, itemKey?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'target' is not null or undefined
            assertParamExists('drilldown', 'target', target)
            // verify required parameter 'total' is not null or undefined
            assertParamExists('drilldown', 'total', total)
            const localVarPath = `/api/v1/dashboard/drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (itemKey !== undefined) {
                localVarQueryParameter['item_key'] = itemKey;
            }

            if (total !== undefined) {
                localVarQueryParameter['total'] = total;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followUps: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/follow-ups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {IntakeTrendRangeEnum} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intakeTrend: async (product?: string, period?: string, authority?: string, range?: IntakeTrendRangeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/intake-trend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }

            if (range !== undefined) {
                localVarQueryParameter['range'] = range;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kpis: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/kpis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quality: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/quality`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        team: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/team`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflow: async (product?: string, period?: string, authority?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dashboard/workflow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardSectionControllerApi - functional programming interface
 * @export
 */
export const DashboardSectionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardSectionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSlas(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseClientSlasResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientSlas(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.clientSlas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async compliance(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseComplianceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.compliance(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.compliance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DrilldownTargetEnum} target 
         * @param {number} total The number that was clicked
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {string} [itemKey] The key of the clicked item, for the targets that need one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async drilldown(target: DrilldownTargetEnum, total: number, product?: string, period?: string, authority?: string, itemKey?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.drilldown(target, total, product, period, authority, itemKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.drilldown']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async filters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDashboardFilterOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.filters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.filters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async followUps(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFollowUpsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.followUps(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.followUps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {IntakeTrendRangeEnum} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async intakeTrend(product?: string, period?: string, authority?: string, range?: IntakeTrendRangeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTrendResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.intakeTrend(product, period, authority, range, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.intakeTrend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async kpis(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseKpisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.kpis(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.kpis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async quality(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQualityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.quality(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.quality']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async team(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseTeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.team(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.team']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workflow(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWorkflowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workflow(product, period, authority, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardSectionControllerApi.workflow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardSectionControllerApi - factory interface
 * @export
 */
export const DashboardSectionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardSectionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSlas(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseClientSlasResponse> {
            return localVarFp.clientSlas(product, period, authority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        compliance(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseComplianceResponse> {
            return localVarFp.compliance(product, period, authority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DrilldownTargetEnum} target 
         * @param {number} total The number that was clicked
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {string} [itemKey] The key of the clicked item, for the targets that need one
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        drilldown(target: DrilldownTargetEnum, total: number, product?: string, period?: string, authority?: string, itemKey?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDrilldownResponse> {
            return localVarFp.drilldown(target, total, product, period, authority, itemKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filters(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDashboardFilterOptions> {
            return localVarFp.filters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        followUps(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFollowUpsResponse> {
            return localVarFp.followUps(product, period, authority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {IntakeTrendRangeEnum} [range] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        intakeTrend(product?: string, period?: string, authority?: string, range?: IntakeTrendRangeEnum, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTrendResponse> {
            return localVarFp.intakeTrend(product, period, authority, range, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        kpis(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseKpisResponse> {
            return localVarFp.kpis(product, period, authority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quality(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQualityResponse> {
            return localVarFp.quality(product, period, authority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        team(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseTeamResponse> {
            return localVarFp.team(product, period, authority, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [product] An option key from GET /api/v1/dashboard/filters
         * @param {string} [period] An option key from GET /api/v1/dashboard/filters
         * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workflow(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWorkflowResponse> {
            return localVarFp.workflow(product, period, authority, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardSectionControllerApi - object-oriented interface
 * @export
 * @class DashboardSectionControllerApi
 * @extends {BaseAPI}
 */
export class DashboardSectionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public clientSlas(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).clientSlas(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public compliance(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).compliance(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DrilldownTargetEnum} target 
     * @param {number} total The number that was clicked
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {string} [itemKey] The key of the clicked item, for the targets that need one
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public drilldown(target: DrilldownTargetEnum, total: number, product?: string, period?: string, authority?: string, itemKey?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).drilldown(target, total, product, period, authority, itemKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public filters(options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).filters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public followUps(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).followUps(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {IntakeTrendRangeEnum} [range] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public intakeTrend(product?: string, period?: string, authority?: string, range?: IntakeTrendRangeEnum, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).intakeTrend(product, period, authority, range, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public kpis(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).kpis(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public quality(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).quality(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public team(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).team(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [product] An option key from GET /api/v1/dashboard/filters
     * @param {string} [period] An option key from GET /api/v1/dashboard/filters
     * @param {string} [authority] An option key from GET /api/v1/dashboard/filters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardSectionControllerApi
     */
    public workflow(product?: string, period?: string, authority?: string, options?: RawAxiosRequestConfig) {
        return DashboardSectionControllerApiFp(this.configuration).workflow(product, period, authority, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const DrilldownTargetEnum = {
    Cases: 'CASES',
    Overdue: 'OVERDUE',
    DueSoon: 'DUE_SOON',
    Stage: 'STAGE',
    Ageing: 'AGEING',
    CaseMix: 'CASE_MIX',
    Authority: 'AUTHORITY',
    Assignee: 'ASSIGNEE',
    Unassigned: 'UNASSIGNED'
} as const;
export type DrilldownTargetEnum = typeof DrilldownTargetEnum[keyof typeof DrilldownTargetEnum];
/**
 * @export
 */
export const IntakeTrendRangeEnum = {
    SevenDays: 'SEVEN_DAYS',
    ThirtyDays: 'THIRTY_DAYS',
    ThreeMonths: 'THREE_MONTHS',
    OneYear: 'ONE_YEAR'
} as const;
export type IntakeTrendRangeEnum = typeof IntakeTrendRangeEnum[keyof typeof IntakeTrendRangeEnum];


/**
 * DeadlineHistoryControllerApi - axios parameter creator
 * @export
 */
export const DeadlineHistoryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadlineHistory: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('deadlineHistory', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/deadline-history`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeadlineHistoryControllerApi - functional programming interface
 * @export
 */
export const DeadlineHistoryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeadlineHistoryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deadlineHistory(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListDeadlineHistoryEntryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deadlineHistory(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeadlineHistoryControllerApi.deadlineHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeadlineHistoryControllerApi - factory interface
 * @export
 */
export const DeadlineHistoryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeadlineHistoryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadlineHistory(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListDeadlineHistoryEntryView> {
            return localVarFp.deadlineHistory(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeadlineHistoryControllerApi - object-oriented interface
 * @export
 * @class DeadlineHistoryControllerApi
 * @extends {BaseAPI}
 */
export class DeadlineHistoryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeadlineHistoryControllerApi
     */
    public deadlineHistory(caseId: number, options?: RawAxiosRequestConfig) {
        return DeadlineHistoryControllerApiFp(this.configuration).deadlineHistory(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeadlineReportControllerApi - axios parameter creator
 * @export
 */
export const DeadlineReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [authority] 
         * @param {string} [priority] 
         * @param {string} [status] A deadline status: Overdue, Due soon, On track, Pending, Complete, Not applicable, Withdrawn
         * @param {boolean} [pendingOnly] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadlineResults: async (authority?: string, priority?: string, status?: string, pendingOnly?: boolean, page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/deadline-results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (authority !== undefined) {
                localVarQueryParameter['authority'] = authority;
            }

            if (priority !== undefined) {
                localVarQueryParameter['priority'] = priority;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (pendingOnly !== undefined) {
                localVarQueryParameter['pending_only'] = pendingOnly;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeadlineReportControllerApi - functional programming interface
 * @export
 */
export const DeadlineReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeadlineReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [authority] 
         * @param {string} [priority] 
         * @param {string} [status] A deadline status: Overdue, Due soon, On track, Pending, Complete, Not applicable, Withdrawn
         * @param {boolean} [pendingOnly] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deadlineResults(authority?: string, priority?: string, status?: string, pendingOnly?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDeadlineReportPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deadlineResults(authority, priority, status, pendingOnly, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeadlineReportControllerApi.deadlineResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeadlineReportControllerApi - factory interface
 * @export
 */
export const DeadlineReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeadlineReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [authority] 
         * @param {string} [priority] 
         * @param {string} [status] A deadline status: Overdue, Due soon, On track, Pending, Complete, Not applicable, Withdrawn
         * @param {boolean} [pendingOnly] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deadlineResults(authority?: string, priority?: string, status?: string, pendingOnly?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDeadlineReportPage> {
            return localVarFp.deadlineResults(authority, priority, status, pendingOnly, page, pageSize, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeadlineReportControllerApi - object-oriented interface
 * @export
 * @class DeadlineReportControllerApi
 * @extends {BaseAPI}
 */
export class DeadlineReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [authority] 
     * @param {string} [priority] 
     * @param {string} [status] A deadline status: Overdue, Due soon, On track, Pending, Complete, Not applicable, Withdrawn
     * @param {boolean} [pendingOnly] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeadlineReportControllerApi
     */
    public deadlineResults(authority?: string, priority?: string, status?: string, pendingOnly?: boolean, page?: number, pageSize?: number, options?: RawAxiosRequestConfig) {
        return DeadlineReportControllerApiFp(this.configuration).deadlineResults(authority, priority, status, pendingOnly, page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeadlineReviewControllerApi - axios parameter creator
 * @export
 */
export const DeadlineReviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} resultId 
         * @param {DeadlineReviewCommand} deadlineReviewCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        review: async (caseId: number, resultId: number, deadlineReviewCommand: DeadlineReviewCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('review', 'caseId', caseId)
            // verify required parameter 'resultId' is not null or undefined
            assertParamExists('review', 'resultId', resultId)
            // verify required parameter 'deadlineReviewCommand' is not null or undefined
            assertParamExists('review', 'deadlineReviewCommand', deadlineReviewCommand)
            const localVarPath = `/api/v1/cases/{caseId}/deadlines/{resultId}/review`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"resultId"}}`, encodeURIComponent(String(resultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deadlineReviewCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeadlineReviewControllerApi - functional programming interface
 * @export
 */
export const DeadlineReviewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeadlineReviewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} resultId 
         * @param {DeadlineReviewCommand} deadlineReviewCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async review(caseId: number, resultId: number, deadlineReviewCommand: DeadlineReviewCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDeadlineReviewed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.review(caseId, resultId, deadlineReviewCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeadlineReviewControllerApi.review']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeadlineReviewControllerApi - factory interface
 * @export
 */
export const DeadlineReviewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeadlineReviewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} resultId 
         * @param {DeadlineReviewCommand} deadlineReviewCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        review(caseId: number, resultId: number, deadlineReviewCommand: DeadlineReviewCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDeadlineReviewed> {
            return localVarFp.review(caseId, resultId, deadlineReviewCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeadlineReviewControllerApi - object-oriented interface
 * @export
 * @class DeadlineReviewControllerApi
 * @extends {BaseAPI}
 */
export class DeadlineReviewControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {number} resultId 
     * @param {DeadlineReviewCommand} deadlineReviewCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeadlineReviewControllerApi
     */
    public review(caseId: number, resultId: number, deadlineReviewCommand: DeadlineReviewCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DeadlineReviewControllerApiFp(this.configuration).review(caseId, resultId, deadlineReviewCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DemoMenuControllerApi - axios parameter creator
 * @export
 */
export const DemoMenuControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoMenuConfiguration: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/demo/menu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DemoMenuControllerApi - functional programming interface
 * @export
 */
export const DemoMenuControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DemoMenuControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async demoMenuConfiguration(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DemoMenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.demoMenuConfiguration(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DemoMenuControllerApi.demoMenuConfiguration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DemoMenuControllerApi - factory interface
 * @export
 */
export const DemoMenuControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DemoMenuControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demoMenuConfiguration(options?: RawAxiosRequestConfig): AxiosPromise<DemoMenuResponse> {
            return localVarFp.demoMenuConfiguration(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DemoMenuControllerApi - object-oriented interface
 * @export
 * @class DemoMenuControllerApi
 * @extends {BaseAPI}
 */
export class DemoMenuControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemoMenuControllerApi
     */
    public demoMenuConfiguration(options?: RawAxiosRequestConfig) {
        return DemoMenuControllerApiFp(this.configuration).demoMenuConfiguration(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DueDatePolicyControllerApi - axios parameter creator
 * @export
 */
export const DueDatePolicyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPolicyDraft: async (dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dueDatePolicyDraftCommand' is not null or undefined
            assertParamExists('checkPolicyDraft', 'dueDatePolicyDraftCommand', dueDatePolicyDraftCommand)
            const localVarPath = `/api/v1/due-date-policies/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dueDatePolicyDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyDraft: async (dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dueDatePolicyDraftCommand' is not null or undefined
            assertParamExists('createPolicyDraft', 'dueDatePolicyDraftCommand', dueDatePolicyDraftCommand)
            const localVarPath = `/api/v1/due-date-policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dueDatePolicyDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyEditorOptions: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/due-date-policies/editor-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersion: async (versionId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('getPolicyVersion', 'versionId', versionId)
            const localVarPath = `/api/v1/due-date-policies/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyTimezones: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/due-date-policies/timezones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyVersions: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/due-date-policies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplacementCandidates: async (versionId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('listReplacementCandidates', 'versionId', versionId)
            const localVarPath = `/api/v1/due-date-policies/{versionId}/replacement-candidates`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {PolicyPublicationCommand} policyPublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPolicyVersion: async (versionId: number, policyPublicationCommand: PolicyPublicationCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('publishPolicyVersion', 'versionId', versionId)
            // verify required parameter 'policyPublicationCommand' is not null or undefined
            assertParamExists('publishPolicyVersion', 'policyPublicationCommand', policyPublicationCommand)
            const localVarPath = `/api/v1/due-date-policies/{versionId}/publish`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyPublicationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {PolicyReplacementCommand} policyReplacementCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePolicyVersion: async (versionId: number, policyReplacementCommand: PolicyReplacementCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('replacePolicyVersion', 'versionId', versionId)
            // verify required parameter 'policyReplacementCommand' is not null or undefined
            assertParamExists('replacePolicyVersion', 'policyReplacementCommand', policyReplacementCommand)
            const localVarPath = `/api/v1/due-date-policies/{versionId}/replacements`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyReplacementCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyDraft: async (versionId: number, dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updatePolicyDraft', 'versionId', versionId)
            // verify required parameter 'dueDatePolicyDraftCommand' is not null or undefined
            assertParamExists('updatePolicyDraft', 'dueDatePolicyDraftCommand', dueDatePolicyDraftCommand)
            const localVarPath = `/api/v1/due-date-policies/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dueDatePolicyDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DueDatePolicyControllerApi - functional programming interface
 * @export
 */
export const DueDatePolicyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DueDatePolicyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPolicyDraft(dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePolicyDraftCheckView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPolicyDraft(dueDatePolicyDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.checkPolicyDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPolicyDraft(dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDueDatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPolicyDraft(dueDatePolicyDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.createPolicyDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyEditorOptions(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePolicyEditorOptionsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyEditorOptions(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.getPolicyEditorOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPolicyVersion(versionId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDueDatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPolicyVersion(versionId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.getPolicyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPolicyTimezones(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListString>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPolicyTimezones(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.listPolicyTimezones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPolicyVersions(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListDueDatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPolicyVersions(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.listPolicyVersions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listReplacementCandidates(versionId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListReplacementCandidateView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listReplacementCandidates(versionId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.listReplacementCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {PolicyPublicationCommand} policyPublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishPolicyVersion(versionId: number, policyPublicationCommand: PolicyPublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDueDatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishPolicyVersion(versionId, policyPublicationCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.publishPolicyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {PolicyReplacementCommand} policyReplacementCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replacePolicyVersion(versionId: number, policyReplacementCommand: PolicyReplacementCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePolicyReplaced>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replacePolicyVersion(versionId, policyReplacementCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.replacePolicyVersion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePolicyDraft(versionId: number, dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDueDatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePolicyDraft(versionId, dueDatePolicyDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DueDatePolicyControllerApi.updatePolicyDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DueDatePolicyControllerApi - factory interface
 * @export
 */
export const DueDatePolicyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DueDatePolicyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPolicyDraft(dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePolicyDraftCheckView> {
            return localVarFp.checkPolicyDraft(dueDatePolicyDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPolicyDraft(dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDueDatePolicyVersionView> {
            return localVarFp.createPolicyDraft(dueDatePolicyDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyEditorOptions(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePolicyEditorOptionsView> {
            return localVarFp.getPolicyEditorOptions(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPolicyVersion(versionId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDueDatePolicyVersionView> {
            return localVarFp.getPolicyVersion(versionId, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyTimezones(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListString> {
            return localVarFp.listPolicyTimezones(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPolicyVersions(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListDueDatePolicyVersionView> {
            return localVarFp.listPolicyVersions(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplacementCandidates(versionId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListReplacementCandidateView> {
            return localVarFp.listReplacementCandidates(versionId, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {PolicyPublicationCommand} policyPublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishPolicyVersion(versionId: number, policyPublicationCommand: PolicyPublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDueDatePolicyVersionView> {
            return localVarFp.publishPolicyVersion(versionId, policyPublicationCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {PolicyReplacementCommand} policyReplacementCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replacePolicyVersion(versionId: number, policyReplacementCommand: PolicyReplacementCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePolicyReplaced> {
            return localVarFp.replacePolicyVersion(versionId, policyReplacementCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePolicyDraft(versionId: number, dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDueDatePolicyVersionView> {
            return localVarFp.updatePolicyDraft(versionId, dueDatePolicyDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DueDatePolicyControllerApi - object-oriented interface
 * @export
 * @class DueDatePolicyControllerApi
 * @extends {BaseAPI}
 */
export class DueDatePolicyControllerApi extends BaseAPI {
    /**
     * 
     * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public checkPolicyDraft(dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).checkPolicyDraft(dueDatePolicyDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public createPolicyDraft(dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).createPolicyDraft(dueDatePolicyDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public getPolicyEditorOptions(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).getPolicyEditorOptions(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public getPolicyVersion(versionId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).getPolicyVersion(versionId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public listPolicyTimezones(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).listPolicyTimezones(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public listPolicyVersions(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).listPolicyVersions(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public listReplacementCandidates(versionId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).listReplacementCandidates(versionId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {PolicyPublicationCommand} policyPublicationCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public publishPolicyVersion(versionId: number, policyPublicationCommand: PolicyPublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).publishPolicyVersion(versionId, policyPublicationCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {PolicyReplacementCommand} policyReplacementCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public replacePolicyVersion(versionId: number, policyReplacementCommand: PolicyReplacementCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).replacePolicyVersion(versionId, policyReplacementCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {DueDatePolicyDraftCommand} dueDatePolicyDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DueDatePolicyControllerApi
     */
    public updatePolicyDraft(versionId: number, dueDatePolicyDraftCommand: DueDatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DueDatePolicyControllerApiFp(this.configuration).updatePolicyDraft(versionId, dueDatePolicyDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DuplicatePolicyControllerApi - axios parameter creator
 * @export
 */
export const DuplicatePolicyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDuplicatePolicyDraft: async (duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'duplicatePolicyDraftCommand' is not null or undefined
            assertParamExists('createDuplicatePolicyDraft', 'duplicatePolicyDraftCommand', duplicatePolicyDraftCommand)
            const localVarPath = `/api/v1/duplicate-policy/drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicatePolicyDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuplicatePolicy: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/duplicate-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuplicateRecheck: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/duplicate-policy/recheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DuplicatePolicyPublicationCommand} duplicatePolicyPublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDuplicatePolicyDraft: async (versionId: number, duplicatePolicyPublicationCommand: DuplicatePolicyPublicationCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('publishDuplicatePolicyDraft', 'versionId', versionId)
            // verify required parameter 'duplicatePolicyPublicationCommand' is not null or undefined
            assertParamExists('publishDuplicatePolicyDraft', 'duplicatePolicyPublicationCommand', duplicatePolicyPublicationCommand)
            const localVarPath = `/api/v1/duplicate-policy/drafts/{versionId}/publish`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicatePolicyPublicationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDuplicateRecheck: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/duplicate-policy/recheck`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDuplicatePolicyDraft: async (versionId: number, duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateDuplicatePolicyDraft', 'versionId', versionId)
            // verify required parameter 'duplicatePolicyDraftCommand' is not null or undefined
            assertParamExists('updateDuplicatePolicyDraft', 'duplicatePolicyDraftCommand', duplicatePolicyDraftCommand)
            const localVarPath = `/api/v1/duplicate-policy/drafts/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicatePolicyDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DuplicatePolicyControllerApi - functional programming interface
 * @export
 */
export const DuplicatePolicyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DuplicatePolicyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDuplicatePolicyDraft(duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDuplicatePolicyDraft(duplicatePolicyDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicatePolicyControllerApi.createDuplicatePolicyDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDuplicatePolicy(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicatePolicyScreenView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDuplicatePolicy(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicatePolicyControllerApi.getDuplicatePolicy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDuplicateRecheck(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateRecheckView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDuplicateRecheck(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicatePolicyControllerApi.getDuplicateRecheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DuplicatePolicyPublicationCommand} duplicatePolicyPublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishDuplicatePolicyDraft(versionId: number, duplicatePolicyPublicationCommand: DuplicatePolicyPublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishDuplicatePolicyDraft(versionId, duplicatePolicyPublicationCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicatePolicyControllerApi.publishDuplicatePolicyDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runDuplicateRecheck(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateRecheckReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runDuplicateRecheck(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicatePolicyControllerApi.runDuplicateRecheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDuplicatePolicyDraft(versionId: number, duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicatePolicyVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDuplicatePolicyDraft(versionId, duplicatePolicyDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicatePolicyControllerApi.updateDuplicatePolicyDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DuplicatePolicyControllerApi - factory interface
 * @export
 */
export const DuplicatePolicyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DuplicatePolicyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDuplicatePolicyDraft(duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicatePolicyVersionView> {
            return localVarFp.createDuplicatePolicyDraft(duplicatePolicyDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuplicatePolicy(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicatePolicyScreenView> {
            return localVarFp.getDuplicatePolicy(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDuplicateRecheck(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateRecheckView> {
            return localVarFp.getDuplicateRecheck(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DuplicatePolicyPublicationCommand} duplicatePolicyPublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishDuplicatePolicyDraft(versionId: number, duplicatePolicyPublicationCommand: DuplicatePolicyPublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicatePolicyVersionView> {
            return localVarFp.publishDuplicatePolicyDraft(versionId, duplicatePolicyPublicationCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDuplicateRecheck(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateRecheckReport> {
            return localVarFp.runDuplicateRecheck(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDuplicatePolicyDraft(versionId: number, duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicatePolicyVersionView> {
            return localVarFp.updateDuplicatePolicyDraft(versionId, duplicatePolicyDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DuplicatePolicyControllerApi - object-oriented interface
 * @export
 * @class DuplicatePolicyControllerApi
 * @extends {BaseAPI}
 */
export class DuplicatePolicyControllerApi extends BaseAPI {
    /**
     * 
     * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicatePolicyControllerApi
     */
    public createDuplicatePolicyDraft(duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicatePolicyControllerApiFp(this.configuration).createDuplicatePolicyDraft(duplicatePolicyDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicatePolicyControllerApi
     */
    public getDuplicatePolicy(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicatePolicyControllerApiFp(this.configuration).getDuplicatePolicy(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicatePolicyControllerApi
     */
    public getDuplicateRecheck(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicatePolicyControllerApiFp(this.configuration).getDuplicateRecheck(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {DuplicatePolicyPublicationCommand} duplicatePolicyPublicationCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicatePolicyControllerApi
     */
    public publishDuplicatePolicyDraft(versionId: number, duplicatePolicyPublicationCommand: DuplicatePolicyPublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicatePolicyControllerApiFp(this.configuration).publishDuplicatePolicyDraft(versionId, duplicatePolicyPublicationCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicatePolicyControllerApi
     */
    public runDuplicateRecheck(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicatePolicyControllerApiFp(this.configuration).runDuplicateRecheck(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {DuplicatePolicyDraftCommand} duplicatePolicyDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicatePolicyControllerApi
     */
    public updateDuplicatePolicyDraft(versionId: number, duplicatePolicyDraftCommand: DuplicatePolicyDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicatePolicyControllerApiFp(this.configuration).updateDuplicatePolicyDraft(versionId, duplicatePolicyDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DuplicateReviewControllerApi - axios parameter creator
 * @export
 */
export const DuplicateReviewControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {AddParentByHandRequest} addParentByHandRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParentByHand: async (caseId: number, addParentByHandRequest: AddParentByHandRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('addParentByHand', 'caseId', caseId)
            // verify required parameter 'addParentByHandRequest' is not null or undefined
            assertParamExists('addParentByHand', 'addParentByHandRequest', addParentByHandRequest)
            const localVarPath = `/api/v1/cases/{caseId}/duplicates/manual`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addParentByHandRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CreateNewCaseRequest} createNewCaseRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewCase: async (caseId: number, createNewCaseRequest: CreateNewCaseRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('createNewCase', 'caseId', caseId)
            // verify required parameter 'createNewCaseRequest' is not null or undefined
            assertParamExists('createNewCase', 'createNewCaseRequest', createNewCaseRequest)
            const localVarPath = `/api/v1/cases/{caseId}/duplicate-analysis/new-case`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createNewCaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} candidateCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparison: async (caseId: number, candidateCaseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getComparison', 'caseId', caseId)
            // verify required parameter 'candidateCaseId' is not null or undefined
            assertParamExists('getComparison', 'candidateCaseId', candidateCaseId)
            const localVarPath = `/api/v1/cases/{caseId}/duplicates/{candidateCaseId}/comparison`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"candidateCaseId"}}`, encodeURIComponent(String(candidateCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseLinks: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listCaseLinks', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/links`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDuplicates: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listDuplicates', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/duplicates`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} parentCaseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFollowup: async (caseId: number, parentCaseId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('previewFollowup', 'caseId', caseId)
            // verify required parameter 'parentCaseId' is not null or undefined
            assertParamExists('previewFollowup', 'parentCaseId', parentCaseId)
            const localVarPath = `/api/v1/cases/{caseId}/followups/preview`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (parentCaseId !== undefined) {
                localVarQueryParameter['parent_case_id'] = parentCaseId;
            }


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {SendToIntakeTriageRequest} sendToIntakeTriageRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToIntakeTriage: async (caseId: number, sendToIntakeTriageRequest: SendToIntakeTriageRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('sendToIntakeTriage', 'caseId', caseId)
            // verify required parameter 'sendToIntakeTriageRequest' is not null or undefined
            assertParamExists('sendToIntakeTriage', 'sendToIntakeTriageRequest', sendToIntakeTriageRequest)
            const localVarPath = `/api/v1/cases/{caseId}/duplicate-analysis/intake-triage`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendToIntakeTriageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} candidateCaseId 
         * @param {DuplicateDecisionRequest} duplicateDecisionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDecision: async (caseId: number, candidateCaseId: number, duplicateDecisionRequest: DuplicateDecisionRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('submitDecision', 'caseId', caseId)
            // verify required parameter 'candidateCaseId' is not null or undefined
            assertParamExists('submitDecision', 'candidateCaseId', candidateCaseId)
            // verify required parameter 'duplicateDecisionRequest' is not null or undefined
            assertParamExists('submitDecision', 'duplicateDecisionRequest', duplicateDecisionRequest)
            const localVarPath = `/api/v1/cases/{caseId}/duplicates/{candidateCaseId}/decision`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"candidateCaseId"}}`, encodeURIComponent(String(candidateCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicateDecisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DuplicateReviewControllerApi - functional programming interface
 * @export
 */
export const DuplicateReviewControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DuplicateReviewControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {AddParentByHandRequest} addParentByHandRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addParentByHand(caseId: number, addParentByHandRequest: AddParentByHandRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateCandidateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addParentByHand(caseId, addParentByHandRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.addParentByHand']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CreateNewCaseRequest} createNewCaseRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewCase(caseId: number, createNewCaseRequest: CreateNewCaseRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCreateNewCaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewCase(caseId, createNewCaseRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.createNewCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} candidateCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComparison(caseId: number, candidateCaseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateComparisonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComparison(caseId, candidateCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.getComparison']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCaseLinks(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCaseLinks(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.listCaseLinks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDuplicates(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateCandidateListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDuplicates(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.listDuplicates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} parentCaseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewFollowup(caseId: number, parentCaseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFollowupPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewFollowup(caseId, parentCaseId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.previewFollowup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {SendToIntakeTriageRequest} sendToIntakeTriageRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendToIntakeTriage(caseId: number, sendToIntakeTriageRequest: SendToIntakeTriageRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseSendToIntakeTriageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendToIntakeTriage(caseId, sendToIntakeTriageRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.sendToIntakeTriage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} candidateCaseId 
         * @param {DuplicateDecisionRequest} duplicateDecisionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitDecision(caseId: number, candidateCaseId: number, duplicateDecisionRequest: DuplicateDecisionRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateDecisionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitDecision(caseId, candidateCaseId, duplicateDecisionRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DuplicateReviewControllerApi.submitDecision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DuplicateReviewControllerApi - factory interface
 * @export
 */
export const DuplicateReviewControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DuplicateReviewControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {AddParentByHandRequest} addParentByHandRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addParentByHand(caseId: number, addParentByHandRequest: AddParentByHandRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateCandidateListResponse> {
            return localVarFp.addParentByHand(caseId, addParentByHandRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CreateNewCaseRequest} createNewCaseRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewCase(caseId: number, createNewCaseRequest: CreateNewCaseRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCreateNewCaseResponse> {
            return localVarFp.createNewCase(caseId, createNewCaseRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} candidateCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComparison(caseId: number, candidateCaseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateComparisonResponse> {
            return localVarFp.getComparison(caseId, candidateCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseLinks(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseLinkResponse> {
            return localVarFp.listCaseLinks(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDuplicates(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateCandidateListResponse> {
            return localVarFp.listDuplicates(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} parentCaseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewFollowup(caseId: number, parentCaseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFollowupPreview> {
            return localVarFp.previewFollowup(caseId, parentCaseId, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {SendToIntakeTriageRequest} sendToIntakeTriageRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendToIntakeTriage(caseId: number, sendToIntakeTriageRequest: SendToIntakeTriageRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseSendToIntakeTriageResponse> {
            return localVarFp.sendToIntakeTriage(caseId, sendToIntakeTriageRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} candidateCaseId 
         * @param {DuplicateDecisionRequest} duplicateDecisionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitDecision(caseId: number, candidateCaseId: number, duplicateDecisionRequest: DuplicateDecisionRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateDecisionResponse> {
            return localVarFp.submitDecision(caseId, candidateCaseId, duplicateDecisionRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DuplicateReviewControllerApi - object-oriented interface
 * @export
 * @class DuplicateReviewControllerApi
 * @extends {BaseAPI}
 */
export class DuplicateReviewControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {AddParentByHandRequest} addParentByHandRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public addParentByHand(caseId: number, addParentByHandRequest: AddParentByHandRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).addParentByHand(caseId, addParentByHandRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {CreateNewCaseRequest} createNewCaseRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public createNewCase(caseId: number, createNewCaseRequest: CreateNewCaseRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).createNewCase(caseId, createNewCaseRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {number} candidateCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public getComparison(caseId: number, candidateCaseId: number, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).getComparison(caseId, candidateCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public listCaseLinks(caseId: number, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).listCaseLinks(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public listDuplicates(caseId: number, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).listDuplicates(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {number} parentCaseId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public previewFollowup(caseId: number, parentCaseId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).previewFollowup(caseId, parentCaseId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {SendToIntakeTriageRequest} sendToIntakeTriageRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public sendToIntakeTriage(caseId: number, sendToIntakeTriageRequest: SendToIntakeTriageRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).sendToIntakeTriage(caseId, sendToIntakeTriageRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {number} candidateCaseId 
     * @param {DuplicateDecisionRequest} duplicateDecisionRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DuplicateReviewControllerApi
     */
    public submitDecision(caseId: number, candidateCaseId: number, duplicateDecisionRequest: DuplicateDecisionRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return DuplicateReviewControllerApiFp(this.configuration).submitDecision(caseId, candidateCaseId, duplicateDecisionRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * E2bReportControllerApi - axios parameter creator
 * @export
 */
export const E2bReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [receiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf: async (id: number, receiver?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadPdf', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/e2b.pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (receiver !== undefined) {
                localVarQueryParameter['receiver'] = receiver;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [receiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadXml: async (id: number, receiver?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadXml', 'id', id)
            const localVarPath = `/api/v1/cases/{id}/e2b.xml`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (receiver !== undefined) {
                localVarQueryParameter['receiver'] = receiver;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getE2bProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/e2b/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * E2bReportControllerApi - functional programming interface
 * @export
 */
export const E2bReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = E2bReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [receiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadPdf(id: number, receiver?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadPdf(id, receiver, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['E2bReportControllerApi.downloadPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [receiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadXml(id: number, receiver?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadXml(id, receiver, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['E2bReportControllerApi.downloadXml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getE2bProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseE2bProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getE2bProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['E2bReportControllerApi.getE2bProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * E2bReportControllerApi - factory interface
 * @export
 */
export const E2bReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = E2bReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} [receiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadPdf(id: number, receiver?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadPdf(id, receiver, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [receiver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadXml(id: number, receiver?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadXml(id, receiver, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getE2bProfile(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseE2bProfileResponse> {
            return localVarFp.getE2bProfile(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * E2bReportControllerApi - object-oriented interface
 * @export
 * @class E2bReportControllerApi
 * @extends {BaseAPI}
 */
export class E2bReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} [receiver] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof E2bReportControllerApi
     */
    public downloadPdf(id: number, receiver?: string, options?: RawAxiosRequestConfig) {
        return E2bReportControllerApiFp(this.configuration).downloadPdf(id, receiver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [receiver] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof E2bReportControllerApi
     */
    public downloadXml(id: number, receiver?: string, options?: RawAxiosRequestConfig) {
        return E2bReportControllerApiFp(this.configuration).downloadXml(id, receiver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof E2bReportControllerApi
     */
    public getE2bProfile(options?: RawAxiosRequestConfig) {
        return E2bReportControllerApiFp(this.configuration).getE2bProfile(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsControllerApi - axios parameter creator
 * @export
 */
export const EventsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvent', 'id', id)
            const localVarPath = `/api/v1/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listEvents', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/events`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsControllerApi - functional programming interface
 * @export
 */
export const EventsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvent(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseEventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsControllerApi.getEvent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEvents(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseEventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEvents(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EventsControllerApi.listEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EventsControllerApi - factory interface
 * @export
 */
export const EventsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseEventDetails> {
            return localVarFp.getEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEvents(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseEventDetails> {
            return localVarFp.listEvents(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsControllerApi - object-oriented interface
 * @export
 * @class EventsControllerApi
 * @extends {BaseAPI}
 */
export class EventsControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsControllerApi
     */
    public getEvent(id: number, options?: RawAxiosRequestConfig) {
        return EventsControllerApiFp(this.configuration).getEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsControllerApi
     */
    public listEvents(caseId: number, options?: RawAxiosRequestConfig) {
        return EventsControllerApiFp(this.configuration).listEvents(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExtractionReportControllerApi - axios parameter creator
 * @export
 */
export const ExtractionReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} bookingId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtractionReportHtml: async (bookingId: number, attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('getExtractionReportHtml', 'bookingId', bookingId)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getExtractionReportHtml', 'attachmentId', attachmentId)
            const localVarPath = `/bookings/{bookingId}/attachments/{attachmentId}/html`
                .replace(`{${"bookingId"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExtractionReportControllerApi - functional programming interface
 * @export
 */
export const ExtractionReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExtractionReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} bookingId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExtractionReportHtml(bookingId: number, attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExtractionReportHtml(bookingId, attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtractionReportControllerApi.getExtractionReportHtml']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExtractionReportControllerApi - factory interface
 * @export
 */
export const ExtractionReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExtractionReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} bookingId 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExtractionReportHtml(bookingId: number, attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getExtractionReportHtml(bookingId, attachmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExtractionReportControllerApi - object-oriented interface
 * @export
 * @class ExtractionReportControllerApi
 * @extends {BaseAPI}
 */
export class ExtractionReportControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} bookingId 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtractionReportControllerApi
     */
    public getExtractionReportHtml(bookingId: number, attachmentId: number, options?: RawAxiosRequestConfig) {
        return ExtractionReportControllerApiFp(this.configuration).getExtractionReportHtml(bookingId, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExtractionSchemaControllerApi - axios parameter creator
 * @export
 */
export const ExtractionSchemaControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractionSchema: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/field-catalog/extraction-schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExtractionSchemaControllerApi - functional programming interface
 * @export
 */
export const ExtractionSchemaControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExtractionSchemaControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async extractionSchema(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseObjectNode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.extractionSchema(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExtractionSchemaControllerApi.extractionSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExtractionSchemaControllerApi - factory interface
 * @export
 */
export const ExtractionSchemaControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExtractionSchemaControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        extractionSchema(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseObjectNode> {
            return localVarFp.extractionSchema(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExtractionSchemaControllerApi - object-oriented interface
 * @export
 * @class ExtractionSchemaControllerApi
 * @extends {BaseAPI}
 */
export class ExtractionSchemaControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExtractionSchemaControllerApi
     */
    public extractionSchema(options?: RawAxiosRequestConfig) {
        return ExtractionSchemaControllerApiFp(this.configuration).extractionSchema(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FollowupDocumentControllerApi - axios parameter creator
 * @export
 */
export const FollowupDocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} targetCaseId 
         * @param {number} followupId 
         * @param {number} sourceCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        read: async (targetCaseId: number, followupId: number, sourceCaseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetCaseId' is not null or undefined
            assertParamExists('read', 'targetCaseId', targetCaseId)
            // verify required parameter 'followupId' is not null or undefined
            assertParamExists('read', 'followupId', followupId)
            // verify required parameter 'sourceCaseId' is not null or undefined
            assertParamExists('read', 'sourceCaseId', sourceCaseId)
            const localVarPath = `/api/v2/cases/{targetCaseId}/followups/{followupId}/documents/{sourceCaseId}`
                .replace(`{${"targetCaseId"}}`, encodeURIComponent(String(targetCaseId)))
                .replace(`{${"followupId"}}`, encodeURIComponent(String(followupId)))
                .replace(`{${"sourceCaseId"}}`, encodeURIComponent(String(sourceCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowupDocumentControllerApi - functional programming interface
 * @export
 */
export const FollowupDocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FollowupDocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} targetCaseId 
         * @param {number} followupId 
         * @param {number} sourceCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async read(targetCaseId: number, followupId: number, sourceCaseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.read(targetCaseId, followupId, sourceCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FollowupDocumentControllerApi.read']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FollowupDocumentControllerApi - factory interface
 * @export
 */
export const FollowupDocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FollowupDocumentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} targetCaseId 
         * @param {number} followupId 
         * @param {number} sourceCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        read(targetCaseId: number, followupId: number, sourceCaseId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.read(targetCaseId, followupId, sourceCaseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FollowupDocumentControllerApi - object-oriented interface
 * @export
 * @class FollowupDocumentControllerApi
 * @extends {BaseAPI}
 */
export class FollowupDocumentControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} targetCaseId 
     * @param {number} followupId 
     * @param {number} sourceCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowupDocumentControllerApi
     */
    public read(targetCaseId: number, followupId: number, sourceCaseId: number, options?: RawAxiosRequestConfig) {
        return FollowupDocumentControllerApiFp(this.configuration).read(targetCaseId, followupId, sourceCaseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FollowupReceiptDateControllerApi - axios parameter creator
 * @export
 */
export const FollowupReceiptDateControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} arrivalId 
         * @param {FollowupReceiptDateCorrection} followupReceiptDateCorrection 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correctReceiptDate: async (caseId: number, arrivalId: number, followupReceiptDateCorrection: FollowupReceiptDateCorrection, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('correctReceiptDate', 'caseId', caseId)
            // verify required parameter 'arrivalId' is not null or undefined
            assertParamExists('correctReceiptDate', 'arrivalId', arrivalId)
            // verify required parameter 'followupReceiptDateCorrection' is not null or undefined
            assertParamExists('correctReceiptDate', 'followupReceiptDateCorrection', followupReceiptDateCorrection)
            const localVarPath = `/api/v1/cases/{caseId}/followups/{arrivalId}/receipt-date`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"arrivalId"}}`, encodeURIComponent(String(arrivalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(followupReceiptDateCorrection, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowupReceiptDateControllerApi - functional programming interface
 * @export
 */
export const FollowupReceiptDateControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FollowupReceiptDateControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} arrivalId 
         * @param {FollowupReceiptDateCorrection} followupReceiptDateCorrection 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async correctReceiptDate(caseId: number, arrivalId: number, followupReceiptDateCorrection: FollowupReceiptDateCorrection, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFollowupReceiptDateCorrected>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.correctReceiptDate(caseId, arrivalId, followupReceiptDateCorrection, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FollowupReceiptDateControllerApi.correctReceiptDate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FollowupReceiptDateControllerApi - factory interface
 * @export
 */
export const FollowupReceiptDateControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FollowupReceiptDateControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} arrivalId 
         * @param {FollowupReceiptDateCorrection} followupReceiptDateCorrection 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correctReceiptDate(caseId: number, arrivalId: number, followupReceiptDateCorrection: FollowupReceiptDateCorrection, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFollowupReceiptDateCorrected> {
            return localVarFp.correctReceiptDate(caseId, arrivalId, followupReceiptDateCorrection, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FollowupReceiptDateControllerApi - object-oriented interface
 * @export
 * @class FollowupReceiptDateControllerApi
 * @extends {BaseAPI}
 */
export class FollowupReceiptDateControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {number} arrivalId 
     * @param {FollowupReceiptDateCorrection} followupReceiptDateCorrection 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowupReceiptDateControllerApi
     */
    public correctReceiptDate(caseId: number, arrivalId: number, followupReceiptDateCorrection: FollowupReceiptDateCorrection, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return FollowupReceiptDateControllerApiFp(this.configuration).correctReceiptDate(caseId, arrivalId, followupReceiptDateCorrection, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FollowupTakeInControllerApi - axios parameter creator
 * @export
 */
export const FollowupTakeInControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFollowupTakeIn: async (caseId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('readFollowupTakeIn', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/followup-take-in`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {FollowupTakeInCommand} followupTakeInCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeInFollowup: async (caseId: number, followupTakeInCommand: FollowupTakeInCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('takeInFollowup', 'caseId', caseId)
            // verify required parameter 'followupTakeInCommand' is not null or undefined
            assertParamExists('takeInFollowup', 'followupTakeInCommand', followupTakeInCommand)
            const localVarPath = `/api/v1/cases/{caseId}/followup-take-in`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(followupTakeInCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FollowupTakeInControllerApi - functional programming interface
 * @export
 */
export const FollowupTakeInControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FollowupTakeInControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readFollowupTakeIn(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFollowupTakeInView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readFollowupTakeIn(caseId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FollowupTakeInControllerApi.readFollowupTakeIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {FollowupTakeInCommand} followupTakeInCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async takeInFollowup(caseId: number, followupTakeInCommand: FollowupTakeInCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseFollowupTakenIn>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.takeInFollowup(caseId, followupTakeInCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FollowupTakeInControllerApi.takeInFollowup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FollowupTakeInControllerApi - factory interface
 * @export
 */
export const FollowupTakeInControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FollowupTakeInControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readFollowupTakeIn(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFollowupTakeInView> {
            return localVarFp.readFollowupTakeIn(caseId, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {FollowupTakeInCommand} followupTakeInCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeInFollowup(caseId: number, followupTakeInCommand: FollowupTakeInCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseFollowupTakenIn> {
            return localVarFp.takeInFollowup(caseId, followupTakeInCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FollowupTakeInControllerApi - object-oriented interface
 * @export
 * @class FollowupTakeInControllerApi
 * @extends {BaseAPI}
 */
export class FollowupTakeInControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowupTakeInControllerApi
     */
    public readFollowupTakeIn(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return FollowupTakeInControllerApiFp(this.configuration).readFollowupTakeIn(caseId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {FollowupTakeInCommand} followupTakeInCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FollowupTakeInControllerApi
     */
    public takeInFollowup(caseId: number, followupTakeInCommand: FollowupTakeInCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return FollowupTakeInControllerApiFp(this.configuration).takeInFollowup(caseId, followupTakeInCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GlobalSearchControllerApi - axios parameter creator
 * @export
 */
export const GlobalSearchControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (q: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('search', 'q', q)
            const localVarPath = `/api/v1/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GlobalSearchControllerApi - functional programming interface
 * @export
 */
export const GlobalSearchControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GlobalSearchControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(q: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseMapStringListObject>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GlobalSearchControllerApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GlobalSearchControllerApi - factory interface
 * @export
 */
export const GlobalSearchControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GlobalSearchControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} q 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(q: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseMapStringListObject> {
            return localVarFp.search(q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GlobalSearchControllerApi - object-oriented interface
 * @export
 * @class GlobalSearchControllerApi
 * @extends {BaseAPI}
 */
export class GlobalSearchControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} q 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GlobalSearchControllerApi
     */
    public search(q: string, options?: RawAxiosRequestConfig) {
        return GlobalSearchControllerApiFp(this.configuration).search(q, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HospitalizationControllerApi - axios parameter creator
 * @export
 */
export const HospitalizationControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseHospitalizations: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listCaseHospitalizations', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/hospitalizations`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HospitalizationControllerApi - functional programming interface
 * @export
 */
export const HospitalizationControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HospitalizationControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCaseHospitalizations(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListHospitalization>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCaseHospitalizations(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HospitalizationControllerApi.listCaseHospitalizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HospitalizationControllerApi - factory interface
 * @export
 */
export const HospitalizationControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HospitalizationControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCaseHospitalizations(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListHospitalization> {
            return localVarFp.listCaseHospitalizations(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HospitalizationControllerApi - object-oriented interface
 * @export
 * @class HospitalizationControllerApi
 * @extends {BaseAPI}
 */
export class HospitalizationControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HospitalizationControllerApi
     */
    public listCaseHospitalizations(caseId: number, options?: RawAxiosRequestConfig) {
        return HospitalizationControllerApiFp(this.configuration).listCaseHospitalizations(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImeSeriousnessControllerApi - axios parameter creator
 * @export
 */
export const ImeSeriousnessControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [preferredTerm] 
         * @param {string} [lltCode] 
         * @param {string} [meddraVersion] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriousness: async (preferredTerm?: string, lltCode?: string, meddraVersion?: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/ema-ime/seriousness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (preferredTerm !== undefined) {
                localVarQueryParameter['preferred_term'] = preferredTerm;
            }

            if (lltCode !== undefined) {
                localVarQueryParameter['llt_code'] = lltCode;
            }

            if (meddraVersion !== undefined) {
                localVarQueryParameter['meddra_version'] = meddraVersion;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImeSeriousnessControllerApi - functional programming interface
 * @export
 */
export const ImeSeriousnessControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImeSeriousnessControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [preferredTerm] 
         * @param {string} [lltCode] 
         * @param {string} [meddraVersion] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async seriousness(preferredTerm?: string, lltCode?: string, meddraVersion?: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImeSeriousnessPreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.seriousness(preferredTerm, lltCode, meddraVersion, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImeSeriousnessControllerApi.seriousness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImeSeriousnessControllerApi - factory interface
 * @export
 */
export const ImeSeriousnessControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImeSeriousnessControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [preferredTerm] 
         * @param {string} [lltCode] 
         * @param {string} [meddraVersion] 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        seriousness(preferredTerm?: string, lltCode?: string, meddraVersion?: string, language?: string, options?: RawAxiosRequestConfig): AxiosPromise<ImeSeriousnessPreview> {
            return localVarFp.seriousness(preferredTerm, lltCode, meddraVersion, language, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImeSeriousnessControllerApi - object-oriented interface
 * @export
 * @class ImeSeriousnessControllerApi
 * @extends {BaseAPI}
 */
export class ImeSeriousnessControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} [preferredTerm] 
     * @param {string} [lltCode] 
     * @param {string} [meddraVersion] 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImeSeriousnessControllerApi
     */
    public seriousness(preferredTerm?: string, lltCode?: string, meddraVersion?: string, language?: string, options?: RawAxiosRequestConfig) {
        return ImeSeriousnessControllerApiFp(this.configuration).seriousness(preferredTerm, lltCode, meddraVersion, language, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IntakeTriageQueueControllerApi - axios parameter creator
 * @export
 */
export const IntakeTriageQueueControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidateByCaseNumber: async (id: number, caseNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('candidateByCaseNumber', 'id', id)
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('candidateByCaseNumber', 'caseNumber', caseNumber)
            const localVarPath = `/api/v1/intake-triage/{id}/candidates/by-case-number`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseNumber !== undefined) {
                localVarQueryParameter['case_number'] = caseNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidates: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('candidates', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/candidates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('claim', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/claim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {IntakeTriageDecisionRequest} intakeTriageDecisionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decide: async (id: number, intakeTriageDecisionRequest: IntakeTriageDecisionRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('decide', 'id', id)
            // verify required parameter 'intakeTriageDecisionRequest' is not null or undefined
            assertParamExists('decide', 'intakeTriageDecisionRequest', intakeTriageDecisionRequest)
            const localVarPath = `/api/v1/intake-triage/{id}/decision`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intakeTriageDecisionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        document: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('document', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/document`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentKind: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('documentKind', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/document/kind`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get1', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {List1StatusEnum} [status] 
         * @param {List1ReasonCodeEnum} [reasonCode] 
         * @param {List1SourceEnum} [source] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list1: async (status?: List1StatusEnum, reasonCode?: List1ReasonCodeEnum, source?: List1SourceEnum, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/intake-triage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (reasonCode !== undefined) {
                localVarQueryParameter['reason_code'] = reasonCode;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        release: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('release', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/release`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopen: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reopen', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/reopen`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {IntakeTriageSliceDto} intakeTriageSliceDto 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSlice: async (id: number, intakeTriageSliceDto: IntakeTriageSliceDto, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('saveSlice', 'id', id)
            // verify required parameter 'intakeTriageSliceDto' is not null or undefined
            assertParamExists('saveSlice', 'intakeTriageSliceDto', intakeTriageSliceDto)
            const localVarPath = `/api/v1/intake-triage/{id}/slice`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(intakeTriageSliceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spreadsheet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('spreadsheet', 'id', id)
            const localVarPath = `/api/v1/intake-triage/{id}/spreadsheet`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntakeTriageQueueControllerApi - functional programming interface
 * @export
 */
export const IntakeTriageQueueControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntakeTriageQueueControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async candidateByCaseNumber(id: number, caseNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseDuplicateCandidateSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.candidateByCaseNumber(id, caseNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.candidateByCaseNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async candidates(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListDuplicateCandidateSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.candidates(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.candidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claim(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claim(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.claim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {IntakeTriageDecisionRequest} intakeTriageDecisionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async decide(id: number, intakeTriageDecisionRequest: IntakeTriageDecisionRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.decide(id, intakeTriageDecisionRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.decide']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async document(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.document(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.document']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async documentKind(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseSourceDocumentInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.documentKind(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.documentKind']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get1(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get1(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.get1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {List1StatusEnum} [status] 
         * @param {List1ReasonCodeEnum} [reasonCode] 
         * @param {List1SourceEnum} [source] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list1(status?: List1StatusEnum, reasonCode?: List1ReasonCodeEnum, source?: List1SourceEnum, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list1(status, reasonCode, source, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.list1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async release(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.release(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.release']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopen(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopen(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.reopen']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {IntakeTriageSliceDto} intakeTriageSliceDto 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveSlice(id: number, intakeTriageSliceDto: IntakeTriageSliceDto, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseIntakeTriageItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveSlice(id, intakeTriageSliceDto, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.saveSlice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async spreadsheet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseSpreadsheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.spreadsheet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IntakeTriageQueueControllerApi.spreadsheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IntakeTriageQueueControllerApi - factory interface
 * @export
 */
export const IntakeTriageQueueControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntakeTriageQueueControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {string} caseNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidateByCaseNumber(id: number, caseNumber: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseDuplicateCandidateSummary> {
            return localVarFp.candidateByCaseNumber(id, caseNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        candidates(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListDuplicateCandidateSummary> {
            return localVarFp.candidates(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageItemResponse> {
            return localVarFp.claim(id, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {IntakeTriageDecisionRequest} intakeTriageDecisionRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        decide(id: number, intakeTriageDecisionRequest: IntakeTriageDecisionRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageItemResponse> {
            return localVarFp.decide(id, intakeTriageDecisionRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        document(id: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.document(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentKind(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseSourceDocumentInfo> {
            return localVarFp.documentKind(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get1(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageItemResponse> {
            return localVarFp.get1(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {List1StatusEnum} [status] 
         * @param {List1ReasonCodeEnum} [reasonCode] 
         * @param {List1SourceEnum} [source] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list1(status?: List1StatusEnum, reasonCode?: List1ReasonCodeEnum, source?: List1SourceEnum, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageListResponse> {
            return localVarFp.list1(status, reasonCode, source, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        release(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageItemResponse> {
            return localVarFp.release(id, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopen(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageItemResponse> {
            return localVarFp.reopen(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {IntakeTriageSliceDto} intakeTriageSliceDto 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveSlice(id: number, intakeTriageSliceDto: IntakeTriageSliceDto, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseIntakeTriageItemResponse> {
            return localVarFp.saveSlice(id, intakeTriageSliceDto, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        spreadsheet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseSpreadsheetView> {
            return localVarFp.spreadsheet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntakeTriageQueueControllerApi - object-oriented interface
 * @export
 * @class IntakeTriageQueueControllerApi
 * @extends {BaseAPI}
 */
export class IntakeTriageQueueControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {string} caseNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public candidateByCaseNumber(id: number, caseNumber: string, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).candidateByCaseNumber(id, caseNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public candidates(id: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).candidates(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public claim(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).claim(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {IntakeTriageDecisionRequest} intakeTriageDecisionRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public decide(id: number, intakeTriageDecisionRequest: IntakeTriageDecisionRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).decide(id, intakeTriageDecisionRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public document(id: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).document(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public documentKind(id: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).documentKind(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public get1(id: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).get1(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {List1StatusEnum} [status] 
     * @param {List1ReasonCodeEnum} [reasonCode] 
     * @param {List1SourceEnum} [source] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public list1(status?: List1StatusEnum, reasonCode?: List1ReasonCodeEnum, source?: List1SourceEnum, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).list1(status, reasonCode, source, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public release(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).release(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public reopen(id: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).reopen(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {IntakeTriageSliceDto} intakeTriageSliceDto 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public saveSlice(id: number, intakeTriageSliceDto: IntakeTriageSliceDto, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).saveSlice(id, intakeTriageSliceDto, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntakeTriageQueueControllerApi
     */
    public spreadsheet(id: number, options?: RawAxiosRequestConfig) {
        return IntakeTriageQueueControllerApiFp(this.configuration).spreadsheet(id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const List1StatusEnum = {
    Active: 'ACTIVE',
    Open: 'OPEN',
    InReview: 'IN_REVIEW',
    Closed: 'CLOSED'
} as const;
export type List1StatusEnum = typeof List1StatusEnum[keyof typeof List1StatusEnum];
/**
 * @export
 */
export const List1ReasonCodeEnum = {
    ExtractionFailed: 'EXTRACTION_FAILED',
    CaseNotStored: 'CASE_NOT_STORED',
    ClassificationFailed: 'CLASSIFICATION_FAILED',
    ServiceUnavailable: 'SERVICE_UNAVAILABLE',
    PifuProcessingPending: 'PIFU_PROCESSING_PENDING',
    UnsupportedReport: 'UNSUPPORTED_REPORT',
    UnsupportedDocument: 'UNSUPPORTED_DOCUMENT',
    NoCaseFound: 'NO_CASE_FOUND',
    CaseScopeUnresolved: 'CASE_SCOPE_UNRESOLVED',
    SubmitFailed: 'SUBMIT_FAILED',
    TimedOut: 'TIMED_OUT',
    DuplicateAnalysisUndecided: 'DUPLICATE_ANALYSIS_UNDECIDED',
    DeadlineRisk: 'DEADLINE_RISK',
    ConflictingIdentifiers: 'CONFLICTING_IDENTIFIERS',
    QuotedIdentifierNotFound: 'QUOTED_IDENTIFIER_NOT_FOUND',
    FourPillarsMissing: 'FOUR_PILLARS_MISSING',
    NoAdverseEvent: 'NO_ADVERSE_EVENT',
    StudySubjectUpdated: 'STUDY_SUBJECT_UPDATED',
    StudyListingNotRead: 'STUDY_LISTING_NOT_READ',
    StudyListingRowsFailed: 'STUDY_LISTING_ROWS_FAILED',
    Unknown: 'UNKNOWN'
} as const;
export type List1ReasonCodeEnum = typeof List1ReasonCodeEnum[keyof typeof List1ReasonCodeEnum];
/**
 * @export
 */
export const List1SourceEnum = {
    Attachment: 'ATTACHMENT',
    Case: 'CASE'
} as const;
export type List1SourceEnum = typeof List1SourceEnum[keyof typeof List1SourceEnum];


/**
 * MeddraControllerApi - axios parameter creator
 * @export
 */
export const MeddraControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {string} version 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meddraTerm: async (code: string, version: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('meddraTerm', 'code', code)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('meddraTerm', 'version', version)
            const localVarPath = `/api/v1/meddra/terms/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releases: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/meddra/releases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} query 
         * @param {string} version 
         * @param {string} [language] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMeddra: async (query: string, version: string, language?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchMeddra', 'query', query)
            // verify required parameter 'version' is not null or undefined
            assertParamExists('searchMeddra', 'version', version)
            const localVarPath = `/api/v1/meddra/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MeddraControllerApi - functional programming interface
 * @export
 */
export const MeddraControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MeddraControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} code 
         * @param {string} version 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async meddraTerm(code: string, version: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeddraTerm>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.meddraTerm(code, version, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeddraControllerApi.meddraTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releases(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MeddraRelease>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releases(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeddraControllerApi.releases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} query 
         * @param {string} version 
         * @param {string} [language] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchMeddra(query: string, version: string, language?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeddraSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchMeddra(query, version, language, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MeddraControllerApi.searchMeddra']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MeddraControllerApi - factory interface
 * @export
 */
export const MeddraControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MeddraControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} code 
         * @param {string} version 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meddraTerm(code: string, version: string, language?: string, options?: RawAxiosRequestConfig): AxiosPromise<MeddraTerm> {
            return localVarFp.meddraTerm(code, version, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releases(options?: RawAxiosRequestConfig): AxiosPromise<Array<MeddraRelease>> {
            return localVarFp.releases(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} query 
         * @param {string} version 
         * @param {string} [language] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMeddra(query: string, version: string, language?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<MeddraSearchResponse> {
            return localVarFp.searchMeddra(query, version, language, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MeddraControllerApi - object-oriented interface
 * @export
 * @class MeddraControllerApi
 * @extends {BaseAPI}
 */
export class MeddraControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} code 
     * @param {string} version 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeddraControllerApi
     */
    public meddraTerm(code: string, version: string, language?: string, options?: RawAxiosRequestConfig) {
        return MeddraControllerApiFp(this.configuration).meddraTerm(code, version, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeddraControllerApi
     */
    public releases(options?: RawAxiosRequestConfig) {
        return MeddraControllerApiFp(this.configuration).releases(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} query 
     * @param {string} version 
     * @param {string} [language] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MeddraControllerApi
     */
    public searchMeddra(query: string, version: string, language?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return MeddraControllerApiFp(this.configuration).searchMeddra(query, version, language, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryLetterControllerApi - axios parameter creator
 * @export
 */
export const QueryLetterControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQueryReminder: async (id: number, attemptNumber: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadQueryReminder', 'id', id)
            // verify required parameter 'attemptNumber' is not null or undefined
            assertParamExists('downloadQueryReminder', 'attemptNumber', attemptNumber)
            // verify required parameter 'queryLetterRequest' is not null or undefined
            assertParamExists('downloadQueryReminder', 'queryLetterRequest', queryLetterRequest)
            const localVarPath = `/api/v1/activities/{id}/attempts/{attemptNumber}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attemptNumber"}}`, encodeURIComponent(String(attemptNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryLetterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQueryAttempts: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('listQueryAttempts', 'id', id)
            const localVarPath = `/api/v1/activities/{id}/attempts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {QueryLetterPreviewRequest} queryLetterPreviewRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewNewQueryLetter: async (caseId: number, queryLetterPreviewRequest: QueryLetterPreviewRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('previewNewQueryLetter', 'caseId', caseId)
            // verify required parameter 'queryLetterPreviewRequest' is not null or undefined
            assertParamExists('previewNewQueryLetter', 'queryLetterPreviewRequest', queryLetterPreviewRequest)
            const localVarPath = `/api/v1/cases/{caseId}/activities/queries/letter-preview`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryLetterPreviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewQueryLetter: async (id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('previewQueryLetter', 'id', id)
            // verify required parameter 'queryLetterRequest' is not null or undefined
            assertParamExists('previewQueryLetter', 'queryLetterRequest', queryLetterRequest)
            const localVarPath = `/api/v1/activities/{id}/letter-preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryLetterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryLetterRecipients: async (id: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('queryLetterRecipients', 'id', id)
            const localVarPath = `/api/v1/activities/{id}/recipients`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryRecipients: async (caseId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('queryRecipients', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/activities/queries/recipients`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readQueryLetter: async (id: number, attemptNumber: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('readQueryLetter', 'id', id)
            // verify required parameter 'attemptNumber' is not null or undefined
            assertParamExists('readQueryLetter', 'attemptNumber', attemptNumber)
            const localVarPath = `/api/v1/activities/{id}/attempts/{attemptNumber}/letter`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attemptNumber"}}`, encodeURIComponent(String(attemptNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFirstQueryLetter: async (id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendFirstQueryLetter', 'id', id)
            // verify required parameter 'queryLetterRequest' is not null or undefined
            assertParamExists('sendFirstQueryLetter', 'queryLetterRequest', queryLetterRequest)
            const localVarPath = `/api/v1/activities/{id}/attempts/first`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryLetterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipQueryReminder: async (id: number, attemptNumber: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skipQueryReminder', 'id', id)
            // verify required parameter 'attemptNumber' is not null or undefined
            assertParamExists('skipQueryReminder', 'attemptNumber', attemptNumber)
            const localVarPath = `/api/v1/activities/{id}/attempts/{attemptNumber}/skip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attemptNumber"}}`, encodeURIComponent(String(attemptNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryLetterControllerApi - functional programming interface
 * @export
 */
export const QueryLetterControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryLetterControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadQueryReminder(id: number, attemptNumber: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryAttemptView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadQueryReminder(id, attemptNumber, queryLetterRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.downloadQueryReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQueryAttempts(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListQueryAttemptView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQueryAttempts(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.listQueryAttempts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {QueryLetterPreviewRequest} queryLetterPreviewRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewNewQueryLetter(caseId: number, queryLetterPreviewRequest: QueryLetterPreviewRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewNewQueryLetter(caseId, queryLetterPreviewRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.previewNewQueryLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewQueryLetter(id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewQueryLetter(id, queryLetterRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.previewQueryLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryLetterRecipients(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListQueryRecipientView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryLetterRecipients(id, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.queryLetterRecipients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryRecipients(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListQueryRecipientView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryRecipients(caseId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.queryRecipients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readQueryLetter(id: number, attemptNumber: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readQueryLetter(id, attemptNumber, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.readQueryLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendFirstQueryLetter(id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryAttemptView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendFirstQueryLetter(id, queryLetterRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.sendFirstQueryLetter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipQueryReminder(id: number, attemptNumber: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryAttemptView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipQueryReminder(id, attemptNumber, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryLetterControllerApi.skipQueryReminder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QueryLetterControllerApi - factory interface
 * @export
 */
export const QueryLetterControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryLetterControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadQueryReminder(id: number, attemptNumber: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryAttemptView> {
            return localVarFp.downloadQueryReminder(id, attemptNumber, queryLetterRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQueryAttempts(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListQueryAttemptView> {
            return localVarFp.listQueryAttempts(id, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {QueryLetterPreviewRequest} queryLetterPreviewRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewNewQueryLetter(caseId: number, queryLetterPreviewRequest: QueryLetterPreviewRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.previewNewQueryLetter(caseId, queryLetterPreviewRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewQueryLetter(id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.previewQueryLetter(id, queryLetterRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryLetterRecipients(id: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListQueryRecipientView> {
            return localVarFp.queryLetterRecipients(id, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryRecipients(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListQueryRecipientView> {
            return localVarFp.queryRecipients(caseId, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readQueryLetter(id: number, attemptNumber: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.readQueryLetter(id, attemptNumber, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {QueryLetterRequest} queryLetterRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendFirstQueryLetter(id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryAttemptView> {
            return localVarFp.sendFirstQueryLetter(id, queryLetterRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} attemptNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipQueryReminder(id: number, attemptNumber: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryAttemptView> {
            return localVarFp.skipQueryReminder(id, attemptNumber, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryLetterControllerApi - object-oriented interface
 * @export
 * @class QueryLetterControllerApi
 * @extends {BaseAPI}
 */
export class QueryLetterControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {number} attemptNumber 
     * @param {QueryLetterRequest} queryLetterRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public downloadQueryReminder(id: number, attemptNumber: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).downloadQueryReminder(id, attemptNumber, queryLetterRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public listQueryAttempts(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).listQueryAttempts(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {QueryLetterPreviewRequest} queryLetterPreviewRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public previewNewQueryLetter(caseId: number, queryLetterPreviewRequest: QueryLetterPreviewRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).previewNewQueryLetter(caseId, queryLetterPreviewRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {QueryLetterRequest} queryLetterRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public previewQueryLetter(id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).previewQueryLetter(id, queryLetterRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public queryLetterRecipients(id: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).queryLetterRecipients(id, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public queryRecipients(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).queryRecipients(caseId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} attemptNumber 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public readQueryLetter(id: number, attemptNumber: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).readQueryLetter(id, attemptNumber, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {QueryLetterRequest} queryLetterRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public sendFirstQueryLetter(id: number, queryLetterRequest: QueryLetterRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).sendFirstQueryLetter(id, queryLetterRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} attemptNumber 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryLetterControllerApi
     */
    public skipQueryReminder(id: number, attemptNumber: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryLetterControllerApiFp(this.configuration).skipQueryReminder(id, attemptNumber, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryManagerControllerApi - axios parameter creator
 * @export
 */
export const QueryManagerControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ListQueryQueueStatusEnum} [status] 
         * @param {number} [assignedTo] 
         * @param {number} [attemptNumber] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {boolean} [reminderReady] 
         * @param {boolean} [autoClosed] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQueryQueue: async (status?: ListQueryQueueStatusEnum, assignedTo?: number, attemptNumber?: number, dueDateFrom?: string, dueDateTo?: string, reminderReady?: boolean, autoClosed?: boolean, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (assignedTo !== undefined) {
                localVarQueryParameter['assigned_to'] = assignedTo;
            }

            if (attemptNumber !== undefined) {
                localVarQueryParameter['attempt_number'] = attemptNumber;
            }

            if (dueDateFrom !== undefined) {
                localVarQueryParameter['due_date_from'] = (dueDateFrom as any instanceof Date) ?
                    (dueDateFrom as any).toISOString().substring(0,10) :
                    dueDateFrom;
            }

            if (dueDateTo !== undefined) {
                localVarQueryParameter['due_date_to'] = (dueDateTo as any instanceof Date) ?
                    (dueDateTo as any).toISOString().substring(0,10) :
                    dueDateTo;
            }

            if (reminderReady !== undefined) {
                localVarQueryParameter['reminder_ready'] = reminderReady;
            }

            if (autoClosed !== undefined) {
                localVarQueryParameter['auto_closed'] = autoClosed;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryManagerSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/activities/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryManagerControllerApi - functional programming interface
 * @export
 */
export const QueryManagerControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryManagerControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {ListQueryQueueStatusEnum} [status] 
         * @param {number} [assignedTo] 
         * @param {number} [attemptNumber] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {boolean} [reminderReady] 
         * @param {boolean} [autoClosed] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQueryQueue(status?: ListQueryQueueStatusEnum, assignedTo?: number, attemptNumber?: number, dueDateFrom?: string, dueDateTo?: string, reminderReady?: boolean, autoClosed?: boolean, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListQueryQueueItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQueryQueue(status, assignedTo, attemptNumber, dueDateFrom, dueDateTo, reminderReady, autoClosed, offset, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryManagerControllerApi.listQueryQueue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryManagerSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryManagerSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryManagerSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryManagerControllerApi.queryManagerSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QueryManagerControllerApi - factory interface
 * @export
 */
export const QueryManagerControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryManagerControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ListQueryQueueStatusEnum} [status] 
         * @param {number} [assignedTo] 
         * @param {number} [attemptNumber] 
         * @param {string} [dueDateFrom] 
         * @param {string} [dueDateTo] 
         * @param {boolean} [reminderReady] 
         * @param {boolean} [autoClosed] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQueryQueue(status?: ListQueryQueueStatusEnum, assignedTo?: number, attemptNumber?: number, dueDateFrom?: string, dueDateTo?: string, reminderReady?: boolean, autoClosed?: boolean, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListQueryQueueItem> {
            return localVarFp.listQueryQueue(status, assignedTo, attemptNumber, dueDateFrom, dueDateTo, reminderReady, autoClosed, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryManagerSummary(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryManagerSummary> {
            return localVarFp.queryManagerSummary(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryManagerControllerApi - object-oriented interface
 * @export
 * @class QueryManagerControllerApi
 * @extends {BaseAPI}
 */
export class QueryManagerControllerApi extends BaseAPI {
    /**
     * 
     * @param {ListQueryQueueStatusEnum} [status] 
     * @param {number} [assignedTo] 
     * @param {number} [attemptNumber] 
     * @param {string} [dueDateFrom] 
     * @param {string} [dueDateTo] 
     * @param {boolean} [reminderReady] 
     * @param {boolean} [autoClosed] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagerControllerApi
     */
    public listQueryQueue(status?: ListQueryQueueStatusEnum, assignedTo?: number, attemptNumber?: number, dueDateFrom?: string, dueDateTo?: string, reminderReady?: boolean, autoClosed?: boolean, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return QueryManagerControllerApiFp(this.configuration).listQueryQueue(status, assignedTo, attemptNumber, dueDateFrom, dueDateTo, reminderReady, autoClosed, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryManagerControllerApi
     */
    public queryManagerSummary(options?: RawAxiosRequestConfig) {
        return QueryManagerControllerApiFp(this.configuration).queryManagerSummary(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListQueryQueueStatusEnum = {
    Open: 'Open',
    Overdue: 'Overdue',
    AwaitingResponse: 'AwaitingResponse',
    Closed: 'Closed'
} as const;
export type ListQueryQueueStatusEnum = typeof ListQueryQueueStatusEnum[keyof typeof ListQueryQueueStatusEnum];


/**
 * QueryResponseControllerApi - axios parameter creator
 * @export
 */
export const QueryResponseControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenQueries: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listOpenQueries', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/activities/queries/open`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordQueryResponseRequest} response 
         * @param {string} [xSessionId] 
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordQueryResponse: async (id: number, response: RecordQueryResponseRequest, xSessionId?: string, document?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('recordQueryResponse', 'id', id)
            // verify required parameter 'response' is not null or undefined
            assertParamExists('recordQueryResponse', 'response', response)
            const localVarPath = `/api/v1/activities/{id}/responses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (document !== undefined) { 
                localVarFormParams.append('document', document as any);
            }
    
            if (response !== undefined) { 
                localVarFormParams.append('response', new Blob([JSON.stringify(response)], { type: "application/json", }));
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} questionId 
         * @param {QuestionOutcomeRequest} questionOutcomeRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setQueryQuestionOutcome: async (id: number, questionId: number, questionOutcomeRequest: QuestionOutcomeRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setQueryQuestionOutcome', 'id', id)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('setQueryQuestionOutcome', 'questionId', questionId)
            // verify required parameter 'questionOutcomeRequest' is not null or undefined
            assertParamExists('setQueryQuestionOutcome', 'questionOutcomeRequest', questionOutcomeRequest)
            const localVarPath = `/api/v1/activities/{id}/questions/{questionId}/outcome`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionOutcomeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryResponseControllerApi - functional programming interface
 * @export
 */
export const QueryResponseControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryResponseControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpenQueries(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListOpenQueryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpenQueries(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryResponseControllerApi.listOpenQueries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordQueryResponseRequest} response 
         * @param {string} [xSessionId] 
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordQueryResponse(id: number, response: RecordQueryResponseRequest, xSessionId?: string, document?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordQueryResponse(id, response, xSessionId, document, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryResponseControllerApi.recordQueryResponse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} questionId 
         * @param {QuestionOutcomeRequest} questionOutcomeRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setQueryQuestionOutcome(id: number, questionId: number, questionOutcomeRequest: QuestionOutcomeRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseActivityView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setQueryQuestionOutcome(id, questionId, questionOutcomeRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryResponseControllerApi.setQueryQuestionOutcome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QueryResponseControllerApi - factory interface
 * @export
 */
export const QueryResponseControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryResponseControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenQueries(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListOpenQueryView> {
            return localVarFp.listOpenQueries(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {RecordQueryResponseRequest} response 
         * @param {string} [xSessionId] 
         * @param {File} [document] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordQueryResponse(id: number, response: RecordQueryResponseRequest, xSessionId?: string, document?: File, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.recordQueryResponse(id, response, xSessionId, document, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} questionId 
         * @param {QuestionOutcomeRequest} questionOutcomeRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setQueryQuestionOutcome(id: number, questionId: number, questionOutcomeRequest: QuestionOutcomeRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseActivityView> {
            return localVarFp.setQueryQuestionOutcome(id, questionId, questionOutcomeRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryResponseControllerApi - object-oriented interface
 * @export
 * @class QueryResponseControllerApi
 * @extends {BaseAPI}
 */
export class QueryResponseControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryResponseControllerApi
     */
    public listOpenQueries(caseId: number, options?: RawAxiosRequestConfig) {
        return QueryResponseControllerApiFp(this.configuration).listOpenQueries(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {RecordQueryResponseRequest} response 
     * @param {string} [xSessionId] 
     * @param {File} [document] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryResponseControllerApi
     */
    public recordQueryResponse(id: number, response: RecordQueryResponseRequest, xSessionId?: string, document?: File, options?: RawAxiosRequestConfig) {
        return QueryResponseControllerApiFp(this.configuration).recordQueryResponse(id, response, xSessionId, document, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} questionId 
     * @param {QuestionOutcomeRequest} questionOutcomeRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryResponseControllerApi
     */
    public setQueryQuestionOutcome(id: number, questionId: number, questionOutcomeRequest: QuestionOutcomeRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryResponseControllerApiFp(this.configuration).setQueryQuestionOutcome(id, questionId, questionOutcomeRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QueryScheduleControllerApi - axios parameter creator
 * @export
 */
export const QueryScheduleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQueryScheduleDraft: async (queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queryScheduleDraftCommand' is not null or undefined
            assertParamExists('checkQueryScheduleDraft', 'queryScheduleDraftCommand', queryScheduleDraftCommand)
            const localVarPath = `/api/v1/query-schedule/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryScheduleDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueryScheduleDraft: async (queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'queryScheduleDraftCommand' is not null or undefined
            assertParamExists('createQueryScheduleDraft', 'queryScheduleDraftCommand', queryScheduleDraftCommand)
            const localVarPath = `/api/v1/query-schedule/drafts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryScheduleDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerySchedule: async (xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/query-schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {QuerySchedulePublicationCommand} querySchedulePublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishQuerySchedule: async (versionId: number, querySchedulePublicationCommand: QuerySchedulePublicationCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('publishQuerySchedule', 'versionId', versionId)
            // verify required parameter 'querySchedulePublicationCommand' is not null or undefined
            assertParamExists('publishQuerySchedule', 'querySchedulePublicationCommand', querySchedulePublicationCommand)
            const localVarPath = `/api/v1/query-schedule/drafts/{versionId}/publish`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(querySchedulePublicationCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} caseNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testQueryScheduleCase: async (caseNumber: string, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseNumber' is not null or undefined
            assertParamExists('testQueryScheduleCase', 'caseNumber', caseNumber)
            const localVarPath = `/api/v1/query-schedule/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (caseNumber !== undefined) {
                localVarQueryParameter['case_number'] = caseNumber;
            }


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} versionId 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueryScheduleDraft: async (versionId: number, queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'versionId' is not null or undefined
            assertParamExists('updateQueryScheduleDraft', 'versionId', versionId)
            // verify required parameter 'queryScheduleDraftCommand' is not null or undefined
            assertParamExists('updateQueryScheduleDraft', 'queryScheduleDraftCommand', queryScheduleDraftCommand)
            const localVarPath = `/api/v1/query-schedule/drafts/{versionId}`
                .replace(`{${"versionId"}}`, encodeURIComponent(String(versionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queryScheduleDraftCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QueryScheduleControllerApi - functional programming interface
 * @export
 */
export const QueryScheduleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QueryScheduleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkQueryScheduleDraft(queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryScheduleCheckView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkQueryScheduleDraft(queryScheduleDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryScheduleControllerApi.checkQueryScheduleDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createQueryScheduleDraft(queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryScheduleVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createQueryScheduleDraft(queryScheduleDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryScheduleControllerApi.createQueryScheduleDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getQuerySchedule(xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryScheduleScreenView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getQuerySchedule(xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryScheduleControllerApi.getQuerySchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {QuerySchedulePublicationCommand} querySchedulePublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishQuerySchedule(versionId: number, querySchedulePublicationCommand: QuerySchedulePublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryScheduleVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishQuerySchedule(versionId, querySchedulePublicationCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryScheduleControllerApi.publishQuerySchedule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} caseNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testQueryScheduleCase(caseNumber: string, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryScheduleTestView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testQueryScheduleCase(caseNumber, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryScheduleControllerApi.testQueryScheduleCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} versionId 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateQueryScheduleDraft(versionId: number, queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseQueryScheduleVersionView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateQueryScheduleDraft(versionId, queryScheduleDraftCommand, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QueryScheduleControllerApi.updateQueryScheduleDraft']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QueryScheduleControllerApi - factory interface
 * @export
 */
export const QueryScheduleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QueryScheduleControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQueryScheduleDraft(queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryScheduleCheckView> {
            return localVarFp.checkQueryScheduleDraft(queryScheduleDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createQueryScheduleDraft(queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryScheduleVersionView> {
            return localVarFp.createQueryScheduleDraft(queryScheduleDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuerySchedule(xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryScheduleScreenView> {
            return localVarFp.getQuerySchedule(xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {QuerySchedulePublicationCommand} querySchedulePublicationCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishQuerySchedule(versionId: number, querySchedulePublicationCommand: QuerySchedulePublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryScheduleVersionView> {
            return localVarFp.publishQuerySchedule(versionId, querySchedulePublicationCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} caseNumber 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testQueryScheduleCase(caseNumber: string, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryScheduleTestView> {
            return localVarFp.testQueryScheduleCase(caseNumber, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} versionId 
         * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateQueryScheduleDraft(versionId: number, queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseQueryScheduleVersionView> {
            return localVarFp.updateQueryScheduleDraft(versionId, queryScheduleDraftCommand, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QueryScheduleControllerApi - object-oriented interface
 * @export
 * @class QueryScheduleControllerApi
 * @extends {BaseAPI}
 */
export class QueryScheduleControllerApi extends BaseAPI {
    /**
     * 
     * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryScheduleControllerApi
     */
    public checkQueryScheduleDraft(queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryScheduleControllerApiFp(this.configuration).checkQueryScheduleDraft(queryScheduleDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryScheduleControllerApi
     */
    public createQueryScheduleDraft(queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryScheduleControllerApiFp(this.configuration).createQueryScheduleDraft(queryScheduleDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryScheduleControllerApi
     */
    public getQuerySchedule(xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryScheduleControllerApiFp(this.configuration).getQuerySchedule(xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {QuerySchedulePublicationCommand} querySchedulePublicationCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryScheduleControllerApi
     */
    public publishQuerySchedule(versionId: number, querySchedulePublicationCommand: QuerySchedulePublicationCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryScheduleControllerApiFp(this.configuration).publishQuerySchedule(versionId, querySchedulePublicationCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} caseNumber 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryScheduleControllerApi
     */
    public testQueryScheduleCase(caseNumber: string, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryScheduleControllerApiFp(this.configuration).testQueryScheduleCase(caseNumber, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} versionId 
     * @param {QueryScheduleDraftCommand} queryScheduleDraftCommand 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QueryScheduleControllerApi
     */
    public updateQueryScheduleDraft(versionId: number, queryScheduleDraftCommand: QueryScheduleDraftCommand, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QueryScheduleControllerApiFp(this.configuration).updateQueryScheduleDraft(versionId, queryScheduleDraftCommand, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * QuestionSuggestionControllerApi - axios parameter creator
 * @export
 */
export const QuestionSuggestionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        querySuggestions: async (caseId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('querySuggestions', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/activities/queries/suggestions`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionSuggestionControllerApi - functional programming interface
 * @export
 */
export const QuestionSuggestionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionSuggestionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async querySuggestions(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListQuestionSuggestion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.querySuggestions(caseId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionSuggestionControllerApi.querySuggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionSuggestionControllerApi - factory interface
 * @export
 */
export const QuestionSuggestionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionSuggestionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        querySuggestions(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListQuestionSuggestion> {
            return localVarFp.querySuggestions(caseId, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionSuggestionControllerApi - object-oriented interface
 * @export
 * @class QuestionSuggestionControllerApi
 * @extends {BaseAPI}
 */
export class QuestionSuggestionControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionSuggestionControllerApi
     */
    public querySuggestions(caseId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return QuestionSuggestionControllerApiFp(this.configuration).querySuggestions(caseId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferenceDocumentControllerApi - axios parameter creator
 * @export
 */
export const ReferenceDocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceDocumentContent: async (caseId: number, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getReferenceDocumentContent', 'caseId', caseId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('getReferenceDocumentContent', 'documentId', documentId)
            const localVarPath = `/api/v1/cases/{caseId}/reference-documents/{documentId}/content`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferenceDocumentControllerApi - functional programming interface
 * @export
 */
export const ReferenceDocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferenceDocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferenceDocumentContent(caseId: number, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferenceDocumentContent(caseId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceDocumentControllerApi.getReferenceDocumentContent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferenceDocumentControllerApi - factory interface
 * @export
 */
export const ReferenceDocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferenceDocumentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferenceDocumentContent(caseId: number, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getReferenceDocumentContent(caseId, documentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferenceDocumentControllerApi - object-oriented interface
 * @export
 * @class ReferenceDocumentControllerApi
 * @extends {BaseAPI}
 */
export class ReferenceDocumentControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDocumentControllerApi
     */
    public getReferenceDocumentContent(caseId: number, documentId: number, options?: RawAxiosRequestConfig) {
        return ReferenceDocumentControllerApiFp(this.configuration).getReferenceDocumentContent(caseId, documentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RoleConfigControllerApi - axios parameter creator
 * @export
 */
export const RoleConfigControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Role} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (role: Role, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'role' is not null or undefined
            assertParamExists('createRole', 'role', role)
            const localVarPath = `/api/v1/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(role, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteRole', 'id', id)
            const localVarPath = `/api/v1/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRole', 'id', id)
            const localVarPath = `/api/v1/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleConfigControllerApi - functional programming interface
 * @export
 */
export const RoleConfigControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleConfigControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Role} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(role: Role, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(role, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleConfigControllerApi.createRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleConfigControllerApi.deleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRole(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRole(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleConfigControllerApi.getRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListRole>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RoleConfigControllerApi.listRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RoleConfigControllerApi - factory interface
 * @export
 */
export const RoleConfigControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleConfigControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Role} role 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(role: Role, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseRole> {
            return localVarFp.createRole(role, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseRole> {
            return localVarFp.getRole(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoles(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListRole> {
            return localVarFp.listRoles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleConfigControllerApi - object-oriented interface
 * @export
 * @class RoleConfigControllerApi
 * @extends {BaseAPI}
 */
export class RoleConfigControllerApi extends BaseAPI {
    /**
     * 
     * @param {Role} role 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleConfigControllerApi
     */
    public createRole(role: Role, options?: RawAxiosRequestConfig) {
        return RoleConfigControllerApiFp(this.configuration).createRole(role, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleConfigControllerApi
     */
    public deleteRole(id: number, options?: RawAxiosRequestConfig) {
        return RoleConfigControllerApiFp(this.configuration).deleteRole(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleConfigControllerApi
     */
    public getRole(id: number, options?: RawAxiosRequestConfig) {
        return RoleConfigControllerApiFp(this.configuration).getRole(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleConfigControllerApi
     */
    public listRoles(options?: RawAxiosRequestConfig) {
        return RoleConfigControllerApiFp(this.configuration).listRoles(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SourceDocumentControllerApi - axios parameter creator
 * @export
 */
export const SourceDocumentControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('download', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/documents/{attachmentId}/download`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentKind: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getDocumentKind', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/documents/{attachmentId}/kind`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSpreadsheet: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getDocumentSpreadsheet', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/documents/{attachmentId}/spreadsheet`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SourceDocumentControllerApi - functional programming interface
 * @export
 */
export const SourceDocumentControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SourceDocumentControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentControllerApi.download']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentKind(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SourceDocumentInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentKind(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentControllerApi.getDocumentKind']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentSpreadsheet(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpreadsheetView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentSpreadsheet(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SourceDocumentControllerApi.getDocumentSpreadsheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SourceDocumentControllerApi - factory interface
 * @export
 */
export const SourceDocumentControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SourceDocumentControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.download(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentKind(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<SourceDocumentInfo> {
            return localVarFp.getDocumentKind(attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSpreadsheet(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<SpreadsheetView> {
            return localVarFp.getDocumentSpreadsheet(attachmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SourceDocumentControllerApi - object-oriented interface
 * @export
 * @class SourceDocumentControllerApi
 * @extends {BaseAPI}
 */
export class SourceDocumentControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourceDocumentControllerApi
     */
    public download(attachmentId: number, options?: RawAxiosRequestConfig) {
        return SourceDocumentControllerApiFp(this.configuration).download(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourceDocumentControllerApi
     */
    public getDocumentKind(attachmentId: number, options?: RawAxiosRequestConfig) {
        return SourceDocumentControllerApiFp(this.configuration).getDocumentKind(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SourceDocumentControllerApi
     */
    public getDocumentSpreadsheet(attachmentId: number, options?: RawAxiosRequestConfig) {
        return SourceDocumentControllerApiFp(this.configuration).getDocumentSpreadsheet(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StudyControllerApi - axios parameter creator
 * @export
 */
export const StudyControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {Study} study 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudy: async (caseId: number, study: Study, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('createStudy', 'caseId', caseId)
            // verify required parameter 'study' is not null or undefined
            assertParamExists('createStudy', 'study', study)
            const localVarPath = `/api/v1/cases/{caseId}/studies`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(study, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {StudyCase} studyCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudyCase: async (studyCase: StudyCase, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyCase' is not null or undefined
            assertParamExists('createStudyCase', 'studyCase', studyCase)
            const localVarPath = `/api/v1/study-cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudy: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStudy', 'id', id)
            const localVarPath = `/api/v1/studies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} studyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyCase: async (studyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('getStudyCase', 'studyId', studyId)
            const localVarPath = `/api/v1/study-cases/{studyId}`
                .replace(`{${"studyId"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} studyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistrations: async (studyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyId' is not null or undefined
            assertParamExists('listRegistrations', 'studyId', studyId)
            const localVarPath = `/api/v1/study-cases/{studyId}/registrations`
                .replace(`{${"studyId"}}`, encodeURIComponent(String(studyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudies: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listStudies', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/studies`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyCases: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/study-cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudyControllerApi - functional programming interface
 * @export
 */
export const StudyControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StudyControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {Study} study 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStudy(caseId: number, study: Study, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStudy(caseId, study, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.createStudy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {StudyCase} studyCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStudyCase(studyCase: StudyCase, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStudyCase(studyCase, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.createStudyCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStudy(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStudy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.deleteStudy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} studyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudyCase(studyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudyCase(studyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.getStudyCase']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} studyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRegistrations(studyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListStudyRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRegistrations(studyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.listRegistrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStudies(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListStudy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStudies(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.listStudies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStudyCases(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListStudyCase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStudyCases(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyControllerApi.listStudyCases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StudyControllerApi - factory interface
 * @export
 */
export const StudyControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StudyControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {Study} study 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudy(caseId: number, study: Study, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudy> {
            return localVarFp.createStudy(caseId, study, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {StudyCase} studyCase 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStudyCase(studyCase: StudyCase, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyCase> {
            return localVarFp.createStudyCase(studyCase, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStudy(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStudy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} studyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyCase(studyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyCase> {
            return localVarFp.getStudyCase(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} studyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistrations(studyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListStudyRegistration> {
            return localVarFp.listRegistrations(studyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudies(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListStudy> {
            return localVarFp.listStudies(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyCases(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListStudyCase> {
            return localVarFp.listStudyCases(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StudyControllerApi - object-oriented interface
 * @export
 * @class StudyControllerApi
 * @extends {BaseAPI}
 */
export class StudyControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {Study} study 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public createStudy(caseId: number, study: Study, options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).createStudy(caseId, study, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {StudyCase} studyCase 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public createStudyCase(studyCase: StudyCase, options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).createStudyCase(studyCase, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public deleteStudy(id: number, options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).deleteStudy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} studyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public getStudyCase(studyId: string, options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).getStudyCase(studyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} studyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public listRegistrations(studyId: string, options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).listRegistrations(studyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public listStudies(caseId: number, options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).listStudies(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyControllerApi
     */
    public listStudyCases(options?: RawAxiosRequestConfig) {
        return StudyControllerApiFp(this.configuration).listStudyCases(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StudyCountryControllerApi - axios parameter creator
 * @export
 */
export const StudyCountryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} studyCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyCountry: async (studyCaseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyCaseId' is not null or undefined
            assertParamExists('getStudyCountry', 'studyCaseId', studyCaseId)
            const localVarPath = `/api/v1/study-countries/{studyCaseId}`
                .replace(`{${"studyCaseId"}}`, encodeURIComponent(String(studyCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyCountryOptions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/study-countries/options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {StudyCountryRequest} studyCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStudyCountry: async (studyCaseId: number, studyCountryRequest: StudyCountryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyCaseId' is not null or undefined
            assertParamExists('setStudyCountry', 'studyCaseId', studyCaseId)
            // verify required parameter 'studyCountryRequest' is not null or undefined
            assertParamExists('setStudyCountry', 'studyCountryRequest', studyCountryRequest)
            const localVarPath = `/api/v1/study-countries/{studyCaseId}`
                .replace(`{${"studyCaseId"}}`, encodeURIComponent(String(studyCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyCountryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudyCountryControllerApi - functional programming interface
 * @export
 */
export const StudyCountryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StudyCountryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} studyCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudyCountry(studyCaseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyCountryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudyCountry(studyCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyCountryControllerApi.getStudyCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStudyCountryOptions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListStudyCountryOption>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStudyCountryOptions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyCountryControllerApi.listStudyCountryOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {StudyCountryRequest} studyCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStudyCountry(studyCaseId: number, studyCountryRequest: StudyCountryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyCountryView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStudyCountry(studyCaseId, studyCountryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyCountryControllerApi.setStudyCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StudyCountryControllerApi - factory interface
 * @export
 */
export const StudyCountryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StudyCountryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} studyCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyCountry(studyCaseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyCountryView> {
            return localVarFp.getStudyCountry(studyCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyCountryOptions(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListStudyCountryOption> {
            return localVarFp.listStudyCountryOptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {StudyCountryRequest} studyCountryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStudyCountry(studyCaseId: number, studyCountryRequest: StudyCountryRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyCountryView> {
            return localVarFp.setStudyCountry(studyCaseId, studyCountryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StudyCountryControllerApi - object-oriented interface
 * @export
 * @class StudyCountryControllerApi
 * @extends {BaseAPI}
 */
export class StudyCountryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} studyCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyCountryControllerApi
     */
    public getStudyCountry(studyCaseId: number, options?: RawAxiosRequestConfig) {
        return StudyCountryControllerApiFp(this.configuration).getStudyCountry(studyCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyCountryControllerApi
     */
    public listStudyCountryOptions(options?: RawAxiosRequestConfig) {
        return StudyCountryControllerApiFp(this.configuration).listStudyCountryOptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} studyCaseId 
     * @param {StudyCountryRequest} studyCountryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyCountryControllerApi
     */
    public setStudyCountry(studyCaseId: number, studyCountryRequest: StudyCountryRequest, options?: RawAxiosRequestConfig) {
        return StudyCountryControllerApiFp(this.configuration).setStudyCountry(studyCaseId, studyCountryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StudyListingControllerApi - axios parameter creator
 * @export
 */
export const StudyListingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyListingStudies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/intake/study-listings/studies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStudyListing: async (studyCaseId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyCaseId' is not null or undefined
            assertParamExists('uploadStudyListing', 'studyCaseId', studyCaseId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadStudyListing', 'file', file)
            const localVarPath = `/api/v1/intake/study-listings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (studyCaseId !== undefined) {
                localVarQueryParameter['study_case_id'] = studyCaseId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudyListingControllerApi - functional programming interface
 * @export
 */
export const StudyListingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StudyListingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStudyListingStudies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StudyListingStudyView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStudyListingStudies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingControllerApi.listStudyListingStudies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadStudyListing(studyCaseId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StudyListingUploadView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadStudyListing(studyCaseId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingControllerApi.uploadStudyListing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StudyListingControllerApi - factory interface
 * @export
 */
export const StudyListingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StudyListingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyListingStudies(options?: RawAxiosRequestConfig): AxiosPromise<Array<StudyListingStudyView>> {
            return localVarFp.listStudyListingStudies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadStudyListing(studyCaseId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<StudyListingUploadView> {
            return localVarFp.uploadStudyListing(studyCaseId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StudyListingControllerApi - object-oriented interface
 * @export
 * @class StudyListingControllerApi
 * @extends {BaseAPI}
 */
export class StudyListingControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingControllerApi
     */
    public listStudyListingStudies(options?: RawAxiosRequestConfig) {
        return StudyListingControllerApiFp(this.configuration).listStudyListingStudies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} studyCaseId 
     * @param {File} file 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingControllerApi
     */
    public uploadStudyListing(studyCaseId: number, file: File, options?: RawAxiosRequestConfig) {
        return StudyListingControllerApiFp(this.configuration).uploadStudyListing(studyCaseId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StudyListingMappingControllerApi - axios parameter creator
 * @export
 */
export const StudyListingMappingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} studyCaseId 
         * @param {StudyListingMappingRequest} studyListingMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStudyListingMapping: async (studyCaseId: number, studyListingMappingRequest: StudyListingMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyCaseId' is not null or undefined
            assertParamExists('addStudyListingMapping', 'studyCaseId', studyCaseId)
            // verify required parameter 'studyListingMappingRequest' is not null or undefined
            assertParamExists('addStudyListingMapping', 'studyListingMappingRequest', studyListingMappingRequest)
            const localVarPath = `/api/v1/study-listing-mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (studyCaseId !== undefined) {
                localVarQueryParameter['studyCaseId'] = studyCaseId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyListingMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveStudyListingMapping: async (mappingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('approveStudyListingMapping', 'mappingId', mappingId)
            const localVarPath = `/api/v1/study-listing-mappings/{mappingId}/approval`
                .replace(`{${"mappingId"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {StudyListingMappingRequest} studyListingMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correctStudyListingMapping: async (mappingId: number, studyListingMappingRequest: StudyListingMappingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('correctStudyListingMapping', 'mappingId', mappingId)
            // verify required parameter 'studyListingMappingRequest' is not null or undefined
            assertParamExists('correctStudyListingMapping', 'studyListingMappingRequest', studyListingMappingRequest)
            const localVarPath = `/api/v1/study-listing-mappings/{mappingId}`
                .replace(`{${"mappingId"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyListingMappingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyListingMapping: async (mappingId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('getStudyListingMapping', 'mappingId', mappingId)
            const localVarPath = `/api/v1/study-listing-mappings/{mappingId}`
                .replace(`{${"mappingId"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyListingMappings: async (studyCaseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'studyCaseId' is not null or undefined
            assertParamExists('listStudyListingMappings', 'studyCaseId', studyCaseId)
            const localVarPath = `/api/v1/study-listing-mappings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (studyCaseId !== undefined) {
                localVarQueryParameter['studyCaseId'] = studyCaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {StudyListingMappingActivation} studyListingMappingActivation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStudyListingMappingActivation: async (mappingId: number, studyListingMappingActivation: StudyListingMappingActivation, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mappingId' is not null or undefined
            assertParamExists('setStudyListingMappingActivation', 'mappingId', mappingId)
            // verify required parameter 'studyListingMappingActivation' is not null or undefined
            assertParamExists('setStudyListingMappingActivation', 'studyListingMappingActivation', studyListingMappingActivation)
            const localVarPath = `/api/v1/study-listing-mappings/{mappingId}/activation`
                .replace(`{${"mappingId"}}`, encodeURIComponent(String(mappingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(studyListingMappingActivation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StudyListingMappingControllerApi - functional programming interface
 * @export
 */
export const StudyListingMappingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StudyListingMappingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} studyCaseId 
         * @param {StudyListingMappingRequest} studyListingMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStudyListingMapping(studyCaseId: number, studyListingMappingRequest: StudyListingMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyListingMappingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStudyListingMapping(studyCaseId, studyListingMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingMappingControllerApi.addStudyListingMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveStudyListingMapping(mappingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyListingMappingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveStudyListingMapping(mappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingMappingControllerApi.approveStudyListingMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {StudyListingMappingRequest} studyListingMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async correctStudyListingMapping(mappingId: number, studyListingMappingRequest: StudyListingMappingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyListingMappingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.correctStudyListingMapping(mappingId, studyListingMappingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingMappingControllerApi.correctStudyListingMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStudyListingMapping(mappingId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyListingMappingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStudyListingMapping(mappingId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingMappingControllerApi.getStudyListingMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStudyListingMappings(studyCaseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListStudyListingMappingSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStudyListingMappings(studyCaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingMappingControllerApi.listStudyListingMappings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {StudyListingMappingActivation} studyListingMappingActivation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setStudyListingMappingActivation(mappingId: number, studyListingMappingActivation: StudyListingMappingActivation, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseStudyListingMappingView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setStudyListingMappingActivation(mappingId, studyListingMappingActivation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StudyListingMappingControllerApi.setStudyListingMappingActivation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StudyListingMappingControllerApi - factory interface
 * @export
 */
export const StudyListingMappingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StudyListingMappingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} studyCaseId 
         * @param {StudyListingMappingRequest} studyListingMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStudyListingMapping(studyCaseId: number, studyListingMappingRequest: StudyListingMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyListingMappingView> {
            return localVarFp.addStudyListingMapping(studyCaseId, studyListingMappingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveStudyListingMapping(mappingId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyListingMappingView> {
            return localVarFp.approveStudyListingMapping(mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {StudyListingMappingRequest} studyListingMappingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        correctStudyListingMapping(mappingId: number, studyListingMappingRequest: StudyListingMappingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyListingMappingView> {
            return localVarFp.correctStudyListingMapping(mappingId, studyListingMappingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudyListingMapping(mappingId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyListingMappingView> {
            return localVarFp.getStudyListingMapping(mappingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} studyCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStudyListingMappings(studyCaseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListStudyListingMappingSummary> {
            return localVarFp.listStudyListingMappings(studyCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} mappingId 
         * @param {StudyListingMappingActivation} studyListingMappingActivation 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setStudyListingMappingActivation(mappingId: number, studyListingMappingActivation: StudyListingMappingActivation, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseStudyListingMappingView> {
            return localVarFp.setStudyListingMappingActivation(mappingId, studyListingMappingActivation, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StudyListingMappingControllerApi - object-oriented interface
 * @export
 * @class StudyListingMappingControllerApi
 * @extends {BaseAPI}
 */
export class StudyListingMappingControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} studyCaseId 
     * @param {StudyListingMappingRequest} studyListingMappingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingMappingControllerApi
     */
    public addStudyListingMapping(studyCaseId: number, studyListingMappingRequest: StudyListingMappingRequest, options?: RawAxiosRequestConfig) {
        return StudyListingMappingControllerApiFp(this.configuration).addStudyListingMapping(studyCaseId, studyListingMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingMappingControllerApi
     */
    public approveStudyListingMapping(mappingId: number, options?: RawAxiosRequestConfig) {
        return StudyListingMappingControllerApiFp(this.configuration).approveStudyListingMapping(mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mappingId 
     * @param {StudyListingMappingRequest} studyListingMappingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingMappingControllerApi
     */
    public correctStudyListingMapping(mappingId: number, studyListingMappingRequest: StudyListingMappingRequest, options?: RawAxiosRequestConfig) {
        return StudyListingMappingControllerApiFp(this.configuration).correctStudyListingMapping(mappingId, studyListingMappingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mappingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingMappingControllerApi
     */
    public getStudyListingMapping(mappingId: number, options?: RawAxiosRequestConfig) {
        return StudyListingMappingControllerApiFp(this.configuration).getStudyListingMapping(mappingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} studyCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingMappingControllerApi
     */
    public listStudyListingMappings(studyCaseId: number, options?: RawAxiosRequestConfig) {
        return StudyListingMappingControllerApiFp(this.configuration).listStudyListingMappings(studyCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} mappingId 
     * @param {StudyListingMappingActivation} studyListingMappingActivation 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StudyListingMappingControllerApi
     */
    public setStudyListingMappingActivation(mappingId: number, studyListingMappingActivation: StudyListingMappingActivation, options?: RawAxiosRequestConfig) {
        return StudyListingMappingControllerApiFp(this.configuration).setStudyListingMappingActivation(mappingId, studyListingMappingActivation, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SubmissionSubmitControllerApi - axios parameter creator
 * @export
 */
export const SubmissionSubmitControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {SubmissionEnqueueRequest} submissionEnqueueRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit: async (id: number, submissionEnqueueRequest: SubmissionEnqueueRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submit', 'id', id)
            // verify required parameter 'submissionEnqueueRequest' is not null or undefined
            assertParamExists('submit', 'submissionEnqueueRequest', submissionEnqueueRequest)
            const localVarPath = `/api/v1/cases/{id}/submit-to-authority`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(submissionEnqueueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubmissionSubmitControllerApi - functional programming interface
 * @export
 */
export const SubmissionSubmitControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubmissionSubmitControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {SubmissionEnqueueRequest} submissionEnqueueRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submit(id: number, submissionEnqueueRequest: SubmissionEnqueueRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseSubmissionEnqueueResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submit(id, submissionEnqueueRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SubmissionSubmitControllerApi.submit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SubmissionSubmitControllerApi - factory interface
 * @export
 */
export const SubmissionSubmitControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubmissionSubmitControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {SubmissionEnqueueRequest} submissionEnqueueRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submit(id: number, submissionEnqueueRequest: SubmissionEnqueueRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseSubmissionEnqueueResult> {
            return localVarFp.submit(id, submissionEnqueueRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubmissionSubmitControllerApi - object-oriented interface
 * @export
 * @class SubmissionSubmitControllerApi
 * @extends {BaseAPI}
 */
export class SubmissionSubmitControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {SubmissionEnqueueRequest} submissionEnqueueRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubmissionSubmitControllerApi
     */
    public submit(id: number, submissionEnqueueRequest: SubmissionEnqueueRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return SubmissionSubmitControllerApiFp(this.configuration).submit(id, submissionEnqueueRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadListControllerApi - axios parameter creator
 * @export
 */
export const UploadListControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUploads: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/case-management/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadListControllerApi - functional programming interface
 * @export
 */
export const UploadListControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadListControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUploads(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UploadBookingView>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUploads(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadListControllerApi.listUploads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UploadListControllerApi - factory interface
 * @export
 */
export const UploadListControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadListControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUploads(options?: RawAxiosRequestConfig): AxiosPromise<Array<UploadBookingView>> {
            return localVarFp.listUploads(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadListControllerApi - object-oriented interface
 * @export
 * @class UploadListControllerApi
 * @extends {BaseAPI}
 */
export class UploadListControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadListControllerApi
     */
    public listUploads(options?: RawAxiosRequestConfig) {
        return UploadListControllerApiFp(this.configuration).listUploads(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadRetryControllerApi - axios parameter creator
 * @export
 */
export const UploadRetryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryUpload: async (attachmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('retryUpload', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/case-management/uploads/{attachmentId}/retry`
                .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadRetryControllerApi - functional programming interface
 * @export
 */
export const UploadRetryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadRetryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryUpload(attachmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadAttachmentView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryUpload(attachmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UploadRetryControllerApi.retryUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UploadRetryControllerApi - factory interface
 * @export
 */
export const UploadRetryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadRetryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} attachmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryUpload(attachmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<UploadAttachmentView> {
            return localVarFp.retryUpload(attachmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadRetryControllerApi - object-oriented interface
 * @export
 * @class UploadRetryControllerApi
 * @extends {BaseAPI}
 */
export class UploadRetryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} attachmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadRetryControllerApi
     */
    public retryUpload(attachmentId: number, options?: RawAxiosRequestConfig) {
        return UploadRetryControllerApiFp(this.configuration).retryUpload(attachmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WhoDrugDictionaryControllerApi - axios parameter creator
 * @export
 */
export const WhoDrugDictionaryControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} releaseId 
         * @param {string} query 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [country] Country name or ISO country code.
         * @param {string} [mah] Marketing authorization holder name or identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWhoDrug: async (releaseId: number, query: string, offset?: number, limit?: number, country?: string, mah?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('searchWhoDrug', 'releaseId', releaseId)
            // verify required parameter 'query' is not null or undefined
            assertParamExists('searchWhoDrug', 'query', query)
            const localVarPath = `/api/v1/whodrug/entries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (releaseId !== undefined) {
                localVarQueryParameter['releaseId'] = releaseId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (mah !== undefined) {
                localVarQueryParameter['mah'] = mah;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoDrugEntry: async (releaseId: number, rid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('whoDrugEntry', 'releaseId', releaseId)
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('whoDrugEntry', 'rid', rid)
            const localVarPath = `/api/v1/whodrug/entries/{rid}`
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (releaseId !== undefined) {
                localVarQueryParameter['releaseId'] = releaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoDrugFilterOptions: async (releaseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('whoDrugFilterOptions', 'releaseId', releaseId)
            const localVarPath = `/api/v1/whodrug/filter-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (releaseId !== undefined) {
                localVarQueryParameter['releaseId'] = releaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoDrugReleases: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/whodrug/releases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhoDrugDictionaryControllerApi - functional programming interface
 * @export
 */
export const WhoDrugDictionaryControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhoDrugDictionaryControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} releaseId 
         * @param {string} query 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [country] Country name or ISO country code.
         * @param {string} [mah] Marketing authorization holder name or identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchWhoDrug(releaseId: number, query: string, offset?: number, limit?: number, country?: string, mah?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhoDrugSearchPage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchWhoDrug(releaseId, query, offset, limit, country, mah, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugDictionaryControllerApi.searchWhoDrug']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whoDrugEntry(releaseId: number, rid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhoDrugEntry>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whoDrugEntry(releaseId, rid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugDictionaryControllerApi.whoDrugEntry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whoDrugFilterOptions(releaseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhoDrugFilterOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whoDrugFilterOptions(releaseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugDictionaryControllerApi.whoDrugFilterOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async whoDrugReleases(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<C3Release>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.whoDrugReleases(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugDictionaryControllerApi.whoDrugReleases']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WhoDrugDictionaryControllerApi - factory interface
 * @export
 */
export const WhoDrugDictionaryControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhoDrugDictionaryControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} releaseId 
         * @param {string} query 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {string} [country] Country name or ISO country code.
         * @param {string} [mah] Marketing authorization holder name or identifier.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchWhoDrug(releaseId: number, query: string, offset?: number, limit?: number, country?: string, mah?: string, options?: RawAxiosRequestConfig): AxiosPromise<WhoDrugSearchPage> {
            return localVarFp.searchWhoDrug(releaseId, query, offset, limit, country, mah, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {string} rid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoDrugEntry(releaseId: number, rid: string, options?: RawAxiosRequestConfig): AxiosPromise<WhoDrugEntry> {
            return localVarFp.whoDrugEntry(releaseId, rid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} releaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoDrugFilterOptions(releaseId: number, options?: RawAxiosRequestConfig): AxiosPromise<WhoDrugFilterOptions> {
            return localVarFp.whoDrugFilterOptions(releaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        whoDrugReleases(options?: RawAxiosRequestConfig): AxiosPromise<Array<C3Release>> {
            return localVarFp.whoDrugReleases(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhoDrugDictionaryControllerApi - object-oriented interface
 * @export
 * @class WhoDrugDictionaryControllerApi
 * @extends {BaseAPI}
 */
export class WhoDrugDictionaryControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} releaseId 
     * @param {string} query 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {string} [country] Country name or ISO country code.
     * @param {string} [mah] Marketing authorization holder name or identifier.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugDictionaryControllerApi
     */
    public searchWhoDrug(releaseId: number, query: string, offset?: number, limit?: number, country?: string, mah?: string, options?: RawAxiosRequestConfig) {
        return WhoDrugDictionaryControllerApiFp(this.configuration).searchWhoDrug(releaseId, query, offset, limit, country, mah, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} releaseId 
     * @param {string} rid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugDictionaryControllerApi
     */
    public whoDrugEntry(releaseId: number, rid: string, options?: RawAxiosRequestConfig) {
        return WhoDrugDictionaryControllerApiFp(this.configuration).whoDrugEntry(releaseId, rid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} releaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugDictionaryControllerApi
     */
    public whoDrugFilterOptions(releaseId: number, options?: RawAxiosRequestConfig) {
        return WhoDrugDictionaryControllerApiFp(this.configuration).whoDrugFilterOptions(releaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugDictionaryControllerApi
     */
    public whoDrugReleases(options?: RawAxiosRequestConfig) {
        return WhoDrugDictionaryControllerApiFp(this.configuration).whoDrugReleases(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WhoDrugRecodeControllerApi - axios parameter creator
 * @export
 */
export const WhoDrugRecodeControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {WhoDrugRecodeRequest} whoDrugRecodeRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyWhoDrugRecode: async (caseId: number, productId: number, whoDrugRecodeRequest: WhoDrugRecodeRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('applyWhoDrugRecode', 'caseId', caseId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('applyWhoDrugRecode', 'productId', productId)
            // verify required parameter 'whoDrugRecodeRequest' is not null or undefined
            assertParamExists('applyWhoDrugRecode', 'whoDrugRecodeRequest', whoDrugRecodeRequest)
            const localVarPath = `/api/v2/cases/{caseId}/review/products/{productId}/whodrug-recode`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whoDrugRecodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {number} releaseId 
         * @param {string} rid 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewWhoDrugRecode: async (caseId: number, productId: number, releaseId: number, rid: string, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('previewWhoDrugRecode', 'caseId', caseId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('previewWhoDrugRecode', 'productId', productId)
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('previewWhoDrugRecode', 'releaseId', releaseId)
            // verify required parameter 'rid' is not null or undefined
            assertParamExists('previewWhoDrugRecode', 'rid', rid)
            const localVarPath = `/api/v2/cases/{caseId}/review/products/{productId}/whodrug-recode`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (releaseId !== undefined) {
                localVarQueryParameter['releaseId'] = releaseId;
            }

            if (rid !== undefined) {
                localVarQueryParameter['rid'] = rid;
            }


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {number} releaseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestWhoDrugRecode: async (caseId: number, productId: number, releaseId: number, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('suggestWhoDrugRecode', 'caseId', caseId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('suggestWhoDrugRecode', 'productId', productId)
            // verify required parameter 'releaseId' is not null or undefined
            assertParamExists('suggestWhoDrugRecode', 'releaseId', releaseId)
            const localVarPath = `/api/v2/cases/{caseId}/review/products/{productId}/whodrug-recode/suggestion`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)))
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (releaseId !== undefined) {
                localVarQueryParameter['releaseId'] = releaseId;
            }


    
            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WhoDrugRecodeControllerApi - functional programming interface
 * @export
 */
export const WhoDrugRecodeControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WhoDrugRecodeControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {WhoDrugRecodeRequest} whoDrugRecodeRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyWhoDrugRecode(caseId: number, productId: number, whoDrugRecodeRequest: WhoDrugRecodeRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCatalogReviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyWhoDrugRecode(caseId, productId, whoDrugRecodeRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugRecodeControllerApi.applyWhoDrugRecode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {number} releaseId 
         * @param {string} rid 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async previewWhoDrugRecode(caseId: number, productId: number, releaseId: number, rid: string, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWhoDrugRecodePreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.previewWhoDrugRecode(caseId, productId, releaseId, rid, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugRecodeControllerApi.previewWhoDrugRecode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {number} releaseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestWhoDrugRecode(caseId: number, productId: number, releaseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWhoDrugSuggestion>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestWhoDrugRecode(caseId, productId, releaseId, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WhoDrugRecodeControllerApi.suggestWhoDrugRecode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WhoDrugRecodeControllerApi - factory interface
 * @export
 */
export const WhoDrugRecodeControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WhoDrugRecodeControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {WhoDrugRecodeRequest} whoDrugRecodeRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyWhoDrugRecode(caseId: number, productId: number, whoDrugRecodeRequest: WhoDrugRecodeRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCatalogReviewResponse> {
            return localVarFp.applyWhoDrugRecode(caseId, productId, whoDrugRecodeRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {number} releaseId 
         * @param {string} rid 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        previewWhoDrugRecode(caseId: number, productId: number, releaseId: number, rid: string, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWhoDrugRecodePreview> {
            return localVarFp.previewWhoDrugRecode(caseId, productId, releaseId, rid, xSessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {number} productId 
         * @param {number} releaseId 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestWhoDrugRecode(caseId: number, productId: number, releaseId: number, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWhoDrugSuggestion> {
            return localVarFp.suggestWhoDrugRecode(caseId, productId, releaseId, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WhoDrugRecodeControllerApi - object-oriented interface
 * @export
 * @class WhoDrugRecodeControllerApi
 * @extends {BaseAPI}
 */
export class WhoDrugRecodeControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {number} productId 
     * @param {WhoDrugRecodeRequest} whoDrugRecodeRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugRecodeControllerApi
     */
    public applyWhoDrugRecode(caseId: number, productId: number, whoDrugRecodeRequest: WhoDrugRecodeRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return WhoDrugRecodeControllerApiFp(this.configuration).applyWhoDrugRecode(caseId, productId, whoDrugRecodeRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {number} productId 
     * @param {number} releaseId 
     * @param {string} rid 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugRecodeControllerApi
     */
    public previewWhoDrugRecode(caseId: number, productId: number, releaseId: number, rid: string, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return WhoDrugRecodeControllerApiFp(this.configuration).previewWhoDrugRecode(caseId, productId, releaseId, rid, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {number} productId 
     * @param {number} releaseId 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WhoDrugRecodeControllerApi
     */
    public suggestWhoDrugRecode(caseId: number, productId: number, releaseId: number, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return WhoDrugRecodeControllerApiFp(this.configuration).suggestWhoDrugRecode(caseId, productId, releaseId, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkspaceControllerApi - axios parameter creator
 * @export
 */
export const WorkspaceControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {CaseContactLog} caseContactLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactLog: async (caseId: number, caseContactLog: CaseContactLog, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('createContactLog', 'caseId', caseId)
            // verify required parameter 'caseContactLog' is not null or undefined
            assertParamExists('createContactLog', 'caseContactLog', caseContactLog)
            const localVarPath = `/api/v1/cases/{caseId}/contact-log`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseContactLog, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CaseNotesAndAttachment} caseNotesAndAttachment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote: async (caseId: number, caseNotesAndAttachment: CaseNotesAndAttachment, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('createNote', 'caseId', caseId)
            // verify required parameter 'caseNotesAndAttachment' is not null or undefined
            assertParamExists('createNote', 'caseNotesAndAttachment', caseNotesAndAttachment)
            const localVarPath = `/api/v1/cases/{caseId}/notes`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(caseNotesAndAttachment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNarrative: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getNarrative', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/narrative`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('getSummary', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/summary`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactLog: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listContactLog', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/contact-log`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes: async (caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('listNotes', 'caseId', caseId)
            const localVarPath = `/api/v1/cases/{caseId}/notes`
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkspaceControllerApi - functional programming interface
 * @export
 */
export const WorkspaceControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkspaceControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {CaseContactLog} caseContactLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContactLog(caseId: number, caseContactLog: CaseContactLog, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseContactLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContactLog(caseId, caseContactLog, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceControllerApi.createContactLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CaseNotesAndAttachment} caseNotesAndAttachment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNote(caseId: number, caseNotesAndAttachment: CaseNotesAndAttachment, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseNotesAndAttachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNote(caseId, caseNotesAndAttachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceControllerApi.createNote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNarrative(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseNarrative>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNarrative(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceControllerApi.getNarrative']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummary(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCaseSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummary(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceControllerApi.getSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContactLog(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseContactLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContactLog(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceControllerApi.listContactLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listNotes(caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCaseNotesAndAttachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listNotes(caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkspaceControllerApi.listNotes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkspaceControllerApi - factory interface
 * @export
 */
export const WorkspaceControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkspaceControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} caseId 
         * @param {CaseContactLog} caseContactLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContactLog(caseId: number, caseContactLog: CaseContactLog, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseContactLog> {
            return localVarFp.createContactLog(caseId, caseContactLog, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {CaseNotesAndAttachment} caseNotesAndAttachment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNote(caseId: number, caseNotesAndAttachment: CaseNotesAndAttachment, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseNotesAndAttachment> {
            return localVarFp.createNote(caseId, caseNotesAndAttachment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNarrative(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseNarrative> {
            return localVarFp.getNarrative(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummary(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCaseSummary> {
            return localVarFp.getSummary(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContactLog(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseContactLog> {
            return localVarFp.listContactLog(caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCaseNotesAndAttachment> {
            return localVarFp.listNotes(caseId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkspaceControllerApi - object-oriented interface
 * @export
 * @class WorkspaceControllerApi
 * @extends {BaseAPI}
 */
export class WorkspaceControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} caseId 
     * @param {CaseContactLog} caseContactLog 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceControllerApi
     */
    public createContactLog(caseId: number, caseContactLog: CaseContactLog, options?: RawAxiosRequestConfig) {
        return WorkspaceControllerApiFp(this.configuration).createContactLog(caseId, caseContactLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {CaseNotesAndAttachment} caseNotesAndAttachment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceControllerApi
     */
    public createNote(caseId: number, caseNotesAndAttachment: CaseNotesAndAttachment, options?: RawAxiosRequestConfig) {
        return WorkspaceControllerApiFp(this.configuration).createNote(caseId, caseNotesAndAttachment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceControllerApi
     */
    public getNarrative(caseId: number, options?: RawAxiosRequestConfig) {
        return WorkspaceControllerApiFp(this.configuration).getNarrative(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceControllerApi
     */
    public getSummary(caseId: number, options?: RawAxiosRequestConfig) {
        return WorkspaceControllerApiFp(this.configuration).getSummary(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceControllerApi
     */
    public listContactLog(caseId: number, options?: RawAxiosRequestConfig) {
        return WorkspaceControllerApiFp(this.configuration).listContactLog(caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkspaceControllerApi
     */
    public listNotes(caseId: number, options?: RawAxiosRequestConfig) {
        return WorkspaceControllerApiFp(this.configuration).listNotes(caseId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WwidSettingsControllerApi - axios parameter creator
 * @export
 */
export const WwidSettingsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWwidSettings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/config/wwid-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WwidSettingsUpdateRequest} wwidSettingsUpdateRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWwidSettings: async (wwidSettingsUpdateRequest: WwidSettingsUpdateRequest, xSessionId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wwidSettingsUpdateRequest' is not null or undefined
            assertParamExists('updateWwidSettings', 'wwidSettingsUpdateRequest', wwidSettingsUpdateRequest)
            const localVarPath = `/api/v1/config/wwid-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xSessionId != null) {
                localVarHeaderParameter['X-Session-Id'] = String(xSessionId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wwidSettingsUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WwidSettingsControllerApi - functional programming interface
 * @export
 */
export const WwidSettingsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WwidSettingsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWwidSettings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWwidSettingsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWwidSettings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WwidSettingsControllerApi.getWwidSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WwidSettingsUpdateRequest} wwidSettingsUpdateRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWwidSettings(wwidSettingsUpdateRequest: WwidSettingsUpdateRequest, xSessionId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseWwidSettingsView>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWwidSettings(wwidSettingsUpdateRequest, xSessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WwidSettingsControllerApi.updateWwidSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WwidSettingsControllerApi - factory interface
 * @export
 */
export const WwidSettingsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WwidSettingsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWwidSettings(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWwidSettingsView> {
            return localVarFp.getWwidSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WwidSettingsUpdateRequest} wwidSettingsUpdateRequest 
         * @param {string} [xSessionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWwidSettings(wwidSettingsUpdateRequest: WwidSettingsUpdateRequest, xSessionId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseWwidSettingsView> {
            return localVarFp.updateWwidSettings(wwidSettingsUpdateRequest, xSessionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WwidSettingsControllerApi - object-oriented interface
 * @export
 * @class WwidSettingsControllerApi
 * @extends {BaseAPI}
 */
export class WwidSettingsControllerApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WwidSettingsControllerApi
     */
    public getWwidSettings(options?: RawAxiosRequestConfig) {
        return WwidSettingsControllerApiFp(this.configuration).getWwidSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WwidSettingsUpdateRequest} wwidSettingsUpdateRequest 
     * @param {string} [xSessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WwidSettingsControllerApi
     */
    public updateWwidSettings(wwidSettingsUpdateRequest: WwidSettingsUpdateRequest, xSessionId?: string, options?: RawAxiosRequestConfig) {
        return WwidSettingsControllerApiFp(this.configuration).updateWwidSettings(wwidSettingsUpdateRequest, xSessionId, options).then((request) => request(this.axios, this.basePath));
    }
}



